export const es = {
    "name": "Spanish",
    "flagCode": "es",
    "locale": "es-es",
    "project": {
        "name": "Nuevo sistema central de reservas QUp"
    },
    "MigrationBanner": {
        "title": "Next-Generation Command Center",
        "subtitle": "Explora el nuevo panel y completa tu migración antes del %{deadline}.",
        "tryNow": "Probar ahora",
        "dismiss": "Cerrar"
    },

    "Sidebar": {
        "Product_Discovery": "Descubrimiento de Producto",
        "Setting": "Ajustes",
        "Map": "Mapa",
        "Cue": "Señal",
        "Invoice": "Factura",
        "Supplier": "Proveedor",
        "Vehicle": "Vehículo",
        "Merchant": "Comerciante",
        "ImportBookings": "Reservas de Transporte de Importación",
        "ImportDeliveryBookings": "Reservas de Entrega de Importación",
        "Trip": "Viaje",
        "New_booking": "Nueva reserva",
        "City": "Ciudad",
        "Chauffeur": "Transporte",
        "Delivery": "Entrega",
        "Shuttle": "Lanzadera",
        "Intercity": "interurbano",
        "Customer": "Clientes",
        "Driver": "Conductores",
        "REPORTS": "Informes",
        "Corporate": "Corporativo",
        "mDispatcher": "Colaborador",
        "Reservation": "Calendario",
        "withdrawalRequest": "Solicitudes de retiro",
        "Driver_Settlement": "Liquidaciones conductor",
        "Dashboard": "Panel de control",
        "SmartData": "Datos inteligentes",
        "Smart_Data": "Datos inteligentes",
        "Campaign_Builder": "Creador de campañas",
        "Company_operator": "Operador de empresa",
        "Queuing_area": "Área de espera",
        "Withdrawal_Requests": "Solicitudes de retiro",
        "pickUp": "Pick up",
        "dropOff": "Entrega",
        "SignUpNotifications": "Notificaciones de Registro",
        "Payout": "Pago",
        "Payout_label": "Pago",
        "Invoice_Setting": "Factura",
        "payout": {
            "payoutDriver": "Pago al Conductor",
            "payoutMerchant": "Pago al comerciante",
            "payoutSupplier": "Pago al proveedor",
            "Pay_To_Driver": "Pagar a los conductores",
            "payoutDriverHistory": "Historial de Conductores de Pago",
            "Pay_To_Merchant": "Pagar a los Comerciantes",
            "Payout_History_For_Merchant": "Historial de pago del comerciante",
            "Pay_To_Supplier": "Pagar a Proveedores",
            "payoutSupplierHistory": "Historial de Pagos a Proveedores",
            "Driver_Payout": "Pago al Conductor",
            "Supplier_Payout": "Pago al Proveedor",
            "Merchant_Payout": "Pago al Comerciante"
        },
        "number_of_records_to_export": "Número de registros para exportar",
        "export": "Exportar",
        "Airline": "Aerolínea",
        "driverPayout": {
            "Pay_to_driver": "Pago a Conductores",
            "Payout_history": "Historial de Pagos"
        },
        "Reports": {
            "Driver_Referral_history": "El conductor recomienda cliente",
            "Driver_refers_Pax": "Conductor refiere Pax",
            "Refund": "Reembolso",
            "Driver_refers_Pax_Customers": "Clientes",
            "Driver_refers_Pax_Bookings": "Reservas",
            "Driver_refers_customer_Drivers": "Conductor recomienda cliente (Conductores)",
            "Driver_refers_customer_Customers": "Conductor recomienda cliente (Clientes)",
            "Driver_refers_customer_Bookings": "Conductor recomienda cliente (Reservas)",
            "Passenger_refers_Passengers": "Cliente recomienda cliente",
            "Driver_refers_drivers_Referrer": "Conductor recomienda conductores (Recomendador)",
            "Deletion_request": "Solicitud de eliminación",
            "Driver_refers_drivers_Referee": "Conductor recomienda conductores (Recomendado)",
            "Supplier_Wallet": "Billetera del Proveedor",
            "Driver_refers_Driver": "Conductor recomienda conductor",
            "Driver_refers_driver_Referrer": "Recomendador",
            "Driver_refers_driver_Referee": "Recomendador",
            "Referral_history": "Historial de referencias",
            "Booking_details": "Detalles de la reserva",
            "Financial": "Financiero",
            "Financial_driver": "Conductor",
            "Financial_fleet": "Flota",
            "Financial_company": "Compañía",
            "Financial_Driver": "Ingresos (Conductor)",
            "Financial_Fleet": "Ingresos (Flota)",
            "Financial_Company": "Ingresos (Empresa)",
            "Financial_fleet_profit": "Beneficio de flota",
            "Financial_Company_Tooltip": "Informe de ingresos netos de conductores, agrupados por empresa",
            "Financial_Driver_ToolTip": "Informe de ganancias netas de cada conductor",
            "Financial_Fleet_Profit_ToolTip": "Beneficio de flota",
            "Driver_activity": "actividad del conductor",
            "Revenue_Summary": "Resumen de ingresos",
            "Revenue_fleet": "Flota",
            "Revenue_driver": "Conductor",
            "Revenue_monthly": "Mensual",
            "Revenue_Summary_Fleet": "Resumen de ingresos (Flota)",
            "Revenue_Summary_Driver": "Resumen de ingresos (Conductor)",
            "Revenue_Summary_Monthly": "Resumen de ingresos (Mensual)",
            "Total_adjustment": "Ajuste total",
            "Promotion": "Promociones",
            "Incident_Cancellation": "Incidente y Cancelación",
            "Booking_logs": "Registros de reservas",
            "Rating": "Calificación de pulgares",
            "Thumbs_rating": "Calificación de pulgares",
            "Stars_rating": "Calificación de pulgares",
            "Operator_logs": "Registros del operador",
            "Daily": "A diario",
            "Daily_Driver": "Conductor diario",
            "Daily_Car": "Coche diario",
            "Daily_Driver_Car": "Coche de conductor diario",
            "mDispatcher": "Compañero",
            "Corporate": "Corporativo",
            "Driver_login_status": "Estado de inicio de sesión del conductor",
            "Car_activity": "actividad del coche",
            "Partner": "Colaborador",
            "Prepaid_top_up": "Prepago",
            "Affiliation": "Afiliación",
            "Affiliation_penalty_compensation": "Sanción/Compensación",
            "Affiliation_payout_history": "Historial de liquidaciones",
            "Affiliation_bookings": "Reservaciones",
            "Booking_summary": "Datos de reservas",
            "Cash_Wallet": "billetera en efectivo",
            "Credit_Wallet": "Crédito monedero",
            "Driver_wallet": "Conductor monedero",
            "Driver_Deposit": "Depósito del conductor",
            "Driver_cash_wallet": "Monedero en efectivo",
            "Driver_Deposit_old": "Depósito conductores",
            "Document_expiry": "Vigencia documentos",
            "Settlement": "Asentamiento",
            "Unapproved_Driver": "Conductor no aprobado",
            "Approved_Driver": "conductor aprobado",
            "Pay_to_driver": "Pagar al conductor",
            "Settlement_history": "Historial de liquidaciones",
            "Withdrawal_History": "Retiro del conductor",
            "creditWalletTooltip": "Depósitos del conductor a la billetera de crédito",
            "Incomplete_payment": "Pago incompleto",
            "Driver_withdrawal": "Retiro del conductor",
            "Incident_&_Cancellation": "Incidente y Cancelación",
            "Passenger_wallet": "Incidente y Cancelación",
            "Accept_Cancel_rate": "Acceptance/Cancellation rate",
            "Acceptance/Cancellation_rate": "Acceptance/Cancellation rate",
            "driverDepositTooltip": "Depósitos del conductor a la billetera de crédito",
            "Customer_quest": "Misión",
            "First_will_win": "El primero ganará",
            "Largest_will_win": "El más grande ganará",
            "redeemed": "Código #",
            "Code_#": "Código #",
            "Quests": "Búsqueda",
            "Merchant_Report": "Comerciante",
            "Merchant_Financial_Report": "Financiero",
            "Merchant_Cash_Report": "Billetera de efectivo",
            "Merchant_Credit_Report": "Billetera de crédito",
            "Deletion_Request": "Solicitud de eliminación",
            "Driver_Rating": "Cliente califica al conductor",
            "Passenger_Rating": "Conductor califica al cliente",
            "Company_settlement": "Liquidación de la empresa",
            "Export": "Historial de exportación",
            "Third_Party_Booking": "Reserva de terceros",
            "BookingDotCom": "Booking.com",
            "Third_Party_Booking_Bookingcom": "Reserva de terceros (Booking.com)",
            "Third_Party_Booking_HolidayTaxis": "Reserva de terceros (HolidayTaxis)",
            "Third_Party_Booking_Karhoo": "Reserva de terceros (Karhoo)",
            "Third_Party_Booking_Hoppa": "Reserva de terceros (Hoppa)",
            "Third_Party_Booking_Klook": "Reserva de Terceros (Klook)",
            "Third_Party_Booking_TransferZ": "Reserva de Terceros (TransferZ)",
            "supplierWallet": "Billetera del Proveedor"
        },
        "Settings": {
            "Block_Passenger": "Bloquear Pasajero",
            "Fleet_info": "información de la flota",
            "Product_Discovery": "Descubrimiento de Producto",
            "Surchage_Policy": "Política de recargos",
            "RateLegacy": "Tarifa (Legado)",
            "Driver": "Controlador",
            "Merchant": "Comerciante",
            "Calendar": "Calendario",
            "Socaial": "Socaial",
            "Quest": "Quest",
            "Referral": "Referencia",
            "Addon_Template": "Add-On Template",
            "Social": "Social",
            "Shift": "Turno",
            "Rate_Templates": "Plantillas de tarifas",
            "Supplier_Plan": "Plan de proveedor",
            "Vehicle_Lead_Time": "Tiempo de entrega del vehículo",
            "Penalty_Policy": "Política de penalización",
            "Stripe_connect": "Stripe Connect",
            "stripe_title_connect": "Activa tu cuenta de Stripe Connect para recibir tu pago automáticamente.",
            "Payment_info": "Información de facturación",
            "Permission": "Permiso",
            "Driver_refer_driver": "Conductor recomienda conductor",
            "Show_referal_history": "Mostrar/ocultar historial de referencias en la aplicación del conductor",
            "companyTooltip": "Empresa proveedora",
            "User": "Usuario",
            "General": "General",
            "Regular": "Regular",
            "Sharing": "Compartir calle",
            "Flat": "Plano",
            "Hourly": "Por Hora - Día",
            "Company": "Compañía",
            "Dispatch": "Asignar",
            "Voice_SMS": "Voz & SMS",
            "Rate": "Tarifas",
            "RateNew": "Tarifas",
            "Car": "Vehículo",
            "Car_type": "Tipo de carro",
            "Car_mgmt": "Gestión de coche",
            "Car_Make": "Haz un modelo",
            "Meeting_Zone": "Zona de Reunión",
            "Restricted_Zone": "Zona Restringida",
            "Stripe_Connect": "Stripe Connect",
            "Voice_&_SMS": "Voz y SMS",
            "Street-sharing_rate": "Tarifa de compartir calle",
            "Partner_type": "tipo de socio",
            "Shift_template": "plantilla de turno",
            "Billing_Usage": "Uso de Facturación",
            "Driver_App": "Aplicación del conductor",
            "Shift_settings": "Ajustes de turno",
            "Operation": "Operación",
            "Driver_Note": "Nota del conductor",
            "Promotion_code": "El código de promoción",
            "Point_config": "Configuración de puntos",
            "Code_#": "Código #",
            "Voucher_code": "Código #",
            "Campaign": "Campaña",
            "Queuing_area": "zona de cola",
            "Referral_code": "Código de referencia",
            "City": "Ciudad",
            "category": "Categoría",
            "3rd_party_location": "ubicación de terceros",
            "Zone": "Zona",
            "App_banner": "Banner de App",
            "App_banner_pegasus": "Banner de aplicación (Pegasus)",
            "Flight_integration": "Integración de vuelos",
            "SMS_integration": "Integración de SMS",
            "Invoice_Setting": "Factura",
            "Payout_Setting": "Plantilla de Pago",
            "AI_Atlas": "Chatbot de Atlas AI",
            "Driver_refers_customer": "Conductor recomienda cliente",
            "Pax_refers_Pax": "Cliente recomienda cliente",
            "Customer_refers_customer": "Cliente recomienda cliente",
            "Dynamic_Surcharge": "Recargo dinámico",
            "Dynamic_Fare": "Tarifa dinámica",
            "FlatZone": "Tarifa fija",
            "IntercityZone": "Interurbano",
            "Intercity_Zone": "Zona interurbana",
            "Intercity_Rate": "Tarifa interurbana",
            "Car_Color": "Color del coche",
            "third_party_integration": "Integración de terceros",
            "bookingCom": "Booking.com",
            "HolidayTaxis": "HolidayTaxis",
            "Karhoo": "Karhoo",
            "Corporate": "Corporativo",
            "KarhooIntegration": "Integración con Karhoo",
            "holidaytaxis": "HolidayTaxis",
            "karhoo": "Karhoo",
            "hoppa": "Hoppa",
            "Hoppa": "Hoppa",
            "HoppaIntegration": "Integración con Hoppa",
            "Third_Party_Integration_Hoppa": "Integración de terceros (Hoppa.com)",
            "titleHoppa": "Credenciales API de Hoppa",
            "noteHoppa": "Comunícate con el equipo técnico de Hoppa para obtener el cliente y la clave secreta para conectarte a su sistema.",
            "titleHoppaWebhook": "Configuración de Webhook",
            "noteHoppaWebhook": "Proporciona los siguientes parámetros para que Hoppa los configure. Estas credenciales se usan para la comunicación entre ambas plataformas. Para cualquier problema, contacta a tu",
            "klook": "Klook",
            "Klook": "Klook",
            "KlookIntegration": "Integración de Klook",
            "Third_Party_Integration_Klook": "Integración de terceros (Klook.com)",
            "titleKlook": "Credenciales de API de Klook",
            "noteKlook": "Comuníquese con el equipo técnico de Klook para proporcionarle el cliente y la clave secreta para conectarse a su sistema.",
            "titleKlookWebhook": "Configuración de Webhook",
            "noteKlookWebhook": "Proporcione los parámetros a continuación para que Klook los configure. Estas credenciales se utilizan para comunicarse entre ambas plataformas. Para cualquier problema, comuníquese con su proveedor de tecnología.",
            "transferZ": "TransferZ",
            "TransferZ": "TransferZ",
            "TransferZIntegration": "Integración de TransferZ",
            "Third_Party_Integration_TransferZ": "Integración de terceros (TransferZ.com)",
            "titleTransferZ": "Credenciales de API de TransferZ",
            "noteTransferZ": "Comuníquese con el equipo técnico de TransferZ para proporcionarle el cliente y la clave secreta para conectarse a su sistema.",
            "titleTransferZWebhook": "Configuración de Webhook",
            "noteTransferZWebhook": "Proporcione los parámetros a continuación para que TransferZ los configure. Estas credenciales se utilizan para comunicarse entre ambas plataformas. Para cualquier problema, comuníquese con su proveedor técnico.",
            "Third_Party_Integration_Booking": "Integración de terceros (Booking.com)",
            "Third_Party_Integration_HolidayTaxis": "Integración de terceros (HolidayTaxis)",
            "Third_Party_Integration_Karhoo": "Integración de terceros (Karhoo.com)",
            "Third_Party_Integration_Mozio": "Integración de terceros (Mozio.com)",
            "invoiceBranding": "Personalización de facturas",
            "invoiceLogo": "Logo de la factura",
            "invoiceColor": "Color de la factura",
            "payoutBranding": "Marca de Pago",
            "titleInvoice": "Personaliza la información del encabezado y pie de página de tu empresa.",
            "titlePayout": "Personaliza la información del encabezado y pie de página de tu empresa.",
            "titleheader": "Título del encabezado",
            "descriptionHeader": "Descripción del encabezado",
            "placehodelHeader": "Por ejemplo, añade detalles de la empresa como correo electrónico, número de teléfono, dirección, número de impuestos, etc.",
            "titleFooter": "Título del pie de página",
            "placehodelFooter": "Por ejemplo, añade información de transferencia bancaria o cualquier política, etc.",
            "descriptionFooter": "Descripción del pie de página",
            "defaultEmailMessage": "Mensaje de correo electrónico predeterminado",
            "placeholderEmailMessage": "La cantidad se transferirá a su cuenta utilizando su método de pago preferido. No dude en contactarnos en <email> si tiene alguna pregunta.\n\nGracias por los servicios prestados. Esperamos una cooperación exitosa en el futuro.\n\nAtentamente,  \nEquipo Good Journey\n\nSi no se recibe ninguna objeción dentro de siete días, la factura autoliquidada se considera aprobada.",
            "titleBookingCom": "Credenciales API de Booking.com",
            "noteBookingCom": "Comunícate con el equipo técnico de Booking.com para obtener el cliente y la clave secreta para conectarte a su sistema.",
            "clientKey": "Clave del cliente",
            "placeHolderClientKey": "Ingresa la clave del cliente",
            "secretKey": "Clave secreta",
            "placeHolderSecretKey": "Ingresa la clave secreta",
            "titleBookingComWebhook": "Configuración de Webhook",
            "noteBookingComWebhook": "Proporciona los siguientes parámetros para que Booking.com los configure. Estas credenciales se usan para la comunicación entre ambas plataformas. Para cualquier problema, contacta a tu proveedor tecnológico.",
            "webhook": "URL de Webhook de la flota",
            "clientId": "Clave de cliente de la flota",
            "clientSecret": "Clave secreta de la flota",
            "driver_app": "Aplicación del conductor",
            "Jobs_tab": "Pestaña de trabajos",
            "Email_config": "Configuración de correo electrónico",
            "Driver_fields": "Campos del conductor",
            "Driver_document": "Documento del conductor",
            "Selected": "Seleccionado",
            "API_Management": "Gestión de API",
            "Penalty_Policy_Customer": "Política de penalización del cliente",
            "Penalty_Policy_Supplier": "Política de penalización del proveedor",
            "Stop_Sales": "Detener Ventas",
            "RestrictedZone": "Zona Restringida",
            "MeetingZone": "Zona de Reunión",
            "block_passenger": "Bloquear Pasajero",
            "Billing_usage": "Uso de facturación"
        }
    },
    "welcome": {
        "next": "Next",
        "getStarted": "Get Started",
        "step1": {
            "title": "Product Discovery",
            "description": "Welcome to Good Journey! Access all the products included in your plan, such as the <span class=\"highlight-white\">Driver App, Customer Web Booker</span> and more.",
            "button": "Learn more"
        },
        "step2": {
            "title": "Introducing Fleet Wallet",
            "description": "Once you reach your free allowance, any additional overage will check your fleet wallet to deduct per additional request.",
            "moreInfo": "💡 Maintain a positive balance, check usage and transaction reports here."
        },
        "step3": {
            "title": "Never Miss a Beat",
            "description": "You can setup <span class=\"highlight-white\">Automated Top-up</span> to ensure no service disruption on top of usage.",
            "description2": "This ensures your drivers stay on the road and your data keeps flowing, no matter how busy things get."
        },
        "step4": {
            "title": "Getting Started",
            "description": "We’re thrilled to have you onboard! Check out our <span class=\"highlight-white\">Guides & Tutorials</span> section to master the platform and get the most out of your fleet management tools."
        }
    },
    "productDiscovery": {
        "title": "Descubrimiento de Producto",
        "fleetCode": " código de flota",
        "fleetCodeDescription": "Los conductores que utilizan la aplicación global para conductores deben ingresar este código antes de iniciar sesión.",
        "description": "Explora y activa las herramientas que impulsan tu flota. Accede a la Aplicación para Conductores, la Aplicación para Clientes, el Portal de Reservas Web y las Aplicaciones de Socios — todas diseñadas para optimizar las operaciones, conectarte con los pasajeros y hacer crecer tu negocio.",
        "web": "Web",
        "ios": "iOS",
        "android": "Android",
        "guide": "Guía",
        "gallery": "Galería",
        "downloadLinks": "Enlaces de descarga",
        "customize": "Configuraciones",
        "base": "Base de Conocimientos",
        "base_description": "Tu guía todo en uno para la plataforma. Explora tutoriales paso a paso, preguntas frecuentes y mejores prácticas para dominar las reservas, el despacho, los pagos y más.",
        "base_allowed": {
            "platform_guides": "Guías de Plataforma",
            "step_by_step_tutorials": "Tutoriales Paso a Paso",
            "faqs_troubleshooting": "Preguntas frecuentes y solución de problemas",
            "best_practices": "Mejores Prácticas",
            "product_releases_updates": "Lanzamiento y Actualizaciones del Producto"
        },
        "driver_app": "Aplicación de conductor",
        "driver_app_description": "Equipa a tus conductores con una aplicación para gestionar trabajos, completar viajes y actualizar reservas sin esfuerzo.",
        "driver_app_allowed": {
            "booking_notifications": "Notificaciones de Reservas",
            "trip_management": "Gestión de Viajes",
            "navigate_realtime_tracking": "Navegación y Seguimiento en Tiempo Real",
            "inapp_communication_support": "Comunicación y Soporte en la Aplicación",
            "track_driver_earnings": "Rastrear los ingresos del conductor",
            "driver_signup_link": "Enlace de Registro de Conductores"
        },
        "passenger_app": "Aplicación de Pasajero",
        "passenger_app_description": "Reserva y gestiona viajes con facilidad. La Aplicación de Pasajeros ofrece una experiencia premium para los viajeros — desde la reserva instantánea hasta las actualizaciones en tiempo real — asegurando comodidad, fiabilidad y control en cada paso.",
        "passenger_app_allowed": {
            "seamless_ride_booking": "Reserva de Viaje Sin Interrupciones",
            "realtime_tracking_notifications": "Seguimiento y Notificaciones en Tiempo Real",
            "inapp_communication": "Comunicación dentro de la aplicación",
            "flexible_payment_receipts": "Pagos y Recibos Flexibles",
            "ride_history_favorites": "Historial de viajes y favoritos"
        },
        "web_driver_app": "Aplicación Web del Conductor",
        "web_driver_app_description": "Brinda a los subcontratistas y conductores socios una forma fácil de aceptar y gestionar trabajos sin necesidad de instalar una aplicación. La Aplicación Web para Conductores funciona directamente en el navegador, perfecta para conductores ocasionales o socios que utilizan sus propios sistemas, con notificaciones enviadas por correo electrónico, SMS o alertas web.",
        "web_driver_app_allowed": {
            "job_access_via_web_link": "Acceso al trabajo a través de enlace web",
            "trip_management": "Gestión de Viajes",
            "notifications_email_sms_web": "Notificaciones por Email/SMS/Web",
            "navigation_status_updates": "Navegación y Actualizaciones de Estado",
            "simple_lightweight": "Sencillo y ligero",
            "signup_link": "Enlace de Registro de Conductores"
        },
        "web_passenger_app": "Aplicación de Reserva Web",
        "web_passenger_app_description": "Permita que sus clientes y socios reservan viajes directamente desde su sitio web. La Aplicación de Reserva Web está diseñada para traslados al aeropuerto, servicios de chófer y reservas bajo demanda, ofreciendo a las OTAs, hoteles y agentes de viajes una forma sencilla de conectar a los viajeros con su flota.",
        "web_passenger_app_allowed": {
            "embed_anywhere": "Incrustar en cualquier lugar",
            "create_ride_bookings": "Crear Reservas de Viaje",
            "seamless_web_experience": "Experiencia Web Sin Costuras",
            "partner_ready": "Listo para socios",
            "customer_friendly_checkout": "Proceso de pago amigable para el cliente"
        },
        "concierge_booker": "Conserje Booker",
        "concierge_booker_description": "Una simple aplicación web para socios y personal — desde conserjes y valet de hoteles hasta bartenders y anfitriones de restaurantes — para crear viajes para sus huéspedes en solo unos pocos clics. Cada usuario tiene su propio inicio de sesión, puede reservar en nombre de los viajeros y rastrear las comisiones ganadas.",
        "concierge_booker_allowed": {
            "quick_guest_booking": "Reservas Rápidas para Huéspedes",
            "individual_user_login": "Inicios de sesión de usuarios individuales",
            "commission_tracking": "Seguimiento de Comisiones",
            "easy_web_access": "Acceso Web Fácil",
            "partner_friendly_setup": "Configuración Amigable para Socios"
        },
        "gojo_api": "API de Buen Viaje",
        "gojo_api_description": "Construya con confianza. Acceda a nuestro portal de desarrolladores para explorar referencias de API, guías de integración y flujos de trabajo de muestra para reservas, despacho, pagos y más.",
        "gojo_api_allowed": {
            "comprehensive_api_reference": "Referencias API completas",
            "integration_guides": "Guías de Integración",
            "sandbox_testing_tools": "Sandbox y Herramientas de Pruebas"
        },
        "gojo_canvas": "Canvas de Buen Viaje",
        "gojo_canvas_description": "Diseña y personaliza tu experiencia de super-app. Good Journey Canvas te brinda el control creativo total para gestionar menús, formularios de entrega, promociones y diseños de pantalla de inicio, todo desde una interfaz simple.",
        "gojo_canvas_allowed": {
            "menu_management": "Gestión de Menú",
            "custom_delivery_forms": "Formularios de Entrega Personalizados",
            "super_app_home_builder": "Constructor de Hogares Super-App",
            "promotion_advertising": "Promociones y Publicidad",
            "flexible_content_management": "Gestión de Contenidos Flexible"
        },
        "gojo_chatbot": "Buen Viaje AI Chat Bot",
        "gojo_chatbot_description": "Reserva viajes con solo una conversación. El asistente de chat impulsado por IA ayuda a clientes, socios o personal a crear reservas al instante, ya sea escribiendo solicitudes, hablando de manera natural o incluso subiendo itinerarios.",
        "gojo_chatbot_allowed": {
            "conversational_booking": "Reserva Conversacional",
            "file_itinerary_uploads": "Carga de Archivos e Itinerarios",
            "multi_channel_access": "Acceso Multicanal",
            "smart_suggestions": "Sugerencias Inteligentes",
            "operator_assistance": "Asistencia del operador"
        },
        "concierge_booker_web_setting": "Configuraciones - Concierge Booker",
        "pax_app_setting": "Ajustes - Aplicación de Pasajero",
        "driver_app_setting": "Configuraciones - Aplicación Global de Conductor",
        "pax_web_setting": "Configuraciones - Aplicación de Reserva Web",
        "driver_web_setting": "Configuraciones - Aplicación Web del Conductor",
        "save": "Guardar",
        "cancel": "Cancelar",
        "themes": "Temas",
        "links": "Enlaces",
        "ios_driver_app": "Aplicación del controlador de iOS",
        "android_driver_app": "Aplicación del controlador de Android",
        "gallery_driver_app": "Aplicación del Conductor de Galería",
        "ios_pax_app": "Aplicación de Pasajero de iOS",
        "android_pax_app": "Aplicación de Pasajero de Android",
        "gallery_pax_app": "Aplicación de Pasajeros de Gallery",
        "light_mode": "Modo Claro",
        "dark_mode": "Modo Oscuro",
        "primary_color": "Color Primario",
        "secondary_color": "Color Secundario",
        "longName": "PWA Nombre Largo",
        "shortName": "Nombre corto de PWA",
        "adsTracking": "Seguimiento de anuncios",
        "googleId": "ID de etiqueta de Google",
        "metaId": "ID de Meta Pixel",
        "customUrl": "Enlace Web de Reserva",
        "partnerLink": "Enlace Web del Socio",
        "webBookingSettings": "Configuraciones de Reserva Web",
        "enableBookNow": "Ahora Reservas",
        "enableBookLater": "Reservas posteriores",
        "enableGuestCheckout": "Pago como invitado",
        "icon192": "Ícono de la aplicación PWA (192x192)",
        "icon512": "Ícono de la aplicación PWA (512x512)",
        "icon192Driver": "Icono de la aplicación PWA (192x192)",
        "icon512Driver": "Icono de la aplicación PWA (512x512)",
        "pax_app": "Aplicación de pasajero",
        "default": "Predeterminado",
        "customized": "Personalizado",
        "html": "HTML",
        "quoteSettings": "Quote Settings",
        "about": "Acerca de",
        "email": "Soporte por correo electrónico",
        "enablePhone": "Número de teléfono",
        "phone": "",
        "policy": "Enlace a la Política de Privacidad",
        "termOfUse": "Enlace a los Términos de Uso",
        "site": "Sitio web",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "archivo HTML",
        "Update_fail": "Se produjeron los errores",
        "Update_success": "La configuración se ha actualizado correctamente.",
        "driverSignUp": "Enlace de Registro de Conductores",
        "customUrlDriver": "Enlace de la aplicación web del conductor"
    },
    "APIKeySetting": {
        "APIKey": "Claves API",
        "APIKey_title": "No compartas tu clave API con otros ni la expongas en el navegador o en otro código del lado del cliente. Para proteger la seguridad de tu cuenta, Good Journey puede desactivar automáticamente cualquier clave API que haya sido filtrada públicamente.",
        "newKeyBtn": "Crear nueva clave",
        "updateApplication": "Actualizar aplicación",
        "RegisterApp": "Registrar una nueva aplicación",
        "RegisterBtn": "Registrar aplicación",
        "appDescription": "Descripción de la aplicación",
        "webhookUrl": "Webhook Endpoint",
        "appName": "Nombre de la aplicación",
        "clientKey": "Clave del cliente",
        "secretKey": "Clave secreta",
        "hostedEndPoint": "Endpoints alojados",
        "maxEndpoints": "Puedes tener un máximo de 5 endpoints",
        "addEndpoint": "Agregar endpoint",
        "updateEndpoint": "Actualizar endpoint",
        "ManageWebhooks": "Gestionar Webhooks",
        "CreateWebhook": "Crear Webhooks",
        "subscriptionID": "ID de suscripción",
        "webhookURL": "URL de Webhook",
        "signingSecret": "Secreto de firma",
        "eventsToSend": "Eventos a enviar",
        "listeningFor": "Escuchando",
        "assignedDriver": "Conductor asignado",
        "bookingStatus": "Estado de la reserva",
        "driverLocation": "Ubicación del conductor",
        "titleSigningSecret": "Este secreto es proporcionado por tu socio. Si por alguna razón el secreto ha sido comprometido, puedes actualizar el secreto o eliminar el Webhook.",
        "notUsingHTTPS": "La URL de Webhook no está usando HTTPS.",
        "invalidURL": "La URL de Webhook es inválida.",
        "clientType": "Tipo de cliente",
        "individual": "Individual",
        "corporate": "Corporativo",
        "signingSecretLength": "El secreto de firma debe tener al menos 30 caracteres.",
        "bookingCreated": "Reserva creada",
        "partner": "Socio",
        "fleetManager": "Gerente de flota",
        "apiProvider": "Proveedor de API",
        "selectAPITitle": "Selecciona la API que te gustaría integrar",
        "isAutoAccept": "Reserva de aceptación automática",
        "isAutoAcceptPA": "Aceptar automáticamente enmienda pendiente",
        "assignedVehicle": "Vehículo Asignado"
    },
    "messages": {
        "credits": {
            "406": "Accion: Fallida",
            "407": "Accion: Fallida",
            "416": "El cupón ha sido usado",
            "417": "Su cuenta ha estado inactiva.  Por favor contacte a nuestro administrador",
            "418": "Hubo errores al realizar el pago",
            "419": "¡El código de promoción no es válido!",
            "420": "Este código de promoción se aplicó para otro viaje.  Utilice otro.",
            "421": "El número de tarjeta no es válido.",
            "422": "La fecha de caducidad no es válida.",
            "429": "El código postal no es válido.",
            "430": "El código postal de AVS no coincide",
            "431": "AVS Código postal no verificado",
            "432": "CVV no es válido.",
            "433": "CVV no coincide",
            "434": "CVV no está verificado",
            "435": "El emisor de CVV no participa",
            "436": "Tu tarjeta fue rechazada",
            "437": "Fondos insuficientes.  Por favor, consulte su saldo!",
            "439": "CVV no procesado",
            "441": "No hay datos de CVV del emisor",
            "443": "No hay datos del emisor/cambio de banknet",
            "445": "El sistema AVS no puede procesar",
            "446": "El banco emisor no admite AVS",
            "447": "AVS no es compatible con su negocio",
            "448": "Esta tarjeta ha sido bloqueada debido a repetidos intentos de pago fallidos.  Cambia tu método de pago o vuelve a intentarlo más tarde",
            "452": "Su tarjeta ha sido rechazada.  Ingrese otra tarjeta de crédito que se registró en la misma área que su número de teléfono",
            "453": "No se admite esta pasarela de pago",
            "454": "La dirección AVS no coincide",
            "455": "AVS Tanto el código postal como la dirección no coinciden",
            "458": "Autenticación fallida",
            "459": "Tarjeta no admitida",
            "461": "Esta tarjeta no ha sido admitida",
            "462": "Titular de la tarjeta no válido",
            "463": "El código de verificación no es válido",
            "464": "El banco no admite el envío del código de verificación",
            "470": "Por favor, introduzca el mail del pasajero antes de crear una reserva con la tarjeta de crédito",
            "474": "Por favor, introduzca el nombre del pasajero antes de crear una reserva con la tarjeta de crédito",
            "475": "Se requiere el número de teléfono",
            "476": "El monto no es válido",
            "524": "Crédito insuficiente. La cuenta no tiene suficiente crédito para realizar la transacción",
            "911": "No podemos autenticar su método de pago.  Elija otro método de pago y vuelva a intentarlo.",
            "2000": "No honrar",
            "2001": "Crédito insuficiente. La cuenta no tiene suficiente crédito para realizar la transacción",
            "2002": "Límite excedido",
            "2003": "Límite de actividad excedido",
            "2004": "Tarjeta expirada",
            "2005": "Número de tarjeta de crédito no válido",
            "2006": "fecha de caducidad no válida",
            "2007": "Sin cuenta",
            "2008": "Longitud de cuenta errónea",
            "2009": "No hay tal emisor",
            "2010": "La entidad emisora rechazó CVV",
            "2011": "Se requiere autorización de voz. El banco del titular de la tarjeta está solicitando que el comerciante llame para obtener un código de autorización especial para completar esta transacción",
            "2012": "Proceso rechazado - posible pérdida de tarjeta",
            "2013": "Proceso rechazado - posible pérdida de tarjeta",
            "2014": "Proceso rechazado - posible proceso de fraude",
            "2015": "Transacción no permitida",
            "2016": "transacción duplicada",
            "2017": "Propietario de tarjeta canceló facturación",
            "2018": "Propietario de tarjeta canceló facturación",
            "2019": "Transacción no válida",
            "2020": "Violación",
            "2021": "Violación de seguridad",
            "2022": "Rechazado - actualización de propietario de tarjeta",
            "2023": "Proceso no admite esta configuración",
            "2024": "tipo de tarjeta no permitida",
            "2025": "Error de configuración - Comercio",
            "2026": "ID de comerciante no válido",
            "2027": "Error de configuración - Importe",
            "2028": "Error de configuración - Estructura",
            "2029": "Error de configuración - Tarjeta",
            "2030": "Error de configuración - Terminal",
            "2031": "Error encriptado",
            "2032": "Cargo no permitido",
            "2033": "Datos no consistentes",
            "2034": "No se ha realizado acción",
            "2035": "Aprobación Parcial Por Monto En Versión Grupo III",
            "2036": "No se pudo encontrar la autorización para revertir",
            "2037": "Correción realizada",
            "2038": "Proceso rechazado. El banco del cliente ha rechazado la transacción, contacte con su entidad para más detalles",
            "2039": "Código de autorización no válido",
            "2040": "Comercio no válido",
            "2041": "Rechazado - Llamar para la aprobación",
            "2042": "Código de cliente no válido",
            "2043": "Error: no reintentar, llame a la entidad emisora",
            "2044": "Declinada - llame a la entidad emisora",
            "2045": "Número comercio no válido",
            "2046": "Rechazado.  El banco del cliente no está dispuesto a aceptar la transacción, debe comunicarse con su banco para obtener más detalles.",
            "2047": "Emisor de llamadas.  Selecciona carta.  Este error indica que la tarjeta ha sido reportada como extraviada o robada por el titular de la tarjeta.",
            "2048": "Importe no válido",
            "2049": "Número SKU no válido",
            "2050": "Plan de crédito no válido",
            "2051": "El número de tarjeta de crédito no coincide con el método de pago",
            "2052": "Compra de nivel III no válida",
            "2053": "Tarjeta reportada como extraviada o robada",
            "2054": "El monto de la reversión no coincide con el monto de la autorización",
            "2055": "Número de división de transacción no válido",
            "2056": "El monto de la transacción excede el límite de división de la transacción",
            "2057": "El titular o la entidad emisora han puesto un límite a la tarjeta",
            "2058": "Comerciante sin MasterCard SecureCode habilitado.",
            "2060": "Fallo en la verificación de la dirección y el código de seguridad de la tarjeta",
            "2061": "Datos de transacción no válidos",
            "2062": "Cantidad de impuestos no válida",
            "2064": "Código de moneda no válido",
            "2078": "Código de pago Seguro no válido",
            "2080": "credenciales de usuario no válidas",
            "3000": "Red de procesador no disponible - Inténtelo de nuevo",
            "4001": "Liquidación declinada",
            "4006": "La cantidad de captura excedió el límite permitido",
            "81703": "Esta cuenta de comerciante no acepta el tipo de tarjeta de crédito.",
            "81706": "Se requiere CVV",
            "81707": "El CVV debe tener 3 o 4 dígitos.",
            "81709": "Se requiere la fecha de caducidad.",
            "81710": "La fecha de caducidad no es válida.",
            "81714": "Se requiere número de tarjeta de crédito.",
            "81715": "El número de la tarjeta de crédito es inválido.",
            "81716": "El número de la tarjeta de crédito debe tener entre 12 y 19 dígitos.",
            "81717": "El número de tarjeta de crédito no es un número de prueba aceptado.",
            "81718": "El número de tarjeta de crédito no se puede actualizar a un tipo de tarjeta no admitido cuando está asociado a suscripciones.",
            "81723": "El nombre del titular de la tarjeta es demasiado largo.  Máximo 175 caracteres.",
            "81809": "El código postal no puede contener más de 9 caracteres de letras o números",
            "81813": "El código postal solo puede contener letras, números, espacios y guiones",
            "91722": "Se requiere token de método de pago.",
            "91723": "Actualizar token existente no es válido",
            "91730": "La verificación no es compatible con esta cuenta de comerciante.",
            "91734": "Esta cuenta de comerciante no acepta el tipo de tarjeta de crédito.",
            "91738": "El método de pago especificado no es una tarjeta de crédito.",
            "91745": "Parámetros no válidos para la actualización de la tarjeta de crédito.",
            "91826": "Código postal invalido.  El código postal debe ser una cadena de 5 o 9 dígitos, opcionalmente separados por un guión o un espacio.",
            "-1": "Esta cuenta de cliente ha sido desactivada.  Por favor, póngase en contacto con nuestro administrador."
        },
        "reBookingMsg": {
            "303": "¡La hora que ha seleccionado debe ser posterior a la hora actual!",
            "304": "Esta reserva no fue encontrada",
            "500": "Parte de la información de la reserva no es válida o falta.  ¡Por favor revisa e intenta de nuevo!"
        },
        "promoMsg": {
            "304": "El código promocional no es válido",
            "306": "Código de promoción no válido.  Parece que la promo se aplica a otras zonas.",
            "413": "Lo sentimos, este código de promoción no está disponible en este momento",
            "414": "El código promocional no es válido",
            "415": "El código promocional no es válido",
            "416": "Este código de promoción ya se ha utilizado.",
            "419": "Lo sentimos, este código de promoción no está disponible en este momento",
            "420": "Lo sentimos, ya has llegado al límite de usos de este código promocional",
            "421": "Lo sentimos, este código de promoción ha alcanzado su límite de uso publicado",
            "422": "Este código de promoción no se puede utilizar en su cuenta",
            "423": "Lo sentimos, ha alcanzado su presupuesto promocional limitado",
            "424": "Código promocional no válido. Código aplicable a otras zonas",
            "425": "Código de promoción no válido.  Parece que la promo solo se aplica a clientes referidos",
            "426": "Has alcanzado tus usos promocionales limitados por día.",
            "427": "No se puede aplicar el código de promoción.  El perfil de este cliente está incompleto.",
            "428": "Este cliente ha agotado el código de promoción mensual.",
            "430": "Has utilizado todos tus códigos promocionales anuales.",
            "431": "El código promocional no se puede usar con este método de pago.",
            "432": "Este importe de tarifa no es elegible para el código promocional.",
            "433": "El código promocional no es elegible para usar en el horario seleccionado.",
            "434": "Lo siento, has alcanzado tu límite de presupuesto promocional.",
            "phoneInvalid": "Ingrese el número de teléfono del pasajero antes de aplicar el código de promoción"
        },
        "updateBookingMsg": {
            "303": "Error al actualizar la reserva.  ¡Inténtalo de nuevo!",
            "304": "Esta reserva no fue encontrada",
            "pickUpTime": "¡La hora que ha seleccionado debe ser posterior a la hora actual!",
            "pickup": "No hay servicios de reserva disponibles en esta área",
            "destination": "Parte de la información de la reserva no es válida o falta.  ¡Por favor revisa e intenta de nuevo!",
            "dispatchType": "Parte de la información de la reserva no es válida o falta.  ¡Por favor revisa e intenta de nuevo!"
        },
        "sessionExpired": {
            "403": "Se ha cerrado la sesión por haberse iniciado desde otro dispositivo"
        },
        "not_found": {
            "404": "la página solicitad no se ha encontrado"
        },
        "booking": {
            "303": "¡La hora que ha seleccionado debe ser posterior a la hora actual!",
            "304": "Esta reserva no fue encontrada",
            "305": "Reserva cancelada o completada por Booking.com; por favor, rechaza el trabajo para eliminarlo de la cola.",
            "306": "No hay tarifa asignada al tipo de coche seleccionado. Para aplicar una tarifa a cualquier tipo de coche, ve a Configuración > Coche > Tipo de coche.",
            "307": "No se puede actualizar la reserva. Por favor, inténtalo de nuevo más tarde.",
            "407": "La tarifa de tipo no admite ubicación adicional.",
            "500": "Parte de la información de la reserva no es válida o falta.  ¡Por favor revisa e intenta de nuevo!",
            "upgroup_success": "La reserva se ha desagrupado con éxito",
            "Please_Select_driver": "Por favor, selecciona un conductor",
            "assign_driver_vehicle_success": "Conductor/Vehículo ha sido asignado con éxito",
            "assign_driver_success": "Conductor ha sido asignado con éxito",
            "detach_driver_success": "Driver has been detach successfully",
            "detach_vehicle_success": "Vehicle has been detach successfully",
            "Group_success": "La reserva se ha agrupado con éxito",
            "change_supplier_success": "La reserva ha cambiado de proveedor con éxito",
            "change_supplier_partial": "Éxito parcial: La asignación por lotes falló para los siguientes viajes (IDs de reserva) debido a acciones en curso: {0}.",
            "detach_driver_partial": "Éxito parcial: La asignación por lotes falló para los siguientes viajes (IDs de reserva) debido a acciones en curso: {0}.",
            "assign_driver_partial": "Éxito parcial: La asignación por lotes falló para los siguientes viajes (IDs de reserva) debido a acciones en curso: {0}.",
            "update_dispatch": "Actualizar y despachar",
            "remove_booking_false": "Error al eliminar la reserva",
            "remove_booking_success": "La reserva se ha eliminado con éxito",
            "GROUP_NOT_FOUND": "ID de grupo no encontrado",
            "NO_SHARING_BOOKINGS": "Solo puedes agrupar reservas si la reserva del cliente permite compartir viaje.",
            "DIFFERENT_CAR_TYPES": "La reserva que intentas agrupar tiene un tipo de coche diferente",
            "LIMIT_EXCEEDED_ON_SEATS_OR_LUGGAGE": "La reserva no puede agruparse: Límite de asientos o equipaje excedido.",
            "INVALID_CAR_TYPE": "No se puede asignar conductor, verifica la capacidad de asientos y equipaje del vehículo del conductor.",
            "VALIDATION_ERROR": "Error de validación",
            "INTERNAL": "Error interno del servidor",
            "fare_gt_zero": "¡La tarifa debe ser mayor que 0!",
            "edit_total_fail": "¡Error al editar el valor total!",
            "complete_fail": "La reserva no ha podido ser completada",
            "cancle_fail": "Ha ocurrido un error al cancelar la reserva. Por favor inténtelo de nuevo",
            "incident_fail": "Incidente fallido",
            "phone_invalid": "¡Por favor ingrese un número de teléfono válido!",
            "add_psg_fail": "No se puede agregar un nuevo pasajero",
            "REMOVE_RECIPIENT_DELIVERED": "No se puede eliminar al destinatario, ya ha sido entregado",
            "REMOVE_LAST_ACTIVE_RECIPIENT": "No se puede eliminar al último destinatario activo",
            "ORDER_HAS_BEEN_FINISHED": "El pedido ya ha sido finalizado",
            "end_booking_leave": "Si abandona esta página, finalizará su reserva.",
            "update_booking_fail": "Error al actualizar la reserva",
            "EXTERNAL_ID_EXISTED": "El ID externo ya existe en el sistema.",
            "area_service_unavailable": "No hay servicios de reserva disponibles en esta área",
            "pickupSameDestination": "La dirección de recogida debe ser distinta a la dirección de destino.",
            "time_invalid": "¡La hora que ha seleccionado debe ser posterior a la hora actual!",
            "psg_inactivate": "Esta cuenta de cliente ha sido desactivada.  Por favor contacte a nuestro administrador",
            "data_incorect": "Algo salió mal. Por favor, inténtalo de nuevo más tarde.",
            "preAuthorize": "Por favor, revisa tu cuenta, ya que se requiere un monto de {0} para garantizar tu reserva.",
            "booking_limited": "Lo sentimos, has llegado al máximo de reservas por minuto/día. Por favor inténtelo más tarde",
            "minimumBookAhead": "La hora de recogida de la reserva debe ser al menos {0} hora(s) {1} minuto(s) desde la hora actual.",
            "exDoDiffDo": "El destino adicional debe ser diferente del destino.",
            "recurringTimeRange": "Fecha fuera de rango. Solo puedes crear reservas con {0} meses de anticipación. Para cualquier problema, contacta al administrador.",
            "recipientsLimit": "El número máximo de destinatarios es {0}.",
            "maximumBookAhead": "La hora de recogida de la reserva no puede ser posterior a {0} día(s) desde la hora actual.",
            "Please_select_or_add_a_card": "¡Seleccione o agregue una tarjeta!",
            "Unable_to_process_by_fare_zero": "No hemos podido procesar tu petición, por favor modifica el tipo de coche o tipo de reserva e inténtalo de nuevo",
            "Can_not_connect_to_server": "No ha sido posible conectar al servidor",
            "Check_connection_or_contact_system_support": "Por favor revisa tu conexión o contacta con el equipo de soporte",
            "Create_new_booking_success": "Tu reserva se ha creado satisfactoriamente!",
            "Create_new_recurring_booking_success": "Se ha(n) creado nueva(s) reserva(s) con éxito",
            "Update_booking_success": "La reserva se ha actualizado satisfactoriamente",
            "addon_exceeded": "{0} quota exceeded.",
            "addon_exceeded_with_params": "Por favor, recargue su saldo de billetera para continuar usando {0}.",
            "Booking_drop_of_success": "La reserva ha sido finalizada satisfactoriamente",
            "Cancel_booking_success": "La reserva ha sido cancelada satisfactoriamente",
            "Cancel_booking_fails": "¡Esta reserva no se puede cancelar!",
            "adjust_fare_booking_success": "La tarifa se ha ajustado con éxito.",
            "adjust_fare_booking_fail": "Error en el ajuste de tarifa.",
            "Booking_detail_not_found": "No se han encontrado los detalles de la reserva!",
            "Check_promo_error": "Revise el error del código promocional",
            "Invalid_format": "Formato no válido",
            "Flight_not_found": "Vuelo no encontrado!",
            "Add_new_credit_error": "Añadir nuevo descuento",
            "Socket_server_disconnected": "Conector del servidor desconectado",
            "Please_reload_page_or_check_your_connection": "Lo sentimos, su petición no ha podido ser procesada. Por favor inténtelo de nuevo",
            "request_timeout": "Lo siento. Tu solicitud ha excedido el tiempo de espera. Por favor, inténtalo de nuevo.",
            "Check_customer_error": "Revise el error en el cliente",
            "Please_select_car_type": "Por favor seleccione el tipo de vehículo",
            "DropOff_country": "Lo sentimos, ¡el destino solicitado está fuera de nuestra área de servicio!",
            "Different_Country": "Los lugares de recogida y devolución deben estar en 2 países diferentes.",
            "Please_enter_destination_for_ridesharing_booking": "Por favor, introduzca destino para la reserva de viaje compartido",
            "Extra_detination_must_be_difference_from_destination": "El destino adicional debe ser diferente del destino actual",
            "Pickup_address_must_be_different_from_destination": "La dirección de recogida debe ser diferente a la dirección de destino",
            "Best_price": "Mejor precio",
            "You_may_be_charged_extra_fee_if_your_trip_excceds": "Es posible que se le cobre una tarifa adicional si su viaje excede",
            "You_may_be_charged_extra_fee_if_your_trip_excceds_with_params": "Es posible que se le cobre una tarifa adicional si su viaje excede {0} {1}, {2} {3}",
            "Reject_booking_success": "La reserva ha sido rechazada satisfactoriamente",
            "Reject_fail": "Ocurrió un error al rechazar la reserva. Por favor inténtelo de nuevo",
            "Please_select_payment_method": "Por favor seleccione el método de pago",
            "Driver_signed_out_or_deactivated": "Este controlador acaba de cerrar sesión o ha sido desactivado",
            "reservation_booking_overlaps": "Lo sentimos, esta reserva de reserva se superpone con otra que Driver ha aceptado.",
            "driver_is_not_available": "Sorry, this driver isn’t available at the requested time.",
            "seats_luggage_limit": "No se puede asignar la reserva al conductor. El asiento o equipaje excede el límite.",
            "full_capacity": "Esta reserva no puede ser asignada al conductor porque el viaje ha alcanzado su capacidad máxima.",
            "marked_failed_ok": "El pedido ha sido marcado como fallido.",
            "warning_markFail_lastRecipient": "Este es el último destinatario de esta reserva. Si procedes a marcar este pedido como fallido, entonces deberás completar la reserva.",
            "BOOKINGS_LIMIT_EXCEEDED": "Solo puedes asignar un máximo de 5 pedidos en cada grupo.",
            "bookingCanceled": "Reserva cancelada o completada por Booking.com; por favor, rechaza el trabajo para eliminarlo de la cola.",
            "contact_info_required": "Por favor, selecciona un perfil de usuario válido o crea uno nuevo antes de continuar. Alternativamente, puedes crear una reserva de invitado.",
            "UNSUPPORTED_ZONE": "La zona no es compatible",
            "INVALID_GUEST_PHONE_NUMBER": "El número de teléfono del pasajero es inválido",
            "NEGATIVE_FLEET_BALANCE": "Parece que tu saldo es demasiado bajo para crear una nueva reserva. Por favor, añade fondos o salda cualquier pago pendiente para continuar."
        },
        "item_no_found": "No se encontró ningún artículo",
        "commonMessages": {
            "greater_than_0": "Introduzca un valor superior a 0.",
            "Required_field": "Este campo es obligatorio",
            "bankPhone_is_required": "El número de teléfono no es válido",
            "bankPhone": "Número de teléfono",
            "distance_from_equa_or_smaller": "La distancia \\desde\\\" debe ser inferior o igual a la distancia \\\"hacia\\",
            "must_be_number": "Por favor ingrese un número válido",
            "equal_or_greater_than_0": "Introduzca un valor superior o igual a cero",
            "must_be_integer": "Por favor ingrese un número entero",
            "invalid_email_format": "Por favor introduzca un correo electrónico válido.",
            "greater_or_equa": "Introduzca un valor superior o igual a {0}.",
            "value_must_between": "Introduzca un número entre {0} y {1}",
            "large_10x_markup_price": "La tarifa editada no debe superar 10 veces la tarifa estimada.",
            "greater_than": "Introduzca un valor superior a cero",
            "less_than": "Introduzca un valor inferior a {0}.",
            "less_or_equal": "Introduzca un valor inferior o igual a {0}.",
            "driver_earnings_warning": "Pagos fuera de línea: Las ganancias del conductor no deben superar la tarifa recaudada.",
            "limit_amount": "Ingrese un valor menor o igual a la cantidad límite",
            "Integer_from_range": "Ingrese un número entero de {0} - {1}",
            "integer_greater_than_0": "Introduzca un número entero mayor que 0.",
            "Error_message": "¡Error!",
            "callcenter_newbooking_message": "nueva reserva con teléfono",
            "callcenter_existed_booking_message": "existe una reserva activa con teléfono",
            "callcenter_close_newbooking_form_warning": "Cierre o complete su libro actual antes de recibir una nueva solicitud de cliente",
            "Emergency_SOS_Title": "SOS",
            "Please_enter_a_future_date": "Por favor introduzca una fecha futura",
            "Card_holder_is_required": "Titular de la tarjeta requerido",
            "Card_number_is_required": "Número de la tarjeta requerido",
            "Expired_date_is_required": "Fecha de caducidad requerida",
            "Credit_code_is_required": "Por favor ingrese el código de crédito (última validación)",
            "Expired_date_is_invalid": "fecha de caducidad no válida. Introduzca la fecha en formato mm/aa",
            "cvv_is_required": "Se requiere CVV",
            "City_is_required": "Ciudad requerida",
            "State_is_required": "El país es requerido",
            "Address_is_required": "La direección es obligatoria",
            "Zipcode_is_required": "Código postal obligatorio",
            "Country_is_required": "País obligatorio",
            "Over_query_limit": "La aplicación de Google no funciona debido a un error temporal. Pruebe más tarde",
            "outOfInputQueueOrder": "El número de # pedido no puede ser mayor que el número total de conductores en la cola.",
            "Same_pickup_destination": "Pick-up address must be different from destination address.",
            "Max_length": "La longitud máxima es de {0} caracteres.",
            "choose_at_least_one": "Por favor, elige al menos una opción.",
            "choose_at_least_one_intercity_schedule": "Por favor, añade un horario o permite que el cliente solicite su hora preferida.",
            "startDate_greater_than_endDate": "La fecha de inicio es mayor que la fecha de finalización."
        },
        "trip": {
            "cancel_trip_success": "¡Este viaje ha sido cancelado con éxito!",
            "data_incorect": "No se ha asignado conductor. Selecciona un conductor de la lista desplegable. <br/> Si no hay conductores disponibles, selecciona Auto Dispatch para asignar más tarde.",
            "INTERNAL": "Error interno del servidor.",
            "NOT_FOUND": "Viaje no encontrado o estado inválido.",
            "SAME_DRIVER": "El asignado debe ser diferente al conductor actual.",
            "OVERLAP": "Lo siento, este viaje se superpone con otro que ha sido aceptado por este conductor.",
            "CANNOT_ASSIGN": "Este conductor no es válido (es decir, no se ha encontrado, no está en línea o no ha iniciado sesión)."
        },
        "car_mgmt": {
            "Search_car_color": "Buscar color del coche.",
            "Searching": "Buscando."
        },
        "driver_note": {
            "Search_driver_note": "Buscar nota del conductor.",
            "Searching": "Buscando."
        }
    },
    "errors": {
        "303": "usuario no encontrado",
        "453": "Pasarela no compatible",
        "553": "¡Lo siento! El cliente tiene una reserva en curso, por favor intenta nuevamente más tarde.",
        "1007": "El período entre la fecha de inicio y la fecha de finalización debe ser inferior a 60 días.",
        "3001": "El número de teléfono existía",
        "3002": "fecha de nacimiento invalida",
        "3003": "Fecha de caducidad de la licencia de conducir inválida",
        "3004": "Controlador no encontrado",
        "3005": "Información de liquidación del conductor faltante (dirección del banco, ciudad, estado, código postal)",
        "3006": "Falta la información de la cuenta bancaria (nombre de la cuenta, tipo de cuenta, número de ruta, número de cuenta, ssn)",
        "3007": "No puede editar este conductor, que tiene un trabajo.",
        "3008": "Este conductor está iniciando sesión actualmente. Pídele que cierre la sesión para editar su información.",
        "3009": "Este conductor ha aceptado una o más reservas.  Asigne la(s) reserva(s) a otros conductores antes de actualizar/cambiar la información del conductor.",
        "3010": "Falló el envío de conexión.",
        "3011": "Este controlador debe estar configurado para funcionar antes de activarse.",
        "3012": "Este controlador debe estar configurado para funcionar antes de activarse.",
        "3013": "Solo se puede eliminar el elemento en estado inactivo.",
        "3014": "Faltan campos obligatorios.  Por favor, compruebe.",
        "3015": "Año de nacimiento inválido.  Por favor, compruebe.",
        "3016": "Código postal no válido.  Por favor, compruebe.",
        "3017": "Estado/provincia no válido.  Por favor, compruebe.",
        "3018": "Nombre de cuenta no válido.  Por favor, compruebe.",
        "3019": "Número de ruta no válido.  Por favor, compruebe.",
        "3020": "Se requiere cumpleaños.  Por favor, compruebe.",
        "3021": "Número de ssn inválido.  Por favor, compruebe.",
        "3022": "La cuenta bancaria del conductor no puede recibir fondos",
        "3023": "Los controladores registrados no pueden ser operados.  Por favor, inténtelo de nuevo más tarde.",
        "3026": "El controlador ya no existe.",
        "3027": "La cuenta bancaria del conductor no está configurada.  Vaya al módulo de Conductores para configurar su cuenta bancaria.",
        "3028": "No se pudo pagar a los conductores seleccionados.  Inténtalo de nuevo.",
        "3029": "Error al limpiar los datos de ganancias de los conductores, inténtelo de nuevo",
        "3032": "Este nombre de usuario ya existe en nuestro sistema.  Por favor ingrese otro.",
        "3033": "BSB inválido. El número debe tener 6 dígitos en el formato xxxxxx.",
        "3036": "Se requiere Captcha",
        "3037": "Captcha es inválido",
        "3039": "Se requiere el ID de grupo.",
        "3040": "Este número de teléfono ya está en uso por un conductor de %{brandName} (es decir, no se puede duplicar). Por favor, ingresa otro.",
        "3041": "El nombre de usuario ya existe.",
        "3044": "El ID nacional está duplicado.",
        "3045": "El conductor ya tiene un vehículo, por favor, actualiza la página.",
        "3046": "La empresa del vehículo y la empresa del conductor son diferentes.",
        "4001": "Su número de placa ha existido en el sistema.  Por favor ingrese otro.",
        "4002": "fecha de caducidad no válida",
        "4003": "El vehículo debe estar desactivado antes de la eliminación",
        "4004": "vehículo no encontrado",
        "4005": "Este vehículo ya está inactivo",
        "4006": "Este vehículo está en uso y no se puede eliminar ni desactivar",
        "4007": "número de matrícula obligatorio",
        "4009": "El vehículo está siendo asignado a una reserva.",
        "4010": "El vehículo está siendo asignado a un conductor.",
        "5001": "Empresa existente",
        "5004": "Empresa no encontrada",
        "6001": "Modelo de vehiculo existente",
        "6004": "Modelo de vehiculo no encontrado",
        "6005": "modelo de vehículo en uso",
        "7001": "Marca de vehículo ya existe, introduzca otra",
        "7004": "Marca de vehículo no encontrada",
        "8001": "El nombre de la tipología de vehículo ya existe, introduzca otra.",
        "8004": "tipología de vehículo no encontrada",
        "9001": "Ruta prefijada existente",
        "9004": "Ruta prefijada no encontrada",
        "10001": "Zona existente",
        "10004": "Zona no encontrada",
        "11001": "Zona existente",
        "11002": "Esta zona se superpone con otra.  Por favor vuelve a dibujar.",
        "11003": "la zona debe tener forma poligonal",
        "11004": "Zona no encontrada",
        "11005": "La zona está en uso",
        "12001": "Bandeja de entrada existente",
        "12002": "Por favor, configure SMS Twilio",
        "12004": "Bandeja de entrada no encontrada",
        "12005": "No hay destinatarios que coincidan con tus filtros. Por favor, revisa la lista y vuelve a intentarlo.",
        "12006": "No existe ningún cliente en el archivo.",
        "13001": "Este código promocional ya existe en el sistema. Por favor introduzca otro.",
        "13002": "Fecha no válida",
        "13003": "Privado",
        "13004": "código promocional no válido",
        "13005": "Sólo nuevos clientes",
        "13006": "Por encima de cantidad límite",
        "13007": "Por encima de límite presupuestado",
        "13008": "Sobre el límite de uso total",
        "13011": "Esta campaña de promoción ha sido desactivada o eliminada",
        "13012": "el rango de datos no es válido",
        "13013": "Código promocional no válido. Código aplicable a otras zonas",
        "13014": "La zona que ha seleccionado ha sido desactivada.",
        "14004": "Reserva no encontrada",
        "15002": "Su flota ha sido desactivada.  Por favor contacte a nuestro administrador",
        "15004": "Flota no encontrada",
        "16001": "El nombre de la tarifa fija existe en el sistema. Por favor introduzca otro",
        "16004": "Tarifa no encontrada",
        "17001": "Tarifa existente",
        "17004": "Tarifa de paquete no encontrada",
        "18001": "Tarifa existente",
        "18002": "Tarifa existente",
        "18004": "Tarifa no encontrada",
        "19001": "El nombre de su paquete ha existido en el sistema.  Por favor ingrese otro.",
        "19002": "Tarifa existente",
        "19004": "Tarifa no encontrada",
        "20001": "El nombre de usuario ya existe en el sistema. Por favor introduzca uno nuevo",
        "20002": "Su cuenta ha estado inactiva.  Por favor contacte a nuestro administrador",
        "20003": "El nombre de usuario o la contraseña son incorrectos.  Inténtalo de nuevo",
        "20004": "El nombre de usuario no está registrado en el sistema.",
        "20005": "the enlace ha caducado",
        "20006": "la contraseña actual no coincide. Inténtelo de nuevo",
        "20007": "El usuario # ya existe.",
        "20008": "Este correo electrónico ya existe en nuestro sistema. Por favor, ingresa otro.",
        "20012": "El ID de la flota ya existe",
        "21001": "Su nombre de permiso ha existido en el sistema.  Por favor ingrese otro.",
        "21002": "No se puede desactivar este permiso porque actualmente está asignado a los usuarios.",
        "21003": "Rol activo",
        "21004": "Rol no encontrado",
        "22001": "el cliente ya existe",
        "22004": "cliente no encontrado",
        "22005": "formato de archivo no válido",
        "22006": "El número de teléfono existe",
        "24001": "Número de teléfono no válido",
        "25001": "Nombre existente, introduzca otro",
        "25002": "Intervalo de tiempo no válido",
        "25004": "Turno no encontrado",
        "26001": "Nombre existente, introduzca otro",
        "26002": "Este turno se utiliza actualmente en funcionamiento, desasignarlo antes de eliminarlo",
        "26004": "Plantilla de turno no encontrada",
        "27001": "Campaña ya existe",
        "27002": "Campaña está activada",
        "27004": "campaña no encontrada",
        "28001": "Ciudad existente",
        "28002": "La ciudad se está activando",
        "28003": "ciudad está en uso",
        "28004": "ciudad no encontrada",
        "29002": "este teléfono ya existe",
        "30001": "Área de espera no encontrada",
        "30002": "Área de espera en uso",
        "30003": "Su nombre de área de espera ha existido en el sistema.  Por favor ingrese otro",
        "30004": "El área de espera no debe superponerse entre sí",
        "30005": "Las coordenadas del área de espera no son válidas",
        "30006": "Las zonas de recogida no son válidas",
        "31001": "Su ID de empresa ha existido en el sistema.  Por favor ingrese otro.",
        "31002": "Este nombre de usuario ya existe en nuestro sistema.  Por favor ingrese otro.",
        "31003": "Empresa no encontrada",
        "31004": "Usuario corporativo no encontrado.",
        "31005": "Solo se pueden eliminar las empresas que están inactivas.",
        "31006": "Este teléfono ha estado presente en el viajero de corp.  Por favor ingrese otro.",
        "31007": "viajero corporativo no encontrado",
        "31008": "tarjeta no encontrada",
        "31009": "Este teléfono ha existido en el sistema.  Por favor ingrese otro.",
        "31010": "esta empresa ha sido desactivada, contacte con nuestro equipo para más información",
        "31011": "este viajero no puede ser activado por pertenecer a una empresa inactiva",
        "31013": "Ya existe un negocio con este nombre.",
        "31014": "Por favor, asigna una tarifa para al menos un tipo de vehículo.",
        "31015": "Este correo electrónico/teléfono ya está vinculado a otra cuenta.",
        "31016": "Este correo electrónico/teléfono está vinculado a otra cuenta corporativa. Por favor, actualiza el perfil o elimina al usuario de la cuenta existente antes de asignarlo a una nueva.",
        "31017": "Este correo electrónico/teléfono está vacío. Por favor, ingresa un correo electrónico/teléfono válido.",
        "32001": "el nombre del servicio ya existe en el sistema, introduzca otro",
        "32004": "servicio no encontrado",
        "33002": "el rango de fechas no debe solaparse con otras",
        "34001": "El código ya existe",
        "34013": "El rango de fechas no es válido",
        "36001": "El nombre ya existe",
        "39001": "El documento es obligatorio",
        "43001": "La plantilla de penalización ya existe",
        "43002": "La plantilla de penalización no se encontró",
        "44001": "La plantilla de tarifas ya existe",
        "44002": "La plantilla de tarifas no se encontró",
        "44003": "La plantilla de tarifas está asignada a una cuenta corporativa. Por favor, desasígnala antes de eliminarla.",
        "45001": "La política de recargo ya existe",
        "45002": "La política de recargo no se encontró",
        "45003": "El ítem de recargo no se encontró",
        "46001": "El nombre ya existe",
        "46002": "Elemento no encontrado.",
        "47001": "Existía Stop Sales",
        "47002": "Ventas detenidas no encontradas",
        "48003": "La ubicación personalizada no contiene la misma zona.",
        "49003": "Duplicar corporativo en el pago",
        "49004": "Imei existe",
        "50001": "Add-on template existed",
        "50002": "Add-on template not found",
        "50003": "Add-on service existed",
        "50004": "Add-on service not found",
        "71001": "El recargo dinámico ya existe.",
        "71002": "Esta zona se superpone con otra.  Por favor, dibújalo de nuevo.",
        "71003": "El recargo dinámico debe ser un objeto polígono.",
        "71004": "Recargo dinámico no encontrado.",
        "72001": "Existía la tarifa dinámica",
        "72002": "Esta zona se superpone con otra.  Por favor, dibújalo de nuevo.",
        "72003": "La tarifa dinámica debe ser un objeto poligonal",
        "72004": "Tarifa dinámica no encontrada.",
        "74001": "La zona ya existe.",
        "74002": "Esta zona se superpone con otra.  Por favor, dibújalo de nuevo.",
        "74003": "La zona debe ser un objeto poligonal",
        "74004": "Tarifa zona no encontrada",
        "74005": "Tarifa zona no encontrada",
        "80001": "El banner de la aplicación existía.",
        "80002": "No se encontró el banner de la aplicación.",
        "80003": "Solo se puede eliminar el elemento en estado inactivo.",
        "81001": "La carga de archivos está vacía.",
        "81002": "La carga de archivos tiene un tamaño límite.",
        "82002": "Error al configurar Flightaware. Por favor vuelva a intentar más tarde",
        "90001": "La zona interurbana ya existe",
        "90002": "Esta área se superpone con otra. Por favor, dibújala nuevamente.",
        "90003": "La zona interurbana debe ser un objeto poligonal",
        "90004": "Zona interurbana no encontrada",
        "90005": "La zona interurbana está en uso",
        "91001": "La tarifa interurbana ya existe",
        "91002": "La tarifa interurbana está en uso",
        "91003": "Tarifa interurbana no encontrada",
        "92001": "El nombre de la ruta ya existe",
        "92002": "Ruta no encontrada",
        "92003": "Esta ruta ya existe en otra ruta, por favor, verifica y vuelve a intentarlo.",
        "92004": "Hay un viaje activo en esta ruta.",
        "93001": "La nota del conductor ya existe en el sistema. Por favor, introduce otra.",
        "93002": "Las notas del conductor inactivas pueden eliminarse.",
        "93003": "La nota del conductor está en uso.",
        "93004": "Nota del conductor no encontrada.",
        "94001": "El nombre de tu color de coche ya existe en el sistema. Por favor, introduce otro.",
        "94002": "Color de coche no encontrado",
        "400000": "¡El número de teléfono no es válido!",
        "400002": "Ha ocurrido un error de validación.",
        "400003": "permiso denegado",
        "400005": "contenido del fichero no válido",
        "400008": "Por favor, ingrese el nombre de la zona",
        "500000": "Error en sistema",
        "500001": "Por favor, configure SMS Twilio",
        "500002": "No ha sido posible atender la reserva. Por favor inténtelo de nuevo",
        "500004": "Error interno del sistema",
        "600001": "Ubicación no encontrada",
        "600002": "Coordenadas de longitud y latitud existentes en el sistema, introduzca otras",
        "610001": "La categoría existía",
        "610002": "Categoría no encontrada",
        "610003": "La categoría existía en la ubicación de la fiesta",
        "700001": "El tipo está en uso",
        "700002": "Socio no encontrado",
        "700003": "Su nombre de tipo de socio ha existido en el sistema.  Por favor ingrese otro.",
        "800000": "Esta tienda ha sido asignada a otra cuenta de comerciante. Por favor, selecciona otra.",
        "800001": "La cuenta bancaria del comerciante no puede recibir fondos.",
        "800002": "La cuenta bancaria del comerciante no puede recibir fondos.",
        "limitMessage": {
            "upgrade": "Upgrade",
            "cancel": "Cancel",
            "driver": {
                "title": "Driver limit reached",
                "description": "Your current subscription allows up to %{limitation} drivers. To add more drivers, please upgrade to the higher plan."
            },
            "vehicle": {
                "title": "Vehicle limit reached",
                "description": "Your current subscription allows up to %{limitation} vehicles. To add more vehicles, please upgrade to the higher plan."
            },
            "operator": {
                "title": "Operator limit reached",
                "description": "Your current subscription allows up to %{limitation} operators. To add more operators, please upgrade to the higher plan."
            }
        },
        "31016_2": "Mensaje: Este correo electrónico/teléfono ya está vinculado a otra cuenta. Por favor, contacta a tu administrador de cuenta para obtener ayuda.",
        "undefined": "Algo salió mal con nuestro servidor, inténtalo de nuevo.",
        "completeBooking": {
            "113": "No podemos autenticar su método de pago.  Elija otro método de pago y vuelva a intentarlo.",
            "450": "El saldo es insuficiente para pagar. Por favor, selecciona otro método.",
            "451": "El saldo es insuficiente para pagar. Por favor, selecciona otro método.",
            "521": "La billetera no tiene fondos suficientes."
        },
        "upload_file_fail": "Archivo no válido, por favor revisa e inténtalo de nuevo.",
        "upload_photo_fail": "Archivo no válido, por favor revisa e inténtalo de nuevo.",
        "missing_some_field": "Campo no válido, por favor revisa e inténtalo de nuevo.",
        "validAddress": "Por favor, selecciona una dirección válida."
    },
    "statusDisplay": {
        "supplierAccepted": "Proveedor aceptado.",
        "pendingAmmendment": "Enmienda pendiente",
        "supplierAllocated": "Proveedor asignado",
        "delivery_supplierAccepted": "Proveedor aceptado.",
        "completedWithoutService": "Completado sin conductor.",
        "confirmed": "Reserva confirmada",
        "pending": "Pendiente",
        "queue": "despacho",
        "offered": "despacho",
        "booked": "Conductor en camino",
        "engaged": "Pasajero a bordo",
        "droppedOff": "dejado",
        "inReview": "Necesita Revisión",
        "pre": "Pendiente",
        "recurrent": "Recurrente",
        "vacant": "",
        "vacantTime": "",
        "arrived": "Llegado y esperando",
        "completed": "Terminado",
        "canceled": "Cancelado",
        "noShow": "no show",
        "driverNoShow": "No presentación del conductor",
        "action": "Esperando para procesar",
        "incident": "Incidencia",
        "pickupTimeExceeded": "Se acabó el tiempo",
        "canceledByCC": "Cancelado por CC",
        "canceledByPassenger": "Cancelado por el pasajero",
        "canceledByDriver": "Cancelado por el conductor",
        "canceledByPartner": "Cancelado por socio",
        "canceledBymDispatcher": "Cancelado por socio",
        "canceledByCorporateAdmin": "Cancelado por el administrador corporativo",
        "canceledByAPI": "Cancelado por API",
        "canceledByWebBooking": "Cancelado por reserva web",
        "canceledByTimeout": "Cancelado por time out",
        "accepted": "Aceptado",
        "rejected": "Rechazado",
        "canceledByCorpAd": "Cancelado por el administrador corporativo",
        "started": "Iniciado",
        "intransit": "En tránsito",
        "empty": "Vacío",
        "notLive": "Parcial - no en vivo",
        "live": "Parcial - en vivo",
        "full": "Completo",
        "delivering": "Entregando",
        "delivery_booked": "Conductor en camino al remitente",
        "delivery_arrived": "Llegado y esperando al remitente",
        "shopForYou_booked": "Conductor en camino para recoger efectivo",
        "shopForYou_arrived": "Llegado y esperando para recoger efectivo",
        "collecting": "Driver on the way to merchant",
        "confirmed_delivery": "Confirmado",
        "food_booked": "Conductor en camino al comerciante",
        "food_collecting": "Llegado y esperando para recoger el artículo",
        "mart_collecting": "Llegado y esperando para recoger el artículo",
        "otwMerchant": "Conductor en camino al comerciante",
        "arrivedAndWaitingToCollectItem": "Llegado y esperando para recoger el artículo",
        "canceledByAirlineAdmin": "Cancelado por el administrador de la aerolínea",
        "partialCompleted": "Parcialmente completado",
        "failed": "Fallido",
        "allocated": "Asignado"
    },
    "tripTypes": {
        "scheduled": "Viajes programados",
        "requested": "Solicitud de viajes",
        "preferred": "Preferido"
    },
    "login": {
        "Username": "Nombre de usuario",
        "Password": "contraseña",
        "Remember_me": "Recuérdame",
        "Forgot_your_password": "Olvidaste tu contraseña",
        "Login": "Acceso"
    },
    "invoice": {
        "createBtn": "Crear factura",
        "searchPlInvoice": "Buscar cliente, contacto, número de factura",
        "searchPl": "Buscar bookId, nombre del cliente",
        "createInvoice": "Crear factura",
        "invoicePeriod": "Período de factura",
        "invoicePeriodNote": "Puedes seleccionar rangos de fechas de mes a mes.",
        "viewEdit": "Ver/Editar",
        "billingContact": "Contacto de facturación",
        "memo": "Memo",
        "memoMessage": "Dejar mensaje al cliente",
        "dueDate": "Fecha de vencimiento",
        "updateInvoice": "Actualizar factura",
        "chargeCustomer": "Cobrar al cliente",
        "invoiceNumber": "Número de factura",
        "noItem": "Número de artículos",
        "issuedDate": "Fecha de emisión",
        "refId": "Ref #",
        "pickupTime": "Pick Up Time",
        "pickup": "Ubicación de recogida",
        "destination": "Ubicación de entrega",
        "customerName": "Nombre del cliente",
        "totalAmount": "Monto total",
        "amountDue": "Monto adeudado",
        "sendInvoice": "Enviar factura",
        "copyInvoice": "Copiar factura",
        "downloadPDF": "Descargar como PDF",
        "paymentLink": "Enlace de pago",
        "deleteInvoice": "Eliminar factura",
        "onlySave": "Guardar factura",
        "saveSend": "Guardar y enviar factura",
        "sendEmail": "Enviar correo electrónico",
        "addRecipients": "Agregar destinatarios",
        "editInvoice": "Editar factura",
        "check": "Cheque",
        "wire": "Transferencia bancaria",
        "digitalWallet": "Billetera digital",
        "cash": "Efectivo",
        "completedTime": "Hora completada",
        "Status": "Estado",
        "bookingStatus": "Estado de la reserva",
        "chargeBtn": "Cobrar {0}",
        "pastDue": "Vencido",
        "payCompleted": "¡Esta factura ha sido pagada exitosamente!",
        "Delete": "¿Eliminar factura?",
        "Delete_content": "Esta acción eliminará permanentemente esta factura. Si es necesario, puedes crear una nueva para estos pedidos.",
        "viewInvoice": "Ver factura",
        "pending": "Pendiente",
        "paid": "Pagado",
        "CopyLink": "Copiar enlace",
        "partial": "Parcial",
        "corporatePrepaid": "Prepago corporativo"
    },
    "cue": {
        "bookingServiceType": "Tipo de servicio",
        "pointToPoint": "Punto a punto",
        "fromAirport": "Desde el aeropuerto",
        "toAirport": "Hacia el aeropuerto",
        "hourly": "Por hora",
        "roundTrip": "Viaje de ida y vuelta",
        "jobVisibility": "Visibilidad del trabajo",
        "jobPubic": "Público",
        "jobPrivate": "Privado",
        "jobSetPubic": "Establecer como público",
        "jobSetPrivate": "Establecer como privado",
        "supplierAccepted": "Proveedor aceptado",
        "pendingAmmendment": "Enmienda pendiente",
        "supplierAllocated": "Proveedor asignado",
        "creationTime": "Hora de creación",
        "Pax": "Número de pasajeros",
        "Luggage": "Equipaje",
        "allocated": "Asignado",
        "completedWithoutService": "Completado sin conductor",
        "shuttle": "Transporte compartido",
        "farmIn": "Farm In",
        "chargeCode": "Código de cobro",
        "clientCaseMatter": "Descripción del viaje",
        "operatorNote": "Notas internas",
        "farmOut": "Subcontratar",
        "roaming": "Roaming",
        "FlightUpdate": "Actualización de vuelo",
        "networkType": "Tipo de red",
        "InHouse": "Interno",
        "External": "Externo",
        "carHailing": "Solicitud de transporte",
        "uploadBookings": "Cargar reservas",
        "moreActions": "Más acciones",
        "rideSharing": "trayecto compartido",
        "Rearrange": "Reorganizar",
        "GroupId": "ID de grupo #",
        "Active": "Activo",
        "Finished": "Terminado",
        "Home_affiliate": "Inicio / Afiliado",
        "Booking_type": "Tipo de reserva",
        "From": "Desde",
        "balanceWallet": "{0}: {1} restante",
        "partialWallet": "Pago parcial con billetera",
        "To": "A",
        "Status": "Estado",
        "Migration_Status": "Estado de migración",
        "Migrated": "migrado",
        "Select_Status": "Seleccionar Estatus",
        "Operator": "Operador",
        "Car_types": "Tipos de vehículos",
        "Service_class": "Clase de servicio",
        "Booking_from": "reserva desde",
        "All": "Todos",
        "Pending": "Pendiente",
        "Dispatching": "despacho",
        "Waiting_for_process": "Esperando para procesar",
        "Confirmed_reservation": "Reserva confirmada",
        "Driver_on_the_way": "Conductor en camino",
        "Arrived_and_waiting": "Llegado y esperando",
        "Passenger_on_board": "Pasajero a bordo",
        "Dropped_off": "dejado",
        "combobox_select": "Seleccione...",
        "Search_here": "Busca aquí",
        "Bookingid": "Reserva #",
        "Pickup_Drop_Off": "Recoger dejar",
        "Pickup_Drop_Off_Crew": "Hora de recogida/entrega",
        "Pickup_Drop_Off_Local_Time": "Tiempo de operador",
        "Pickup_Location_Destination": "Lugar de recogida/ Destino",
        "Passenger": "Pasajero",
        "Intercity_Route": "Ruta interurbana",
        "Airport_Pickup": "Recogida en el aeropuerto",
        "Airport_Pickup_Crew": "Aeropuerto",
        "Flight_Status": "Estado",
        "Payment": "Pago",
        "Vehicle": "Vehículo",
        "Car_type": "Tipo de carro",
        "Driver": "Conductor",
        "Estimated_Fare": "Tarifa estimada",
        "Notes": "notas",
        "Note": "Nota",
        "Type": "Tipo",
        "Home": "Casa",
        "Affiliate": "Afiliado",
        "now": "Ahora",
        "reservation": "Reserva",
        "recurring": "Recurrente (Transporte)",
        "No_show": "no show",
        "Canceled_by_CC": "Cancelado por CC",
        "Canceled_by_passenger": "Cancelado por el pasajero",
        "Canceled_by_partner": "Cancelado por socio",
        "Canceled_by_mDispatcher": "Cancelado por socio",
        "Canceled_by_Corporate_Admin": "Cancelado por el administrador corporativo",
        "Canceled_by_API": "Cancelado por API",
        "canceled_By_Web_Booking": "Cancelado por reserva web",
        "canceled_By_Time_Out": "Cancelado por time out",
        "Canceled": "Cancelado",
        "Completed": "Terminado",
        "Incident": "Incidencia",
        "Payment_Method": "Método de pago",
        "No_Phone": "Sin teléfono",
        "VIP": "VIP",
        "Non_VIP": "no VIP",
        "Passenger_type": "Tipo de pasajero",
        "Error_load_booking": "no se ha podido cargar la reserva, inténtelo de nuevo o actualice la página!",
        "Edit_total_success": "¡Total editado con éxito!",
        "Edit_total_fail": "Error al editar el total",
        "Time_out": "Se acabó el tiempo",
        "Ride_Service": "Servicio de viaje",
        "Regulation": "Regulación",
        "Ride_Sharing": "trayecto compartido",
        "Unmatching": "cancelando asignación",
        "Matching": "asignando",
        "all": "Todos",
        "matching": "asignando",
        "unmatching": "cancelando asignación",
        "regulation": "Regulación",
        "Support_service": "servicio de soporte",
        "SOS": "llamada de socorro",
        "Non_SOS": "non-SOS",
        "Corporate": "Clientes empresas",
        "Individual": "Individual",
        "On_curb": "en la acera",
        "Meet_Greet": "Conocer y saludar",
        "Close": "Cerca",
        "auto_refrest_cue": "Auto-actualización ({0} segundos)",
        "Ride_type": "Tipo de trayecto",
        "Edit_total_note": "Notas: subtotal, cargo por tecnología, cargos por reserva, impuestos y propinas serán actualizados cuando se cargue el total del trayecto",
        "Booking": "Reserva",
        "Edit_fare": "editar la tarifa",
        "Adjust_price": "Ajustar precio",
        "Total": "Total editado satisfactoriamente",
        "Reason": "Motivo",
        "Please_enter_reason": "Introduzca el motivo",
        "Save": "Guardar",
        "Cancel": "Cancelar",
        "dmc": "tablón de reservas",
        "corp": "Panel de reservas (CTM)",
        "Zone": "zona de recogida",
        "dropOffZone": "Zona de entrega",
        "mDispatcher": "Colaborador",
        "streetSharing": "Compartición de calles",
        "Driver_No_Job_found": "Esperando asignaciones...",
        "expandFilter": "mostrar filtros",
        "collapseFilter": "ocultar filtros",
        "clearSelectedItems": "Borrar datos seleccionados",
        "Accepted": "Aceptado",
        "Yes": "Sí",
        "No": "No",
        "Order_accepted": "Pedido aceptado",
        "Confirmed": "Confirmado",
        "spotTime": "Tiempo de ubicación",
        "ETA": "Hora estimada de llegada",
        "spareTime": "Tiempo adicional",
        "expectedTime": "Hora estimada de recogida",
        "Driver_on_the_way_to_sender": "Conductor en camino al remitente",
        "Driver_on_the_way_to_recipient": "Conductor en camino al destinatario",
        "Driver_on_the_way_to_collect_cash": "Conductor en camino para recoger efectivo",
        "Driver_on_the_way_to_collect_goods": "Conductor en camino para recoger mercancía",
        "Arrived_waiting_for_sender": "Llegado y esperando al remitente",
        "Arrived_waiting_for_recipient": "Llegado y esperando al destinatario",
        "Arrived_waiting_to_collect_cash": "Llegado y esperando para recoger efectivo",
        "Arrived_waiting_to_deliver_goods": "Llegado y esperando para entregar mercancía",
        "Delivered": "Entregando",
        "delivery": "Entrega",
        "Service": "Servicio",
        "intercity": "Interurbano",
        "Transport": "Transporte",
        "About_Sender": "Sobre el remitente",
        "About_Merchant": "Sobre el comerciante",
        "About_Recipient": "Sobre el destinatario",
        "photos": "Fotos",
        "listOfItems": "Lista de artículos",
        "cashOnPickUp": "COP",
        "Package_information": "Información del paquete",
        "otwMerchant": "Conductor en camino al comerciante",
        "arrivedAndWaitingToCollectItem": "Llegado y esperando para recoger el artículo",
        "Save_Filter": "Guardar Filtro",
        "add_favorite_filter": "Agregar filtro",
        "favorite_filter_name": "Nombre",
        "list_favorite_filter": "Administrar Filtros",
        "favorite_filter_actions": "Acción",
        "clear_all_filters": "Limpiar todos los filtros",
        "Delete_Filter": "Eliminar filtro",
        "CONFIRM_DELETE_FILTER_TEMPLATE": "¿Estás seguro de que quieres eliminar este filtro?",
        "batchDelivery": "Entrega por lotes",
        "editFare": {
            "creditTransactionFee": "Tarifas de tarjeta de crédito",
            "preferredAdjustment": "Ajuste preferido",
            "editFareFee": "Editar tarifa y cargos",
            "markupPrice": "Precio de margen",
            "quotedPrice": "Precio cotizado",
            "basicFare": "Tarifa básica",
            "preferredEarning": "Ganancia preferida",
            "difference": "Diferencia",
            "rushHourFee": "Recargo",
            "serviceFee": "Servicio adicional",
            "otherFees": "Otros cargos",
            "subTotal": "Subtotal",
            "airportFee": "Tarifa de aeropuerto",
            "meetDriverFee": "Conocer al conductor",
            "deliveryFee": "Tarifa de entrega",
            "tollFee": "Tarifa de peaje",
            "parkingFee": "Tarifa de estacionamiento",
            "gasFee": "Tarifa de combustible",
            "techFee": "Tarifa tecnológica",
            "tip": "Propina",
            "bookingFee": "Tarifa de reserva",
            "tax": "Impuesto",
            "promoAmount": "Monto promocional",
            "etaFare": "Total",
            "fleetService": "Servicio de flota",
            "Note_serviceFee": "(para editar servicios adicionales, visita la lista externa)",
            "startingFee": "Comenzando",
            "moveFeeInJourney": "En movimiento",
            "waitFeeInJourney": "Esperando (en viaje)",
            "total": "Total",
            "totalPayout": "Pago",
            "updatedTotal": "Total actualizado",
            "updatedPayout": "Pago actualizado",
            "profit": "Ganancia",
            "extraWaitFee": "Tarifa inicial de espera",
            "heavyTraffic": "Tráfico pesado",
            totalWithoutPromo: 'Total before promo',
        },
        "partialCompleted": "Parcialmente completado",
        "failed": "Fallido",
        "Recurring": "Recurrente #",
        "DragAndDrop": "Arrastrar y soltar para reordenar columnas.",
        "bookingCom": "Booking.com",
        "syncingCompleted": "Sincronización completada",
        "groupManifest": "Manifiesto de grupo",
        "assignSuppliers": "Asignar proveedores",
        "viewActions": "Ver acciones",
        "holidaytaxis": "HolidayTaxis",
        "karhoo": "Karhoo",
        "klook": "Klook",
        "transferZ": "TransferZ",
        "pickupTime": "Pick-up time",
        "AssignSupplier": "Asignar proveedor",
        "sharedTransfer": "Transferencia compartida (%{id})",
        "batchDeliveryGroup": "Entrega por lotes (%{id})",
        "foundersFund": "Fondo de Fundadores",
        "zeroCommission": "Comisión cero",
        "unassignDriver": "Desasignar conductor",
        "notUnassignDriver": "No se puede desasignar conductor, por favor intenta de nuevo",
        "notAssignDriver": "No se puede asignar conductor, por favor intenta de nuevo",
        "selectDriver": "Seleccionar conductor",
        "unassignVehicle": "Desasignar vehículo",
        "unassignAll": "Desasignar todo",
        "notUnassignAll": "No se puede desasignar todo, por favor intenta de nuevo",
        "unassignAllSuccess": "El vehículo y el conductor se han desvinculado exitosamente.",
        "unassign_all_partial": "Éxito parcial: la desasignación por lotes falló para los siguientes viajes (IDs de reserva) debido a acciones en curso: {0}.",
        "notUnassignVehicle": "No se puede desasignar vehículo, por favor intenta de nuevo",
        "notAssignVehicle": "No se puede asignar vehículo, por favor intenta de nuevo",
        "selectVehicle": "Seleccionar vehículo",
        "confirmUnassign": "¿Estás seguro de que quieres desasignar?",
        "printMeetingBoard": "Imprimir Tablero de Reuniones",
        "needReview": "Necesita Revisión"
    },
    "trip": {
        "Driver_vehicle": "Vehículo del conductor",
        "tripId": "Viaje #",
        "tripTypes": "Tipos de viaje",
        "Start_Time": "Hora de inicio",
        "Seats_Status": "Estado de los asientos",
        "No_Of_Booking": "Número de reservas",
        "Vehicle": "Vehículo del conductor",
        "Estimated_Fare": "Tarifa",
        "capacityStatus": "Estado del asiento",
        "Trip_Types": "Tipos de viaje",
        "scheduled": "Viajes programados",
        "requested": "Solicitud de viajes",
        "preferred": "Preferido",
        "All": "Todo",
        "Confirmed": "Confirmado",
        "Started": "Comenzado",
        "In_Transit": "En tránsito",
        "Empty": "Vacío",
        "Partial_not_live": "Parcial - no en vivo",
        "Partial_live": "Parcial - en vivo",
        "Full": "Completo",
        "Error_load_trip": "No se puede cargar el viaje, por favor intenta de nuevo o actualiza la página."
    },
    "tripDetails": {
        "Trip_ID": "Viaje interurbano",
        "DRIVER_JOB": "Información del conductor",
        "BOOKINGS": "Reservaciones",
        "updateTrip": "Actualizar viaje",
        "cancelTrip": "Cancelar viaje",
        "note_cancel": "Por favor, asigna todas las reservas a otro conductor antes de cancelar este viaje.",
        "TRIP_INFORMATION": "Información del viaje",
        "route": "Ruta",
        "startTime": "Start Time",
        "distance": "Distancia",
        "duration": "Duración",
        "fare": "Tarifa",
        "cartype": "Tipo de vehículo interurbano",
        "seatStatus": "Estado del asiento",
        "started": "Comenzado",
        "intransit": "En tránsito",
        "empty": "Vacío",
        "notLive": "Parcial - no en vivo",
        "live": "Parcial - en vivo",
        "full": "Completo",
        "noOfBooking": "Número de reservas",
        "luggage": "Equipaje",
        "nameDriver": "Nombre",
        "vehicleType": "Vehículo",
        "assignDriver": "Asignar conductor",
        "pickUpAddress": "Levantar",
        "destinationAddress": "Dejar",
        "customerName": "Nombre",
        "customerPhone": "Teléfono",
        "customerNumber": "Asientos",
        "customerLuggageNumber": "Equipaje",
        "additionalService": "Servicios adicionales",
        "paymentBooking": "Pago",
        "note": "Nota",
        "CONFIRM_UPDATE": "confirmar actualización",
        "CONFIRM_UPDATE_MESSAGE": "¿Seguro que quieres actualizar este viaje?",
        "Yes": "sí",
        "No": "No",
        "Update_info": "Sí, Actualizar información"
    },
    "newbooking": {
        "Addon_driver_capability": "This assignment does not fully meet the customer’s service requirements. Missing Requirements ({0})",
        "Search_Vehicle": "Buscar vehículo",
        "rideSharing_multi_point": "Solo se permite un punto de recogida y un punto de entrega para reservas de viaje compartido.",
        "Pick_up_time": "Pick up time",
        "Drop_off_time": "Hora de entrega",
        "All_Suppliers": "Todos los proveedores",
        "Recipient": "Destinatario",
        "All": "Todos",
        "New_Booking": "Nueva reserva",
        "GoogleMapRoute": "Google Map",
        "BOOKING_INFORMATION": "Información de reserva",
        "TIP_PROMO": "Sugerencia - Promoción",
        "Pick_up": "Levantar",
        "instructions": "Instrucciones",
        "instructions_placeholder": "Enumere sus instrucciones aquí...",
        "Enter_a_location": "Introduce una ubicación",
        "Enter_a_location_delivery": "Introduce una ubicación",
        "Enter_3rd_party_location": "Introduce la ubicación de un tercero",
        "Enter_a_sender": "Introduce un remitente",
        "Enter_a_recipient": "Ingrese un Destinatario",
        "Vehicle_Selection": "Selección de vehículo",
        "Destination": "Destino",
        "Pickup_time": "Hora de recogida",
        "Note": "Notas",
        "note_for_driver": "Notas al conductor",
        "affiliate_note": "Nota para afiliado",
        "affiliate_note_placeholder": "Ingresar notas de afiliado para operadores",
        "operator_note": "Ingresar notas internas para operadores",
        "TRAVELER_INFORMATION": "Información del viajero",
        "Traveler_type": "tipo de viajero",
        "Individual": "Individual",
        "Corporation": "Corporación",
        "Phone_number": "Número de teléfono",
        "First_name": "Nombre de pila",
        "Last_name": "Apellido",
        "Email_address": "Dirección de correo electrónico",
        "Corp_id": "ID de corporación",
        "Manager_name": "El nombre del gerente",
        "Manager_email": "correo electrónico del gerente",
        "Cost_centre": "centro de costo",
        "Department": "Departamento",
        "Corp_division": "división de corporaciones",
        "Tip": "Propina",
        "Promo_code": "Código promocional",
        "Apply": "Solicitar",
        "Promo": "Promoción",
        "DISPATCH": "Asignar",
        "Auto_dispatch": "Despacho automático",
        "Assign_driver": "Asignar conductor",
        "FarmOut": "Externalización",
        "Driver": "Conductor",
        "Driver_Supplier": "Proveedor/Conductor",
        "PAYMENT_METHOD": "Método de pago",
        "OPERATOR_NOTE": "Notas internas",
        "TRIP_ESTIMATE": "Estimación de viaje",
        "Choose_a_stored_card": "Elegir una tarjeta guardada",
        "Choose_a_payment_method": "Elegir un método de pago",
        "Use_new_card": "Usar tarjeta nueva",
        "Card_holder": "titular de la tarjeta",
        "Card_number": "Número de tarjeta",
        "Expired_date": "Fecha de caducidad (mm/aa)",
        "ccv": "CVV",
        "Distance": "Distancia",
        "Duration": "Duración",
        "Fare": "Tarifa",
        "Route": "Ruta",
        "Create": "Crear",
        "Cancel": "Cancelar",
        "Meet_driver": "Conozca al conductor",
        "Airline": "Aerolínea",
        "Flight": "Vuelo #",
        "FLY_INFO": "Informacion de vuelo",
        "Ride_Sharing": "Compartir viaje",
        "Round_trip": "Viaje ida y vuelta",
        "Car_type": "Tipo de carro",
        "Address": "Habla a",
        "City": "Ciudad",
        "State": "Expresar",
        "Zip_code": "Código postal",
        "Remove": "Eliminar",
        "Client_case_matter": "asunto del caso del cliente",
        "Charge_code": "Código de carga",
        "CANCEL_BOOKING": "Cerrar Reserva Confirmar",
        "CANCEL_BOOKING_CONFIRM": "¿Quieres salir de este formulario?  Perderá todos los datos de la reserva.",
        "Search_here": "Busca aquí",
        "No_support_location": "Desafortunadamente, el servicio no está disponible en esta área.",
        "Closest_driver_message": "El conductor más cercano está aproximadamente a {0} de distancia",
        "No_cars_available": "No hay auto disponible dentro del radio de despacho.",
        "processed_by_affiliate": "Sus solicitudes serán procesadas por nuestros socios afiliados",
        "FlightExample": "Número de vuelo, por ejemplo, AA1097",
        "Yes": "sí",
        "No": "No",
        "dispatch_3rd": "Asignado a un tercero",
        "Company": "Empresa",
        "Card_required": "¡Seleccione o agregue una tarjeta!",
        "Tip_value": "No aplica",
        "Calendar": "Calendario",
        "Extra_Destination": "destino adicional",
        "Driver_credit_limited_balance_warning": "El saldo del conductor es menor o igual que la cantidad limitada",
        "Meet_Greet_option": "Conocer y saludar",
        "On_Curb_option": "en la acera",
        "Extra_Services": "Servicios adicionales",
        "Addl_Services": "Servicios adicionales",
        "Save": "Ahorrar",
        "Regular": "Regular",
        "Please_fill_in_all_the_required_fields": "Por favor complete los campos requeridos",
        "Route_names_not_dup": "Los nombres de las rutas no deben estar duplicados.",
        "Please_select_weekdays": "Por favor, selecciona los días en los que deseas que ocurra esta reserva",
        "Flat_rate": "Tarifa fija",
        "All_company": "toda la compañía",
        "Best_price": "Mejor precio",
        "PromoTitle": "Promoción",
        "Show_more": "Mostrar más",
        "Warning_pending_payment": "Este cliente tiene un pago incompleto de reservas anteriores: %{fare}",
        "Warning_outstanding_balance": "El saldo pendiente se aplicará al final del viaje.",
        "Not_available": "No disponible",
        "Warning_assigned_rate": "Asignar tarifa al tipo de coche elegido para continuar",
        "PaxLuggageNumber": "Número de pasajero/equipaje",
        "paxNumber": "Pasajero",
        "luggageNumber": "Equipaje",
        "Date": "Fecha",
        "Single": "Único",
        "Recurring": "Periódico",
        "Date_range": "Date Range",
        "WeekDays": "Repetir en días",
        "Create_Route": "Crear ruta",
        "Pickup_Point": "Levantar",
        "Drag_To_Render": "Arrastrar y soltar para reordenar",
        "DropOff_Point": "Puntos de entrega",
        "Sender": "Remitente",
        "Recipients": "Destinatarios",
        "Sender_Infomation": "Información del remitente",
        "Recipient_Infomation": "Información del destinatario",
        "Recipient_Name": "Nombre del destinatario *",
        "Recipient_Phone": "Número de teléfono *",
        "Room_floor_block": "Habitación, piso y bloque (opcional)",
        "Details": "Detalles",
        "Package_Content": "Contenido del paquete *",
        "Order_ID": "Pedido # (ej. número de pedido de Shopify)",
        "Instructions_for_driver": "Instrucciones para el conductor",
        "Cost_of_Goods": "Pago contra entrega (COD)",
        "Enter_amount": "Introducir monto",
        "Additional_Information": "Información adicional",
        "Insurance": "Seguro",
        "Special_Care": "Cuidado especial",
        "Delivery_Fee": "Tarifa de entrega",
        "Item_fees": "Tarifas de artículos",
        "Tech_Fee": "Tarifa tecnológica",
        "Tax": "Impuesto",
        "driverNotes": "Notas del conductor",
        "rejectModal": "Rechazar reserva",
        "rejectModalBody": "¿Estás seguro de que quieres rechazar esta reserva?",
        "rejectButton": "Rechazar reserva",
        "acceptModal": "Aceptar reserva",
        "acceptModalBody": "¿Estás seguro de que quieres aceptar esta reserva?",
        "ConfirmedTo": "Confirmado a ({0})",
        "proceedAction": "¿Estás seguro de que quieres proceder con esta acción?",
        "acceptButton": "Aceptar reserva",
        "denyModal": "Denegar reserva",
        "denyModalBody": "¿Estás seguro de que quieres denegar esta reserva?",
        "denyButton": "Denegar reserva",
        "Accept_booking_success": "¡Esta reserva ha sido aceptada exitosamente!",
        "Deny_booking_success": "¡Esta reserva ha sido denegada exitosamente!",
        "adjustFare": "Ajustar tarifa",
        "totalFare": "Tarifa total",
        "Profit": "Ganancia",
        "DriverEarning": "Ganancia del conductor",
        "Payout": "Pago",
        "totalPayout": "Pago total",
        "DriverPayOut": "Driver Payout",
        "confirmReject": "Confirmar rechazo",
        "confirmCancelMSG": "¿Estás seguro de que quieres rechazar esta reserva? Puedes incurrir en una penalización por parte de tu proveedor.",
        "reasonCancel3rd": "Motivo del rechazo",
        "welcome_psg": "Bienvenido pasajero",
        "AmountDue": "Monto adeudado",
        "Fleet_Company": "Flota",
        "Search_driver_hydra": "Intentaremos encontrar un conductor para ti pronto.",
        "ExternalID": "ID externo",
        "viewRate": "Ver tarifa",
        "PointToPoint": "Punto a punto",
        "Offer_driver": "Ofrecer conductor",
        "Assign_driver_vehicle": "Asignar conductor/vehículo",
        "notify_via_email": "Notificar al cliente por correo electrónico",
        "fleetFare": "Tarifa de Flota",
        "onlySave": "Guardar",
        "saveCharge": "Guardar y Cargar",
        "saveRefund": "Guardar y Reembolsar",
        "lateCancelConfirm": "¿Estás seguro de que quieres completar esta reserva como",
        "canceledDriverConfirm": "¿Está seguro de que desea cancelar esta reserva para el conductor? Se aplicará una tarifa de penalización.",
        "canceledDriverNoChargeConfirm": "¿Está seguro de que desea cancelar esta reserva para el conductor?",
        "canceledCustomerNoChargeConfirm": "¿Estás seguro de que quieres marcar a este cliente como un",
        "noshowDriverConfirmCharge": "¿Está seguro de que desea marcar al conductor como ausente? Se puede aplicar una tarifa de penalización.",
        "noshowDriverConfirmNoCharge": "Are you should you want to mark this customer as a no show?",
        "NoShowConfirm": "Se aplicará la política de no presentación.",
        "completeConfirm": "¿Estás seguro de que quieres Completar sin conductor?",
        "completeChargeConfirm": "Se aplicará el cargo completo al cliente. El conductor no recibirá ninguna comisión por esta reserva.",
        "PricingPlan": "Plan de precios",
        "editFerviceFees": "para editar las tarifas de servicio, visita la lista externa",
        "ungroupAll": "Desagrupar todo",
        "satisfaction": "satisfacción",
        "Reassign": "Reasignar",
        "addNote": "Agregar nota",
        "noteMagicSend": "Subject",
        "items": "Elementos",
        "PaidAmount": "Cantidad Pagada",
        "ExternalPartner": "Socio Externo",
        "ExternalPartnerNote": "Socios independientes que gestionan sus propios conductores y vehículos. Los pagos se manejan directamente con el proveedor.",
        "InHousePartner": "Socio interno",
        "InHousePartnerNote": "Gestionado directamente por tu flota. Los pagos se realizan directamente a los conductores.",
        "Role": "Rol",
        "Client": "Cliente",
        "ApplyCancellation": "Aplicar política de cancelación",
        "unassigned": "no asignado",
        "bookingSelected": "reserva seleccionada",
        "Update": "Actualizar",
        "emailInvoice": "Factura por correo electrónico",
        "Receipt": "Recibo",
        "addItem": "Añadir artículo",
        "newCustomer": "Agregar Nuevo Cliente",
        "forGuest": "Reservar para el huésped",
        "invalid_some_field": "Campo inválido, por favor verifica y vuelve a intentarlo.",
        "ExpandCorp": "Expandir detalles de la empresa",
        "hideCorp": "Ocultar detalles de la empresa",
        "searchCusPlaceholder": "Buscar por nombre de contacto, teléfono, correo electrónico",
        "CorporationGuest": "Corporación - Invitado",
        "IndividualGuest": "Individual - Huésped",
        "passInfo": "Información del Pasajero",
        "noAdjustmentPickupTime": "No hay ajustes en la hora de recogida",
        "whenFlightArrives": "Cuando llegue el vuelo",
        "minAfterArrival": "{0} min después de la llegada del vuelo",
        "pickupInstructions": "Instrucciones de recogida",
        "selectMeetingPoint": "Seleccionar Punto de Recogida",
        "durationTrip": "Duración (Horas)"
    },
    "bookingDetailLogs": {
        "recipient": "Destinatario",
        "updatedInfo": "Información actualizada",
        "updatedField": "Campo actualizado",
        "valueBefore": "Valor anterior",
        "valueAfter": "Valor después",
        "location": "Ubicación",
        "etaFare": "Tarifa",
        "dispatchType": "Despacho",
        "drvInfo": "Conductor",
        "meetingPoint": "Punto de Encuentro",
        "vehicleTypeRequest": "Solicitud de vehículo",
        "clientCaseMatter": "Descripción del viaje",
        "chargeCode": "Código del viaje",
        "driverEarningType": "Tipo de ganancia del conductor",
        "editedDriverEarning": "Ganancia del conductor",
        "reasonEditFare": "Motivo",
        "bookingReference": "ID externo",
        "tip": "Propina",
        "type": "Tipo de servicio",
        "promo": "Promoción",
        "dispatch3rd": "Despacho de terceros",
        "rideSharing": "Viaje compartido",
        "notes": "Notas del conductor",
        "operatorNote": "Notas internas",
        "welcomeMessage": "Mensaje de bienvenida",
        "flightNumber": "Número de vuelo",
        "fullName": "Nombre completo",
        "email": "Correo electrónico",
        "cardMask": "Máscara de tarjeta",
        "paymentType": "Método de pago",
        "recipients": "Destinatarios",
        "sender": "Remitente",
        "pickupName": "Nombre de recogida",
        "pickupPhone": "Teléfono de recogida",
        "pickupEmail": "Correo electrónico de recogida",
        "supplierEarningType": "Tipo de pago",
        "editedSupplierEarning": "Valor de pago",
        "route": "Nombre de ruta",
        "markupDifference": "Diferencia de margen",
        "selectedDates": "Fechas seleccionadas",
        "services": "Servicios de flota",
        "destinationAddress": "Ubicación de destino",
        "pickupAddress": "Ubicación de recogida",
        "tripType": "Tipo de viaje",
        "pickUpTime": "Hora de recogida",
        "paxNumber": "Pasajero",
        "luggageNumber": "Equipaje",
        "vehicle": "Vehículo",
        "minutesToArrive": "Hora estimada de llegada del conductor",
        "affiliateNote": "Nota de afiliado",
        "packageRateName": "Nombre del paquete",
        "supplierCompanies": "Empresa",
        "puPoints": "Ubicación de recogida",
        "doPoints": "Ubicación de destino",
        "promoValue": "Valor promocional",
        "packageInfo": "Información del paquete",
        "orderId": "ID de pedido",
        "cashOnDelivery": "Pago contra entrega",
        "externalId": "ID externo",
        "recurring": "Recurrente",
        "batchDelivery": "Entrega por lotes",
        "payout": "Pago",
        "locationDetails": "Detalles de ubicación",
        "name": "Nombre",
        "phone": "Teléfono",
        "address": "Dirección",
        "basicFare": "Tarifa básica",
        "airportFee": "Tarifa de aeropuerto",
        "bookingFee": "Tarifa de reserva",
        "creditTransactionFee": "Tarifas de tarjeta de crédito",
        "fleetService": "Servicio de flota",
        "fleetServices": "Servicios de flota",
        "gasFee": "Tarifa de combustible",
        "meetDriverFee": "Tarifa de encuentro con el conductor",
        "moveFeeInJourney": "Tarifa de traslado",
        "otherFees": "Otros cargos",
        "parkingFee": "Tarifa de estacionamiento",
        "promoAmount": "Monto promocional",
        "rushHourFee": "Tarifa de hora pico",
        "serviceFee": "Tarifa de servicio",
        "startingFee": "Tarifa de inicio",
        "subTotal": "Subtotal",
        "tax": "Impuesto",
        "techFee": "Tarifa tecnológica",
        "tollFee": "Tarifa de peaje",
        "waitFeeInJourney": "Tarifa de espera (en viaje)",
        "psgPhone": "Teléfono del pasajero",
        "totalAddonFee": "Addon fee",
        "addonServices": "Addon services"
    },
    "bookingdetail": {
        "RefreshFare": "Actualizar tarifa",
        "noShowAction": "Acción de No Presentación",
        "noShowClose": "Aplicar No-show y Cerrar Reserva",
        "noShowNotClose": "Aplicar No-show y Desasignar",
        "cancelAction": "Cancelar acción",
        "cancelClose": "Aplicar Cancelar y Cerrar Reserva",
        "cancelNotClose": "Aplicar Cancelar y Desasignar",
        "settings": "Configuración",
        "updateSuccessJobVisibilitySingle": "Visibilidad actualizada exitosamente",
        "updateSuccessJobVisibilityMulti": "%{number} reservas han sido actualizadas exitosamente",
        "failApi": "¡Algo salió mal!",
        "settingsTooltip": "Conductor ya asignado o el viaje está en curso.",
        "shareJobPublicly": "Compartir trabajo públicamente",
        "groupOder": "Pedido grupal",
        "ExistingGroup": "Grupo existente",
        "NewGroup": "Nuevo grupo",
        "Search_trip": "Buscar viaje #",
        "All": "Todos",
        "creditTransactionFee": "Tarifas de tarjeta de crédito",
        "partial_payment": "Pago parcial",
        "Write_off_debt": "Cancelar deuda",
        "Booking_detail": "Reserva",
        "Order_detail": "Pedido",
        "Completed_Booking": "Reserva completada",
        "Late_Cancel_Passenger": "Cancelación tardía por parte del pasajero",
        "Late_Cancel_Driver": "Cancelación tardía por parte del conductor",
        "No_Show_Passenger": "No presentación del pasajero",
        "No_Show_Driver": "Conductor no se presenta",
        "Late_Cancel": "Cancelación tardía",
        "Cancel_Driver": "Cancelación por el conductor",
        "No_Show": "No presentación",
        "Without_driver": "Completado sin conductor",
        "Complete_driver": "Completado con conductor",
        "BOOKING_INFORMATION": "Información de la reserva",
        "TIP_PROMO": "Sugerencia - Promoción",
        "Rearrange_Column": "Reordenar columna",
        "Pick_up": "Levantar",
        "Enter_a_location": "Introduce una ubicación",
        "Destination": "Destino",
        "Pickup_time": "Hora de recogida",
        "Notes": "notas",
        "TRAVELER_INFORMATION": "Información del viajero",
        "Traveler_type": "tipo de viajero",
        "Individual": "Individual",
        "Corporation": "Corporación",
        "Phone_number": "Número de teléfono",
        "First_name": "Nombre de pila",
        "Last_name": "Apellido",
        "Email_address": "Dirección de correo electrónico",
        "Corp_id": "ID de corporación",
        "Manager_name": "El nombre del gerente",
        "Manager_email": "correo electrónico del gerente",
        "Cost_centre": "centro de costo",
        "Department": "Departamento",
        "Corp_division": "división de corporaciones",
        "Tip": "Propina",
        "Promo_code": "Código promocional",
        "Apply": "Solicitar",
        "Promo": "Promoción",
        "DISPATCH": "Asignar",
        "Auto_dispatch": "Despacho automático",
        "Assign_driver": "Asignar conductor",
        "Driver": "Conductor",
        "PAYMENT_METHOD": "Método de pago",
        "Payment_methods": "Métodos de pago",
        "pending_payment": "Pago pendiente",
        "TRIP_ESTIMATE": "Estimación de viaje",
        "Choose_a_stored_card": "Elegir una tarjeta guardada",
        "Choose_a_payment_method": "Elegir un método de pago",
        "OPERATOR_NOTE": "Notas internas",
        "Use_new_card": "Usar tarjeta nueva",
        "Card_holder": "titular de la tarjeta",
        "Card_number": "Número de tarjeta",
        "Expired_date": "Fecha de caducidad (mm/aa)",
        "ccv": "CVV",
        "Distance": "Distancia",
        "Duration": "Duración",
        "Fare": "Tarifa",
        "Route": "Ruta",
        "Meet_driver": "Conozca al conductor",
        "Airline": "Aerolínea",
        "Flight": "Vuelo #",
        "FLY_INFO": "Informacion de vuelo",
        "Ride_Sharing": "Compartir viaje",
        "Round_trip": "Viaje ida y vuelta",
        "Car_type": "Tipo de carro",
        "Address": "Habla a",
        "City": "Ciudad",
        "State": "Expresar",
        "Zip_code": "Código postal",
        "Remove": "Eliminar",
        "New_Booking": "Nueva reserva",
        "Clone_Booking": "Clonar reserva",
        "New_Order": "New Order",
        "ViewTrackLink": "View track link",
        "driverLink": "Enlace del conductor",
        "ClickCopy": "Haz clic para copiar el enlace",
        "meetingBoard": "Reunión \n Junta",
        "ViewLog": "View dispatch logs",
        "Message": "Mensaje",
        "Update_Booking": "Actualizar reserva",
        "Cancel_Booking": "Cancelar reserva",
        "Complete_with_payment": "Completar con pago",
        "Incident": "Incidencia",
        "CONFIRM_CANCEL": "confirmar cancelar",
        "CONFIRM_CANCEL_MESSAGE": "¿Está seguro de que desea cancelar esta reserva?",
        "CONFIRM_UPDATE": "confirmar actualización",
        "CONFIRM_UPDATE_MESSAGE": "¿Está seguro de que desea actualizar esta reserva?",
        "CONFIRM_RESET_EDIT_FARE_MESSAGE": "Tu tarifa editada ha sido restablecida, por favor revisa antes de continuar.",
        "Close": "Cerca",
        "Update_info": "Actualizar información",
        "Update_info_dispatch": "Actualizar información y envío",
        "Update_info_tooltip": "Si va a reasignar esta reserva a un nuevo controlador, elija \"Sí, Actualizar información y envío",
        "BOOKING": "Reserva",
        "DROPPED_OFF": "dejado",
        "Payment_Type": "Tipo de pago",
        "Total": "Total editado satisfactoriamente",
        "Next": "próximo",
        "Pay_here": "Pague aquí",
        "Complete_booking": "Reserva completa",
        "Complete_booking_tooltip": "Haga clic en \"Actualizar reserva\" para guardar los cambios antes de continuar.",
        "Cancel": "Cancelar",
        "Back": "atrás",
        "Tax": "Impuesto",
        "Booking_fees": "Costos de reserva",
        "Tech_fees": "Tarifas tecnológicas",
        "Subtotal": "Total parcial",
        "Other_fees": "Otros cargos",
        "Waiting_fee": "Tarifa de espera",
        "Toll_fees": "Suplemento por peaje",
        "Heavy_traffic": "Tráfico pesado",
        "Rush_hour": "Recargo",
        "Basic_fare": "Tarifa básica",
        "Ok": "Aceptar",
        "Input_reason": "Motivo de entrada",
        "Client_case_matter": "Código interno del cliente",
        "Charge_code": "Código de cargo",
        "Enter_3rd_party_location": "Introduzca la ubicación del otro pasajero",
        "Company": "Empresa",
        "Check_promo_error": "Revise el error del código promocional",
        "Add_new_credit_error": "Añadir nuevo descuento",
        "Can_not_get_fare_setting": "No se ha podido obtener configuración de tarifas",
        "Can_not_get_affilate_fare_setting": "No se ha podido obtener configuración de tarifas de colaborador",
        "Can_not_check_commisson": "No se ha podido comprobar la comisión",
        "No_flight_info": "Información de vuelo no disponible",
        "Socket_server_disconnected": "Conector del servidor desconectado",
        "Please_reload_page_or_check_your_connection": "Lo sentimos, su petición no ha podido ser procesada. Por favor inténtelo de nuevo",
        "View_Logs": "Visualizar registros",
        "Bookingid": "Reserva #",
        "Calendar": "Calendario",
        "Extra_Destination": "destino adicional",
        "Meet_Greet_option": "Recogida con cartel",
        "On_Curb_option": "Recogida a pie de calle",
        "Credit_Card": "Tarjeta de crédito",
        "Charge": "Cargo",
        "No_charge": "Sin cargo",
        "QR_Code_method_not_allow_error_message": "Seleccionar otro método de pago. Código QR no disponible",
        "change_payment_method_note": "Si desea cambiar el método de pago, por favor vuelva atrás al formulario de reserva",
        "Airport_Fee": "Tarifa Aeropuerto",
        "Addi_service": "Servicios adicionales",
        "Additional_Services": "Servicios adicionales",
        "Minimum": "Mínimo",
        "Search_here": "Busca aquí",
        "No_Driver_Yet": "Aún no se ha asignado un conductor",
        "Personal_Card": "Tarjeta personal",
        "Reject_booking": "Rechazar reserva",
        "Confirm_reject": "Confirmar la cancelación",
        "Confirm_reject_message": "¿Está seguro de rechazar la reserva?",
        "Confirm_reject_booking_with_charge": "Se le cobrará {0}% de la tarifa cotizada según nuestra política de cancelación. ¿Está seguro de que desea rechazar esta reserva?",
        "Yes": "Sí",
        "No": "No",
        "shortTrip": "Viaje corto",
        "Add_new_card": "Agregar nueva tarjeta",
        "Require_customer_info": "Introducir la información del cliente para continuar",
        "Require_corp_info": "Por favor, ingrese la información corporativa para continuar.",
        "Require_corp_customer_info": "Necesito información del usuario para crear una nueva tarjeta.",
        "confirm_force_overlap": "Confirmación",
        "confirm_force_overlap_message": "Esta reserva se superpone con las reservas aceptadas del conductor. ¿Estás seguro de que deseas asignársela?",
        "select": "Seleccionar",
        "PICKUP_TIME_RANGE": "Recogida estimada a las {0}",
        "food": "Comida",
        "mart": "Tienda",
        "Order_summary": "Resumen del pedido",
        "addOnPrice": "Precio ajustado",
        "applicableFee": "Total (aplicable)",
        "itemValue": "Valor del artículo",
        "promotion_note_paymentMethod": "A este pedido se le ha aplicado un código de promoción con un método de pago limitado: %{method}.",
        "promotion_note_minimum_fare": "A este pedido se le ha aplicado un código de promoción con una tarifa mínima limitada: %{fare}.",
        "promotion_note_schedules": "A este pedido se le ha aplicado un código de promoción con tiempo de recogida limitado.",
        "edited_fare_note": "Estos son registros de ajuste de tarifas solo para referencia. Visita los informes para verificar la tarifa y el costo final.",
        "view_good_receipt": "Ver recibo de mercancía",
        "confirmRemoveGroupTransport": "¿Estás seguro de que deseas eliminar la reserva actual de este manifiesto?",
        "confirmRemoveGroupDelivery": "¿Estás seguro de que deseas eliminar la reserva actual de este grupo?",
        "confirmUngroupTransport": "¿Estás seguro de que deseas desagrupar todas las reservas de este manifiesto?",
        "confirmUngroupDelivery": "¿Estás seguro de que deseas desagrupar todas las reservas de este grupo?",
        "view_delivery_receipt": "Ver foto de entrega",
        "select_time": "Seleccionar hora",
        "InputReason": "Introducir motivo",
        "viewOrder": "Ver pedido",
        "markFailed": "Marcar como fallido",
        "corporateName": "Nombre corporativo",
        "sendMessage": "Enviar mensaje",
        "AmountDueBefore": "Monto adeudado antes",
        "AmountDueAfter": "Monto adeudado después",
        "chargeCustomer": "Cobrar al cliente",
        "pending": "No pagado",
        "refundPayment": "Reembolso de pago",
        "refundableAmount": "Monto reembolsable",
        "refundReason": "Agregar motivo de reembolso",
        "refundBtn": "Reembolsar {0}",
        "partial": "Parcial",
        "paid": "Pagado",
        "ViewPaymentLogs": "View payment logs",
        "pmActivity": "Actividad de pagos",
        "paidStatus": "Estado de pago",
        "paymentLog": "Registro de pagos",
        "extraWaitFee": "Tarifa inicial de espera",
        "extraWaitTime": "Tiempo de espera (inicial)",
        "copied": "Copiado",
        "warnningCancelCorporate": "Ten en cuenta que podrías incurrir en un cargo de acuerdo con nuestra política de cancelación.",
        "customerAdjustments": "Ajustes del cliente",
        "customerAdjustmentsTooltip": "Ajustes del cliente",
        "supplierDriverAdjustments": "Ajustes del proveedor/conductor",
        "updateSummary": "Resumen de actualización",
        "orderDetails": "Detalles del pedido",
        "saveAndSendEmail": "Guardar y Enviar E-Recibo",
        "pastDetacted": "Reserva pasada detectada",
        "pastDetactedContent": "Estás a punto de crear una reserva en el pasado",
        "DriverSupplier": "Conductor/Proveedor",
        "supplierCancelCharge": "Advertencia: Penalización por Cancelación",
        "supplierCancelNoCharge": "Confirmar Cancelación",
        "supplierCancelChargeBody": "¿Estás seguro de que quieres cancelar la reserva?",
        "willChargedPenalty": "Se le cobrará una penalización de {0}.",
        "noChargedPenalty": "Esta es una cancelación gratuita, no se cobrará ninguna penalización.",
        "errorGetToken": "No se puede obtener el token, por favor inténtalo de nuevo más tarde.",
        "unlinkFlight": "Desvincular vuelo",
        "unlinkFlightBody": "¡Atención! Cambiar la hora de recogida desvinculará los detalles de su vuelo y eliminará el número de vuelo."
    },
    "map": {
        "AWS_map_hint": "Sugerencia: Presiona Enter o Esc para terminar de dibujar.",
        "Apple_map_hint": "Sugerencia: Presiona y mantén para arrastrar y redimensionar el polígono.",
        "Enter_a_location": "Ingrese una ubicación",
        "All_company": "Toda la empresa",
        "All_cars": "Todos los autos",
        "Show_all_cars": "Mostrar todos los vehículos",
        "Hide_all_cars": "Ocultar todos los vehículos",
        "Vacant": "Disponible",
        "Dispatching": "despacho",
        "Driver_on_the_way": "Conductor en camino",
        "Arrived_and_waiting": "Llegado y esperando",
        "P_O_B": "Pasajero a bordo",
        "Dropped_off": "Entregado",
        "Waiting_for_process": "Esperando el proceso",
        "Unavailable": "Indisponible",
        "Total_Drivers": "Total conductores",
        "Estimate": "Estimar",
        "Destination": "Destino",
        "Pickup": "Levantar",
        "Start_point": "Punto de origen",
        "Passenger": "Pasajero",
        "Driver_name": "Nombre del conductor",
        "Search_car_here": "Buscar nombre de coche/conductor",
        "Error_load_booking": "no se ha podido cargar la reserva, inténtelo de nuevo o actualice la página!",
        "Show_all": "Mostrar todo",
        "BookCardInfo": "Información de la Tarjeta de Reserva",
        "drvPhoneNo": "Número de teléfono del conductor",
        "vhcPhoneNo": "Número de Teléfono del Vehículo",
        "driversLiveMap": "Mapa de conductores",
        "heatMap": "Mapa de demanda",
        "Trip": "Viaje",
        "traffic": "Tráfico",
        "bicyclingLayers": "Ciclismo",
        "layer": "Capa",
        "trafficBicycling": "Tráfico, ciclismo",
        "All_airline": "Todas las aerolíneas"
    },
    "customer": {
        "Customers": "Clientes",
        "Points": "Puntos",
        "Migration_Status": "Estado de migración",
        "ADD_CUSTOMER": "Agregar cliente",
        "EDIT_CUSTOMER": "Editar cliente",
        "Add": "Agregar",
        "Activate": "Activar",
        "Deactivate": "Desactivar",
        "Delete": "Borrar",
        "Import": "Importar",
        "Download_template": "Descargar plantilla",
        "View_Message": "Mensaje",
        "Send_Message": "Enviar mensaje",
        "Export_to_excel": "Exportar a Excel",
        "Filter": "Filtro",
        "Apply": "Aplicar",
        "Clear": "Limpiar",
        "Name": "Nombre",
        "Phone_Number": "Número de teléfono",
        "Email": "Correo electrónico",
        "Vip": "VIP",
        "companies": "Empresa",
        "File": "Archivo",
        "Number_successful_imports": "Número de importaciones exitosas",
        "Number_skipped": "Número de omitidos",
        "Number_duplicate_phone_numbers": "Número de números de teléfono duplicados",
        "Number_wrong_phone_numbers": "Número de números de teléfono incorrectos",
        "Corporate_Name": "Empresa",
        "Registered_From": "Registrado desde",
        "Registration_Date": "Fecha de Registro",
        "Registration_date_from": "Fecha de registro desde",
        "Registration_date_to": "Fecha de registro a",
        "IOS_Last_Login_Version": "Versión de último inicio de sesión de IOS",
        "Android_Last_Login_Version": "Versión de último inicio de sesión de Android",
        "Last_Active_Date": "Última fecha activa",
        "Verification": "Verificación",
        "Support_ID": "ID de soporte",
        "Days_Since_Last_Active": "Días desde la última actividad",
        "Completed_Bookings": "Reservas Completadas",
        "Outstanding_amount": "Cantidad pendiente",
        "Status": "Estado",
        "Actions": "Acciones",
        "Action": "Acción",
        "Inactive": "Inactivo",
        "Active": "Activo",
        "Edit": "Editar",
        "View": "Vista",
        "ALERT_SELECT_ACTIVATE": "Seleccione el cliente para activar.",
        "ALERT_SELECT_DEACTIVATE": "Seleccione el cliente para desactivar.",
        "ALERT_SELECT_DELETE": "Seleccione el cliente para eliminar.",
        "CONFIRM_DELETE": "¿Está seguro de que desea eliminar el cliente seleccionado?",
        "CONFIRM_DELETE_MULTI": "¿Está seguro de que desea eliminar estos clientes?  Solo se pueden eliminar los clientes que están inactivos y que no son usuarios registrados a través de la aplicación.",
        "CONFIRM_DEACTIVATE_MULTI": "¿Quieres desactivar estos clientes?",
        "CONFIRM_ACTIVATE_MULTI": "¿Quieres activar estos clientes?",
        "CONFIRM_EXPORT_TO_EXCEL": "¿Desea exportar toda la información a un archivo .xlsx?",
        "Add_card_top_up_success": "Tarjeta prepago ha sido recargada satisfactoriamente",
        "Add_card_success": "¡La tarjeta ha sido añadida con éxito!",
        "Add_customer_success": "Se ha creado satisfactoriamente el nuevo cliente",
        "Update_customer_success": "El cliente ha sido actualizado satisfactoriamente",
        "Deleted_customer_success": "El cliente ha sido eliminado satisfactoriamente",
        "Create_customer_fail": "Fallo al crear cliente",
        "Update_customer_fail": "No se pudo actualizar el cliente",
        "ERROR_EXISTED_PHONE": "Este teléfono ha existido en el sistema.  Por favor ingrese otro",
        "ERROR_INPUT_FIRSTNAME": "Por favor ingrese el primer nombre.",
        "ERROR_INPUT_PHONE": "Por favor ingrese el número de teléfono.",
        "ERROR_INPUT_VALIDPHONE": "Por favor ingrese un número de teléfono válido.",
        "ERROR_INPUT_VALIDEMAIL": "Por favor, introduce una dirección de correo electrónico válida.",
        "CONFIRM_DELETE_CARD": "¿Está seguro de que desea eliminar estas tarjetas?",
        "First_name": "Nombre de pila",
        "Last_name": "Apellido",
        "Phone_number": "Número de teléfono",
        "Email_address": "Dirección de correo electrónico",
        "Notes": "notas",
        "Account": "Cuenta",
        "Card_management": "Gestión de tarjetas",
        "Home": "Casa",
        "Affiliate": "Afiliado",
        "SHOW_PERSONAL_CARD": "Mostrar tarjeta personal",
        "ADD_PERSONAL_CARD": "Añadir tarjeta personal",
        "SHOW_mDISPATCHER_CARD": "Mostrar tarjeta de socio",
        "ADD_mDISPATCHER_CARD": "Agregar tarjeta de socio",
        "Personal_card": "Tarjeta personal",
        "mDispatcher_card": "Tarjeta de socio",
        "Card_holder": "Titular de la tarjeta",
        "Card_number": "Número de tarjeta",
        "Credit_type": "Tipo de crédito",
        "Credit_code": "Código de crédito",
        "Sms_verification": "Verificación por SMS",
        "Sms_verification_placeholder": "Ingresar código de verificación",
        "Expired_date": "Fecha de vencimiento",
        "CVV": "CVV",
        "Address": "Habla a",
        "Country": "País",
        "City": "Ciudad",
        "State": "Estado",
        "Zip_code": "Código postal",
        "postal_code": "Código postal",
        "Required_fields": "Campos requeridos",
        "Cancel": "Cancelar",
        "Save": "Ahorrar",
        "ERROR_INPUT_CARD_HOLDER": "Ingrese el titular de la tarjeta",
        "ERROR_INPUT_CARD_NUMBER": "Por favor ingrese número de tarjeta",
        "ERROR_INPUT_EXPIRED_DATE": "Ingrese la fecha de caducidad",
        "ERROR_VAILD_EXPIRED_DATE": "Fecha de caducidad no es válida",
        "ERROR_INPUT_CVV": "Por favor ingrese CVV",
        "ERROR_INPUT_ADDRESS": "Por favor ingrese la dirección",
        "ERROR_INPUT_CITY": "Por favor ingrese la ciudad",
        "ERROR_INPUT_ZIPCODE": "Por favor ingrese el código postal",
        "ERROR_INPUT_COUNTRY": "Introducir país",
        "Info_edit_error": "¡Error!",
        "Gender": "Sexo",
        "Select_Gender": "Seleccione",
        "Select_Idtype": "Select",
        "Male": "Masculino",
        "Female": "Mujer",
        "Other": "Otro",
        "Date_of_birth": "Fecha de nacimiento",
        "Street_address": "Calle",
        "Select_Zone": "Zona",
        "ERROR_GET_GATEWAYS": "ERROR !!!  Obtener puertas de enlace",
        "Require_email": "Introduzca un email antes de agregar una nueva tarjeta",
        "Require_lastName": "Introduzca el apellido antes de agregar una nueva tarjeta",
        "Require_phone_number": "Introduzca el teléfono del pasajero antes de realizar una reserva con tarjeta de crédito",
        "IMPORT_CUSTOMER_SUCCESS": "Clientes importados satisfactoriamente",
        "No_card": "No se encontró ninguna tarjeta",
        "No_Support": "La nueva tarjeta introducidad no es válida en esta zona",
        "Card_Management": "Gestión de tarjetas",
        "Emergency_contacts": "Contactos de emergencia",
        "DETAIL_CUSTOMER": "Datos del cliente",
        "Select_Country": "Seleccionar país",
        "Customer_ID": "Documento de Identidad",
        "Credit_balance": "Balance de crédito",
        "required_email_payment": "Se requiere el correo electrónico del cliente.  Por favor, actualice el perfil para continuar.",
        "Yes": "Sí",
        "No": "No",
        "WriteOffDebt": "Cancelar deuda",
        "selectPayment": "Seleccione un método de pago para cerrar todas las reservas que tengan un pago pendiente",
        "writeOffDebtSuccess": "Cancelar la deuda con éxito",
        "writeOffDebtNotes": "Nota: Esta acción de cancelación solo debe confirmarse después de que todo el monto pendiente se haya pagado en su totalidad.",
        "totalCustomer": "Nombre total de clients",
        "Personal_Card": "Tarjeta personal",
        "INFO_ADD_BALANCE_SUCCESS": "El saldo del pasajero se ha actualizado correctamente",
        "INFO_UPDATE_POINT_SUCCESS": "Los puntos del pasajero se han actualizado correctamente",
        "currency": "Moneda",
        "balance": "Saldo",
        "changeBalance": "Cambiar saldo",
        "change": "Cambio",
        "WALLET_DEPOSIT": "Billetera",
        "AccessDenied": "¡No tienes permiso para acceder a este módulo!",
        "referral_code": "Código de referido",
        "loginMethod": "Método de inicio de sesión",
        "searchCustomerPlaceholder": "Buscar por nombre de contacto, teléfono, correo electrónico, corporación, ID de soporte"
    },
    "importBookings": {
        "no": "Número",
        "status": "Estado",
        "pickupDate": "Fecha de recogida",
        "pickup": "Dirección de recogida",
        "dropoff": "Dirección de entrega",
        "passenger": "Pasajero",
        "phone": "Número de teléfono",
        "seats": "Asientos",
        "luggages": "Equipajes",
        "rideSharing": "Viaje compartido",
        "flightNumber": "Número de vuelo",
        "notes": "Notas",
        "externalId": "ID externo",
        "operatorNote": "Notas internas",
        "clientCaseMatter": "Descripción del viaje",
        "chargeCode": "Código del viaje",
        "price": "Precio",
        "payout": "Pago",
        "paymentType": "Pago",
        "vehicleTypeRequest": "Tipo de coche",
        "importBookings": "Importar reservas",
        "corporation": "Corporación",
        "clickOrDropCsvFile": "Haz clic o arrastra el archivo .csv",
        "importingFileForReview": "Importando archivo para revisión...",
        "import": "Importar",
        "submit": "Enviar",
        "downloadTemplate": "Descargar plantilla",
        "learnMore": "Más información",
        "total": "Total",
        "valid": "Válido",
        "invalid": "Inválido",
        "failed": "Fallido",
        "processing": "Procesando",
        "success": "Éxito",
        "confirm": "Confirmar",
        "confirmMessage": "Se crearán pedidos. ¿Estás seguro de que deseas proceder?",
        "create": "Crear",
        "cancel": "Cancelar",
        "close": "Cerrar",
        "leavingConfirmMessage": "¡Tu trabajo no está guardado! ¿Estás seguro de que quieres salir?",
        "resultMessage": "${success} reserva(s) se ha(n) creado exitosamente, ${failed} falló/fallaron.",
        "limitExceededBookings": "Tamaño máximo del archivo de importación: 100 reservas",
        "delivery": {
            "no": "#",
            "pickupDate": "Fecha de recogida",
            "senderName": "Nombre del remitente",
            "senderPhone": "Teléfono del remitente",
            "senderMail": "Correo electrónico del remitente",
            "senderAddress": "Dirección del remitente",
            "recipients": "Destinatarios",
            "senderDistrictOptional": "Distrito",
            "senderLocationDetails": "Detalles de ubicación",
            "recipientName": "Nombre del destinatario",
            "recipientPhone": "Teléfono del destinatario",
            "recipientAddress": "Dirección del destinatario",
            "recipientDistrictOptional": "Contenido del paquete",
            "recipientLocationDetailsOptional": "Detalles de ubicación",
            "packageContent": "Contenido del paquete",
            "orderNumber": "Pedido #",
            "instructions": "Instrucciones para el conductor",
            "cod": "Valor del artículo COD",
            "rideShare": "Compartir viaje",
            "paymentType": "Tipo de pago",
            "carType": "Tipo de coche",
            "recipientLocationDetails": "Detalles de ubicación",
            "operatorNote": "Notas internas",
            "rideSharing": "Entrega por lotes"
        }
    },
    "merchant": {
        "INFO_ADD_BALANCE_SUCCESS": "El saldo del comerciante se ha actualizado correctamente",
        "ADD_MERCHANT_USER": "Agregar cuenta de comerciante",
        "EDIT_MERCHANT_USER": "Editar cuenta de comerciante",
        "MERCHANT_USER_DETAILS": "Detalles de la cuenta de comerciante",
        "CASH_WALLET": "Billetera de efectivo",
        "CREDIT_WALLET": "Billetera de crédito",
        "ADD_MERCHANT": "Agregar comerciante",
        "ACCOUNT_INFO": "Información de la cuenta",
        "BILLING_ADDRESS": "Información bancaria",
        "user": {
            "fullName": "Usuario comerciante",
            "Phone_Number": "Número de teléfono",
            "Email": "Correo electrónico",
            "storeName": "Comerciante",
            "status": "Estado",
            "actions": "Acción",
            "First_name": "Nombre",
            "Last_name": "Apellido",
            "Select_store": "Seleccionar comerciante",
            "accountHolder": "Nombre del titular de la cuenta",
            "First_M_Last": "Nombre M. Apellido",
            "accountNumber": "Número de cuenta",
            "ibanNumber": "Número IBAN",
            "bankName": "Nombre del banco",
            "IDtype": "Tipo de identificación",
            "IDnumber": "Número de identificación / IC Nacional",
            "routingNumber": "Número de ruta/tránsito/sucursal",
            "checkNumber": "Número de cheque",
            "ssn": "SSN/NI",
            "sortCode": "Código de clasificación",
            "transitNumber": "Número de tránsito",
            "institutionNumber": "Número de institución",
            "birthDay": "Fecha de nacimiento",
            "address": "Dirección",
            "city": "Ciudad",
            "state": "Estado",
            "postalCode": "Código postal",
            "beneficiaryIDIC": "Número de identificación del beneficiario / IC#",
            "relationshipOtherName": "¿Relación con otro?",
            "verificationDocumentFront": "Documento de verificación (frente)",
            "verificationDocumentBack": "Documento de verificación (dorso)",
            "Verification_document_tooltip": "Formas aceptables de identificación:\n- Pasaporte\n- Licencia de conducir\n- Permiso de residencia\n- Tarjeta de ciudadano\n- Documento de identidad",
            "additionalDocumentFront": "Documento adicional (frente)",
            "additionalDocumentBack": "Documento adicional (dorso)",
            "Additional_document_tooltip": "Formas aceptables de verificación de dirección:\n- Licencia de conducir\n- Factura de servicios\n- Carta emitida por el gobierno\n- Estado de cuenta de una institución financiera\n- Registro electoral",
            "please_select": "Por favor seleccione",
            "commission": "Comisión",
            "ERROR_INPUT_VALIDPHONE": "Por favor ingrese un número de teléfono válido.",
            "ERROR_EXISTED_PHONE": "Este teléfono ya existe en el sistema. Por favor ingrese otro.",
            "Activate": "Activar",
            "Deactivate": "Desactivar",
            "ALERT_SELECT_ACTIVATE": "Por favor seleccione usuario para activar.",
            "ALERT_SELECT_DEACTIVATE": "Por favor seleccione usuario para desactivar.",
            "CONFIRM_ACTIVATE_MULTI": "¿Desea activar estos usuarios?",
            "CONFIRM_DEACTIVATE_MULTI": "¿Desea desactivar estos usuarios?",
            "RESET_PASSWORD": "¿Desea restablecer la contraseña?",
            "CONFIRM_RESET_PASSWORD": "¿Desea restablecer la contraseña?",
            "REMOVE_BANK_INFO": "Confirmar eliminación de información bancaria",
            "CONFIRM_REMOVE_BANK_INFO": "¿Desea eliminar la información bancaria?",
            "note_account_password_default": "Nota: Para una nueva cuenta de comerciante, la contraseña predeterminada es \"12345678",
            "Cash_Balance": "Saldo en efectivo",
            "Credit_Balance": "Saldo de crédito"
        },
        "Update_merchant_user_success": "El usuario comerciante se ha actualizado correctamente",
        "Update_merchant_user_fail": "Error al actualizar usuario comerciante",
        "Create_merchant_user_success": "Se ha creado un nuevo usuario comerciante correctamente",
        "Create_merchant_user_fail": "Error al crear usuario comerciante",
        "Update_merchant_user_status_success": "El usuario comerciante se ha actualizado correctamente",
        "Update_merchant_user_status_fail": "Error al actualizar usuario comerciante",
        "Reset_password_merchant_user_success": "Contraseña restablecida correctamente",
        "Reset_password_merchant_user_fail": "Error al restablecer la contraseña",
        "Deleted_merchant_bank_info_success": "Información bancaria eliminada correctamente",
        "Deleted_merchant_bank_info_fail": "Error al eliminar información bancaria"
    },
    "table_header": {
        "Items_per_page": "elementos por página",
        "Page": "Página",
        "Search_here": "Busca aquí",
        "Shown_Active": "%{start} - %{end} de %{total} mostrado",
        "Active": "%{activo} Activo",
        "OF": "de"
    },
    "driver": {
        "Driver": "Conductor",
        "Add": "Agregar",
        "addDriver": "Agregar conductor",
        "Detail": "Detalle",
        "detailDriver": "Detalles del conductor",
        "addNewVehicle": "Agregar vehículo",
        "serviceType": "Tipo de servicio",
        "transport": "Transporte",
        "delivery": "Entrega",
        "stripeConnect": "Stripe Connect",
        "stripeConnectDes": "Agregar una cuenta de Stripe Connect para facilitar los pagos",
        "bankAccount": "Información bancaria",
        "bankAccountDes": "Información bancaria del conductor para gestionar pagos",
        "supplierComission": "Comisión del proveedor",
        "supplierComissionDes": "Set commissions the supplier earns for every complete order.",
        "fleetCommission": "Comisión de flota/proveedor",
        "fleetCommissionDes": "Establecer comisiones que la flota o el proveedor ganan por cada pedido completado. Si el conductor pertenece a un proveedor, la comisión se deducirá de las ganancias del proveedor.",
        "operationZones": "Zonas de operación",
        "operationZonesDes": "Zonas desde las que los proveedores pueden recibir trabajos.",
        "notes": "Notas",
        "notesDes": "Notas internas sobre este conductor.",
        "searchNotes": "Agregar notas para el conductor.",
        "marketplace": "Mercado",
        "marketplaceDes": "Capacitar a los conductores para aceptar los trabajos que desean realizar.",
        "otherSettings": "Otros ajustes",
        "topDriver": "Conductor TOP",
        "topDriverDes": "Priorizar a los mejores conductores con la etiqueta \"Conductor TOP\", asegurando que reciban más viajes.",
        "walletTransferBetweenDriver": "Transferencias de billetera entre conductores",
        "walletTransferBetweenDriverDes": "Permitir que los conductores transfieran fondos directamente entre sus billeteras, facilitando la distribución de créditos por líderes de equipo o embajadores.",
        "rideSharing": "Compartir viaje",
        "rideSharingDes": "Permitir que los conductores realicen trabajos de viaje compartido. Contacte a su administrador de cuenta para esta función avanzada.",
        "individual_vehicle": "Vehículo individual",
        "company_vehicle": "Vehículo de empresa",
        "ContactInfo": "Información de contacto",
        "name": "Nombre",
        "expiryDate": "Fecha de vencimiento",
        "action": "Acción",
        "editDocument": "Editar documento",
        "documentToUpload": "Documento para subir",
        "addFiles": "Haga clic o arrastre el archivo a esta área para subirlo.",
        "fileSize": "Tamaño máximo de archivo 10 MB.",
        "fileSizeDes": "La extensión del archivo debe ser .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip.",
        "removeOldFile": "Por favor, elimine el archivo anterior antes de subir uno nuevo.",
        "maxLengthFiles": "Por favor, suba un máximo de 1 archivo.",
        "maxSizeFiles": "Por favor, suba un archivo con un tamaño menor a 10 MB.",
        "typeFiles": "Por favor, suba un archivo del tipo .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip.",
        "maxAvatarSizeFiles": "Por favor, suba un avatar con un tamaño menor a 8 MB.",
        "IFSCCode": "Código IFSC",
        "Drivers": "Conductores",
        "default": "Predeterminado",
        "customize": "Personalizado",
        "Activate": "Activar",
        "Stripe_connect": "STRIPE CONNECT",
        "status_stripe": "Estado: {0}",
        "stripeConnectStatus": "Stripe Connect",
        "stripeStatus": "Estado de la cuenta de Stripe",
        "Deactivate": "Desactivar",
        "Delete": "Borrar",
        "acceptInDay": "Máximo de reservas que un conductor puede aceptar en un día",
        "acceptATime": "Número total de reservas que un conductor puede aceptar a la vez",
        "Commission": "Establecer comisión de flota",
        "Title_Commission": "Establecer comisión de flota para todos los conductores",
        "Confirm_Set_Commission": "¿Está seguro de que desea establecer este valor de comisión para todos los conductores?",
        "Commission_Successfully": "La comisión del conductor se ha actualizado con éxito",
        "Apply": "Solicitar",
        "Type": "Tipo",
        "Currency": "Divisa",
        "View_Message": "Mensaje",
        "Send_Message": "Enviar mensaje",
        "Driver_Name": "Nombre del conductor",
        "Driver_ID": "Documento de Identidad",
        "Phone_Number": "número de teléfono",
        "Driver_Type": "Tipo de controlador",
        "TOP": "CIMA",
        "Company": "Compañía",
        "City": "Ciudad",
        "Driver_License_Number": "Número de licencia de conducir",
        "License_Plate": "Placa",
        "Car_Type": "Tipo de carro",
        "Zone": "Zona",
        "Registered_From": "Registrado desde",
        "Registration_Date": "Fecha de Registro",
        "IOS_Last_Login_Version": "Versión de último inicio de sesión de IOS",
        "Android_Last_Login_Version": "Versión de último inicio de sesión de Android",
        "Last_Active_Date": "Útima fecha de conexión",
        "Days_Since_Last_Active": "Días desde la última actividad",
        "Completed_bookings": "Reservas completadas",
        "Status": "Estado",
        "Actions": "Acciones",
        "Action": "Acción",
        "Inactive": "Inactivo",
        "Active": "Activo",
        "Edit": "Editar",
        "View": "Vista",
        "ALERT_SELECT_ACTIVATE": "Seleccione el controlador para activar.",
        "ALERT_SELECT_DEACTIVATE": "Seleccione el controlador para desactivar.",
        "ALERT_SELECT_DELETE": "Seleccione el controlador para eliminar.",
        "CONFIRM_DELETE": "¿Está seguro de que desea eliminar esta cuenta de conductor? Una vez eliminada, el conductor podrá registrarse con un nuevo perfil, pero todos los datos anteriores se perderán permanentemente.",
        "CONFIRM_DEACTIVATE_MULTI": "¿Está seguro de que desea desactivar al(los) conductor(es) seleccionado(s)? Su(s) taxímetro(s) conectado(s) también se desactivará(n). Solo los conductores que no tengan ningún viaje o reserva en curso pueden ser desactivados.",
        "CONFIRM_ACTIVATE_MULTI": "¿Desea activar a estos conductores? Solo los conductores que estén completamente configurados para la operación pueden ser activados.",
        "CONFIRM_DELETE_MULTI": "¿Desea eliminar a estos conductores? Solo los conductores que estén en estado inactivo pueden ser eliminados.",
        "CONFIRM_REMOVE_BANKING_INFOR": "¿Está seguro de que desea eliminar la información bancaria?",
        "REMOVE_BANKING_INFOR": "Eliminar información bancaria",
        "ADD_DRIVER": "AÑADIR CONDUCTOR",
        "Avatar": "Avatar",
        "Individual_Driver": "Transporte - Vehículo de empresa",
        "Owner_Operator": "Transporte - Vehículo individual",
        "deliveryCompany": "Entrega - Vehículo de empresa",
        "deliveryIndividual": "Entrega - Vehículo individual",
        "CONTACT_INFO": "DATOS DE CONTACTO",
        "Home_address": "Direccion de casa",
        "Username": "nombre de usuario",
        "First_name": "Nombre",
        "Last_name": "Apellidos",
        "Phone_number": "número de teléfono",
        "Email_address": "Dirección de correo electrónico",
        "Select_city": "Ciudad selecta",
        "State": "Estado",
        "Zip_code": "Código postal",
        "Date_of_birth": "Fecha de nacimiento",
        "placeholderDate": "dd/mm/yyyy",
        "City_driver_want_to_drive": "Ciudad de trabajo",
        "Driver_license_number": "Número de licencia de conducir",
        "Driver_license_state": "Licencia de conducir estado/provincia",
        "Driver_license_expiry": "Caducidad de la licencia de conducir",
        "FOR_INSPECTOR": "PARA EL INSPECTOR",
        "Document": "Documento",
        "Document_Id": "ID de documento",
        "Link": "Enlace",
        "Notes": "notas",
        "UPLOAD_DOCUMENT": "CARGAR DOCUMENTO",
        "Click_here_to_download": "Haga click aquí para descargar.",
        "Click_here_to_view": "Haz clic para ver",
        "EXTENSION_REQUIREMENT": "La extensión del archivo debe ser .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip y menos de 5Mb.",
        "Invalid_file": "Archivo inválido",
        "File_size_larger_than_5Mb": "Tamaña de archivo debe ser superior a 5 Mb",
        "BANK_ACCOUNT": "CUENTA BANCARIA",
        "Name_of_bank": "Nombre del banco",
        "Name_of_account": "Nombre de la cuenta",
        "First_M_Last": "Primero M. Apellido",
        "RTBnumber": "Ruta/Tránsito/Número de oficina",
        "bankName": "Nombre del banco",
        "Select_a_bank": "Seleccione un banco",
        "Account_number": "Número de cuenta",
        "IBAN_number": "Número IBAN",
        "Check_number": "Compruebe número",
        "Swift_code_number": "Número de código Swift",
        "SSNNI": "Número de Seguridad Social",
        "sortCode": "Código de clasificación",
        "Verification_document": "Documento de verificación (frente)",
        "Additional_document": "Documento adicional (frente)",
        "Verification_document_back": "Documento de verificación (dorso)",
        "Additional_document_back": "Documento adicional (dorso)",
        "others": "Otros",
        "signedW9Form": "Formulario W-9 firmado",
        "driverLicense": "Licencia de conducir",
        "Verification_document_tooltip": "Cargue la copia escaneada de uno de los siguientes documentos: \n- Pasaporte \n- Licencia de conducir \n- Tarjeta de identificación",
        "Additional_document_tootip": "Formas aceptables de verificación de dirección:\n- Licencia de conducir\n- Factura de servicios públicos\n- Carta emitida por el gobierno\n- Estado de cuenta de una institución financiera\n- Registro electoral",
        "isBankAccountOwner": "¿Es esta tu cuenta?",
        "yes": "Sí",
        "no": "No",
        "beneficiary_name": "Nombre del beneficiario",
        "beneficiary_idic": "ID/IC del beneficiario",
        "relationship": "Relación",
        "select_relationship": "Seleccionar estado de la relación",
        "spouse": "Cónyuge",
        "daughterOrSon": "Hija/Hijo",
        "brotherOrSister": "Hermano/Hermana",
        "relative": "Pariente",
        "friends": "Amigos",
        "other": "Otro",
        "relationshipOtherName": "¿Relación con otro?",
        "OPERATION": "OPERACIÓN",
        "CAR_INSURANCE": "SEGURO DE AUTO",
        "Policy_number": "Número de póliza",
        "Effective_date": "Fecha efectiva",
        "Expired_date": "Fecha de vencimiento",
        "Select_company": "Seleccionar empresa",
        "All_company": "Todas las empresas",
        "All_Car_Type": "Todos los tipos de coche",
        "Car": "Coche",
        "Existing_car": "Coche existente",
        "New_car": "Coche nuevo",
        "License_plate": "Placa de matrícula",
        "Select_license_plate": "Seleccionar matrícula",
        "Select_Car_Type": "Seleccionar tipo de coche",
        "vehicleOwner": "Nombre del propietario del vehículo",
        "Make": "Fabricar",
        "Select_Car_Make": "Seleccionar marca de coche",
        "Model": "Modelo",
        "Select_Car_Model": "Seleccionar modelo de coche",
        "Year": "Año",
        "Select_Year": "Seleccionar año",
        "Color": "Color",
        "Passengers": "Pasajeros",
        "Luggage": "Equipaje",
        "License_expiry": "Caducidad de la licencia",
        "Shift": "Turno",
        "Select_Shift_Template": "Seleccionar plantilla de turno",
        "Fleet_commission": "Comisión de flota (informe)",
        "Company_commission": "Comisión de la empresa (informe)",
        "rideHailing": "Solicitud de taxi en la calle",
        "intercity": "Interurbano",
        "food": "Comida",
        "mart": "Tienda",
        "streetSharing": "Compartir viaje en la calle",
        "Shuttle": "Transporte lanzadera",
        "parcel": "Paquete",
        "driverInsurance": "Seguro del conductor",
        "Percentage": "Porcentaje",
        "Amount": "Monto",
        "transaction": "Transacción",
        "Terminal_ID": "ID terminal",
        "Auth_key": "clave de autentificación",
        "CREDIT_DEPOSIT": "Crédito monedero",
        "Credit_Balance": "Balance de crédito",
        "Balance": "Saldo crédito",
        "Change_balance": "Modificar saldo",
        "Select_balance": "Seleccionar saldo",
        "Adjust_amount": "ajustar importe",
        "Adjust_value": "Ajustar valor",
        "New_balance": "nuevo saldo",
        "New_point": "Nuevo punto",
        "Enter_reason": "introduzca los motivos",
        "ERROR_INPUT_BALANCE": "Seleccione el saldo.",
        "ERROR_INPUT_AMOUNT": "Ingrese este valor.",
        "ERROR_INPUT_REASON": "Introduce el motivo.",
        "ERROR_INPUT_VALID_AMOUNT": "Por favor ingrese un valor mayor o igual a 0.",
        "INFO_ADD_BALANCE_SUCCESS": "El saldo del conductor se ha actualizado con éxito",
        "INFO_ADD_CASH_BALANCE_SUCCESS": "El saldo en efectivo del conductor se ha actualizado correctamente",
        "Force_meter": "medidor de fuerza",
        "Force_meter_tooltip": "La aplicación del conductor debe estar conectada al medidor antes de operar. Aplicado a los medidores Pulsar y Centrodyne.",
        "ERROR_EXISTED_PHONE": "Este teléfono ha existido en el sistema.  Por favor ingrese otro",
        "TOP_driver": "conductor TOP",
        "Ride_sharing": "viaje compartido",
        "Note_password": "Nota: Para una nueva cuenta de conductor, la contraseña predeterminada es \"12345678\".",
        "Required_fields": "Campos requeridos",
        "Cancel": "Cancelar",
        "Save": "Ahorrar",
        "SaveAndInProgress": "Guardar y en progreso",
        "SaveAndDeactivate": "Guardar y desactivar",
        "ERROR_REQUIRE_": "Por favor, input",
        "ERROR_INPUT_AVATAR": "Por favor sube el avatar.",
        "ERROR_INPUT_DRIVER_TYPE": "Por favor seleccione el tipo de conductor.",
        "ERROR_INPUT_DOCUMENT": "por favor sube",
        "ERROR_INPUT_USERNAME": "Por favor introduzca un usuario",
        "ERROR_INPUT_VALID_USERNAME": "Usuario deben contener sólo minúsculas y números y debe contener entre 3-20 caracteres",
        "ERROR_INPUT_PHONE": "Por favor, especifique un número de teléfono válido.",
        "ERROR_INPUT_VALID_EMAIL": "Por favor introduzca un correo electrónico válido.",
        "ERROR_INPUT_EMAIL": "Por favor ingrese el correo electrónico.",
        "ERROR_INPUT_FIRSTNAME": "Por favor ingrese el primer nombre.",
        "ERROR_INPUT_LASTNAME": "Por favor ingrese el apellido.",
        "ERROR_INPUT_ADDRESS": "Ingrese la dirección de su casa.",
        "ERROR_INPUT_CITY": "Por favor ingrese la ciudad.",
        "ERROR_INPUT_STATE": "Por favor ingrese el estado.",
        "ERROR_INPUT_ZIPCODE": "Por favor ingrese el código postal.",
        "ERROR_INPUT_BIRTHDAY": "Por favor ingrese cumpleaños.",
        "ERROR_INPUT_NAME_OF_BANK": "Ingrese el nombre del banco.",
        "ERROR_INPUT_NAME_OF_ACCOUNT": "Ingrese el nombre de la cuenta.",
        "ERROR_INPUT_ROUTING_NUMBER": "Ingrese el número de ruta.",
        "ERROR_INPUT_BANK_NAME": "Seleccione un banco.",
        "ERROR_INPUT_ACCOUNT_NUMBER": "Por favor ingrese un número de cuenta",
        "ERROR_INPUT_CHECK_NUMBER": "Por favor compruebe número",
        "ERROR_INPUT_SSN": "Por favor, introduzca el SSN.",
        "ERROR_INPUT_DocumentId": "Por favor, ingrese el ID del documento.",
        "ERROR_INPUT_SORTCODE": "Por favor, ingrese el código de clasificación.",
        "ERROR_INPUT_COMPANY": "Seleccione la empresa para activar.",
        "ERROR_INPUT_LICENSE_PLATE": "Por favor, elija la matrícula.",
        "ERROR_INPUT_ZONE": "Seleccione la zona para activar.",
        "ERROR_INPUT_SHIFT": "Seleccione turno para activar.",
        "ERROR_ACCOUNT_NUMBER_ONLY_NUMBERS": "Esto debe contener solo números",
        "ERROR_SSN_ONLY_NUMBERS": "Esto debe contener solo números",
        "ERROR_SSN_LENGTH": "SSN debe tener al menos 4 caracteres",
        "ERROR_COMMISSION_NUMBERS": "por favor ingrese un número valido",
        "INFO_DEACTIVAED_SUCCESS": "El controlador se ha desactivado con éxito.",
        "INFO_ACTIVAED_SUCCESS": "El controlador se ha activado con éxito.",
        "INFO_DEACTIVAED_SUCCESS_BUT_HARDWARE": "El controlador se ha desactivado pero el medidor de hardware integrado no se puede apagar por algunas razones inesperadas.",
        "INFO_MULTIDEACTIVAED_SUCCESS": "Los {0} conductores seleccionados han sido desactivados con éxito.",
        "INFO_MULTIDEACTIVAED_HARDWARE_SUCCESS": "Los {0} controladores seleccionados se han desactivado correctamente.  Se deshabilitaron {1} medidores de hardware conectados.",
        "INFO_MULTIDEACTIVAED_SUCCESS_BUT_HARDWARE": "Los {0} controladores seleccionados se han desactivado correctamente.  Se deshabilitaron {1} medidores de hardware conectados.  {2} no se debieron a razones inesperadas.",
        "INFO_MULTIACTIVAED_SUCCESS": "Los {0} conductores seleccionados han sido activados con éxito.",
        "DRIVER_UPDATE_SUCCESS": "El controlador se ha actualizado con éxito.",
        "DRIVER_CREATE_SUCCESS": "La información del conductor se ha agregado con éxito",
        "Expiry_Date": "Fecha de caducidad",
        "Case_number": "número de expediente",
        "Export_to_csv": "Exportar a CSV",
        "CONFIRM_EXPORT_TO_CSV": "¿Está seguro de que desea exportar todos los datos en formato .csv?",
        "Ride_sharing_tooltip": "El viaje compartido es una función avanzada, comuníquese con nuestro equipo de soporte para obtener más información",
        "In_Review": "En revisión",
        "Reset_password_success": "Contraseña restablecida satisfactoriamente",
        "Topup_note": "(Se permite recargar el saldo luego de activar al conductor)",
        "cash_balance": "Saldo en efectivo",
        "cash_wallet": "Efectivo en monedero",
        "total_balance": "Balance total",
        "total_cash_balance": "Saldo total en efectivo",
        "total_credit_balance": "Saldo de crédito total",
        "banking_status": "estado bancario",
        "bankingStatus": {
            "verified": "Verificado",
            "not_verified": "No verificado",
            "inComplete": "Incompleto",
            "connected": "Conectado",
            "disconnected": "Desconectado"
        },
        "INVALID_FILE_SIZE": "El tamaño del archivo debe ser menor a 8 Mb.",
        "totalDrivers": "Total de conductores",
        "profileStatus": "Estado del perfil",
        "profile_completed": "Perfil completado",
        "profile_incomplete": "Perfil Completado",
        "profile_inProgress": "Perfil en progreso",
        "in_review_completed": "En revisión (perfil completado)",
        "in_review_incomplete": "En revisión (perfil incompleto)",
        "in_review_inProgress": "En revisión (perfil en progreso)",
        "CASH_WALLET_DEPOSIT": "Billetera de efectivo",
        "payoutSelect": "Pago (se enviará un mensaje y un correo electrónico al conductor después del pago)",
        "Confirm_update_cash_balance": "Cambiar saldo en efectivo",
        "Confirm_update_cash_balance_msg": "¿Está seguro de que desea cambiar el saldo del conductor?",
        "cashBalance": "Saldo en efectivo",
        "cashBalance_unavailable": "0.00",
        "cashBalance_active": "Activo",
        "cashBalance_negative": "Negativo",
        "creditBalance": "Saldo de crédito",
        "ERROR_INPUT_DOCUMETID": "Por favor, ingrese el ID del documento.",
        "ERROR_INPUT_EXPIRYDATE": "Por favor, ingrese la fecha de vencimiento.",
        "driverType": "Tipo de conductor",
        "tooltip_in_review_completed": "Enviar mensaje en la bandeja de entrada a los conductores 'En revisión' que completen su perfil.",
        "tooltip_in_review_incomplete": "Enviar mensaje en la bandeja de entrada a los conductores 'En revisión' que no han completado su perfil.",
        "tooltip_in_review_inProgress": "Enviar mensaje en la bandeja de entrada a los conductores 'En revisión' que han completado su perfil pero necesitan verificación adicional.",
        "tooltip_active": "Enviar mensaje en la bandeja de entrada a los conductores 'Activos'.",
        "tooltip_inactive": "Enviar mensaje en la bandeja de entrada a los conductores que han reactivado su cuenta.",
        "active": "Activar",
        "inactive": "Desactivar",
        "inReviewInProgress": "En revisión",
        "Market_place": "Mercado",
        "Market_place_tooltip": "Permitir a los conductores elegir entre reservas bajo demanda o programadas.",
        "selectDriverType": "Seleccionar tipo de conductor",
        "PlsSelectDriverType": "Por favor seleccione el tipo de conductor",
        "emergencyContacts": "Contactos de emergencia",
        "switchVehicle": "Cambiar a cualquier vehículo",
        "switchVehicleNote": "Permitir que el conductor cambie a cualquier vehículo de la empresa proveedora asignada.",
        "vehicleModel": "Modelo",
        "licensePlateNumber": "Placa del vehículo",
        "addVehicle": "Agregar vehículo",
        "newVehicle": "Nuevo vehículo",
        "linkVehicle": "Vincular vehículo",
        "modal": "Modal",
        "selectVehicle": "Seleccionar vehículo",
        "selectVehicleNote": "Permitir que el conductor seleccione o cambie de vehículo para una reserva.",
        "Warning_change_company": "Advertencia: Reasignar este conductor a otra empresa desvinculará todos los vehículos asociados.",
        "searchDriverPlaceholder": "Buscar por nombre, teléfono, correo electrónico, nombre de usuario, matrícula",
        "please_select_a_name_of_bank": "Por favor, seleccione un nombre de banco"
    },
    "corporate": {
        "User_Name": "Nombre de usuario",
        "Edit_Balance": "Editar saldo",
        "Corporates": "Empresas",
        "Supplier": "Proveedor",
        "CarTypes": "Tipos de coche",
        "Add": "Agregar",
        "Balance": "Saldo",
        "Activate": "Activar",
        "Deactivate": "Desactivar",
        "Delete": "Borrar",
        "Company_Name": "Nombre de empresa",
        "Admin_Name": "Nombre del administrador",
        "Username": "Nombre de usuario",
        "Phone_Number": "Número de teléfono",
        "importBooking": "Capaz de importar reservas",
        "Email": "Correo electrónico",
        "Registered_From": "Registrado desde",
        "Registration_Date": "Fecha de Registro",
        "Status": "Estado",
        "Actions": "Acciones",
        "Action": "Acción",
        "Inactive": "Inactivo",
        "Active": "Activo",
        "In_Review": "En revisión",
        "Edit": "Editar",
        "View": "Vista",
        "ADD_CORPORATE_CARD": "Agregar tarjeta corporativa",
        "selectCountry": "Seleccionar país",
        "CONFIRM_DELETE_CARD": "¿Está seguro de que desea eliminar estas tarjetas?",
        "ALERT_SELECT_ACTIVATE": "Seleccione corporativo para activar.",
        "ALERT_SELECT_DEACTIVATE": "Seleccione corporativo para desactivar.",
        "ALERT_SELECT_DELETE": "Seleccione empresa para eliminar",
        "CONFIRM_DELETE": "¿Quieres eliminar esta empresa?",
        "CONFIRM_DELETE_USER": "¿Desea eliminar este usuario corporativo?",
        "CONFIRM_DEACTIVATE_MULTI": "¿Quieres desactivar estas empresas?",
        "CONFIRM_ACTIVATE_MULTI": "¿Quieres activar estos corporativos?",
        "CONFIRM_DELETE_MULTI": "¿Desea eliminar estas empresas?\n ** Solo se pueden eliminar las empresas que están inactivas.",
        "ERROR_INPUT_PHONE": "Por favor, especifique un número de teléfono válido.",
        "ERROR_INPUT_VALIDPHONE": "Por favor ingrese un número de teléfono válido.",
        "ERROR_EXISTED_PHONE": "Este teléfono ha existido en el sistema.  Por favor ingrese otro",
        "Account": "Cuenta",
        "Corp_traveler": "viajero del cuerpo",
        "Payment_methods": "Métodos de pago",
        "Corp_operators": "operadores de corporaciones",
        "Pricing": "Tarifas",
        "COMPANY_INFORMATION": "Información de la empresa",
        "Company_name": "nombre de empresa",
        "Company_ID": "ID de la empresa (para registro de viajero corporativo)",
        "Company_address": "Dirección de la empresa",
        "Invoice_email": "Correo electrónico de la factura",
        "Confirmation_email": "Email de confirmación",
        "colorCodeBooking": "Código de color",
        "ADMIN_ACCOUNT": "cuenta de administrador",
        "First_name": "Nombre de pila",
        "Last_name": "Apellido",
        "Commission": "Comisión",
        "commissionBooking": "Aplicar comisión para reservas desde la aplicación/pwa",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "Reset_password": "Restablecer la contraseña",
        "Employee_Name": "Nombre de empleado",
        "Created_Date": "Fecha de creación",
        "Add_corporate_card": "Agregar tarjeta corporativa",
        "Corp_Users": "Usuarios corporativos",
        "Pricing_Default": "Plantilla de tarifa corporativa",
        "Pricing_Discount": "Descuento en porcentaje (aplicado sólo a viajeros corporativos)",
        "Markup_By_Percent": "Marcado por porcentaje (aplicado solo para viajeros corporativos)",
        "Pricing_Discount_new": "Descuento por porcentaje",
        "Markup_By_Percent_new": "Incremento por porcentaje",
        "Pricing_Add_different_rates": "Asignar tarifas personalizadas",
        "ERROR_INPUT_COMPANYNAME": "Ingrese el nombre de la empresa.",
        "ERROR_INPUT_USERNAME": "Por favor ingrese el nombre de usuario.",
        "ERROR_INPUT_FIRSTNAME": "Por favor ingrese el primer nombre.",
        "ERROR_INPUT_EMAIL": "Por favor ingrese el correo electrónico.",
        "ERROR_INPUT_VALID_EMAIL": "Por favor, introduce una dirección de correo electrónico válida.",
        "ERROR_INPUT_VALID_NUMBER": "Por favor ingrese un número válido",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Por favor, introduzca un valor entre {0} y {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "La cuenta {0} se ha creado correctamente.  Consulte el correo electrónico {1} para obtener los detalles de las credenciales de inicio de sesión.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "La información ha sido actualizada satisfactoriamente",
        "INFO_UPDATE_PRICING_SUCCESS": "Precios actualizados correctamente",
        "INFO_RESET_PASSWORD_SUCCESS": "La cuenta ha sido restablecida satisfactoriamente. Revise su correo electrónico para obtener sus claves de acceso",
        "COMFIRM_RESET_PASSWORD": "¿Quieres restablecer la contraseña?",
        "Traveler_signature": "Firma del viajero",
        "Parcel_Delivery": "Habilitar entrega de paquetes",
        "Tracking_log": "registros de seguimiento",
        "Rating": "Clasificación",
        "Email_address": "Dirección de correo electrónico",
        "Assistant_email": "Correo electrónico de asistente",
        "Corp_PO": "Orden de compra de la corporación",
        "Cost_centre": "centro de costo",
        "Corp_division": "División de empresa",
        "Corp_id": "Identificador empresa",
        "Department": "departamento",
        "Manager_email": "correo electrónico del gerente",
        "Manager_name": "El nombre del gerente",
        "Corporate_card": "Tarjeta corporativa",
        "Direct_invoicing": "facturación directa",
        "Corporate_Prepaid": "Prepago Corporativo",
        "Cash": "Dinero en efectivo",
        "Car_Type_ID": "ID tipo de vehículo",
        "App_Display_Name": "nombre App",
        "Normal_Fare": "Tarifa normal",
        "Flat_Fare": "Tarifa Plana",
        "Hourly_Daily_Rate": "Horas/días",
        "Delivery_Rate": "Entrega",
        "Assign_rate": "Asignar tarifa",
        "Zone": "Zona",
        "Rate": "Calificar",
        "Zone_Rate": "Zona - tarifa",
        "Please_select_rate": "Por favor seleccione tarifa",
        "Paid_by": "Pagado por",
        "Enter_new_credit_card": "Introducir nueva tarjeta de crédito",
        "TOP_UP": "aumentar",
        "Top_up": "aumentar",
        "Topup_amount": "incrementar importe",
        "Currency": "Divisa",
        "ERROR_INPUT_AMOUNT": "Ingrese una cantidad válida.",
        "VAT_number": "Número de IVA",
        "Gender": "Seleccione",
        "Select_Gender": "Seleccionar",
        "Male": "Masculino",
        "Female": "Femenino",
        "Date_of_birth": "Fecha de nacimiento",
        "Street_address": "Calle",
        "City": "Ciudad",
        "State": "Estado",
        "Zip_code": "Código postal",
        "Country": "País",
        "adding_new_card": "Está agregando una nueva tarjeta para usar el servicio en el área de %{zoneName}.",
        "No_Support": "La nueva tarjeta introducidad no es válida en esta zona",
        "Job_title": "cargo profesional",
        "required_phone_number_payment": "Se requiere el número de teléfono de la empresa.  Por favor, actualice el perfil para continuar.",
        "Yes": "Sí",
        "No": "No",
        "AddCardBeforeTopup": "No se encontró ninguna tarjeta de crédito.  Agregue una nueva tarjeta para continuar.",
        "flightNumber": "Número de vuelo",
        "Company_Type": "Tipo de empresa",
        "Standard": "Corporativo estándar",
        "Airline": "Aerolínea",
        "Branding": "Marca",
        "bgImage": "Imagen de fondo (1600x900)",
        "logoImage": "Imagen del logotipo",
        "aliasTitle": "Parámetro Alias (URL)",
        "importChauffeurBooking": "May kakayahang mag-import ng mga booking sa transportasyon",
        "isCorporateVip": "VIP corporativo",
        "isCorporateVipToolTip": "Habilite esta configuración para asignar automáticamente el estado VIP a todos los viajeros corporativos al crearlos, puede desactivarlo para cada usuario individual.",
        "qrTitle": "Enlace de reserva web con código QR",
        "qrNote": "¡Aquí está su enlace de reserva personalizado! Muéstrelo en bares, recepciones de hoteles, habitaciones de huéspedes y en su sitio web—en cualquier lugar donde sus clientes puedan necesitar un viaje o entrega. Considere diseñar carteles con su código QR único para permitir a los clientes escanear y reservar fácilmente su viaje.",
        "PricingLegacy": "Precios (heredados)",
        "defaultTemplate": "Plantilla predeterminada",
        "Select_Rate_Template": "Seleccionar plantilla de tarifa"
    },
    "airline": {
        "Airlines": "Aerolíneas",
        "Add": "Agregar",
        "Activate": "Activar",
        "Deactivate": "Desactivar",
        "Delete": "Eliminar",
        "Company_Name": "Nombre de la empresa",
        "Admin_Name": "Nombre del administrador",
        "Username": "Nombre de usuario",
        "Phone_Number": "Número de teléfono",
        "Email": "Correo electrónico",
        "Registered_From": "Registrado desde",
        "Registration_Date": "Fecha de registro",
        "Status": "Estado",
        "Actions": "Acciones",
        "Action": "Acción",
        "Inactive": "Inactivo",
        "Active": "Activo",
        "In_Review": "En revisión",
        "Edit": "Editar",
        "View": "Ver",
        "ADD_CORPORATE_CARD": "Agregar tarjeta de aerolínea",
        "selectCountry": "Seleccionar país",
        "CONFIRM_DELETE_CARD": "¿Está seguro de que desea eliminar estas tarjetas?",
        "ALERT_SELECT_ACTIVATE": "Por favor, seleccione la aerolínea para activar.",
        "ALERT_SELECT_DEACTIVATE": "Por favor, seleccione la aerolínea para desactivar.",
        "ALERT_SELECT_DELETE": "Por favor, seleccione la aerolínea para eliminar.",
        "CONFIRM_DELETE": "¿Desea eliminar esta aerolínea?",
        "CONFIRM_DELETE_USER": "¿Desea eliminar este usuario de la aerolínea?",
        "CONFIRM_DEACTIVATE_MULTI": "¿Está seguro de que desea desactivar esta empresa?",
        "CONFIRM_ACTIVATE_MULTI": "¿Está seguro de que desea activar esta empresa?",
        "CONFIRM_DELETE_MULTI": "¿Está seguro de que desea eliminar esta empresa? \n** Solo las empresas que están inactivas pueden eliminarse.",
        "ERROR_INPUT_PHONE": "Por favor, especifique un número de teléfono válido.",
        "ERROR_INPUT_VALIDPHONE": "Por favor, ingrese un número de teléfono válido.",
        "ERROR_EXISTED_PHONE": "Este número ya existe en el sistema. Por favor, ingrese otro.",
        "Airline": "Aerolínea",
        "Crew": "Tripulación",
        "Payment_methods": "Métodos de pago",
        "Airline_operators": "Operadores de aerolíneas",
        "Pricing": "Precios",
        "COMPANY_INFORMATION": "Información de la empresa",
        "Company_name": "Nombre de la empresa",
        "Company_ID": "ID de la empresa",
        "Company_address": "Dirección de la empresa",
        "Invoice_email": "Correo de facturación",
        "Confirmation_email": "Correo de confirmación",
        "colorCodeBooking": "Código de color",
        "ADMIN_ACCOUNT": "Cuenta de administrador",
        "First_name": "Nombre",
        "Last_name": "Apellido",
        "Commission": "Comisión",
        "Required_fields": "Campos obligatorios",
        "Required_fields_crews": "Nota: Para una nueva cuenta de tripulación, la contraseña predeterminada es \"12345678",
        "Save": "Guardar",
        "Cancel": "Cancelar",
        "Reset_password": "Restablecer contraseña",
        "Crew_Name": "Tripulación",
        "Created_Date": "Fecha de creación",
        "Add_corporate_card": "Agregar tarjeta de aerolínea",
        "Corp_Users": "Operadores",
        "Pricing_Default": "Predeterminado",
        "Pricing_Discount": "Descuento por porcentaje",
        "Markup_By_Percent": "Incremento por porcentaje",
        "Pricing_Add_different_rates": "Agregar diferentes tarifas",
        "ERROR_INPUT_COMPANYNAME": "Por favor, ingrese el nombre de la empresa.",
        "ERROR_INPUT_USERNAME": "Por favor, ingrese el nombre de usuario.",
        "ERROR_INPUT_FIRSTNAME": "Por favor, ingrese el nombre.",
        "ERROR_INPUT_EMAIL": "Por favor, ingrese el correo electrónico.",
        "ERROR_INPUT_VALID_EMAIL": "Por favor, ingrese una dirección de correo electrónico válida.",
        "ERROR_INPUT_VALID_NUMBER": "Por favor, ingrese un número válido.",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Por favor, ingrese un valor entre {0} y {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "La cuenta {0} se ha creado correctamente.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "La información se ha actualizado correctamente.",
        "INFO_UPDATE_PRICING_SUCCESS": "Precios actualizados correctamente.",
        "INFO_RESET_PASSWORD_SUCCESS": "La cuenta {0} se ha restablecido correctamente.",
        "COMFIRM_RESET_PASSWORD": "¿Desea restablecer la contraseña?",
        "Traveler_signature": "Firma del viajero",
        "Tracking_log": "Registro de seguimiento",
        "Rating": "Calificación",
        "Email_address": "Dirección de correo electrónico",
        "Assistant_email": "Correo electrónico del asistente",
        "Corp_PO": "Orden de compra corporativa",
        "Cost_centre": "Centro de costos",
        "Corp_division": "División corporativa",
        "Corp_id": "ID corporativo",
        "Department": "Departamento",
        "Manager_email": "Correo electrónico del gerente",
        "Manager_name": "Nombre del gerente",
        "Corporate_card": "Tarjeta de aerolínea",
        "Direct_invoicing": "Facturación directa",
        "Corporate_Prepaid": "Pago anticipado de aerolínea",
        "Cash": "Efectivo",
        "Car_Type_ID": "ID de tipo de coche",
        "App_Display_Name": "Nombre mostrado en la aplicación",
        "Normal_Fare": "Regular",
        "Flat_Fare": "Tarifa fija",
        "Hourly_Daily_Rate": "Por hora/día",
        "Delivery_Rate": "Entrega",
        "Assign_rate": "Asignar tarifa",
        "Zone": "Zona",
        "Rate": "Tarifa",
        "Zone_Rate": "Zona - Tarifa",
        "Please_select_rate": "Por favor seleccione la tarifa",
        "Paid_by": "Pagado por",
        "Enter_new_credit_card": "Ingresar nueva tarjeta de crédito",
        "TOP_UP": "Recargar",
        "Top_up": "Recarga",
        "Topup_amount": "Monto de recarga",
        "Currency": "Moneda",
        "ERROR_INPUT_AMOUNT": "Por favor, ingrese un monto válido.",
        "VAT_number": "Número de IVA",
        "Gender": "Género",
        "Select_Gender": "Seleccionar",
        "Male": "Masculino",
        "Female": "Femenino",
        "Date_of_birth": "Fecha de nacimiento",
        "Street_address": "Dirección",
        "City": "Ciudad",
        "State": "Estado",
        "Zip_code": "Código postal",
        "Country": "País",
        "adding_new_card": "Está agregando una nueva tarjeta para usar el servicio en el área %{zoneName}",
        "No_Support": "La adición de nuevas tarjetas no está actualmente disponible en esta área",
        "Job_title": "Título del trabajo",
        "required_phone_number_payment": "Se requiere el número de teléfono corporativo. Por favor, actualice su perfil para continuar.",
        "Yes": "Sí",
        "No": "No",
        "AddCardBeforeTopup": "No se encontró una tarjeta de crédito. Por favor, agregue una nueva tarjeta para continuar."
    },
    "message": {
        "Add": "Agregar",
        "Delete": "Borrar",
        "Items_per_page": "elementos por página",
        "Page": "Página",
        "Search_here": "Busca aquí",
        "Shown_Active": "{0} - {1} de {2} mostrado",
        "Date": "fecha",
        "Subject": "Sujeto",
        "To": "A",
        "Type": "Tipo",
        "Result": "Resultado",
        "Actions": "Acciones",
        "New_message": "Nuevo mensaje",
        "MESSAGE_DETAILS": "detalles de mensaje",
        "All": "Todo",
        "Company": "Compañía",
        "Active": "Activo",
        "In_Active": "Inactivo",
        "In_Review": "En revisión",
        "Send_to": "Enviar a",
        "All_drivers": "Todos los conductores",
        "All_customers": "Todos los clientes",
        "All_merchants": "Todos los comerciantes",
        "Customized_driver": "Conductores específicos",
        "Customized_customer": "Clientes específicos",
        "Customized_merchant": "Comerciante personalizado",
        "Receiver_list": "Lista de receptores",
        "Content": "Contenido",
        "Required_fields": "Campos requeridos",
        "Search_driver_name_driver_phone_number": "Buscar nombre del conductor, número de teléfono del conductor",
        "Search_category_name": "Nombre de la categoría de búsqueda",
        "Search_customer_name_customer_phone_number": "Buscar nombre de cliente, número de teléfono del cliente",
        "Search_merchant_name_merchant_phone_number": "Buscar nombre de comerciante, número de teléfono del comerciante",
        "Search_car_type": "Buscar tipo de vehículo",
        "Searching": "Buscando...",
        "No_results": "No hay resultados",
        "Send": "Enviar",
        "Cancel": "Cancelar",
        "SMS_failed_Inbox_succeeded": "SMS falló, la bandeja de entrada tuvo éxito",
        "Failed": "Fallido",
        "Succeeded": "logrado",
        "CONFIRM_DELETE": "¿Quieres borrar este mensaje?",
        "CONFIRM_DELETE_MULTI": "¿Quieres eliminar estos mensajes?",
        "ALERT_SELECT_DELETE": "Seleccione el mensaje para eliminar.",
        "ERROR_INPUT_RECEIVERLIST": "Elija al menos un conductor para enviar el mensaje",
        "ERROR_INPUT_CUSTOMER_RECEIVERLIST": "Elija al menos un cliente para enviar el mensaje",
        "ERROR_INPUT_SUBJECT": "Por favor ingrese asunto",
        "ERROR_INPUT_CONTENT": "Por favor ingrese el contenido",
        "ERROR_INPUT_LEAST_ONE_SUBJECT_CONTENT": "Por favor, configure al menos un idioma para continuar",
        "ERROR_INPUT_SUBJECT_MULTI_LANGUAGE": "Por favor, ingrese el asunto para el idioma {0}",
        "ERROR_INPUT_CONTENT_MULTI_LANGUAGE": "Por favor, ingrese el contenido para el idioma {0}",
        "ERROR_INPUT_URL_MULTI_LANGUAGE": "Por favor, ingrese la URL para el idioma {0}",
        "ERROR_INPUT_TITLE_MULTI_LANGUAGE": "Por favor, ingrese el título para el idioma {0}",
        "ERROR_INPUT_BODY_MULTI_LANGUAGE": "Por favor, ingrese el cuerpo para el idioma {0}",
        "import_fail_success_driver": "%{success} conductor(es) se han importado correctamente, %{fail} fallaron.",
        "import_fail_success_passenger": "%{success} cliente(s) se han importado correctamente, %{fail} fallaron.",
        "import_fail_success_merchant": "%{success} comerciante(s) se han importado correctamente, %{fail} fallaron.",
        "CONFIRM_SEND_SUCCESS": "Tu mensaje ha sido enviado.  Esto puede tomar unos pocos minutos.  Espere mientras el sistema procesa su solicitud.",
        "Load_message_and_sms_fail": "Los errores ocurrieron al cargar el mensaje y los detalles de SMS",
        "Update_message_and_sms_fail": "Los errores ocurrieron al actualizar el mensaje y los detalles de SMS",
        "Update_message_and_sms_success": "Los detalles de mensajes y SMS se han actualizado con éxito",
        "Driver_List": "Lista de conductores",
        "Car_Type_List": "Lista de tipos de coches",
        "Search_vehicle_type_name": "buscar nombre de tipo de vehículo",
        "ALERT_PROCESSING_DELETE": "Su petición está siendo procesada, puede tardar algunos segundos",
        "Customer": "Cliente",
        "Driver": "Conductor",
        "StatusOfCustomer": "Estatus del cliente",
        "StatusOfDriver": "Estatus del conductor",
        "StatusOfMerchant": "Estado del comerciante",
        "SendTo": "Enviar a",
        "DownloadReceiverList": "Descargar lista de receptores",
        "warningInputChangeOver": "Hay un cambio relativo de más del 20% entre las 2 entradas recientes.  ¡Por favor considera!",
        "NoteDownloadReveverList": "Después de 1 mes, la descarga de la lista de receptores se desactivará.",
        "Load_voip_fail": "Los errores ocurrieron al cargar los detalles de VOIP.",
        "Update_voip_success": "Los detalles de VOIP se han actualizado con éxito.",
        "Update_voip_fail": "Los errores ocurrieron al actualizar los detalles de VOIP.",
        "expiryDate": "Enviar al nuevo usuario hasta",
        "expiryDate_placeholder": "Expiry Date (mm/dd/yyyy)",
        "NA": "No disponible",
        "PleaseSelectStatusOfDriver": "Por favor, seleccione el estado del conductor",
        "versionApp": "Versión de la aplicación",
        "platform": "Plataforma",
        "contentType": "Tipo de contenido",
        "url": "URL",
        "title": "Título",
        "contentId": "ID de contenido",
        "body": "Cuerpo",
        "image_notification": "Imagen",
        "platformItem": {
            "all": "Todos",
            "iOS": "iOS",
            "android": "Android"
        },
        "comparisonVersionApp": {
            "is": "Es",
            "is_not": "No es",
            "is_one_of": "Es uno de",
            "is_not_one_of": "No es uno de",
            "greater_or_equal": "Mayor o igual",
            "less_or_equal": "Menor o igual"
        },
        "contentTypeItem": {
            "html": "HTML",
            "link": "Enlace"
        },
        "Please_input": "Este campo es obligatorio"
    },
    "fleetInfo": {
        "Fleet_name": "Nombre de la flota",
        "Phone_number": "Número de teléfono",
        "Email_address": "Dirección de correo electrónico",
        "Country": "País",
        "Time_zone": "Zona horaria",
        "Address": "Habla a",
        "Website": "Sitio web",
        "Currency": "Divisa",
        "Distance_unit": "Unidad de distancia",
        "Load_fleet_info_fail": "Ocurrió un error durante la carga de la información de flota"
    },
    "surchargePolicy": {
        "Surchage_Policy": "Política de recargo",
        "SurgePolicy": "Política de aumento",
        "surgeType": "Tipo de aumento",
        "bookingTimeCoverage": "Cobertura de tiempo de reserva",
        "Delete_surcharge": "¿Está seguro de que desea eliminar el recargo seleccionado?",
        "Delete_surcharge_item": "¿Está seguro de que desea eliminar el elemento de recargo seleccionado?",
        "Delete_surcharge_item_success": "El recargo ha sido desactivado correctamente",
        "Delete_surcharge_item_fail": "Se produjeron errores al desactivar el elemento de recargo",
        "linkNewPolicy": "Vincular una nueva política",
        "Link": "Vincular",
        "ViewPolicy": "Ver política",
        "Unlink": "Desvincular",
        "Create_Surcharge_Item_success": "El elemento de recargo se ha creado correctamente",
        "Create_Surcharge_Item_fail": "Se produjeron errores al crear el elemento de recargo",
        "Update_Surcharge_Item_success": "El elemento de recargo se ha actualizado correctamente",
        "Update_Surcharge_Item_fail": "Se produjeron errores al actualizar el elemento de recargo",
        "single": "Día único",
        "yearly": "Anual",
        "weekly": "Día de la semana",
        "Please_select_at_least_one_day": "Por favor, seleccione al menos un día",
        "Booking_lead_time": "Tiempo de Anticipación de Reserva",
        "Start_date_must_be_before_end_date": "The start date must be before the end date"
    },
    "penaltyPolicy": {
        "penaltyPolicy": "Política de penalización",
        "Reservation": "Reserva",
        "onDemand": "Bajo demanda",
        "noShow": "No presentación",
        "driverNoShow": "Falta del conductor",
        "freeCancellation": "Margen de cancelación gratuita",
        "fieldExclusions": "Campos incluidos",
        "penaltyActive": "Nivel de duración de cancelación - antes de la hora de recogida",
        "penaltyType": "Tipo de penalización",
        "Compensation": "Compensación del proveedor/conductor",
        "Create_penalty_success": "La plantilla de penalización se ha creado correctamente",
        "Create_penalty_fail": "Se produjeron errores al crear la plantilla de penalización",
        "Update_penalty_success": "La plantilla de penalización se ha actualizado correctamente",
        "Update_penalty_fail": "Se produjeron errores al actualizar la plantilla de penalización",
        "confirmDelete": "Confirmar eliminación",
        "confirmDeleteContent": "¿Está seguro de que desea eliminar esta política de penalización? Eliminar esta política desvinculará todas las tarifas de reserva.",
        "Delete_success": "La plantilla de penalización se ha eliminado correctamente",
        "Delete_fail": "Se produjeron errores al eliminar la plantilla de penalización",
        "payoutPolicy": "Política de pago",
        "commission": "Porcentaje de penalización del cliente",
        "commissionPayout": "Porcentaje de pago del proveedor",
        "fixAmount": "Monto",
        "amount": "Monto",
        "amount_driver": "Cantidad",
        "percent": "Percent",
        "percent_driver": "Porcentaje basado en la tarifa",
        "basedOnPayout_driver": "Porcentaje basado en el Pago",
        "percentPayout": "% del pago",
        "percentFare": "% de la tarifa",
        "penaltyFee": "Tarifa de cancelación",
        "commissionType": "Tipo de compensación",
        "commissionFee": "Compensación",
        "tax": "Impuesto",
        "techFee": "Tarifa tecnológica",
        "minute": "minuto",
        "hour": "hora",
        "setDefaultSuccess": "La política de penalización predeterminada se ha establecido con éxito.",
        "setDefaultFail": "Se produjeron errores al establecer la política de penalización predeterminada."
    },
    "rateTemplates": {
        "Rate_Templates": "Plantillas de tarifas",
        "newRate": "Nueva plantilla de tarifas",
        "placeHolderName": "Ingrese el nombre de la plantilla de tarifas",
        "Assign_Rate": "Asignar tarifa",
        "carTypeName": "Nombre del tipo de coche",
        "appDisplayName": "Nombre mostrado en la aplicación",
        "assign_rate_success": "El tipo de coche ha sido asignado a la tarifa correctamente",
        "assign_rate_fail": "Se produjeron errores al asignar la tarifa",
        "confirmDeleteTitle": "Confirmar eliminación",
        "confirmDelete": "¿Está seguro de que desea eliminar esta plantilla? Eliminar esta plantilla desvinculará todos los socios/corporaciones a los que esté vinculada.",
        "setDefaultSuccess": "La plantilla de tarifa predeterminada se ha establecido correctamente",
        "setDefaultFail": "Se produjeron errores al establecer la plantilla de tarifa predeterminada",
        "Delete_rate_template_success": "La plantilla de tarifa se ha eliminado correctamente",
        "Delete_rate_template_fail": "Se produjeron errores al eliminar la plantilla de tarifa",
        "setDefault": "Establecer como predeterminado",
        "Regular": "Tarifa regular",
        "Sharing": "Tarifa de viaje compartido en la calle",
        "Flat": "Tarifa fija",
        "Hourly": "Por hora/Día",
        "Delete_default": "Si intenta eliminar la plantilla predeterminada, no se debe permitir hasta que establezca otra tarifa predeterminada."
    },
    "supplierPlan": {
        "Supplier_Plan": "Plan del proveedor",
        "rateTemplate": "Esquema de tarifas",
        "rateTemplateNote": "El cálculo de tarifas utilizado para determinar el monto pagado al conductor o proveedor.",
        "percent": "Comisión de flota",
        "percentNote": "El porcentaje cobrado por la flota en cada reserva.",
        "amount": "Monto fijo",
        "amountNote": "El monto que la flota deduce en cada reserva.",
        "supplierPenaltyId": "Política de penalización del proveedor",
        "payoutType": "Tipo",
        "Select_penalty_policy": "Seleccionar política de penalización",
        "Select_corporate": "Seleccionar Corporativo",
        "Select_supplier_plan": "Seleccionar plan de proveedor",
        "Create_supplier_plan_success": "El plan del proveedor se ha creado correctamente",
        "Create_supplier_plan_fail": "Se produjeron errores al crear el plan del proveedor",
        "Update_supplier_plan_success": "El plan del proveedor se ha actualizado correctamente",
        "Update_supplier_plan_fail": "Se produjeron errores al actualizar el plan del proveedor",
        "Payout_Plan": "Plan de pagos",
        "Payout_Plan_note": "Configurar cuánto se paga al proveedor.",
        "default": "Predeterminado",
        "custom": "Plan personalizado",
        "cannotSetPayout": "No se puede establecer un plan de pagos para el conductor de un socio externo."
    },
    "stopSales": {
        "stopSales": "Detener Venta",
        "confirm_delete": "¿Está seguro de que desea eliminar esta póliza?",
        "Create_stop_sales_success": "La detención de ventas se ha creado con éxito.",
        "Create_stop_sales_fail": "Se produjeron errores al crear ventas de detención",
        "Update_stop_sales_success": "La detención de ventas se ha actualizado con éxito.",
        "Update_stop_sales_fail": "Se produjeron errores al actualizar las ventas detenidas",
        "Delete_success": "La venta de paradas ha sido eliminada con éxito.",
        "Delete_fail": "Se produjeron errores al eliminar las ventas de parada",
        "allVehicle": "Todos los vehículos",
        "allZone": "Todo Zona"
    },
    "generalSetting": {
        "alertNotifications": {
            "title": "Notificaciones de alerta",
            "emails": "Correos electrónicos",
            "emailsPlaceholder": "Ingresar correo electrónico",
            "slack": "Canal de Slack (Instrucciones)",
            "slackPlaceholder": "URL de publicación de Slack",
            "discord": "Canal de Discord (Instrucciones)",
            "discordPlaceholder": "Ingresar canal de Discord",
            "telegram": "Canal de Telegram (Instrucciones)",
            "telegramPlaceholder": "Ingresar canal de Telegram"
        },
        "showFare": {
            "title": "Mostrar tarifa al conductor",
            "totalFare": "Tarifa total",
            "estimateGross": "Estimación de ingresos brutos"
        },
        "carHailing": "Solicitud de taxi en la calle",
        "regular": "Regular",
        "cancelTimeout": "Cancelar automáticamente las reservas que excedan el tiempo límite",
        "allowStripePaymentLink": "Permitir generar enlace de pago de Stripe",
        "flat": "Fijo",
        "techFee": "Tarifa tecnológica por transacción",
        "customizeLogo": "Personalizar logotipo del panel",
        "logo": "Logotipo",
        "customerApp": "Aplicación del cliente",
        "hourly": "Por hora",
        "shuttle": "Transporte lanzadera",
        "parcel": "Paquete",
        "freeCancelTime": "Número de cancelaciones gratuitas por día",
        "AM": "AM",
        "PM": "PM",
        "RUSH_HOUR": "Recargo",
        "Name": "Nombre",
        "Date": "fecha",
        "Mon": "Lun",
        "Tue": "Mar",
        "Wed": "casarse",
        "Thu": "Jue",
        "Fri": "Vie",
        "Sat": "Se sentó",
        "Sun": "sol",
        "Time_range": "Intervalo de tiempo",
        "From": "Desde",
        "To": "A",
        "Rush_hour_time_calculation": "Tiempo de cálculo del recargo",
        "Rush_hour_surcharge": "Recargo",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "MDISPATCHER_CANCELLATION": "Cancelaciones usuarios/colaboradores/reservas web",
        "Book_now": "Reservar ahora",
        "MDISPATCHER_CANCELLATION_TOOLTIP": "Pax / Socio / Cancelación de reserva web",
        "Book_now_toolTip": "La tarifa de cancelación se aplica si las reservas bajo demanda se cancelan dentro de",
        "Book_later_toolTip": "La tarifa de cancelación se aplica si una reserva se cancela antes de la hora de recogida",
        "Drv_Book_now_toolTip": "Se aplica una tarifa de cancelación si las reservas bajo demanda se cancelan dentro del tiempo establecido, desde el momento de aceptación.",
        "Drv_Book_later_toolTip": "Se aplica una tarifa de cancelación si las reservas anticipadas se cancelan dentro del tiempo establecido, antes de la hora de recogida esperada.",
        "Free_cancel": "Duración de cancelación gratuita",
        "Hide_cancel_btn": "Ocultar botón de cancelación después de los tiempos establecidos",
        "Driver_cancellation": "Cancelación del conductor",
        "Time_day": "Veces por día",
        "Duration": "Duración",
        "Times": "Veces",
        "Book_later": "Reservar con antelación",
        "Intercity": "Interurbano",
        "Intercity_tooltip": "Se aplica una tarifa de cancelación si una reserva interurbana se cancela dentro del tiempo establecido, antes de la hora de recogida.",
        "MDISPATCHER_NO_SHOW": "no show",
        "AIRPORT_FEE": "Tarifa de aeropuerto",
        "From_airport": "Del aeropuerto",
        "To_airport": "Al aeropuerto",
        "MEET_DRIVER": "Conozca al conductor",
        "On_curb": "en la acera",
        "Meet_Greet": "Conocer y saludar",
        "Add": "Agregar",
        "Edit": "Editar",
        "DELETE_SURCHARGE": "Eliminar recargo",
        "DELETE_SERVICE": "Eliminar servicio",
        "CHANGE_APPLY_SERVICE_FEES": "Cambiar aplicar tarifas de servicio",
        "DELETE_CONFIRM": "¿Está seguro de que desea eliminar este elemento?",
        "DELETE_SURCHARGE_CONFIRM": "¿Está seguro de eliminar el cargo seleccionado?",
        "DELETE_ADDITIONAL_SERVICES_CONFIRM": "¿Está seguro de eliminar el servicio seleccionado?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_CUSTOM": "¿Está seguro de aplicar tarifas diferentes para zonas separadas?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_ALL": "¿Está seguro de aplicar las mismas tarifas para todas las zonas?",
        "EDIT_SERVICE_FEES": "Editar tarifas de servicio",
        "EDIT_SERVICE_FEES_CONFIRM": "¿Está seguro de que desea salir sin guardar la configuración de %{currentZone}?",
        "HEAVY_TRAFFIC": "Tráfico pesado",
        "Heavy_traffic_surcharge": "Recargo por tráfico pesado",
        "TOLL_FEE": "Peaje",
        "parkingFee": "Tarifa de estacionamiento",
        "gasFee": "Tarifa de combustible",
        "OTHER_FEES": "Otros cargos",
        "Can_edit": "Capaz de editar",
        "Can_add_note": "Capaz de agregar nota",
        "Other_fees_amount": "Importe de otras tasas",
        "TAX": "IMPUESTO",
        "Tax_surcharge": "recargo fiscal",
        "TIP": "Propina",
        "Default_tip": "Consejo predeterminado",
        "RESERVATION_REMINDER": "Recordatorio de reserva",
        "Driver_app_SMS_alert_before": "Aplicación de conductor - SMS y alerta antes",
        "notifyWhenDriverFailStartTrip": "Notificar al operador si el conductor no inicia el viaje antes de la hora de recogida",
        "notifyWhenDriverFailStartTripTooltip": "Las notificaciones se mostrarán en la sección de notificaciones de la plataforma. También puede configurar alertas para que se envíen por correo electrónico, Slack, Discord o Telegram para actualizaciones oportunas.",
        "Pax_app_alert_before": "Aplicación Pax - Alerta antes",
        "Confirm_driver_info_via_email_before": "Enviar email/sms de confirmación de reserva al cliente antes",
        "Confirm_driver_info_via_email_before_hint": "El sistema enviará una confirmación de reserva al cliente según el tiempo establecido, antes de la hora de recogida.",
        "Show_request_tab_on_driver_app": "Mostrar pestaña \"Solicitudes\" en la aplicación del conductor",
        "Show_preferred_tab_on_driver_app": "Mostrar pestaña \"Preferidos\" en la aplicación del conductor",
        "Sound_notification": "Sonido de notificación",
        "Advance_information": "Información adicional viajero corporativo",
        "Load_general_fail": "Ocurrió un error al descargar la configuración general",
        "Update_general_success": "La configuración general se ha actualizado correctamente",
        "Update_general_fail": "Los errores ocurrieron al actualizar la configuración general",
        "Time_over_lap": "Los intervalos de tiempo no deben superponerse entre sí",
        "Allow_passenger_to_register_as_corp_traveler": "Permitir que el pasajero se registre como viajero corporativo",
        "Not_Allow_Make_Booking_Without_Assign_Fare": "No mostrar el tipo de coche en PWA y en la aplicación si no hay tarifa asignada (v4.6.60 y superior).",
        "Not_Allow_show_car_type_on_cc": "No mostrar el tipo de coche en CC si no hay tarifa asignada",
        "Disable_Direct_Invoicing_Receipt_Email": "Deshabilitar correo electrónico de recibo de facturación directa",
        "Additional_services": "Servicios adicionales",
        "Edit_additional_services": "Editar servicios adicionales",
        "Service_Fee_By_Currencies": "Tarifa de servicio",
        "Service_type": "Tipo de Servicio",
        "Optional": "Opcional",
        "Compulsory": "Obligatorio",
        "Vehicle_type": "Tipo de vehículo",
        "Adding_additional_service_success": "Nuevo servicio ha sido creado con éxito",
        "Update_additional_service_success": "El servicio ha sido actualizado con éxito.",
        "Delete_additional_service_success": "Servicio eliminado satisfactoriamente",
        "Adding_additional_service_fail": "No se pudo agregar el servicio",
        "Update_additional_service_fail": "No se pudo actualizar el servicio",
        "Other_settings": "Otros ajustes",
        "Operator_assign_error": "La configuración general se ha actualizado con éxito.",
        "Create_surcharge_success": "Se produjeron errores al actualizar la configuración general.",
        "Update_surcharge_success": "Los rangos de tiempo no deben superponerse entre sí.",
        "Delete_surcharge_success": "Permitir que los pasajeros se registren como usuarios corporativos.",
        "Create_surcharge_fail": "Error al generar el recargo",
        "Update_surcharge_fail": "Error al actualizar el recargo",
        "Delete_surcharge_fail": "Error al eliminar el recargo",
        "Get_surcharge_detail_fail": "Error al obtener los detalles del recargo.",
        "Repeat": "Repetir",
        "DayOfWeek": "Día de la semana",
        "SingleDay": "Día único",
        "Yearly": "Anual",
        "Backup_phone_number": "Número de respaldo",
        "Backup_phone_number_hint": "Redirigir a este teléfono cuando conductor y pasajero están fuera de zonas operativas",
        "Apply_countdown_clock": "Establecer contador de tiempo",
        "No_show_duration_tooltip": "Configure el tiempo para mostrar el botón No Show después de que el conductor toque el botón Llegado en la aplicación Driver",
        "Limit_radius": "Radio límite",
        "Limit_radius_tooltip": "El conductor puede informar una reserva como no-show dentro de este radio",
        "Limit_radius_arrive_pickup": "Limitar el radio dentro del cual el conductor puede llegar y recoger para reservas de transporte",
        "Booking_validation": "Validaciones de reserva",
        "Invalid_period_of_time": "Periodo de tiempo no válido",
        "hide_Provider_Filter_From_Corporate_Board": "Ocultar el filtro de proveedores de la junta corporativa",
        "customer_email_is_optional": "e-mail del cliente es opcional en App de pasajero",
        "disable_hourly_rate": "Desactivar tarifa por horas cuando coincide con tarifa fija",
        "customer_gender_is_compulsory": "El género del cliente es obligatorio en App de pasajero",
        "SHOW_MAP_STATUS": "Mostrar estados en mapa",
        "Pay_to": "Pagar a",
        "EMERGENCY_SOS": "Emergencias S.O.S.",
        "customer_address_is_compulsory": "Dirección del cliente es obligatorio en App de pasajero",
        "customer_id_is_compulsory": "El número de identificación del cliente / número de identificación nacional es obligatorio en la aplicación de pasajeros.",
        "allowPassengerToUploadDocument": "Permitir que el pasajero cargue el documento de identificación / número de identificación nacional.",
        "compulsoryNationalIcDocumentInPaxApp": "El documento de identificación / número de identificación nacional del cliente es obligatorio en la aplicación de pasajeros.",
        "doNotAllowAddDriverWhenNationalIdDuplicated": "No permitir al operador agregar un conductor si el ID nacional está duplicado",
        "forceCustomerToUseLiveLocation": "Obligar al cliente a usar la ubicación en tiempo real",
        "disableMarketPlace": "Deshabilitar el mercado para nuevos conductores",
        "dontShowSecondStageImmediately": "Ocultar el registro en la etapa 2",
        "dontAddCarMM": "No permitir que el conductor añada nueva marca/modelo de coche",
        "dontEditCapability": "Do not allow Driver to edit Driver Capability",
        "compulsoryCarInsurance": "El seguro del coche del conductor es obligatorio",
        "marketPlace": "Mercado",
        "Enable": "Habilitar",
        "Disable": "Deshabilitar",
        "showTotalFareWithoutPromotionOnDriverApp": "Mostrar tarifa total sin promoción en la aplicación del conductor",
        "showTotalFareWithoutPromotionOnDriverApp_hint": "-Transporte: aplica esta configuración antes de que el conductor realice el pago. <br/> - Entrega y viajes interurbanos: aplica esta configuración antes de que el conductor comience el trabajo.",
        "hideFareOnPaxAppForAllCorporateBookings": "Ocultar tarifa en la aplicación Pax para todas las reservas corporativas",
        "hidePaxNameAvatarOnDispatchScreen": "Ocultar información del cliente en la aplicación del conductor antes del inicio del viaje",
        "showFullCustomerNameOnDriverApp": "Mostrar el nombre completo del cliente en la aplicación del conductor",
        "hideDriverLogoutBtn": "Ocultar el botón de cierre de sesión del conductor en la aplicación",
        "showMeetAndGreetButtonForEveryBooking": "Mostrar el botón \"Meet & Greet\" para cada reserva",
        "showEcontract": "Mostrar botón de E-Contract",
        "isShowConfirmationCode": "Mostrar código de confirmación de reserva",
        "showIncidentReportButton": "Botón Mostrar Incidente",
        "inReviewStatus": "Estado en revisión",
        "inReviewStatusTooltip": "Marca una reserva como \"En revisión\". El viaje permanece activo hasta que el operador lo cierre.",
        "incidentBtnDrvApp": "Mostrar el botón \"Incidente\" en la aplicación del conductor",
        "incidentBtnDrvAppTooltip": "Agrega un botón en los viajes activos para que los conductores informen incidentes, que el operador puede revisar y cerrar.",
        "fareChangeTolerance": "Tolerancia al cambio de tarifa",
        "fareChangeToleranceTooltip": "Los cambios de tarifa superiores a este % requieren aprobación manual por parte del operador.",
        "groupManifest": "Manifiesto del Grupo",
        "JobOrderedBy": "Trabajo ordenado por",
        "optional": "Opcional",
        "pickupTime": "Hora de recogida",
        "route": "Ruta",
        "settings": "Ajustes",
        "Default_value": "Valor por defecto",
        "limitTopupAmount": {
            "valueByCurrencies": "Monto de advertencia",
            "minimumByCurrencies": "Monto mínimo de recarga",
            "maximumByCurrencies": "Monto máximo de recarga",
            "title": "Monto mínimo y máximo de recarga"
        },
        "driverApp": "Aplicación de conductor",
        "passengerApp": "Aplicación para pasajeros",
        "Default_Topup_Values": "Importe de recarga predeterminado",
        "service_fees": "Tarifas de servicios",
        "commission_fleet": "Comisión de flota predeterminada",
        "apply_all": "Lo mismo para todas las zonas de operación.",
        "apply_custom_zone": "Separados en cada zona de operación",
        "apply": "Solicitar",
        "tollFeeDriverCanInput": "Cantidad limitada que puede ingresar el conductor",
        "unlimited": "Ilimitado",
        "limited": "Limitado",
        "sameFee": "Misma tarifa",
        "customizedAirportfee": "Tarifa de aeropuerto personalizada",
        "noteAirportFeeModal": "Nota: Cualquier aeropuerto que no esté en la lista no se le aplicará la tarifa",
        "intercity_schedule_trip_time_range": "Para garantizar el orden cronológico de las reservas, asegúrese de que el rango de tiempo de los viajes preferidos/solicitados sea mayor que el de los viajes programados",
        "airportFee": {
            "tooltipApply": "La tarifa de aeropuerto predeterminada será aplicada por cada viaje desde y hacia el aeropuerto por defecto. Si la tarifa es personalizada, la nueva tarifa será aplicada.",
            "titleSearchAiportZone": "Buscar el aeropuerto e introducir la tarifa",
            "airport": "Aeropuerto",
            "currency": "Divisa",
            "fromAirportFee": "Desde la tarifa del aeropuerto",
            "toAirportFee": "Tasa de aeropuerto",
            "action": "Comportamiento"
        },
        "Yes": "Sí",
        "No": "No",
        "tipPaymentMethod": "Métodos de pago disponibles para que el cliente le dé propina a su conductor después del viaje",
        "allowPaxUpdateTip": "Permitir que el pasajero actualice el porcentaje de propina durante el viaje",
        "tipDefaultValues": "Consejo predeterminado después del viaje",
        "creadit": "Tarjeta de crédito (Tarjeta personal / Tarjeta corporativa)",
        "wallet": "Cartera",
        "tnGeWallet": "Monedero electrónico TnG",
        "vippseWallet": "Vipps",
        "DurationRegularBooking": "Duración (para reservas regulares)",
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "DurationRegularBookingToolTip": "Esta es la duración del tiempo de espera gratuito que el conductor debe esperar por el cliente. No pueden marcar la reserva como una ausencia hasta que haya transcurrido el tiempo de espera gratuito.",
        "noShowCountDown": {
            "customizedNoShow": "Configuración para ubicaciones específicas (aeropuerto, etc)",
            "customizedNoShowTitle": "Aplicar antelación No Show para ubicaciones específicas (aeropuerto, etc)"
        },
        "maxWaitTime": "Tiempo máximo de espera adicional",
        "maxWaitTimeToolTip": "Este es el tiempo máximo de espera adicional que se cobrará al cliente. Tienes la flexibilidad de personalizar la tarifa por minuto en la configuración de tarifas.",
        "maxWaitTimePlaceholder": "Tiempo máximo de espera con cargo",
        "HEAT_MAP": "Mapa de demanda",
        "heatMap": {
            "defaultMode": "Modo por defecto",
            "radius": "Radio",
            "intensity": "Intensidad",
            "opacity": "Opacidad",
            "requestedBookings": "Reservas solicitadas",
            "activePassengers": "Pasajeros activos",
            "completedBookings": "Reservas completadas",
            "timeoutBookings": "Reservas de tiempo fuera",
            "tooltipRadius": "El radio de influencia de cada punto de datos, en píxeles.",
            "tooltipIntensity": "La intensidad máxima del mapa de calor.",
            "tooltipOpacity": "La opacidad del mapa de calor, expresada como un número entre 0 y 1."
        },
        "schedule_trip": "Programar viaje",
        "driver_starts_trip_before_set_time": "El conductor inicia el viaje antes de la hora establecida",
        "request_trip": "Solicitar viaje",
        "preferred_trip": "Viaje preferido",
        "time_range": "Rango de tiempo para solicitud y viaje preferido",
        "working_time": "Tiempo de trabajo",
        "hour": "hora",
        "hours": "Horas",
        "minutes": "minutos",
        "indicate_pickup_time_in_advance_to_customer": "Indicar la hora de recogida con antelación al cliente.",
        "customers_can_select_start_time_and_request_intercity_trip": "Los clientes pueden seleccionar la hora de inicio y solicitar un viaje interurbano. Los conductores también pueden crear su viaje preferido con su propio horario. Ejemplo: un rango de tiempo de 1 hora permitirá a clientes y conductores crear un viaje interurbano que comience entre las 8:00 am - 9:00 am, 9:00 am - 10:00 am o 10:00 am - 11:00 am.",
        "this_setting_limits_customers_to_create_request_trip_within_working_hours_only": "Esta configuración limita a los clientes a crear viajes solicitados solo dentro del horario laboral.",
        "face_mask_verify": "Verificación de mascarilla",
        "faceMask_allZones": "Todas las zonas",
        "faceMask_customized": "Zona personalizada",
        "turn_on_verify": "Activar verificación",
        "force_to_wear_face_mask": "Obligar a usar mascarilla",
        "time_range_to_verify": "No volver a verificar dentro de",
        "customizedFaceMaskZone": "Verificación personalizada de mascarilla",
        "zoneOperation": "Zona de operación",
        "FaceMaskCustomized": "Personalizado",
        "time": "tiempo",
        "day": "día",
        "days": "días",
        "allow_driver_to_skip_verification_after": "Permitir que el conductor omita la verificación después de",
        "driver_need_to_verify": "Cuándo el conductor necesita verificar",
        "open_app": "Abrir aplicación",
        "start_reservation": "Iniciar reserva",
        "choose_at_least_one": "Debes seleccionar al menos una acción para continuar.",
        "face_mask_customized_fail": "Debes seleccionar al menos una acción para continuar ({0}).",
        "vehicleAgeLimit": "Límite de edad del vehículo",
        "vehicleAgeLimit_years": "Años",
        "founderFund_firstBooking": "Fondo del fundador: solo primera reserva",
        "distance_diversity": "Diversidad de distancia",
        "Add_Surcharge_Distance": "Agregar",
        "from": "Desde",
        "to": "Hasta",
        "surchargeValue": "Recargo",
        "actions": "Acción",
        "please_enter_distance_range_valid": "¡La distancia %{name} no es válida!",
        "please_enter_distance_to": "Por favor, ingrese la distancia \"Hasta",
        "please_enter_surchargeValue": "Por favor, ingrese la distancia \"Recargo\" para el rango de distancia %{name}",
        "please_enter_surchargeValue_is_number": "Por favor, ingrese un número válido en \"Recargo\" para el rango de distancia %{name}",
        "Update_service_fee_success": "Las tarifas de servicio se han actualizado correctamente",
        "Update_service_fee_fail": "Ocurrieron errores al actualizar las tarifas de servicio",
        "Update_fleet_commission_success": "La comisión predeterminada de la flota se ha actualizado correctamente",
        "Update_fleet_commission_fail": "Ocurrieron errores al actualizar la comisión predeterminada de la flota",
        "RESERVATION_POLICY": "Política de reserva",
        "default_expected_pickup_time": "Tiempo de recogida esperado por defecto",
        "default_expected_pickup_time_hint": "El valor por defecto que esperas que un conductor llegue desde la hora de recogida.",
        "same_original_pickup_time": "Igual que la hora de recogida original",
        "quarter_before": "15 min antes",
        "half_before": "30 min antes",
        "quarter_after": "15 min después",
        "half_after": "30 min después",
        "custom": "Personalizado",
        "min_before": "min antes",
        "min_after": "min después",
        "TransactionFee": "Tarifa de transacción",
        "creditCardPercent": "Tarjeta de crédito / prepago",
        "directBilling": "Facturación directa",
        "externalCard": "External Card",
        "zoneIds": "Ubicaciones",
        "vehicles": "Vehículos",
        "default_expected_pickup_time_airport": "Hora de recogida esperada por defecto (Llegadas del Aeropuerto)",
        "expectedPickupTooltip": "Si se proporciona un número de vuelo, este búfer predeterminado se aplicará para calcular automáticamente la hora de recogida. Esto se aplica solo a las reservas creadas a través del panel de administración."
    },
    "social": {
        "pax_app": "Aplicación de pasajero",
        "driver_app": "Aplicación de conductor",
        "default": "Predeterminado",
        "customized": "Personalizado",
        "html": "HTML",
        "about": "Acerca de",
        "email": "Soporte por correo electrónico",
        "enablePhone": "Número de teléfono",
        "phone": "",
        "policy": "Link Privacy Policy – Enlace Política de Privacidad",
        "termOfUse": "Enlace Términos de Uso",
        "site": "Sitio web",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "Archivo HTML",
        "Update_fail": "Ocurrieron errores al actualizar las redes sociales",
        "Update_success": "Las redes sociales se han actualizado con éxito"
    },
    "user": {
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "Search_here": "Busca aquí",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Username": "nombre de usuario",
        "Name": "Nombre",
        "Phone_number": "Número de teléfono",
        "Email": "Correo electrónico",
        "Permission": "Permisos",
        "Status": "Estado",
        "Actions": "Acciones",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "Edit": "Editar",
        "Deactivate": "Desactivar",
        "Delete": "Borrar",
        "Add": "Agregar",
        "ADD_USER": "Agregar usuario",
        "First_name": "Nombre de pila",
        "Last_name": "Apellido",
        "AgendId": "Usuario #",
        "Email_address": "Dirección de correo electrónico",
        "Address": "Habla a",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "EDIT_USER": "Editar usuario",
        "Yes": "Sí",
        "DELETE_USER": "Borrar usuario",
        "DETAIL_USER": "Detalle de usuario",
        "DELETE_CONFIRM": "¿Está seguro de que desea eliminar el usuario seleccionado?",
        "Update_user_fail": "Los errores ocurrieron al actualizar el usuario",
        "Update_user_success": "El usuario ha sido actualizado con éxito",
        "Create_user_fail": "Los errores ocurrieron al crear el usuario.",
        "Create_user_success": "La cuenta {0} se ha creado correctamente.  Consulte el correo electrónico {1} para obtener los detalles de las credenciales de inicio de sesión.",
        "Load_user_fail": "Los errores ocurrieron al cargar el usuario",
        "Update_user_status_fail": "Los errores ocurrieron al actualizar el estado del usuario",
        "Delete_user_fail": "Los errores ocurrieron al eliminar el usuario",
        "Delete_user_success": "El usuario ha sido eliminado con éxito",
        "CONFIRM_RESET_PASSWORD": "¿Quieres restablecer la contraseña?",
        "RESET_PASSWORD": "¿Quieres restablecer la contraseña?",
        "Reset_password": "¿Quieres restablecer la contraseña?",
        "Select_permission": "Seleccionar permiso",
        "Reset_password_success": "Restablecer contraseña con éxito"
    },
    "report": {
        "query": {
            "errorMessage": {
                "bookFrom": "Por favor seleccione reserva de",
                "paymentMethod": "Por favor seleccione el método de pago",
                "bookingType": "Elegir tipo de reserva",
                "ratingType": "Seleccione el tipo de calificación",
                "stars": "Seleccione el tipo de calificación",
                "type": "Tipo",
                "transactionType": "Seleccione el tipo de transacción",
                "serviceType": "Seleccione el tipo de servicio",
                "rideService": "Seleccione tipo de trayecto",
                "invalidEmail": "Por favor, introduce una dirección de correo electrónico válida."
            },
            "search": {
                "driverReferalPax": "Buscar: nombre del conductor, número de teléfono",
                "passengerRefersPassengers": "Buscar: Nombre del cliente, Número de teléfono",
                "driverReferalPaxDetail": "Buscar: Nombre del pasajero",
                "bookingDetails": "Buscar: ID reserva, Operador, teléfono cliente, nombre cliente, nombre conductor, DNI, matrícula, área, notas",
                "financial": "Buscar: Nombre conductor, Teléfono",
                "completedTime": "Tiempo completado",
                "collectedTime": "Tiempo de cobro",
                "financialDriver": "Buscar: ID reserva, Nombre conductor, DNI",
                "carActivity": "Buscar: Matrícula",
                "affiliation": "Buscar: ID Reserva",
                "prepaidTopUp": "Buscar: nombre empresa, recarga ID, transacción",
                "operatorLogs": "Buscar: nombre operador, usuario, descripción",
                "corporate": "Buscar: ID reserva, nombre conductor, viajero corporativo, código interno cliente, código cargo",
                "bookingLogs": "Buscar: ID de reserva, nombre del cliente, ID de soporte, nombre del conductor, número de identificación / número de identificación nacional.",
                "rating": "Buscar: ID de reserva, teléfono del cliente, nombre del cliente, número de placa",
                "mDispatcher": "Buscar: ID de reserva, nombre del socio",
                "totalAdjustment": "Buscar: ID Reserva",
                "incidentCancellation": "Buscar: ID reserva, teléfono cliente, nombre cliente",
                "acceptanceCancellationRate": "Buscar: nombre del conductor, número de teléfono",
                "revenueDriver": "Buscar: nombre conductor",
                "dailyDriver": "Buscar: teléfono del conductor, nombre del conductor, ID# / IC# nacional",
                "dailyCar": "Buscar: matrícula, permiso",
                "dailyDriverCar": "Buscar: teléfono del conductor, nombre del conductor, ID#/IC# nacional, matrícula",
                "driverLoginStatus": "Buscar: teléfono del conductor, nombre del conductor, ID#/IC# nacional, matrícula",
                "bookingSummary": "Buscar: nombre operador, usuario, ID reserva",
                "creditWallet": "Buscar: nombre empresa, nombre conductor, ID reserva, operador",
                "cashWallet": "Buscar: nombre empresa, nombre conductor, ID reserva, Phone number",
                "SupplierWallet": "Buscar: Nombre de la empresa, ID de reserva",
                "settlement": "Buscar: nombre del conductor, ID# / IC# nacional",
                "driverRating": "Buscar: ID de reserva, teléfono del cliente, nombre del cliente, número de placa",
                "driverWithdrawal": "Nombre del conductor, teléfono, empresa, ID de transacción, número de referencia",
                "penaltyCompensation": "Búsqueda: ID de reserva, nombre del conductor, nombre del pasajero",
                "incompletePayment": "Buscar: ID de reserva, ID de soporte, nombre del cliente.",
                "passengerWallet": "Buscar: ID de reserva, ID de transacción, nombre del cliente.",
                "driverDeposit": "Buscar: nombre de la empresa, nombre del conductor, ID de reserva, operador.",
                "refund": "Buscar: ID de reserva, ID de viaje, ID de soporte, nombre del cliente.",
                "driverRefersCustomerBookings": "Buscar: código de referencia, ID de soporte.",
                "driverHistory": "Buscar: ID de pago",
                "merchantHistory": "Buscar: ID de pago",
                "firstWillWin": "Buscar: nombre del cliente, teléfono del cliente, ID del cliente",
                "firstWillWinDriver": "Buscar: nombre del conductor, teléfono del conductor, nombre de usuario",
                "merchant": "Buscar: tienda",
                "merchantCashTransactionHistory": "Search: Booking ID, ID de transacción, Merchant name",
                "merchantCreditTransactionHistory": "Search: Booking ID, ID de transacción, Merchant name",
                "deleteAccountRequest": "Buscar: Teléfono",
                "affiliationPayoutHistory": "Buscar: ID de pago",
                "thirdPartyBooking": "Buscar: ID de reserva, ID externo"
            },
            "common": {
                "all": "Todo"
            },
            "today": "Hoy dia",
            "sendDownloadLink": "Dirección de correo electrónico del destinatario",
            "generaltingYourExcel": "Ten en cuenta que generar tu archivo Excel puede tardar un poco. Te lo enviaremos por correo electrónico tan pronto como esté listo.",
            "messageSuccess": "Archivo en proceso. Recibirás un correo electrónico cuando esté listo. Puedes seguir el progreso o descargarlo directamente desde Informes/Historial de exportaciones.",
            "thisMonth": "Este mes",
            "lastMonth": "El mes pasado",
            "past30Days": "últimos 30 días",
            "thisYear": "Este año",
            "custom": "Personalizado",
            "customize": "Personalizar",
            "thisWeek": "Esta semana",
            "past7Days": "Últimos 7 días",
            "weekly": "Semanalmente",
            "monthly": "Mensual",
            "allTime": "Todo el tiempo",
            "tomorrow": "Mañana",
            "nextWeek": "La próxima semana",
            "lastWeek": "La semana pasada",
            "nextMonth": "El próximo mes",
            "next7Day": "Los próximos 7 días",
            "yesterday": "Ayer",
            "fromDate": "Partir de la fecha",
            "toDate": "Hasta la fecha",
            "driver": "Conductor: %{name}",
            "customer": "Cliente: %{name}",
            "referralCode": "Código de referencia: %{name}",
            "referer": "Referer: %{name}",
            "referee": "Árbitro: %{name}",
            "usedPromoCode": "Promoción: %{name}",
            "voucherCode": "Código: %{name}",
            "city": "Ciudad",
            "company": "Compañía",
            "company_report": "Empresa: %{name}",
            "companySupplier_report": "Proveedor/Empresa: %{name}",
            "supplier_report": "Proveedor: %{name}",
            "corporate_report": "Corporativo: %{name}",
            "campaign_report": "Campaña: %{name}",
            "operator": "Operador",
            "farmType": "Tipo de comercial",
            "carLicensePlate": "Matrícula del auto: %{name}",
            "settlementType": "Tipo",
            "bookingService": "Tipo de red",
            "payoutOption": "Opción de pago",
            "currency": "Divisa",
            "bookingFrom": "reserva desde",
            "Provider": "Proveedor",
            "thirdPartyAction": "Acción",
            "paymentMethod": "Método de pago",
            "paymentStatus": "Estado de pago",
            "bookingType": "Tipo de reserva",
            "adjustPrice": "Ajustar precio",
            "intercityRoute": "Ruta interurbana",
            "ratingType": "Tipo de evaluación",
            "stars": "Evaluación",
            "driverRating": "Evaluación del conductor",
            "vehicleRating": "Evaluación del vehículo",
            "mDispatcherType": "tipo de socio",
            "mDispatcher": "Nombre del socio",
            "campaign": "Campaña",
            "promocode": "Código promocional",
            "canceledBy": "Cancelado por",
            "timezone": "Zona horaria",
            "month": "Mes",
            "year": "Año",
            "view": "Vista",
            "action": "Acción",
            "status": "Estado",
            "module": "Módulo",
            "driverType": "Tipo",
            "vehicleType": "Tipo de carro",
            "serviceType": "Tipo de servicio",
            "expireDate": "Fecha de caducidad",
            "rideSharing": "Compartir viaje",
            "rideService": "servicio de paseo",
            "transactionType": "Tipo de transacción",
            "completeFromCC": "Completar desde CC",
            "withDrawalTransactionType": "tipo de transacción",
            "bookingStatus": "Estado de la reservación",
            "withdrawalStatus": "Estado",
            "originalStatus": "Estado de pago original",
            "currentStatus": "Estado de pago actual",
            "tip": "Propina",
            "type": "Tipo",
            "userType": "Tipo de usuario",
            "eventType": "Tipo de evento",
            "eventState": "Estado del evento",
            "eventName": "Nombre del evento",
            "merchantType": "Tipo de comerciante",
            "merchantService": "Servicio de comerciante",
            "storeName": "Tienda",
            "merchant": "Comerciante",
            "event": "Nombre del evento: %{name}",
            "store": "Nombre de la tienda: %{name}",
            "selectedMerchant": "Comerciante: %{name}",
            "associatedApps": "Aplicaciones asociadas",
            "settlement": "Liquidación",
            "rideServiceItem": {
                "all": "Todo",
                "regulation": "Regulares",
                "rideSharing": "viaje compartido"
            },
            "actionItem": {
                "all": "Todo",
                "login": "Iniciar sesión",
                "logout": "Cerrar sesión",
                "bookIn": "Disponible",
                "bookOff": "No disponible",
                "deny": "Rechazar",
                "ignore": "Ignorar",
                "accept": "Aceptar",
                "startTrip": "En camino",
                "updateBooking": "Actualizar",
                "arrive": "Llegar",
                "pickup": "Levantar",
                "drop": "Dejar",
                "complete": "Completo",
                "noShow": "no show",
                "driverNoShow": "No presentación del conductor",
                "rqJob": "despacho",
                "cancel": "Cancelar"
            },
            "loginStatusItem": {
                "all": "Todo",
                "online": "Iniciando sesión",
                "offline": "Desconectado"
            },
            "payoutType": "Tipo de pago",
            "affiliationPayoutTypeItem": {
                "auto": "Pago automático",
                "manual": "Pago manual"
            },
            "affiliationSettlementItem": {
                "payable": "Pagadero",
                "receivable": "Por cobrar"
            },
            "affiliationPaymentMethod": {
                "online": "En línea",
                "directInvoicing": "Facturación directa"
            },
            "payoutPaymentStatusItem": {
                "paid": "Pagado",
                "pending": "Pendiente"
            },
            "farmTypeItem": {
                "all": "Todo",
                "farmIn": "Finca en",
                "farmOut": "externalizar",
                "roaming": "Itinerancia",
                "affiliationOwner": "propietario de la afiliación",
                "farmInAndAffiliationOwner": "Propietario de finca y afiliación",
                "farmOutAndAffiliationOwner": "Farm out y propietario de la afiliación"
            },
            "settlementDriverTypeItem": {
                "all": "Todo conductor",
                "individual": "Vehículo de la empresa"
            },
            "shortTrip": {
                "all": "Todo",
                "shortTrip": "Viaje corto",
                "nonShortTrip": "Viaje no corto"
            },
            "paymentMethodItem": {
                "B2BTerminal": "B2BTerminal",
                "webBooking": "reserva web",
                "pendingPayment": "Pago pendiente",
                "all": "Todo",
                "cash": "Dinero en efectivo",
                "cashBySender": "Efectivo por remitente",
                "cashByRecipient": "Efectivo por destinatario",
                "personalCard": "Tarjeta personal",
                "corporateCard": "Tarjeta corporativa",
                "qrCodePayment": "Código QR",
                "directBilling": "Facturación directa",
                "externalCard": "Tarjeta externa",
                "mDispatcherCard": "Tarjeta de socio",
                "corporatePrepaid": "Prepago corporativo",
                "canceled": "Cancelado",
                "noShow": "No presentarse",
                "driverNoShow": "No presentación del conductor",
                "incident": "Incidencia",
                "fleetCard": "Tarjeta externa",
                "applePay": "Apple Pay",
                "creditCardExternal": "Tarjeta de crédito (externa)",
                "paxWallet": "Cartera",
                "tngeWallet": "Monedero electrónico TnG",
                "vippseWallet": "Vipps",
                "zainCash": "ZainCash",
                "xendit": "Xendit",
                "exAlipay": "Alipay",
                "FIB": "FIB",
                "SantimPay": "SantimPay",
                "gCash": "GCash",
                "completedWithoutService": "Completado sin conductor",
                "BankOfGeorgia": "Banco de Georgia",
                "partialCompleted": "Parcialmente completado",
                "failed": "Fallido",
                "googlePay": "Google Pay",
                "paymentLink": "Enlace de pago",
                "easyPaisa": "Easy Paisa",
                "jazzCash": "Jazz Cash",
                "samsung_pay": "Samsung Pay",
                "kakao_pay": "Kakao Pay",
                "naver_pay": "Naver Pay",
                "wechat_pay": "WeChat Pay",
                "alipay": "Alipay",
                "paynow": "PayNow",
                "grabpay": "GrabPay",
                "cashapp": "Cash App Pay"
            },
            "paymentStatusItem": {
                "all": "Todos",
                "fullPayment": "Pago completo",
                "partialPayment": "Pago parcial",
                "pendingPayment": "Pago pendiente",
                "partialRefund": "Reembolso parcial",
                "fullRefund": "Reembolso total"
            },
            "companySettlementTypeItem": {
                "all": "Todos",
                "fleetOweCompany": "La flota le debe a la empresa",
                "companyOweFleet": "La empresa le debe a la flota"
            },
            "bookingStatusItem": {
                "all": "Todos",
                "completed": "Terminado",
                "incident": "Incidente",
                "paxNoShow": "Pax no se presenta",
                "driverNoShow": "Conductor no show",
                "rejected": "Rechazado",
                "canceledByTimeOut": "Cancelado por tiempo de esperal",
                "canceledByTimeOutRejected": "Cancelado por tiempo de espera (rechazado)",
                "canceledByBookingBoard": "Cancelado por la junta de reservas",
                "canceledByCustomer": "Cancelado por el cliente",
                "canceledBySupplier": "Cancelado por el proveedor"
            },
            "bookingFromItem": {
                "all": "Todos",
                "paxApp": "App de pasajero",
                "mDispatcher": "Compañero",
                "kiosk": "terminal",
                "cc": "Centro de comando",
                "webBooking": "Reservas Web",
                "carHailing": "Coche de granizo",
                "streetSharing": "Compartir calle",
                "dashboard": "Panel de reservas",
                "corp": "Tablón de reservas (CTM)",
                "dmc": "Tablero de reservas (DMC)",
                "Boost_web_link": "Enlace web promocionado"
            },
            "thirdPartyActionItem": {
                "all": "Todos",
                "searched": "Buscado",
                "allocated": "Asignado",
                "updated": "Actualizado",
                "cancelled": "Cancelado"
            },
            "bookingTypeItem": {
                "batchDelivery": "Entrega por lotes",
                "all": "Todos",
                "now": "Ahora (Transporte)",
                "reservation": "Reserva (Transporte)",
                "intercity": "Interurbano",
                "delivery": "Entrega",
                "shuttle": "Lanzadera"
            },
            "adjustPrices": {
                "all": "Todos",
                "normalPrice": "Precio normal",
                "addonPrice": "Precio adicional"
            },
            "bookingServiceItem": {
                "all": "Todos",
                "roaming": "Itinerancia",
                "homeFleet": "Subcontratar",
                "localBooking": "Reserva local",
                "farmIn": "Finca en",
                "farmInAndAffiliationOwner": "Propietario de finca y afiliación",
                "provideService": "Finca en"
            },
            "ratingTypeItem": {
                "all": "Todos",
                "like": "Me gusta",
                "dislike": "Disgusto"
            },
            "starsItem": {
                "all": "Todo",
                "star1": "1 estrella",
                "star2": "2 estrellas",
                "star3": "3 estrellas",
                "star4": "4 estrellas",
                "star5": "5 estrellas"
            },
            "incidentCanceledTypes": {
                "all": "Todo",
                "incident": "Incidente",
                "canceled": "Cancelado"
            },
            "canceledByItem": {
                "all": "Todos",
                "CorpAD": "Administrador corporativo",
                "passenger": "Pasajero",
                "driver": "Conductor",
                "merchant": "Comerciante",
                "CC": "Central Reservas",
                "mDispatcher": "Compañero",
                "Partner": "Compañero",
                "webBooking": "Reservas Web",
                "timeout": "Se acabó el tiempo"
            },
            "incidentStatusItem": {
                "RESOLVED": "Resuelto",
                "DISPUTED": "Disputado"
            },
            "bookingSummaryActionItem": {
                "all": "Todos",
                "create": "Crear",
                "update": "Actualizar",
                "cancel": "Cancelar",
                "complete": "Completo",
                "incident": "Incidente"
            },
            "transactionTypeItem": {
                "DriverFees": "Driver Fees",
                "bookingAdjustment": "Ajuste de reserva",
                "bankAccount": "Transferido a cuenta bancaria",
                "sentToCustomer": "Enviar al cliente",
                "receivedFromDriver": "Recibido del conductor",
                "sentToDriver": "Enviado al conductor",
                "creditWallet": "Transferido a billetera de crédito",
                "netEarning": "Ganancia neta",
                "referralEarning": "Ganancia de referencia",
                "all": "Todos",
                "topUp": "Completar",
                "editBalance": "Editar saldo",
                "bookingDeduction": "Deducciones en Reservas",
                "bookingPromo": "Promoción de reserva",
                "topUpGCash": "Recargar por Gcash",
                "cashWallet": "billetera en efectivo",
                "topUpMOLPay": "Recarga con Razer Pay",
                "topUpQRIS": "Recargar mediante QRIS",
                "topUpZainCash": "Recarga por ZainCash",
                "topUpXendit": "Recarga por Xendit",
                "topUpalipayExternal": "Recargar mediante Alipay",
                "topUpFIB": "Recarga por FIB",
                "topUpSantimPay": "Recarga por SantimPay",
                "topUpTelebirr": "Recarga por Telebirr",
                "topUpKsher": "Recarga por Ksher",
                "topUpWallet": "Recarga por {0}",
                "TnG": "Recarga por TnG",
                "credit": "Recarga con tarjeta de crédito",
                "ride": "Montar",
                "tipAfterCompleted": "Consejo después del viaje",
                "debtWriteOff": "Cancelación de deuda",
                "refund": "Reembolso",
                "excessOffsetAmount": "Crédito en efectivo excedente",
                "excessDeductionAmount": "Débito en efectivo excedente",
                "cashExcess": "Débito en efectivo excedente",
                "gateway": "Recarga desde la pasarela",
                "driverTopUpForPax": "Débito en efectivo excedente",
                "updatedBalance": "Saldo actualizado",
                "partialEarning": "Ganancia",
                "payout": "Payout manual",
                "payoutManual": "Pago manual",
                "payoutDriver": "Pago",
                "itemValue": "Valores de los artículos",
                "redeemVoucher": "Código de canje #",
                "topUpReferrer": "Recompensa por referencia",
                "driverInsurance": "Seguro del conductor",
                "cancellationPenalty": "Penalización por cancelación",
                "WingBank": "Transferencias a la cuenta de Wingbank",
                "customerDebt": "Deuda del cliente",
                "googlePay": "Recarga por Google Pay",
                "applePay": "Recarga por Apple Pay",
                "samsung_pay": "Recargar con Samsung Pay",
                "kakao_pay": "Recargar por Kakao Pay",
                "naver_pay": "Recargar con Naver Pay",
                "wechat_pay": "Recargar por WeChat Pay",
                "alipay": "Recargar por Alipay",
                "paynow": "Recargar por PayNow",
                "grabpay": "Recargar con GrabPay",
                "cashapp": "Recargar mediante Cash App Pay",
                "merchantCommission": "Comisión del comerciante",
                "eWallet": "Transferido a billetera electrónica externa",
                "reversed": "Retiro revertido",
                "driverNoShow": "Falta del conductor",
                "noShowPenalty": "Falta del conductor",
                "bookingEarning": "Ganancia Neta"
            },
            "moduleItem": {
                "all": "Todos",
                "bookings": "Reservas",
                "customers": "Clientes particulares",
                "dispatch": "Asignar",
                "general": "General",
                "promotion": "Promociones",
                "quest": "Misión",
                "rate": "Tarifas",
                "car": "Vehículo",
                "city": "Ciudad",
                "company": "Compañía",
                "drivers": "Conductores",
                "driverSettlement": "Liquidación del conductor",
                "login": "Registro",
                "logout": "Cerrar sesión",
                "mDispatcher": "Compañero",
                "mDispatcherType": "tipo de socio",
                "operation": "Operaciones",
                "partners": "Colaboradores",
                "permission": "Permisos",
                "queuingArea": "zona de cola",
                "report": "Informe",
                "shift": "Turno",
                "user": "Usuario",
                "voiceSms": "Voz & SMS",
                "intercityZone": "Zona (interurbana)",
                "Payout": "Pago",
                "code#": "Código #",
                "ApiManagement": "Gestión de API"
            },
            "serviceTypeItem": {
                "all": "Todo",
                "oneWay": "Ida",
                "fromAirport": "Desde Aeropuerto",
                "toAirport": "Al Aeropuerto",
                "hourly": "Por horas / días",
                "roundTrip": "Ida y vuelta",
                "fromAirportHourlyDaily": "Desde aeropuerto - por horas/días",
                "fromAirportRoundTrip": "Desde aeropuerto - Ida y vuelta",
                "toAirportHourlyDaily": "Al aeropuerto - Por horas/días",
                "toAirportRoundTrip": "Al aeropuerto - Ida y vuelta"
            },
            "merchantTransactionTypeItem": {
                "all": "Todos",
                "editBalance": "Editar saldo",
                "payout": "Pago",
                "earning": "Ganancia",
                "itemValue": "Valor del artículo",
                "orderDeduction": "Deducción de pedido"
            },
            "withdrawalTransactionType": {
                "WingBank": "Transferido a la cuenta de Wingbank",
                "bankAccount": "Transferido a cuenta bancaria",
                "cashWallet": "Transferido a monedero en efectivo",
                "creditWallet": "Transferido a la billetera de crédito"
            },
            "payoutDriver": {
                "driversHaveBankAccount": "Los conductores tienen cuenta bancaria",
                "driversDontHaveBankAccount": "Los conductores no tienen cuenta bancaria",
                "payoutEndTime": "Hora de finalización del pago",
                "driverHaveInvalidBankAccount": "Los conductores tienen cuenta bancaria no válida"
            },
            "payoutMerchant": {
                "HaveBankAccount": "Los comerciantes tienen cuenta bancaria",
                "DontHaveBankAccount": "Los comerciantes no tienen cuenta bancaria",
                "HaveInvalidBankAccount": "Los comerciantes tienen cuenta bancaria no válida",
                "payoutEndTime": "Hora de finalización del pago"
            }
        },
        "error": {
            "23005": "Por rendimiento del sistema, solo puede ver informes en %{interval} %{unitLabel}, ajuste su rango de fechas"
        },
        "result": {
            "idPermitType": "Tipo de identificación",
            "noResultFound": "No se han encontrado resultados",
            "page": "Página",
            "itemsPerPage": "elementos por página",
            "showPages": "Mostrado %{from} - %{to} de %{total}.",
            "exportToExcel": "Exportar a Excel",
            "exportToCSV": "Exportar a csv",
            "exportToPaymentFile": "Exportar a archivo de pago",
            "pay": "Pagar",
            "paySelected": "Pagar seleccionado",
            "payAll": "Pagar todo",
            "invalidBankAccount": "Cuenta bancaria no válida",
            "validBankAccount": "Cuenta bancaria válida",
            "bookingDetails": {
                "customerAdjustmentsFee": "Ajuste del cliente",
                "supplierDriverAdjustmentsFee": "Ajuste del proveedor/conductor",
                "supplierPayout": "Pago al proveedor",
                "driverPayout": "Pago al conductor",
                "profit": "Ganancia",
                "successSendMessage": "Su mensaje ha sido enviado",
                "packageName": "Nombre del paquete",
                "transactionId": "ID de transacción",
                "proofOfFailure": "Prueba de fallo",
                "recipientsNumber": "Número de destinatario",
                "recipientsInfo": "Información del destinatario",
                "creditTransactionFee": "Tarifas de tarjeta de crédito",
                "carTypeRequest": "Tipo de coche solicitado",
                "bookingId": "Reserva #",
                "bookingStatus": "Estado de reserva",
                "tripId": "Viaje #",
                "bookFrom": "reserva desde",
                "bookingService": "Tipo de red",
                "bookingType": "Tipo de reserva",
                "serviceType": "Tipo de servicio",
                "operator": "Operador",
                "customerPhone": "Número de teléfono del pasajero",
                "customerName": "Nombre del pasajero",
                "customerIdNumber": "Pasajero ID# / IC#",
                "corpDivision": "Departamento",
                "corpDept": "Depart.",
                "chargeCode": "Código de cargo",
                "tripDescription": "Descripción del viaje",
                "rideSharing": "viaje compartido",
                "queueName": "zona de cola",
                "bookingTime": "tiempo de reserva",
                "pickupTime": "Hora de recogida",
                "expectedPickupTime": "Hora estimada de recogida",
                "dispatchTime": "Tiempo del envío",
                "onBoardTime": "tiempo a bordo",
                "droppedOffTime": "Hora de entrega",
                "onBoardDuration": "Duración usuario a bordo",
                "dispatch": "Asignación",
                "completedTime": "Tiempo completado",
                "driverName": "Nombre del conductor",
                "driverIdPermit": "Documento de Identidad",
                "driverLicenseNumber": "Número de licencia de conducir",
                "companyName": "Compañía",
                "carType": "Tipo de carro",
                "licensePlate": "Placa de matrícula",
                "intercityRoute": "Ruta interurbana",
                "pickupLocation": "Ubicación de recogida",
                "geoPickup": "Ubicación de recogida lat/long",
                "extraDestination": "Destinos adicionales",
                "originDestination": "Destino inicial",
                "originEstDistance": "Distancia estimada inicial",
                "destination": "destino real",
                "geoDestination": "Latitud/longitud del destino real",
                "pickupFrom": "Punto de recogida desde",
                "distanceTour": "distancia P.O.B",
                "internalNotes": "Notas internas",
                "notes": "Notas",
                "basicFareCalculator": "Calculadora tarifa base",
                "basicFare": "Tarifa básica",
                "editFare": "Editar tarifa base",
                "oldBasicFare": "Tarifa base anterior",
                "airportFee": "Tarifa de aeropuerto",
                "meetDriver": "Encuentro con conductor",
                "rushHour": "Recargo",
                "surchargeParameter": "Recargo dinámico",
                "dynamicFare": "Tarifa dinámica",
                "heavyTraffic": "Tráfico pesado",
                "tollFee": "Peaje",
                "parkingFee": "Tarifa de estacionamiento",
                "gasFee": "Tarifa de combustible",
                "otherFees": "Otros cargos",
                "subtotal": "Total parcial",
                "subTotalFF": "Subtotal FF",
                "techFee": "Tarifa técnica",
                "serviceFee": "Servicios adicionales",
                "fleetServiceFee": "Servicios de flota",
                "bookingFee": "Tarifa de reserva",
                "salesTax": "Impuesto de venta",
                "tipAmt": "Cantidad de propina",
                "promoCode": "Código promocional",
                "promoAmt": "Promociones",
                "requestedTotalAmount": "OTA Price",
                "total": "Importe total",
                "totalNotRounded": "Ronda (cantidad total)",
                "actualReceived": "importe recibido",
                "differenceAmt": "Importe de diferencia",
                "customerDebt": "Deuda del cliente",
                "markupDifference": "Diferencia de margen",
                "receivedWhenDropOff": "Recibido en la entrega",
                "refundAmount": "Monto del reembolso",
                "requestedPaymentMethod": "Método de pago solicitado",
                "paidBy": "Pagado por",
                "splitPayment": "Pago dividido",
                "paidByWallet": "Pagado con billetera",
                "paidByOtherMethod": "Pagado por otro método",
                "cashReceived": "Efectivo recibido",
                "transferredChangeByWallet": "Transferir cambio con billetera",
                "returnedChangeByCash": "Devolver cambio en efectivo",
                "instructions": "Instrucciones",
                "additionalServiceName": "Nombre",
                "additionalServiceValue": "Valor",
                "sendReceiptHeader": "",
                "sendReceipt": "Enviar recibo",
                "send": "Enviar",
                "cancel": "Cancelar",
                "sentReceiptSuccess": "El recibo ha sido enviado correctamente",
                "sentReceiptFailed": "El recibo no se puede enviar en este momento.  Inténtalo de nuevo.",
                "coRider": "Co-viajero",
                "coriderName": "Nombre",
                "stopAddress": "destino adicional",
                "stopGeo": "Latitud longitud",
                "addonPrice": "Ajuste de precio por el cliente",
                "oldSubTotal": "Subtotal antes de ajuste",
                "view_good_receipt": "Recibo de bienes",
                "view_delivery_receipt": "Foto de entrega",
                "view": "Ver",
                "tipAfterCompletedDetails": "Transferido: {0}{1}; Tarifa de transacción: {0}{2}",
                "fleetMarkup": "Ganancia",
                "editedDriverEarning": "Ganancia del conductor editada",
                "driverEarning": "Ganancia del conductor",
                "supplierAmount": "Ganancia del proveedor",
                "currencyISO": "Moneda",
                "pickUpZoneName": "Zona de recogida",
                "dynamicFactor": "Tarifa dinámica (factor)",
                "supplierEarning": "Ganancia del proveedor",
                "passengerName": "Nombre del pasajero",
                "totalPayout": "Pago total",
                "numberOfTrips": "Número de viajes",
                "psgLocation": "Ubicación del pasajero (lat/long)",
                "psgIp": "IP del pasajero",
                "DeviceImei": "IMEI del dispositivo",
                "otaDiscount": 'OTA Discount',
            },
            "financial": {
                "supplierPayout": "Pago al proveedor",
                "driverPayout": "Pago al conductor",
                "profit": "Ganancia",
                "currencyISO": "Moneda",
                "supplierAmount": "Ganancia del proveedor",
                "driverEarning": "Ganancia del conductor",
                "supplierEarning": "Ganancia del proveedor",
                "passengerName": "Nombre del pasajero",
                "totalPayout": "Pago total",
                "numberOfTrips": "Número de viajes",
                "driverName": "Nombre del conductor",
                "driverPhone": "Número de teléfono",
                "driverUserName": "nombre de usuario",
                "companyName": "Compañía",
                "bookingList": "Detalle de reservas",
                "totalFare": "Tarifa total sin promoción",
                "netEarning": "Ganancia neta",
                "showBookingList": "Mostrar",
                "referralEarning": "Ganancias derivadas",
                "totalEarningNet": "Ganancia total (neta)",
                "totalEarningNetTooltip": "Dinero que ganaste después de devolver todas las tarifas a la flota. Ganancia total (neta) = Ganancia neta + Propina después del viaje",
                "totalEarningNetTooltipRefferal": "Dinero que ganaste después de devolver todas las tarifas a la flota. Ganancia total (neta) = Ganancia por referencia + Ganancia neta + Propina después del viaje",
                "totalEarningGross": "Ganancia total (bruta)",
                "totalEarning": "Total ganancias",
                "totalEarningGrossTooltip": "Dinero que ganaste por la tarifa de reserva y propinas. Ganancia total (bruta) = Ganancia bruta + Propina después del viaje",
                "totalEarningGrossTooltipRefferal": "Dinero que ganaste por la tarifa de reserva y propina. Ganancia total (bruta) = Ganancia por referencia + Ganancia bruta + Propina después del viaje",
                "note": "Nota",
                "shortTrip": "Viaje corto",
                "deduction": "Deducción",
                "totalDriverEarning": "Ganancias totales del conductor",
                "totalDriverEarningTooltip": "Incluye reservas con pago en línea y fuera de línea",
                "totalDriverPayout": "Pago total del conductor",
                "totalDriverPayoutTooltip": "No incluye reservas con pago en efectivo o fuera de línea"
            },
            "financialDriver": {
                "supplierAmount": "Comisión del proveedor",
                "payoutType": "Tipo de pago",
                "date": "fecha",
                "driverTipAfterCompleted": "Consejo después del viaje",
                "bookingId": "ID reserva",
                "paidBy": "Pagado por",
                "bookFrom": "reserva desde",
                "bookingType": "Tipo de reserva",
                "companyName": "Compañía",
                "driverName": "Conductor",
                "driverIdPermit": "ID# / IC# Nacional",
                "totalFare": "Tarifa total sin promoción",
                "subtotal": "Total parcial",
                "airportFee": "Cargo aeropuerto",
                "meetDriver": "Encuentro con conductor",
                "tollFee": "Peaje",
                "parkingFee": "Tarifa de estacionamiento",
                "gasFee": "Tarifa de combustible",
                "rushHour": "Hora punta",
                "transactionFee": "tarifa por transacción",
                "techFee": "Tarifa técnica",
                "salesTax": "Impuesto de venta",
                "tipAmt": "Cantidad de propina",
                "bookingFee": "Tarifa de reserva",
                "commission": "Comisión",
                "deduction": "Deducción",
                "promoAmt": "Promociones",
                "ridePayment": "Pago del trayecto",
                "driverTax": "Impuesto del conductor",
                "grossEarning": "Ganancias brutas",
                "driverDeduction": "Deducciones conductores",
                "netEarning": "Ganancia neta",
                "payToDriver": "Pagar al conductor",
                "payToFleet": "Pago a la flota",
                "totalNotRounded": "Ronda (cantidad total)",
                "fleetServiceFee": "Tarifas de servicio de flota",
                "editedDriverEarning": "Ganancia del conductor editada",
                "stripeFee": "Tarifa de Stripe",
                "currencyISO": "Moneda"
            },
            "financialCompany": {
                "companyName": "Compañía",
                "homeFleetNetEarning": "Ganancia neta de la flota local",
                "affiliateNetEarning": "Ventas netas colaboradores",
                "totalNetEarning": "Total conductor ventas netas",
                "status": "Estado",
                "companyAmount": "Company profit",
                "numberOfTrips": "Número de viajes"
            },
            "companySettlement": {
                "companyName": "Empresa",
                "pendingSettlement": "Liquidación pendiente",
                "viewDetails": "Ver detalles",
                "settlementType": "Tipo"
            },
            "companySettlementDetails": {
                "bookId": "ID de reserva",
                "dateTime": "Fecha y hora",
                "originalPaymentStatus": "Estado de pago original",
                "subTotal": "Subtotal",
                "fleetAmount": "Monto de la flota",
                "driverAmount": "Monto del conductor",
                "companyAmount": "Monto de la empresa",
                "companyOweFleet": "La empresa debe a la flota",
                "fleetOweCompany": "La flota debe a la empresa",
                "notes": "Notas"
            },
            "financialProfit": {
                "profit": "Lucro",
                "bookingId": "Reserva #",
                "subTotal": "Total parcial",
                "subTotalFF": "Subtotal FF",
                "fleetCommission": "comisión de flota",
                "techFee": "Tarifa técnica",
                "promotion": "Promoción",
                "markupDifference": "Diferencia de margen",
                "Profit": "Ganancia",
                "currency": "moneda",
                "fleetServiceFee": "Servicio de flota (toma de flota)",
                "fleetServiceFeeTooltip": "Monto que la flota toma de comisión de las tarifas de servicio"
            },
            "promotion": {
                "date": "fecha",
                "promoCode": "Código promocional",
                "users": "Usuarios",
                "uses": "Usos",
                "checked": "Verificado",
                "applied": "Aplicado",
                "totalPromoAmount": "Importe total de la promoción",
                "totalReceipt": "Recibo total",
                "numberOfUsers": "Número de usuarios",
                "numberOfPromoCodeAppliance": "Número de aplicaciones de código promocional",
                "numberOfSuccessfulBookings": "Número de reservas exitosas",
                "numberOfCompletedBookings": "Número de reservas completadas",
                "numberOfCompletedUsers": "Número de usuarios completados",
                "numberOfUsersApplyPromotion": "Número de usuarios que aplican promoción",
                "numberOfUsersApplyPromotionAndCompleteBooking": "Número de usuarios que aplican promoción y completan la reserva",
                "numberOfPromoCodeApplianceTooltip": "Número de aplicaciones de código promocional por todos los usuarios",
                "numberOfSuccessfulBookingsTooltip": "Número de reservas creadas exitosamente con código promocional",
                "numberOfCompletedBookingsTooltip": "Número de reservas completadas que aplicaron código promocional"
            },
            "export": {
                "createdDate": "Fecha",
                "sessionName": "Nombre de la sesión",
                "download": "Descargar",
                "delete": "Eliminar",
                "percent": "Percent",
                "status": "Estado",
                "name": "Nombre del módulo"
            },
            "redeemed": {
                "date": "Fecha",
                "code": "Código",
                "customers": "Cliente",
                "phone": "Número de teléfono",
                "value": "Valor",
                "currency": "Moneda",
                "campaignName": "Campaña"
            },
            "carActivity": {
                "plateNumber": "Matrícula de coche",
                "vehicleType": "Tipo de carro",
                "companyName": "Compañía",
                "day1st": "1º",
                "day2nd": "2º",
                "day3rd": "3º",
                "day4th": "4º",
                "day5th": "5º",
                "day6th": "6º",
                "day7th": "7º",
                "day8th": "8º",
                "day9th": "9º",
                "day10th": "10º",
                "day11th": "11º",
                "day12th": "12º",
                "day13th": "13º",
                "day14th": "14º",
                "day15th": "15º",
                "day16th": "16º",
                "day17th": "17º",
                "day18th": "18º",
                "day19th": "19º",
                "day20th": "20º",
                "day21st": "21º",
                "day22nd": "22º",
                "day23rd": "23º",
                "day24th": "24º",
                "day25th": "25º",
                "day26th": "26º",
                "day27th": "27º",
                "day28th": "28º",
                "day29th": "29º",
                "day30th": "30º",
                "day31st": "31º",
                "operationDays": "Días de operación",
                "activeCars": "Total vehículos activos:"
            },
            "carActivityLogsTitle": "Registros",
            "carActivityLogs": {
                "licensePlate": "Matrícula de coche",
                "companyName": "Compañía",
                "bookingId": "ID reserva",
                "driverName": "Nombre del conductor",
                "driverIDNumber": "ID# / IC# Nacional",
                "date": "hora aceptada",
                "bookFrom": "reserva desde"
            },
            "affiliation": {
                "date": "Hora de recogida",
                "bookingId": "ID reserva",
                "bookingType": "Tipo de reserva",
                "homeFleet": "Home Flota",
                "providerFleet": "flota proveedor",
                "driver": "Conductor",
                "passenger": "Pasajero",
                "paidBy": "Pagado por",
                "airportFee": "Tarifa de aeropuerto",
                "meetDriver": "Conozca al conductor",
                "rushHour": "Hora pico",
                "tollFee": "Peaje",
                "parkingFee": "Tarifa de estacionamiento",
                "gasFee": "Tarifa de combustible",
                "heavyTraffic": "Tráfico pesado",
                "otherFees": "Otros cargos",
                "provider": "Proveedor",
                "basicFareProvider": "Tarifa base proveedor",
                "subTotalProvider": "Subtotal proveedor",
                "techFeeProvider": "cargo por tecnología proveedor",
                "bookingFeeProvider": "Tarifa por reserva proveedor",
                "taxValueProvider": "Importe impuestos proveedor",
                "tipProvider": "Propina proveedor",
                "totalFareProvider": "Total tarifa proveedor",
                "basicFare": "Tarifa básica",
                "subtotal": "Total parcial",
                "techFee": "Tarifa técnica",
                "bookingFee": "Tarifa de reserva",
                "tax": "Impuesto",
                "tip": "Propina",
                "totalFare": "total tarifa",
                "payoutInLocalCurrency": "Abono en moneda local",
                "payoutInUSD": "Pago en USD",
                "fleetCommInUSD": "comisión flota en USD",
                "bookingFeeInUSD": "Tarifa reserva en USD",
                "totalPayoutInUSD": "Total reembolso en USD",
                "subTotal": "Total parcial",
                "bookingStatus": "Estado de la reservación",
                "vehicle": "Vehículo",
                "customerPhone": "Número de teléfono del cliente",
                "driverPhone": "Número de teléfono del conductor",
                "total": "Total",
                "totalInUSD": "Tarifa total (USD)",
                "supplierPayout": "Pago al proveedor",
                "supplierPayoutInUSD": "Pago al proveedor (USD)",
                "buyerPayout": "Comisión del comprador",
                "buyerPayoutInUSD": "Comisión (USD)",
                "buyerCommission": "Comisión",
                "buyerCommissionInUSD": "Comisión (USD)",
                "receivableInUSD": "Cuentas por cobrar (USD)",
                "payableInUSD": "Cuentas por pagar (USD)",
                "fleetMarkupInUSD": "Ganancia (USD)",
                "paymentMethod": "Método de pago",
                "paymentStatus": "Estado de pago"
            },
            "prepaidTopUp": {
                "date": "Fecha y hora",
                "topUpId": "ID recarga",
                "transactionId": "ID de transacción",
                "name": "Nombre",
                "company": "Compañía",
                "paidBy": "Pagado por",
                "amount": "Monto",
                "newAmount": "Nuevo saldo",
                "transactionType": "Tipo de transacción"
            },
            "operatorLogs": {
                "date": "fecha",
                "operator": "Operador",
                "username": "nombre de usuario",
                "module": "Módulo",
                "description": "Descripción"
            },
            "corporate": {
                "date": "fecha",
                "bookingId": "ID reserva",
                "operatorName": "Operador corporativo",
                "corporateName": "Compañía",
                "corpTraveler": "viajero del cuerpo",
                "travelerSignature": "Firma del viajero",
                "corpId": "ID de corporación",
                "corpDivision": "división de corporaciones",
                "costCentre": "Centro de coste",
                "corpPO": "PO corporativo",
                "managerName": "Nombre director",
                "managerEmail": "correo electrónico dirección",
                "title": "Cargo",
                "department": "departamento",
                "clientCaseMatter": "Código interno del cliente",
                "chargeCode": "Código de cargo",
                "driverName": "Conductor",
                "pickupLocation": "Lugar de recogida",
                "destination": "Destino",
                "total": "Importe total",
                "subtotal": "Total parcial",
                "subTotalFF": "Subtotal FF",
                "commission": "Comisión",
                "commissionBooking": "Aplicar comisión para reservas desde la aplicación/pwa",
                "paidBy": "Pagado por",
                "statusDisplay": "Estado",
                "flightNumber": "Número de vuelo"
            },
            "bookingLogs": {
                "bookingId": "ID reserva",
                "bookingService": "Tipo de red",
                "bookingType": "Tipo de reserva",
                "driverName": "Conductor",
                "driverIdPermit": "ID# / IC# Nacional",
                "customerName": "Pasajero",
                "pickupTime": "Hora de recogida",
                "onBoardTime": "tiempo a bordo",
                "droppedOffTime": "Hora de entrega",
                "pickupLocation": "Lugar de recogida",
                "destination": "Destino",
                "dispatchHistory": "Historial de envíos",
                "otwDistance": "Distancia O.T.W",
                "distanceTour": "Distancia P.O.B",
                "duration": "Duración del P.O.B",
                "paidBy": "Pagado por",
                "bookFrom": "Reserva desde",
                "map": "Mapa",
                "showDispatchHistory": "Mostrar",
                "showMap": "Mostrar",
                "paymentActivities": "Actividades de pago"
            },
            "rating": {
                "date": "fecha",
                "bookingId": "ID reserva",
                "driverName": "Conductor",
                "driverIdPermit": "ID# / IC# Nacional",
                "customerName": "Nombre del cliente",
                "customerPhone": "teléfono cliente",
                "like": "Me gusta",
                "dislike": "Disgusto",
                "notes": "Comentario",
                "stars": "Clasificación",
                "vehicleRating": "Evaluación vehículo",
                "driverRating": "Evaluación conductor",
                "plateNumber": "Matrícula"
            },
            "mDispatcher": {
                "date": "fecha",
                "bookingId": "ID reserva",
                "mDispatcherName": "Nombre del socio",
                "mDispatcherType": "tipo de socio",
                "subtotal": "Total parcial",
                "commission": "Comisión",
                "paidBy": "Pagado por"
            },
            "totalAdjustment": {
                "date": "fecha",
                "bookingId": "ID reserva",
                "oldAmount": "Cantidad anterior",
                "type": "Tipo",
                "markupDifference": "Diferencia de margen",
                "newAmount": "nueva cantidad",
                "username": "nombre de usuario",
                "reason": "Motivo"
            },
            "incidentCancellation": {
                "date": "fecha",
                "bookingId": "ID reserva",
                "customerName": "Nombre del cliente",
                "customerPhone": "teléfono cliente",
                "bookFrom": "Reserva desde",
                "canceledBy": "cancelado por",
                "type": "Tipo",
                "reason": "Motivo",
                "reasonCode": {
                    "0": "Encontré otra opción de viaje",
                    "1": "Conductor muy lejos",
                    "2": "Entré en una ubicación incorrecta",
                    "3": "Esperé demasiado",
                    "4": "El conductor pidió cancelar",
                    "5": "Cambié mis planes",
                    "6": "Quería cambiar de ubicación",
                    "101": "La mayoría o todos los artículos no están disponibles",
                    "102": "Estamos demasiado ocupados ahora",
                    "103": "Estamos cerrados ahora",
                    "104": "Cerramos pronto"
                },
                "canceller": "Puesto de dirigente",
                "incidentStatus": "Estado del incidente"
            },
            "acceptanceCancellationRate": {
                "companyId": "ID de la compañía",
                "driverId": "identificación del conductor",
                "driverName": "Nombre del conductor",
                "phoneNumber": "Número de teléfono",
                "company": "Compañía",
                "acceptanceRate": "Tarifa de aceptación",
                "cancellationRate": "Tarifa de cancelación",
                "rating": "Clasificación"
            },
            "revenueFleet": {
                "date": "fecha",
                "fareRevenue": "Ingresos por tarifa",
                "trip": "Trayecto",
                "avgFareTrip": "Promedio ingresos/trayectos",
                "drivers": "# Conductores",
                "avgTripPerDriver": "Viaje medio/conductor",
                "dispatcher": "# Peticionario"
            },
            "revenueDriver": {
                "date": "fecha",
                "driverName": "Conductor",
                "fareRevenue": "Ingresos por tarifa",
                "trip": "# Viaje",
                "avgFareTrip": "Promedio ingresos/trayectos"
            },
            "revenueMonthly": {
                "month": "Mes",
                "trip": "Trayectos finalizados",
                "subtotal": "Total parcial",
                "tipAmt": "Propina",
                "techFee": "Cargo por tecnología",
                "salesTax": "Impuestos",
                "partnerCommission": "Comisión del socio / ODD",
                "totalFare": "Tarifa total sin promoción",
                "netEarning": "Ganancias netas",
                "fleetServiceFee": "Tarifas de servicio de flota"
            },
            "dailyDriver": {
                "driverName": "Conductor",
                "driverIDPermit": "ID# / IC# Nacional",
                "driverPhone": "Teléfono",
                "companyName": "Compañía",
                "workingHoursOnline": "En línea (horas)",
                "workingHoursAvailable": "Disponible (hrs)",
                "driverWorkingHours": "Horario de trabajo del conductor",
                "distance": "Distancia recorrida por el conductor",
                "CC_activity": "Actividad de CC",
                "fare_summary": "Actividad de CC",
                "workingHoursNotAvailable": "No disponible (hrs)",
                "workingHoursPob": "Pasajero a bordo (hrs)",
                "workingHoursPobToolTip": "Duración del pasajero a bordo",
                "workingHoursAccepted": "Aceptado",
                "workingHoursReject": "Rechazar",
                "workingHoursIgnore": "Ignorar",
                "workingHoursCancel": "Cancelar",
                "completedTripsTotal": "Total editado satisfactoriamente",
                "completedTripsCc": "Desde cc",
                "completedTripsCarHailing": "Desde el coche de granizo",
                "completedTripsStreetSharing": "Desde Street Sharing",
                "completedTripsPaxApp": "Desde la aplicación pax",
                "completedTripsWebBooking": "Desde reserva web",
                "completedTripsMDispatcher": "De socio",
                "completedTripsKiosk": "Desde el quiosco",
                "completedTripsApi": "Desde la API",
                "ccActivityDispatchedTrips": "viajes despachados",
                "ccActivityAccepted": "Aceptado",
                "ccActivityReject": "Rechazar",
                "ccActivityIgnore": "Ignorar",
                "ccActivityCancelByPassenger": "Cancelado por el pasajero",
                "ccActivityCancelByDriver": "Cancelado por el conductor",
                "ccActivityCancelByCc": "Cancelado por centro de comando",
                "ccActivityCancelByAPI": "Cancelado por API",
                "ccActivityNoShow": "No presentación",
                "fareSummaryTotalCash": "Dinero en efectivo",
                "fareSummaryTotalCreditCard": "Tarjeta de crédito",
                "fareSummaryTotalExternalCard": "tarjeta externa",
                "fareSummaryTotalPaxWallet": "Billetera",
                "fareSummaryTotalDirectBilling": "Facturación directa",
                "fareSummaryTotalQrCode": "Código QR",
                "fareSummaryTotalPrePaid": "Prepago corporativo",
                "fareSummaryTotalApplePay": "Apple Pay",
                "fareSummaryTotalTngeWallet": "TNG eWallet",
                "fareSummaryTotalVippseWallet": "Vipps",
                "fareSummaryTotal": "Total editado satisfactoriamente",
                "ratingNotes": "N.º de notas",
                "ratingDislike": "N.º de disgustos",
                "ratingLike": "N.º de me gusta",
                "fareDetailsBasicFare": "Tarifa básica",
                "fareDetailsAirportFee": "Tarifa de aeropuerto",
                "fareDetailsRushHour": "Recargo",
                "fareDetailsHeavyTraffic": "Tráfico intenso",
                "fareDetailsOtherFees": "Otros cargos",
                "fareDetailsSubTotal": "Total parcial",
                "fareDetailsSubTotalFF": "Subtotal FF",
                "fareDetailsTechFee": "Tarifa técnica",
                "fareDetailsBookingFee": "Tarifa de reserva",
                "fareDetailsSalesTax": "Impuesto de venta",
                "fareDetailsTip": "Cantidad de propina",
                "fareDetailsPromoAmount": "Promociones",
                "fareDetailsTotalAmt": "Importe total",
                "availableDistance": "Disponible",
                "otwDistance": "En camino",
                "otwDistanceToolTip": "en el camino distancia",
                "pobDistance": "Pasajero a bordo",
                "pobDistanceToolTip": "Pasajero a bordo distancia",
                "ratingStars1": "nº 1 estrellas",
                "ratingStars2": "nº 2 estrellas",
                "ratingStars3": "nº 3 estrellas",
                "ratingStars4": "nº 4 estrellas",
                "ratingStars5": "nº 5 estrellas",
                "ratingAvg": "Promedio",
                "ssnNumber": "Número de Seguridad Social",
                "driverEmail": "Dirección de correo electrónico",
                "driverAddress": "Direccion de casa",
                "fareDetailsAddonPrice": "Ajuste de precio del cliente",
                "fareDetailsOldSubTotal": "Subtotal antes del ajuste"
            },
            "dailyCar": {
                "carInfo": "información del coche",
                "fareDetails": "Detalles de tarifas",
                "completedTrips": "Viajes completados",
                "carInfoCompanyName": "Compañía",
                "carInfoPermission": "Permiso",
                "carInfoVehiclePlateNumber": "Placa",
                "carInfoVhcId": "Vehículo",
                "carInfoCarType": "Tipo de carro",
                "completedTripsTotal": "Total editado satisfactoriamente",
                "completedTripsCc": "Desde cc",
                "completedTripsCarHailing": "Desde el coche de granizo",
                "completedTripsStreetSharing": "Desde Street Sharing",
                "completedTripsPaxApp": "Desde la aplicación pax",
                "completedTripsWebBooking": "Desde reserva web",
                "completedTripsMDispatcher": "De socio",
                "completedTripsKiosk": "Desde el quiosco",
                "completedTripsAPI": "Desde la API",
                "fareDetailsBasicFare": "Tarifa básica",
                "fareDetailsAirportFee": "Tarifa de aeropuerto",
                "fareDetailsMeetDriver": "Conozca al conductor",
                "fareDetailsRushHour": "Recargo",
                "fareDetailsHeavyTraffic": "Tráfico pesado",
                "fareDetailsTollFee": "Peaje",
                "fareDetailsParkingFee": "Tarifa de estacionamiento",
                "fareDetailsGasFee": "Tarifa de combustible",
                "fareDetailsOtherFees": "Otros cargos",
                "fareDetailsSubTotal": "Subtotal",
                "fareDetailsSubTotalFF": "Subtotal FF",
                "fareDetailsTechFee": "Tarifa técnica",
                "fareDetailsBookingFee": "Tarifa de reserva",
                "fareDetailsSalesTax": "Impuesto de venta",
                "fareDetailsTip": "Propina",
                "fareDetailsPromoAmount": "Importe de la promoción",
                "fareDetailsTotalAmt": "Importe total",
                "fareDetailsAddonPrice": "Ajuste de precio del cliente",
                "fareDetailsOldSubTotal": "Subtotal antes del ajuste"
            },
            "dailyDriverCar": {
                "driverInfo": "información del conductor",
                "driverName": "Nombre del conductor",
                "driverIDPermit": "ID# / IC# Nacional",
                "driverPhone": "Número de teléfono",
                "companyName": "Compañía",
                "actionInfo": "Acciones",
                "date": "fecha",
                "action": "Acción",
                "bookingId": "ID reserva",
                "carInfo": "información del coche",
                "permission": "Permiso",
                "licensePlate": "Placa",
                "carId": "Carro #",
                "carType": "Tipo de carro"
            },
            "driverLoginStatus": {
                "driver": "Conductor",
                "driverIdPermit": "ID# / IC# Nacional",
                "phone": "Número de teléfono",
                "username": "Nombre de usuario",
                "company": "Empresa",
                "carType": "Tipo de carro",
                "licensePlate": "Placa de matrícula",
                "status": "Estado"
            },
            "bookingSummary": {
                "date": "fecha",
                "operator": "Operador",
                "username": "nombre de usuario",
                "action": "Acción",
                "bookingId": "ID reserva"
            },
            "cashWallet": {
                "bankAccount": "Transferido a cuenta bancaria",
                "creditWallet": "Transferido a billetera de crédito",
                "tipAfterCompleted": "Sugerencia después de completar",
                "netEarning": "Ganancia neta",
                "referralEarning": "Ganancia de referencia",
                "receiverAccount": "Cuenta del receptor",
                "dateAndTime": "Fecha y hora",
                "driverName": "Nombre del conductor",
                "phoneNumber": "número de teléfono",
                "userName": "nombre de usuario",
                "company": "Empresa",
                "type": "Tipo",
                "bookingId": "Reserva #",
                "operator": "Operador",
                "reason": "Motivo",
                "amount": "importe modificado",
                "newAmount": "nuevo saldo",
                "currency": "moneda",
                "topUpGCashReason": "Recargar por Gcash",
                "topUpReason": "Recarga desde tarjeta de crédito *{0}",
                "cashWalletReason": "Recargue de Cash Wallet",
                "topUpMOLPayReason": "Pago de Razer [ {0} ]",
                "chargedAmount": "Precio a cobrar",
                "differentPercent": "Descuento / Cargo adicional (%)",
                "operatorName": "Operador",
                "sendPayout": "Acción",
                "sendPayoutTitle": "Reenviar correo de pago",
                "payoutReason": "{0} (Pago {1} {2})"
            },
            "creditWallet": {
                "receiverType": "Tipo de receptor",
                "receiverName": "Nombre del receptor",
                "receiverPhone": "Número de teléfono del receptor",
                "senderPhone": "Número de teléfono del remitente",
                "senderName": "Nombre del remitente",
                "sentToCustomer": "Enviar al cliente",
                "sentToDriver": "Enviar al conductor",
                "dateAndTime": "Fecha y hora",
                "driverName": "Nombre del conductor",
                "phoneNumber": "número de teléfono",
                "userName": "nombre de usuario",
                "company": "Empresa",
                "type": "Tipo",
                "bookingId": "Reserva #",
                "operator": "Operador",
                "reason": "Motivo",
                "amount": "importe modificado",
                "newAmount": "nuevo saldo",
                "currency": "moneda",
                "transactionId": "ID de transacción",
                "topUpGCashReason": "Recargar por Gcash",
                "topUpReason": "Recarga desde tarjeta de crédito *{0}",
                "cashWalletReason": "Recargue de Cash Wallet",
                "topUpMOLPayReason": "Pago de Razer [ {0} ]",
                "topUpWalletReason": "{0} [ {1} ]",
                "chargedAmount": "Precio a cobrar",
                "differentPercent": "Descuento / Cargo adicional (%)",
                "cashExcessReason": "El cliente debe pagar {0}; Efectivo recibido {1}",
                "referralEarningReason": "Cliente {0} {1} completó la primera reserva {2}",
                "referralEarningReason_2": "Cliente {0} {1} completó la reserva {2}",
                "insurance": "Seguro del conductor"
            },
            "passengerWallet": {
                "dateTime": "Fecha y hora",
                "customerName": "Nombre del cliente",
                "phoneNumber": "Número de teléfono",
                "type": "Tipo",
                "bookingId": "Reserva #",
                "changedAmount": "Importe modificado",
                "amount": "Importe modificado",
                "newBalance": "Nuevo equilibrio",
                "currency": "Divisa",
                "transactionId": "ID de transacción",
                "Note": "Nota",
                "credit": "Recarga con tarjeta de crédito *{0}",
                "TnG": "Recarga por TnG #{0}",
                "MOLPay": "Recarga desde [RazerPay - #{0}]",
                "gatewayName": "Recarga desde [{0} - #{1}]",
                "cashExcess": "El cliente debe pagar {0}, Efectivo entregado {1}",
                "editBalance": "Editar saldo",
                "ride": "Viaje",
                "topUp": "Recarga",
                "topUpReferee": "Recompensa por referencia ({0})",
                "topUpReferrer": "Nuevo referido (#{0}): {1} ({2})"
            },
            "recipientsInfo": {
                "order": "No.",
                "orderId": "Pedido #",
                "name": "Nombre del destinatario",
                "phone": "Número de teléfono del destinatario",
                "address": "Dirección del destinatario",
                "deliveryFee": "Tarifa de entrega",
                "ItemValue": "Valor del artículo (COD)",
                "status": "Estado",
                "Performer": "Ejecutante",
                "Reason": "Motivo",
                "proofOfFailure": "Prueba de fallo",
                "referenceNumber": "Número de referencia"
            },
            "dispatchHistory": {
                "performer": "Ejecutante",
                "name": "Nombre",
                "action": "Acción",
                "date": "fecha",
                "location": "ubicación del conductor",
                "estimate": "Estimación del lugar de recogida del vehículo",
                "passenger": "Cliente",
                "detachVehicle": "Desvincular vehículo",
                "assignVehicle": "Asignar vehículo"
            },
            "payToDriver": {
                "driverName": "Conductor",
                "totalUnsettledTransactions": "Total transacciones sin saldar",
                "totalUnsettledAmount": "total importe sin saldar",
                "actions": "Acciones",
                "pay": "Pagar",
                "remove": "Eliminar",
                "clearSuccess": "Las ganancias de los conductores seleccionados han sido correctamente borradas",
                "clearFailed": "Error al limpiar los datos de ganancias de los conductores, inténtelo de nuevo",
                "selectDriver": {
                    "title": "",
                    "body": "Seleccione el conductor para pagar.",
                    "buttonTitle": "Está bien"
                },
                "confirmClear": {
                    "title": "",
                    "body": "¿está seguro de querer limpiar los datos de ganancias de los conductores?. Esta acción no se podrá deshacer",
                    "buttonTitle": "Sí",
                    "closeButtonText": "No"
                },
                "confirmPay": {
                    "body": "¿Está seguro de que desea pagar a los conductores seleccionados?",
                    "buttonTitle": "Sí",
                    "closeButtonText": "No"
                },
                "paymentSuccessfully": "Pagos liquidados con éxito a los conductores",
                "ProcessPayout": "Procesar Pago"
            },
            "customerQuest": {
                "name": "Nombre",
                "phoneNumber": "Número de teléfono",
                "supportId": "ID de soporte",
                "ranking": "Clasificación",
                "points": "Puntos",
                "numberOfReservation": "Número de reservas",
                "driver": "Conductor",
                "customer": "Cliente",
                "firstWillWin": "Primero ganará",
                "firstWillWinLuckyDraw": "Primero ganará (sorteo)",
                "largestWillWin": "El mayor ganará (tabla de clasificación)",
                "qualified": "Calificado",
                "notQualified": "No calificado",
                "userName": "Nombre de usuario",
                "completedDate": "Fecha de finalización",
                "isQualified": "Estado",
                "ticket": "Ticket",
                "numOfComplete": "Número de completados",
                "bookingDistance": "Distancia P.O.B",
                "numberOfIntercity": "Número de interurbanos",
                "numberOfDelivery": "Número de entregas",
                "pleaseSelectEventName": "Por favor, seleccione el nombre del evento.",
                "numberOfQualifiedSetting": "Número de calificados (configuración):",
                "numberOfActualQualified": "Número de calificados reales:",
                "driverRating": "Calificación del conductor",
                "acceptanceRating": "Calificación de aceptación",
                "cancellationRating": "Calificación de cancelación",
                "period": "Período:"
            },
            "payoutToDriver": {
                "IFSCCode": "Código IFSC",
                "payoutID": "ID de pago",
                "driverName": "Conductor",
                "driverPhone": "Número de teléfono",
                "companyName": "Empresa",
                "period": "Período",
                "driverId": "ID# / IC Nacional#",
                "cashWalletBalance": "Saldo de billetera en efectivo",
                "creditBalance": "Saldo de crédito",
                "holdAmount": "Monto retenido",
                "minPayout": "Pago mínimo",
                "enterMinimumPayoutAmount": "Ingresar monto mínimo de pago",
                "payoutAmount": "Monto de pago",
                "payoutDate": "Fecha de pago",
                "actions": "Acciones",
                "pay": "Pagar",
                "remove": "Eliminar",
                "payoutEndTime": "Hora de finalización del pago",
                "clearSuccess": "Las ganancias del conductor seleccionado se han borrado correctamente.",
                "clearFailed": "Error al borrar los datos de ganancias del conductor. Por favor, inténtelo de nuevo.",
                "amountKeepInDriverCashWallet": "Monto retenido en la billetera en efectivo del conductor",
                "selectDriver": {
                    "title": "",
                    "body": "Por favor, seleccione el conductor para pagar.",
                    "buttonTitle": "Está bien"
                },
                "confirmClear": {
                    "title": "",
                    "body": "¿Está seguro de que desea borrar los datos de ganancias de este conductor? Esta acción no se puede deshacer.",
                    "buttonTitle": "Sí",
                    "closeButtonText": "No"
                },
                "confirmPay": {
                    "body": "¿Está seguro de que desea pagar a los conductores seleccionados? <br> - Número de conductores: <b>%{drivers}</b> <br> - Pago mínimo para cada conductor: %{currency} <b>%{min}</b> <br> - Monto retenido: %{currency}<b> %{hold}</b> <br> - Pago total: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Sí",
                    "closeButtonText": "No"
                },
                "paymentSuccessfully": "Los pagos se han liquidado exitosamente a los conductores.",
                "paymentCompleted": "Pago completado: <br> - Pagado exitosamente: %{success} <br> - Fallido: %{failed} <br> - Pago total exitoso: %{currency} %{total}",
                "noteSelectDrivers": "Nota: seleccione conductores que tengan cuenta bancaria para pagar.",
                "sendPayout": "Enviar notificación de pago exitoso a la dirección de correo electrónico.",
                "accountNumber": "Número de cuenta",
                "iBanNumber": "Número IBAN",
                "accountHoldName": "Nombre del titular de la cuenta",
                "bankName": "Nombre del banco",
                "selelctedDriverHasBeenPaid": "Los conductores seleccionados han sido pagados.",
                "selelctedDriverHasBeenFailed": "Error al pagar a los conductores seleccionados.",
                "selelctedDriverHasBeenUpdateAsInvalid": "Los conductores seleccionados han sido actualizados como 'Cuenta bancaria inválida'.",
                "selelctedDriverHasBeenUpdateAsValid": "Los conductores seleccionados han sido actualizados como 'Cuenta bancaria válida'.",
                "isBankAccountOwner": "Beneficiario igual que el conductor",
                "isBankAccountOwner_true": "Sí",
                "isBankAccountOwner_false": "No",
                "beneficiaryIDIC": "ID# / IC# del beneficiario",
                "bankRelationship": "Relación",
                "bankRelationship_1": "Esposo/a",
                "bankRelationship_2": "Hija/Hijo",
                "bankRelationship_3": "Hermano/Hermana",
                "bankRelationship_4": "Pariente",
                "bankRelationship_5": "Amigos",
                "bankRelationship_6": "Otro: {0}",
                "bankStatus": "Estado del Banco",
                "emailStatement": "Estado de Cuenta por Correo Electrónico",
                "viewStatement": "Ver Estado de Cuenta",
                "downloadStatement": "Descargar como PDF",
                "emailStatementSuccess": "Estado del correo electrónico enviado con éxito",
                "NumberDriver": "Número de conductor",
                "NumberSupplier": "Número de Proveedor",
                "sendMailPayout": "Envía una notificación de pago exitoso a la siguiente dirección de correo electrónico:",
                "confirmPayoutTitle": "¿Estás seguro de que deseas pagar a los usuarios seleccionados?",
                "phoneOfBank": "Teléfono del Banco"
            },
            "payoutToMerchant": {
                "payoutId": "ID de pago",
                "merchantName": "Nombre del comerciante",
                "phone": "Número de teléfono",
                "accountNumber": "Número de cuenta",
                "iBanNumber": "Número IBAN",
                "bankAccountHolder": "Nombre del titular de la cuenta",
                "bankName": "Nombre del banco",
                "pendingAmount": "Monto pendiente",
                "payoutAmount": "Monto de pago",
                "payoutDate": "Fecha de pago",
                "holdAmount": "Monto retenido",
                "minPayout": "Pago mínimo",
                "selelctedMerchantHasBeenPaid": "Los comerciantes seleccionados han sido pagados.",
                "selelctedMerchantHasBeenFailed": "Error al pagar a los comerciantes seleccionados.",
                "pay": "Pagar",
                "selectMerchant": {
                    "title": "Advertencia",
                    "body": "Por favor, seleccione un comerciante para pagar.",
                    "buttonTitle": "Está bien"
                },
                "confirmPay": {
                    "body": "¿Está seguro de que desea pagar a los comerciantes seleccionados? <br> - Número de comerciantes: <b>%{merchants}</b> <br> - Pago mínimo para cada conductor: %{currency} <b>%{min}</b> <br> - Monto retenido: %{currency}<b> %{hold}</b> <br> - Pago total: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Sí",
                    "closeButtonText": "No"
                },
                "sendPayout": "Enviar notificación de pago exitoso a la dirección de correo electrónico.",
                "HasBeenUpdateAsInvalid": "Los comerciantes seleccionados han sido actualizados como 'Cuenta bancaria inválida'.",
                "HasBeenUpdateAsValid": "Los comerciantes seleccionados han sido actualizados como 'Cuenta bancaria válida'."
            },
            "payoutSupplier": {
                "selelctedSupplierHasBeenUpdateAsValid": "El(los) proveedor(es) seleccionado(s) ha(n) sido actualizado(s) como 'Cuenta bancaria válida'",
                "selelctedSupplierHasBeenUpdateAsInvalid": "El(los) proveedor(es) seleccionado(s) ha(n) sido actualizado(s) como 'Cuenta bancaria inválida'",
                "selelctedSupplierHasBeenFailed": "El(los) proveedor(es) seleccionado(s) ha(n) fallado",
                "selelctedSupplierHasBeenPaid": "El(los) proveedor(es) seleccionado(s) ha(n) sido pagado(s)",
                "confirmPay": {
                    "body": "¿Está seguro de que desea pagar a los proveedores seleccionados? <br> - Número de proveedores: <b>%{drivers}</b> <br> - Pago mínimo para cada proveedor: %{currency} <b>%{min}</b> <br> - Monto de retención: %{currency}<b> %{hold}</b> <br> - Pago total: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Sí",
                    "closeButtonText": "No"
                },
                "agentName": "Nombre del agente",
                "walletBalance": "Saldo de la billetera",
                "newAmount": "Nueva Cantidad"
            },
            "settlementHistory": {
                "date": "fecha",
                "driverName": "Nombre del conductor",
                "dateRange": "rango de fechas",
                "totalTransaction": "total transacciones saldadas",
                "paidAmount": "total importe saldado"
            },
            "settlement": {
                "driverName": "Conductor",
                "driverIdPermit": "ID# / IC# Nacional",
                "totalBookings": "total reservas",
                "total": "Importe total",
                "approved": "Aprobado",
                "acct": "CUENTA",
                "gross": "Bruto",
                "percent": 0.03,
                "net": "Neto"
            },
            "documentExpiry": {
                "driverName": "Nombre del conductor",
                "driverPhone": "Teléfono del conductor",
                "company": "Compañía",
                "documentName": "Nombre del documento",
                "expiredDate": "Fecha de vencimiento",
                "status": "Estado",
                "statusStr": {
                    "NA": "No aplica",
                    "expired": "Expirado",
                    "active": "Activo",
                    "expireSoon": "Expira pronto"
                }
            },
            "referralDetail": {
                "bookingId": "Reserva #",
                "completedDate": "Hora fin trayecto",
                "paidBy": "Pagado por",
                "bookFrom": "Reserva desde",
                "driverName": "Nombre del conductor",
                "driverIdPermit": "Documento de Identidad",
                "companyName": "Empresa",
                "Passenger": "Pasajero",
                "Customer": "Cliente",
                "subtotal": "Total parcial",
                "subTotalFF": "Subtotal FF",
                "subtotalWithPromo": "Subtotal con promoción",
                "referralEarning": "Ganancias derivadas",
                "Amount": "Importe",
                "Note": "Notas",
                "Currency": "moneda",
                "PercentOfSubTotal": "{0}% del subtotal",
                "max": "máx {0}",
                "referrerInfo": "El conductor refiere al cliente",
                "phoneReferral": "Número de teléfono del conductor",
                "driverNumber": "ID# / IC Nacional#",
                "referralCode": "Código de referencia",
                "reference": "Reference"
            },
            "referralHistory": {
                "driverName": "Nombre del conductor",
                "phoneNumber": "Número de teléfono",
                "companyName": "Compañía",
                "referralCode": "Código de referencia",
                "commission": "Comisión",
                "expectedReferralEarning": "Ganancias esperadas por referencia",
                "activePaxTooltip": "Pasajeros que hayan canjeado el código de referencia del conductor con al menos una reserva realizada con éxito.",
                "referredPaxTooltip": "Pasajeros que hayan canjeado el código de referencia del conductor pero que aún no hayan realizado ninguna reserva.",
                "activePax": "Total de pasajeros activos",
                "referredPax": "Total de pasajeros referidos",
                "detailFields": {
                    "passengerId": "Identificación del pasajero",
                    "passengerName": "Nombre del pasajero",
                    "firstBookingDate": "1a fecha de reserva completa",
                    "firstBookingDateGMT": "1.ª fecha de reserva completa (GMT)",
                    "passengerPhone": "Número de teléfono del cliente",
                    "appliedDate": "Fecha de referencia",
                    "referredByDriver": "Referido por el conductor",
                    "driverPhone": "Número de teléfono del conductor",
                    "referralCode": "Código de referencia"
                },
                "showDetail": "Mostrar",
                "detail": "Detalle"
            },
            "paxReferralHistory": {
                "customerName": "Nombre del cliente",
                "phoneNumber": "Número de teléfono",
                "referralCode": "Código de referencia",
                "commission": "Comisión total",
                "activePaxTooltip": "Pasajeros que han canjeado el código de referencia con al menos una reserva realizada con éxito.",
                "referredPaxTooltip": "Pasajeros que han canjeado el código de referencia pero aún no han realizado ninguna reserva.",
                "activePax": "Total de clientes activos",
                "referredPax": "Total de clientes referidos",
                "detailFields": {
                    "passengerId": "ID de pasajero",
                    "passengerName": "Nombre del pasajero",
                    "firstBookingDate": "Fecha de la primera reserva completada",
                    "firstBookingDateGMT": "Fecha de la primera reserva completada (GMT)"
                },
                "showDetail": "Mostrar",
                "detail": "Detalle"
            },
            "driverRefersDriver": {
                "companyName": "Empresa",
                "phoneNumber": "Número de teléfono",
                "username": "Nombre de usuario",
                "referralCode": "Código de referencia",
                "referrer": "Referente",
                "numberOfReferees": "Número de referidos",
                "activeReferees": "Referidos activos",
                "referee": "Referido",
                "refereePhone": "Número de teléfono del referido",
                "refereeUsername": "Nombre de usuario del referido",
                "referredDate": "Fecha de referencia",
                "activatedDate": "Fecha de activación",
                "referrerByDriver": "Referente",
                "referrerPhone": "Número de teléfono del referente",
                "referralStatus": "Estado de la referencia",
                "lifeTimeBookings": "Reservas de por vida",
                "inReview": "En revisión",
                "activated": "Activado"
            },
            "driverWithdrawal": {
                "transferToEWallet": "Transferido a billetera electrónica externa *{0}",
                "channelCode": "Código de canal",
                "channelName": "Nombre de canal",
                "reversed": "Revertido",
                "currentBalanceTooltip": "El saldo actual de la billetera en efectivo del conductor antes de la solicitud de retiro",
                "paymentTime": "Tiempo de pago",
                "requestTime": "Tiempo requerido",
                "referenceId": "Referencia #",
                "transactionId": "ID de transacción",
                "description": "Descripción",
                "transferAmount": "Monto de la transferencia",
                "currency": "Divisa",
                "approved": "Aprobado",
                "rejected": "Rechazado",
                "failed": "Fallido",
                "reason": "Razón"
            },
            "penaltyCompensation": {
                "penaltyAmount": "Pena",
                "totalCollect": "Necesidad de pagar en moneda local.",
                "totalCollectInUSD": "Necesidad de pagar en USD",
                "compensationAmount": "Remuneración",
                "compensationAmountInUSD": "Compensación (USD)",
                "penaltyReason": "Motivo de la sanción",
                "estimatedPrice": "Precio estimado",
                "estimatedPriceInUSD": "Precio estimado (USD)",
                "penaltyAmountInUSD": "Pena (USD)",
                "amount": "Monto",
                "amountInUSD": "Monto (USD)"
            },
            "imcompletePayment": {
                "bookingId": "ID de reserva",
                "bookFrom": "reserva desde",
                "bookingTime": "Fecha/Hora de reserva",
                "completedTime": "Fecha/Hora de reserva completada",
                "customerName": "Nombre del cliente",
                "requestedPaymentMethod": "Método de pago solicitado",
                "originalPaymentStatus": "Estado de pago original",
                "currentPaymentStatus": "Estado de pago actual",
                "updatedDateTime": "Fecha / Hora actualizada",
                "totalAmt": "Importe total",
                "originalOutstandingAmount": "Cantidad original pendiente",
                "currentOutstandingAmount": "Cantidad pendiente actual",
                "outstandingAmountPaidBy": "Cantidad pendiente pagada por",
                "writeOffDebtMethod": "Descartar el método deb",
                "reason": "Razón",
                "customerPhone": "Número de teléfono",
                "amountCollected": "Monto recaudado",
                "partialPaymentAmount": "Pago parcial al dejar"
            },
            "driverDeposit": {
                "dateAndTime": "Fecha y hora",
                "userName": "nombre de usuario",
                "type": "Tipo",
                "newAmount": "nuevo saldo",
                "topUpGCashReason": "Recargar por Gcash",
                "topUpReason": "Recarga desde tarjeta de crédito *{0}",
                "cashWalletReason": "Recargue de Cash Wallet",
                "topUpMOLPayReason": "Pago de Razer [ {0} ]"
            },
            "refund": {
                "fullRefund": "Reembolso completo",
                "partialRefund": "Reembolso parcial",
                "tripId": "ID de viaje",
                "route": "Ruta",
                "refundAmount": "Monto de reembolso",
                "refundTime": "Hora de reembolso",
                "paymentStatus": "Estado de pago"
            },
            "merchant": {
                "store": "Tienda",
                "name": "Nombre",
                "phoneNumber": "Número de teléfono",
                "bookingId": "Número de reserva",
                "totalOrders": "Total de pedidos",
                "completedOrders": "Pedidos completados",
                "canceledOrders": "Pedidos cancelados",
                "incidentOrders": "Incidente",
                "revenue": "Ingresos",
                "commission": "Comisión",
                "earning": "Ganancias",
                "food": "Comida",
                "mart": "Tienda",
                "preferredMerchant": "Comerciante preferido",
                "regularMerchant": "Comerciante regular",
                "companyName": "Empresa"
            },
            "merchantCashTransactionHistory": {
                "companyName": "Empresa",
                "dateTime": "Fecha y hora",
                "merchantUserName": "Usuario comerciante",
                "merchantUserPhone": "Número de teléfono",
                "merchantUserEmail": "Correo electrónico",
                "merchantName": "Comerciante",
                "transactionType": "Tipo",
                "bookId": "Número de reserva",
                "transactionId": "ID de transacción",
                "operatorName": "Operador",
                "reason": "Motivo",
                "amount": "Monto",
                "newBalance": "Nuevo saldo",
                "currencyISO": "Moneda"
            },
            "merchantCreditTransactionHistory": {
                "dateTime": "Fecha y hora",
                "merchantUserName": "Usuario comerciante",
                "merchantUserPhone": "Número de teléfono",
                "merchantUserEmail": "Correo electrónico",
                "merchantName": "Comerciante",
                "transactionType": "Tipo",
                "bookId": "Número de reserva",
                "transactionId": "ID de transacción",
                "operatorName": "Operador",
                "reason": "Motivo",
                "amount": "Monto",
                "newBalance": "Nuevo saldo",
                "currencyISO": "Moneda"
            },
            "deleteAccountRequest": {
                "date": "Fecha",
                "phone": "Teléfono",
                "username": "Nombre de usuario",
                "supportId": "ID de soporte",
                "requestFrom": "Solicitud de",
                "associatedApps": "Aplicaciones asociadas",
                "reason": "Motivo"
            },
            "affiliationPayoutHistory": {
                "payoutId": "ID de pago",
                "dateTime": "Fecha y hora",
                "payoutType": "Tipo",
                "accountHolderName": "Nombre del titular de la cuenta",
                "bankName": "Nombre del banco",
                "accountNumber": "Número de cuenta",
                "totalPayout": "Pago total (USD)",
                "viewDetails": "Ver detalles",
                "notes": "Nota",
                "bookId": "Número de reserva",
                "transactionType": "Tipo de transacción",
                "transactionId": "ID de transacción (transferencia automática)",
                "settlement": "Liquidación",
                "paymentMethod": "Tipo",
                "networkType": "Tipo de red"
            },
            "thirdPartyBooking": {
                "date": "Fecha",
                "bookingId": "ID de reserva",
                "externalId": "ID externo",
                "psgPhone": "Número de teléfono del pasajero",
                "psgName": "Nombre del pasajero",
                "pickupLocation": "Ubicación de recogida",
                "pickupLocationLatLong": "Ubicación de recogida lat/long",
                "dropoffLocation": "Ubicación de destino",
                "dropoffLocationLatLong": "Ubicación de destino lat/long",
                "pickupTime": "Hora de recogida",
                "numOfPassenger": "Número de pasajeros",
                "action": "Acción"
            },
            "external": "Proveedor Externo",
            "inHouse": "Proveedor interno",
            "negative": "Negativo",
            "positive": "Positivo",
            "supplierType": "Tipo de Proveedor",
            "supplierCompany": "Proveedor/Empresa",
            "invalidOrNoBank": "No válido",
            "BankInfo": "Información Bancaria",
            "BankStatusConnect": "Estado del Gateway",
            "payManually": "Pagar Manualmente",
            "payViaGateway": "Pago a través de %{gateway}",
            "payConfirmModal_manual": "Confirmación de Pago Manual",
            "payConfirmModal_manual_note": "Estás a punto de procesar un <b>pago manual</b> al %{type} seleccionado. Esto actualizará el saldo de la billetera de cada %{type} y generará un informe de pago para el procesamiento bancario.",
            "payConfirmModal_auto": "Confirmación de Pago Automático",
            "payConfirmModal_auto_note": "Estás a punto de procesar <b>pagos automáticos</b> al seleccionado %{type} a través de <b>%{gateway}</b>. Los pagos se enviarán directamente a sus cuentas bancarias registradas.",
            "Eligible": "Elegible para pago automático",
            "EligibleNote": "Solo %{value} proveedores son elegibles para el pago automático. Por favor, verifica y actualiza los detalles de la cuenta bancaria para los proveedores restantes."
        }
    },
    "zoneSetting": {
        "Add": "Agregar",
        "Import": "Importar",
        "Name": "Nombre",
        "Status": "Estado",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "Deactivate": "Desactivar",
        "Activate": "Activar",
        "Delete": "Borrar",
        "Cancel": "Cancelar",
        "Input_zone_name": "Introducir nombre de zona",
        "Save_zone": "Guardar zona",
        "Clear_draw": "Limpiar dibujo zona",
        "Edit": "Editar",
        "Delete_zone_success": "La zona ha sido eliminada con éxito",
        "Delete_zone_fail": "Los errores ocurrieron al eliminar la zona",
        "Update_zone_fail": "Los errores ocurrieron al actualizar la zona",
        "Update_zone_success": "La zona ha sido actualizada con éxito",
        "Create_zone_fail": "Los errores ocurrieron al crear la zona.",
        "Create_zone_success": "La nueva zona se ha creado con éxito",
        "Draw_zone": "Por favor dibuje la zona en el mapa",
        "Import_zones_successful": "zona importada correctamente",
        "Import_zones_fail": "Error al importar zonas",
        "DELETE_ZONE": "Eliminar zona",
        "ZONE_CONFIRM": "¿Está seguro de que desea eliminar la zona seleccionada?",
        "Name_zone_required": "¡El nombre y la zona son obligatorios!",
        "Select_file": "seleccionar archivo",
        "No": "No",
        "Yes": "Sí",
        "Import_zones_intercity_successful": "[{0}] zona(s) se ha importado correctamente, [{1}] falló.  {2}",
        "Import_zones_intercity_successful_failed": "[{0}] zona(s) se ha importado correctamente, [{1}] falló.",
        "Flat_zone": "zona plana",
        "Json_file": "archivo json",
        "Import_zones": "Importar zonas",
        "timezone": "Zona horaria"
    },
    "companySetting": {
        "DELETE_COMPANY": "Borrar empresa",
        "DELETE_CONFIRM": "¿Quieres eliminar la empresa!",
        "DETAIL_COMPANY": "Detalles empresa",
        "commissionValue": "Comisión de la empresa",
        "connectStatus": "Stripe Connect",
        "connectStripe": "Conectar",
        "stripeConnectId": "ID de cuenta Stripe",
        "loginStripe": "Panel de control",
        "disconnectStripe": "Desconectar",
        "Yes": "sí",
        "No": "No",
        "Cancel": "Cancelar",
        "EDIT_COMPANY": "EDITAR EMPRESA",
        "ADD_COMPANY": "AÑADIR EMPRESA",
        "Name": "Nombre",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Actions": "Acciones",
        "Edit": "Editar",
        "Add": "Agregar",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Create_company_success": "La nueva empresa se ha creado con éxito.",
        "Create_company_fail": "error durante la creación de la empresa",
        "Update_company_success": "La empresa ha sido actualizada con éxito",
        "Update_company_fail": "Los errores ocurrieron al actualizar la empresa",
        "Load_company_fail": "Los errores ocurrieron al cargar la empresa",
        "Delete_company_success": "La empresa ha sido eliminada con éxito",
        "Delete_company_fail": "Los errores ocurrieron al eliminar la empresa",
        "hideFare": "Siempre ocultar tarifa",
        "Broadcast_orders": "Transmitir todos los pedidos",
        "paymentMethodsApply": "Método de pago compatible",
        "emailsNotification": "Notificación por correo electrónico",
        "CopySignUpLink": "Copiar enlace de registro",
        "operationZone": "Zona de operación",
        "delayBroadcast": "Mostrar pedido después",
        "releaseTime": "Hora de liberación",
        "advanceBookingVisibility": "Visibilidad de reserva anticipada",
        "advanceBookingVisibilityTooltip": "Establezca la cantidad de días antes de la fecha de recogida en que un proveedor puede ver la reserva. Esto garantiza que las reservas se liberen a los conductores de manera oportuna, según cada proveedor."
    },
    "dispatchSetting": {
        "Cut_off_time_range": "Corte de reservas fuera del horario",
        "Cut_off_time_range_tooltip": "Si la ventana de corte es de 10PM a 6AM, los clientes aún pueden reservar antes de las 10PM para recogidas después de las 10PM. Sin embargo, si la hora actual está entre las 10PM y las 6AM, la primera recogida permitida es después de las 6AM + tiempo de anticipación.",
        "GENERAL": "General",
        "Offer_interval": "Intervalo de oferta (conductor)",
        "Offer_interval_merchant": "Intervalo de oferta (comerciante)",
        "Offer_interval_merchant_toolTip": "Tiempo máximo para que un comerciante acepte un pedido",
        "Offer_interval_toolTip": "Tiempo máximo para que un conductor acepte una reserva",
        "soundMarketplace": "Sonido",
        "sound": "Sonido",
        "Auto_re_dispatch_interval_toolTip": "Tiempo de descanso entre 2 rondas de despacho",
        "Maximum_auto_dispatch_duration_toolTip": "Tiempo máximo de envío de una reserva a los conductores",
        "Seconds": "Segundos",
        "Auto_re_dispatch_interval": "Intervalo de reenvío automático",
        "Maximum_auto_dispatch_duration": "Duración máxima del envío automático",
        "Time_out": "Se acabó el tiempo",
        "mins": "minutos",
        "minTimeBeforeReservation": "No permita que el conductor inicie la reserva antes de",
        "IN_ADVANCE": "POR ADELANTADO",
        "Assign_reservation_to_driver": "asignar reserva a conductor",
        "Dispatcher_confirms_job_for_driver": "El despachador confirma el trabajo del conductor",
        "Dispatcher_confirms_job_for_offline_driver": "El despachador confirma la reserva para el conductor fuera de línea",
        "Broadcast_orders": "Transmitir pedidos a todas las empresas",
        "Broadcast_orders_tooltip_1": "Habilite esta configuración si solo desea transmitir todos los viajes a todos los proveedores de la empresa. Tenga en cuenta que debe habilitar el modo de transmisión en el perfil de cada empresa.",
        "Minimum_book_ahead": "Reserva mínima por delante",
        "Maximum_book_ahead": "Reserva máxima por delante",
        "Maximum_period_recurring_oders_fleet": "Período máximo para pedidos recurrentes (operador de flota)",
        "Maximum_period_recurring_oders_corp": "Período máximo para pedidos recurrentes (corporativo)",
        "Day": "Día",
        "Week": "Semana",
        "Month": "Mes",
        "hrs": "horas",
        "Driver_cancellation_duration": "Duración de la cancelación del conductor",
        "Mins": "min",
        "Maximum_Day": "Máximo de reservas que el conductor puede aceptar en un día.",
        "Maximum_Accept_Reservation": "Máximo de reservas que el conductor puede aceptar a la vez.",
        "jobRTDriver": "Tiempo de liberación del trabajo al conductor (antes de la recogida)",
        "jobRTDriverDes": "Establecer cuándo el trabajo se vuelve visible para el conductor asignado en su aplicación antes de la hora de recogida. - por ejemplo, 24 horas antes de la recogida.",
        "Local_notification_before": "Notificación local antes",
        "Dispatch_mode": "modo de despacho",
        "Manual": "Manual",
        "Immediate_auto_dispatch": "Envío automático inmediato",
        "Delayed_auto_dispatch": "Envío automático retrasado",
        "Auto_dispatch_before_pickup_time": "Tiempo alarma previo a hora recogida",
        "Auto_Reassign_Before_Pickup_Time": "Reasignar automáticamente antes de la hora de recogida",
        "Auto_Reassign_Before_Pickup_Time_Tooltip": "Reasigna automáticamente el trabajo si el conductor asignado no ha comenzado el viaje X minutos antes de la hora de recogida. Nota: Esto se aplica solo a los conductores de proveedores internos.",
        "Required_fields": "Campos requeridos",
        "Shuttle": "TRANSPORTE COMPARTIDO",
        "Shuttle_Dispatch_mode": "Modo de despacho",
        "Dispatch_setting_Shuttle_Dispatch_mode_tooltip": "- Manual mode: Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. After clicking on “Update booking” at the booking detail, reservation will be dispatched to your assigned drivers or to all drivers in case of no driver assigning. It will be integrated into driver device calendar and reminder will be available. <br>- Delayed mode:Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. Reservation will be automatically dispatched before “time value at “Process in advance”” from pick up time to the assigned driver or the nearest available one in case of no driver assigning. <br>- Immediate auto-dispatch mode: Reservation will be automatically dispatched to all drivers once reservation is created. It will be integrated into driver device calendar and reminder will be available.",
        "Save": "Ahorrar",
        "Process_in_advance": "Proceso por adelantado",
        "Save_dispatch_success": "El envío se ha actualizado con éxito",
        "Save_dispatch_fail": "Hubo errores al actualizar despacho",
        "Dispatch_setting_general_tooltip": "Aplicar a la reserva bajo demanda, reserva por adelantado con envío automático retrasado",
        "Dispatch_setting_Assign_reservation_to_driver_tooltip": "La reserva es asignada y aceptada por el conductor automáticamente cuando esta opción está activada",
        "Dispatch_setting_Driver_cancellation_duration_tooltip": "La duración es desde el momento en que la hora de recogida hasta el conductor cancela la reserva.",
        "Dispatch_setting_Dispatch_mode_tooltip": "- Modo manual: la reserva se guardará y permanecerá en Cue de su Centro de Comando en estado Pendiente\" una vez que se crea la reserva. Después de hacer clic en \"Actualizar reserva\" en los detalles de la reserva, \"la reserva se enviará a su asignado  controladores o a todos los controladores en caso de que no haya una asignación de controlador. Se integrará en el calendario del dispositivo del controlador y el recordatorio estará disponible. <br>- Modo retrasado\": la reserva se guardará y permanecerá en Cue de su Command Center en \"  Pendiente\" una vez que se crea la reserva. La reserva se enviará automáticamente antes del \"valor de tiempo en\" Procesar por adelantado \" desde la hora de recogida al conductor asignado o al \"disponible más cercano en caso de que no haya asignación de conductor. <br>  - Modo de envío automático inmediato\": la reserva se enviará automáticamente a todos los conductores una vez que se cree la reserva. Se integrará en el calendario del dispositivo del conductor y el recordatorio estará disponible.",
        "Notification_nearby_drivers_before_pickup_time": "Notificación a los conductores cercanos antes de la hora de recogida",
        "Dispatch_setting_Maximum_Day_tooltip": "Esto es para limitar que los conductores tengan demasiadas reservas en el mismo día. Aplicable para Marketplace e Intercity.",
        "Maximum_Accept_Reservation_tooltip": "El número de reservas aceptadas por el conductor no puede exceder este número. Esto limita al conductor de aceptar demasiadas a la vez. Aplicable para Marketplace e Intercity.",
        "Notification_nearby_drivers_before_pickup_time_tooltip": "Si la reserva de un cliente no ha sido aceptada por ningún conductor antes del tiempo establecido, antes de la hora de recogida, el sistema notificará a los conductores cercanos. Esto, con suerte, los alentará a verificar el marketplace para aceptar la reserva.",
        "marketPlace": "MERCADO",
        "howFarDriverSeeBookingMarketplace": "Cuán lejos puede ver el conductor las reservas en el mercado",
        "shortNoticeOrder": "Pedido de aviso corto",
        "shortNoticeOrderTooltip": "Establezca el marco de tiempo para que las reservas sean consideradas urgentes y visibles para todos los niveles de inmediato."
    },
    "voiceSMSSetting": {
        "ACCOUNT_SETTINGS": "Configuraciones de la cuenta",
        "Account_SID": "SID de la cuenta",
        "Auth_Token": "Token de autenticación",
        "Application_ID": "ID de aplicación",
        "SMS_number_1": "SMS número 1",
        "SMS_number_2": "SMS número 2",
        "SMS_SETTINGS": "AJUSTES DE SMS",
        "MASKED_PHONE_SETTINGS": "AJUSTES DE TELÉFONO ENMASCARADO",
        "SMS_MARKETING_SETTINGS": "AJUSTES DE MARKETING POR SMS",
        "Phone_number": "Número de teléfono",
        "Save": "Ahorrar",
        "voiceSMS": "TWILIO",
        "DRIVER_APP": "Aplicación de conductor",
        "PASSENGER_APP": "Aplicación para pasajeros",
        "allowDriverToCallCC": "Permita que el conductor llame al Command Center a través de:",
        "allowDriverToCallHelpdesk": "Permitir que el conductor llame al servicio de ayuda mediante:",
        "allowDriverToCallPassenger": "Permitir que el conductor llame al pasajero a través de:",
        "allowPassengerToCallCC": "Permitir que el Pasajero llame al Centro de Comando a través de:",
        "allowPassengerToCallHelpdesk": "Permitir que el pasajero llame al servicio de ayuda mediante:",
        "allowPassengerToCallDriver": "Permitir que el Pasajero llame al Conductor a través de:",
        "voip": "VOIP",
        "mobile": "Móvil",
        "bookingSMS": "Plantilla de mensaje",
        "bookingSMSTemplate": {
            "name": "Nombre",
            "content": "Contenido",
            "action": "Acción",
            "DELETE": "Eliminar plantilla de mensaje",
            "DELETE_CONFIRM": "¿Está seguro de que desea eliminar la plantilla de mensaje seleccionada?",
            "EDIT": "Editar plantilla de mensaje",
            "ADD": "Agregar plantilla de mensaje",
            "DETAIL": "Detalle de la plantilla de mensaje",
            "Update_success": "La plantilla de mensaje se ha actualizado correctamente",
            "Create_success": "La plantilla de mensaje se ha creado correctamente",
            "Delete_success": "La plantilla de mensaje se ha eliminado correctamente",
            "Delete_fail": "Se produjeron errores al eliminar la plantilla de mensaje",
            "Load_fail": "Se produjeron errores al cargar la plantilla de mensaje",
            "Update_fail": "Se produjeron errores al actualizar la plantilla de mensaje",
            "Create_fail": "Se produjeron errores al crear la plantilla de mensaje"
        },
        "bookingSMSModal": {
            "title": "Agregar plantilla de SMS",
            "save": "Guardar",
            "cancel": "Cancelar",
            "titleMessage": "Enviar mensaje",
            "template": "Plantilla",
            "phoneNumber": "Número de teléfono",
            "content": "Contenido",
            "messageType": "Tipo de mensaje",
            "inbox": "Bandeja de entrada",
            "sms": "SMS",
            "sendTo": "Enviado a",
            "passenger": "Pasajero",
            "driver": "Conductor"
        }
    },
    "regularSetting": {
        "extraWaitTimeTooltip": "Fee to compensate the driver when he has to wait additional time for the customer till they are onboard.",
        "fareWaitTimeLater": "Tarifa por minuto (Reserva)",
        "fareWaitTimeNow": "Tarifa por minuto (Ahora)",
        "transport": "Transporte",
        "delivery": "Entrega",
        "Fer_Stop": "Tarifa por parada",
        "First_Stop": "Tarifa por primera parada",
        "Each_Stop": "Tarifa por cada parada adicional",
        "Name": "Nombre",
        "Pay_to_driver_Cash": "Pago al proveedor/conductor (Reserva en efectivo)",
        "Last_Update": "Última actualización",
        "Status": "Estado",
        "Required_fields": "Campos requeridos",
        "Yes": "Sí",
        "No": "No",
        "Cancel": "Cancelar",
        "Save": "Ahorrar",
        "Actions": "Acciones",
        "Edit": "Editar",
        "Add": "Agregar",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrado",
        "DELETE_CONFIRM": "¿Quieres borrar?",
        "ADD_REGULAR_RATE": "Añadir tarifa normal",
        "EDIT_REGULAR_RATE": "Editar tarifa normal",
        "DETAIL_REGULAR_RATE": "Detalle tarifa regular",
        "DELETE_REGULAR_RATE": "Eliminar tarifa normal",
        "Delete_confirm_regular_rate": "¿Quieres eliminar este artículo?",
        "STARTING": "Iniciando",
        "Starting_Now": "Iniciando (Ahora)",
        "Starting_Reservation": "Iniciando (Reserva)",
        "FIRST_DISTANCE_FEE": "Tasa de primera distancia",
        "First_distance_fee": "Tasa de primera distancia",
        "From": "Desde",
        "To": "A",
        "Fee_for_first_distance": "Tasa por primera distancia",
        "SECOND_DISTANCE_FEE": "Tasa de segunda distancia",
        "Second_distance_fee": "Tasa de segunda distancia",
        "AFTER_SECOND_DISTANCE": "Después de la segunda distancia",
        "Fee_after_second_distance": "Tarifa después de la segunda distancia",
        "PER_MINUTE": "Por minuto",
        "Fee_per_minute": "Tarifa por minuto",
        "mi": "min",
        "hour": "hora",
        "MINIMUM": "Mínimo",
        "Minimum_Now": "Mínimo (ahora)",
        "Minimum_Reservation": "Mínimo (Reserva)",
        "PAX_MDISPATCHER_CANCELLATION": "Cancelación de pasajero/pareja",
        "On_demand": "Bajo demanda",
        "Penalty": "Multa",
        "In_advance": "Por adelantado",
        "PAX_MDISPATCHER_NO_SHOW": "Pax/pareja no show",
        "Driver_cancel_demand": "Política de cancelación del conductor - bajo demanda",
        "Driver_cancel_advance": "Política de cancelación del conductor - con antelación",
        "Assign_car_type": "Asignar tipo de coche",
        "Select_car_type": "Seleccionar tipo de coche",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "Deactivate": "Desactivar",
        "DELETE_FLATE_RATE": "Eliminar tarifa plana",
        "Delete_confirm_flat_rate": "¿Quieres eliminar este artículo?",
        "EDIT_FLAT_RATE": "Editar tarifa plana",
        "ADD_FLAT_RATE": "Añadir tarifa plana",
        "DELETE_FLAT_RATE": "Eliminar tarifa fija",
        "DELETE_HOURLY_RATE": "Eliminar tarifa por hora/diaria",
        "Delete_confirm_hour_rate": "¿Quieres eliminar este artículo?",
        "EDIT_HOURLY_RATE": "Editar tarifa por hora/diaria",
        "ADD_HOURLY_RATE": "Agregar tarifa por hora/diaria",
        "DELETE_FLAT_ROUTE": "Eliminar ruta prefijada",
        "DELETE_ROUTE_CONFIRM": "Estás seguro de querer eliminar esta ruta?",
        "EDIT_ROUTE": "Editar ruta",
        "ADD_ROUTE": "Añadir ruta",
        "Route_name": "Nombre de la ruta",
        "Route_type": "Tipo de ruta",
        "Zone_to_zone": "Zona a Zona",
        "Zipcode_to_zipcode": "Codigo postal a código postal",
        "First_location": "Primera ubicación",
        "Second_location": "Segunda ubicación",
        "First_location_zip_note": "*Notas: puedes agregar varios códigos postales a la vez, usando la coma (,). Para códigos consecutivos, puedes usar -> en lugar de introducir uno a uno (por. ej. 41000->41200, 41500, 41600)",
        "Second_location_zip_note": "*Notas: puedes agregar varios códigos postales a la vez, usando la coma (,). Para códigos consecutivos, puedes usar -> en lugar de introducir uno a uno (por. ej. 41000->41200, 41500, 41600)",
        "SINGLE_TRIP_SETUP": "Configuración de un solo viaje",
        "Route_1": "Ruta 1 (Primera ubicación -> Segunda ubicación)",
        "Route_2": "Ruta 2 (Segunda ubicación -> Primera ubicación)",
        "Limitation": "Límites",
        "Unlimited": "Ilimitado",
        "Limited": "Limitado",
        "Time_coverage": "Tiempo incluido",
        "Extra_time": "Tiempo extra",
        "ROUND_TRIP_SETUP": "Configuración de ida y vuelta",
        "Round_trip": "Viaje ida y vuelta",
        "ROUTES": "RUTAS",
        "Route_1_Fare": "Tarifa ruta 1",
        "Route_2_Fare": "Tarifa ruta 2",
        "Round_Trip_Fare": "Tarifa ida y vuelta",
        "Select_a_zone": "Seleccione una zona",
        "minute": "minuto",
        "VIEW_REGULAR_RATE": "Ver detalles tarifa regular",
        "VIEW_FLAT_RATE": "Ver tarifa fija",
        "VIEW_HOURLY_RATE": "ver tarifa por días/horas",
        "HOURLY_PACKAGE_RATE": "Tarifa de paquete por hora",
        "Package_name": "Nombre del Plan",
        "Package_duration": "duración del Plan",
        "PackageId": "ID de paquete",
        "Base_rate": "Tarifa base",
        "Distance_coverage": "Distancia incluida",
        "Extra_duration": "Duración extra",
        "Extra_distance": "Distancia extra",
        "DELETE_HOURLY_PACKAGE": "Eliminar Plan por días/horas",
        "DELETE_PACKAGE_CONFIRM": "Desea eliminiar la tarifa del Plan?",
        "EDIT_PACKAGE": "Editar paquete",
        "VIEW_PACKAGE": "Ver detalle del paquete",
        "ADD_PACKAGE": "Agregar paquete",
        "Fee_per_extra_duration": "Tarifa por duración extra",
        "Fee_per_extra_distance": "Tarifa por distancia extra",
        "hours": "hora(s)",
        "days": "día(s)",
        "Update_flat_rate_success": "La tarifa plana se ha actualizado con éxito",
        "Update_flat_rate_fail": "Los errores ocurrieron al actualizar la tarifa plana",
        "Created_flat_rate_success": "La tarifa plana se ha creado con éxito",
        "Created_flat_rate_fail": "Los errores ocurrieron al crear la tarifa plana",
        "Update_flat_rate_route_success": "La ruta de tarifa plana se ha actualizado con éxito",
        "Update_flat_rate_route_fail": "Los errores ocurrieron al actualizar la ruta de tarifa plana",
        "Created_flat_rate_route_success": "La ruta de tarifa plana se ha creado correctamente",
        "Created_flat_rate_route_fail": "Los errores ocurrieron al crear la ruta de tarifa plana",
        "Loading_flat_rate_fail": "Los errores ocurrieron al cargar el detalle de la tarifa plana",
        "Delete_flat_rate_route_fail": "Los errores ocurrieron al eliminar la ruta de tarifa plana",
        "Delete_flat_rate_success": "La tarifa plana se ha eliminado correctamente",
        "Delete_flat_rate_fail": "Los errores ocurrieron al eliminar la tarifa plana",
        "Update_intercity_rate_success": "La tarifa interurbana se ha actualizado con éxito",
        "Update_intercity_rate_fail": "Los errores ocurrieron al actualizar la tarifa interurbana",
        "Created_intercity_rate_success": "La tarifa interurbana se ha creado con éxito",
        "Created_intercity_rate_fail": "Los errores ocurrieron al crear la tarifa interurbana",
        "Update_intercity_rate_route_success": "La tarifa de ruta interurbana se ha actualizado con éxito",
        "Update_intercity_rate_route_fail": "Los errores ocurrieron al actualizar la ruta de la tarifa interurbana",
        "Created_intercity_rate_route_success": "La ruta de tarifa interurbana se ha creado con éxito",
        "Created_intercity_rate_route_fail": "Los errores ocurrieron al crear la ruta de tarifa interurbana",
        "Loading_intercity_rate_fail": "Los errores ocurrieron al cargar el detalle de la tarifa interurbana",
        "Delete_intercity_rate_route_fail": "Los errores ocurrieron al eliminar la ruta de la tarifa interurbana",
        "Delete_intercity_rate_success": "La tarifa interurbana se ha eliminado correctamente",
        "Delete_intercity_rate_fail": "Los errores ocurrieron al eliminar la tarifa interurbana",
        "Update_regular_rate_success": "La tarifa regular ha sido actualizada con éxito",
        "Update_regular_rate_fail": "Los errores ocurrieron al actualizar la tarifa regular",
        "Create_regular_rate_success": "La tarifa regular se ha creado con éxito",
        "Create_regular_rate_fail": "Los errores ocurrieron al crear la tarifa regular",
        "Update_hourly_rate_success": "Tarifa por horas actualizada correctamente",
        "Update_hourly_rate_fail": "Los errores ocurrieron al actualizar la tarifa por hora",
        "Create_hourly_rate_success": "La tarifa por hora se ha creado con éxito",
        "Create_hourly_rate_fail": "Los errores ocurrieron al crear la tarifa por hora",
        "Update_hourly_rate_package_success": "El paquete de tarifa por hora se ha actualizado con éxito",
        "Update_hourly_rate_package_fail": "Los errores ocurrieron al actualizar el paquete de tarifa por hora",
        "Create_hourly_rate_package_success": "El paquete de tarifa por hora se ha creado correctamente",
        "Create_hourly_rate_package_fail": "Los errores ocurrieron al crear el paquete de tarifa por hora",
        "Load_hourly_rate_fail": "Los errores ocurrieron al cargar los detalles de la tarifa por hora",
        "Update_hourly_status": "Los errores ocurrieron al actualizar el estado de la tarifa por hora",
        "Delete_hourly_fail": "Los errores ocurrieron al eliminar la tarifa por hora",
        "Delete_hourly_success": "La tarifa por hora se ha eliminado correctamente",
        "Loading_regular_rate_fail": "Los errores ocurrieron al cargar la tarifa regular",
        "Update_regular_status_fail": "Los errores ocurrieron al actualizar el estado de la tarifa regular",
        "Delete_regular_rate_success": "La tarifa normal se ha eliminado correctamente",
        "Delete_regular_rate_fail": "Los errores ocurrieron al eliminar la tarifa regular",
        "Please_go_to_Car_Type_settings": "Para aplicar esta tarifa a cualquier tipo de automóvil, vaya a Configuración > Coche > Tipo de coche.",
        "Car_type_filter": "Filtro tipo de vehículo",
        "Delete_package_error": "¡Hubo un error al eliminar el paquete!",
        "Pax_mDispatcher_cancellation_tooltip": "Política de cancelación aplicada para pasajeros",
        "Penalty_tooltip": "monto cobrado",
        "Pax_mDispatcher_no_show_tooltip": "Se aplicó la política de no presentarse para los pasajeros. Se cobrará esta tarifa si los conductores presionan \"No presentarse\" cuando no ven pasajeros en el lugar de recogida.",
        "detail_route": "Detalle de ruta",
        "detail_package": "Detalle de Plan",
        "THIRD_DISTANCE_FEE": "Tarifa de tercera distancia",
        "AFTER_DISTANCE_FEE": "Tarifa después de tercera distancia",
        "Loading_delivery_rate_fail": "Se produjeron errores al cargar el detalle de la tarifa de entrega",
        "Update_delivery_rate_fail": "Se produjeron errores al actualizar la tarifa de entrega",
        "Update_delivery_rate_success": "La tarifa de entrega se ha actualizado correctamente",
        "Created_delivery_rate_success": "La tarifa de entrega se ha creado correctamente",
        "Created_delivery_rate_fail": "Se produjeron errores al crear la tarifa de entrega",
        "Starting_fee": "Tarifa inicial",
        "First_distance": "Primera distancia",
        "Second_distance": "Segunda distancia",
        "Third_distance": "Tercera distancia",
        "Fee_for_second_distance": "Tarifa por segunda distancia",
        "Fee_for_third_distance": "Tarifa por tercera distancia",
        "Fee_after_third_distance": "Tarifa después de tercera distancia",
        "Assign_rate_to_car_type": "Asignar tarifa al tipo de automóvil",
        "car_type": "Tipo de automóvil",
        "PRICE_ADJUSTABLE": "Precio ajustable",
        "Amount_Step": "Precio ajustable",
        "Tax": "Impuesto",
        "TechFee": "Tarifa tecnológica",
        "Pay_to_driver": "Pago al proveedor/conductor",
        "Pay_to_driver_tooltip": "Opciones para compensar a los conductores:\r\n- Monto fijo: Un monto fijo que recibirá el conductor.\r\n- Comisión: Comisión establecida por el conductor aplicada al monto de la penalización.",
        "Fix_amount": "Monto",
        "Commission": "Comisión",
        "fareFlat": "Tarifa plana",
        "flatRoute": "Ruta plana",
        "Mode": "Modo",
        "speedThresholdKM": "Umbral de velocidad (km/h)",
        "speedThresholdMI": "Umbral de velocidad (mi/h)",
        "timeAndMileage": "Tiempo y kilometraje",
        "timeOrMileage": "Tiempo o kilometraje",
        "perDistanceKM": "Por kilómetro",
        "perDistanceMI": "Por milla",
        "perTime": "Por minuto",
        "regularRates": "Tarifas regulares",
        "newRate": "Nueva tarifa",
        "enterName": "Introducir nombre de la tarifa",
        "actualMode": "Tarifa real",
        "estimatedMode": "Tarifa cotizada",
        "feePerStop": "Tarifa por paradas adicionales",
        "extraWaitTime": "Tiempo de espera adicional",
        "startingFee": "Inicio",
        "minimumFee": "Mínimo",
        "minAppend": "/min",
        "kmAppend": "/km",
        "miAppend": "/mi",
        "kmhrAppend": "km/h",
        "mihrAppend": "mi/h",
        "feePerKm": "Por kilómetro",
        "feePerMi": "Por milla",
        "feeSpeedThreshold": "Umbral de velocidad",
        "serviceType": "Tipo de servicio",
        "fareMode": "Fórmula",
        "calculationMode": "Modo de cálculo",
        "timeChangeMode": "Modo de cobro por tiempo",
        "minimum_Percent_Adjust": "Mínimo % de la tarifa estimada",
        "maximum_Percent_Adjust": "Máximo % de la tarifa estimada",
        "AllowAdjustPrice": "Permitir que el cliente ajuste el precio",
        "Calculation": "Cálculo",
        "distanceTier": "Nivel de distancia",
        "perKm": "Tarifa por km",
        "perMi": "Tarifa por mi",
        "flatFee": "Tarifa fija",
        "defaultRate": "Tarifa predeterminada",
        "timeRange": "Rango de tiempo",
        "bookingType": "Tipo de reserva",
        "rateDetail": "Detalle de tarifa",
        "subRate": "Subtarifa",
        "specialRates": "Tarifas especiales",
        "surcharge": "Recargo",
        "penalty": "Penalización",
        "basedOriginMode": "Basado en la hora original de recogida",
        "basedDriverMode": "Basado en la hora de recogida del conductor",
        "hourlyRate": "Tarifa por hora",
        "flat_Fare": "Tarifa fija",
        "flatFeeOption": "Cuota fija",
        "fareModeTooltip": "El tiempo o kilometraje solo se aplica a las tarifas de clientes, esto no se aplicará a la tarifa de pago del proveedor/conductor.",
        "cloneRate": "Tasa de Clonación",
        "rateName": "Nombre de la tarifa",
        "Infinity": "Infinito",
        "Fee": "Tarifa",
        "headerTile": "Ingrese el título del encabezado",
        "enterFooter": "Ingrese el título del pie de página",
        "invoiceNo": "Número de factura",
        "paidOn": "Pagado el",
        "amountPaid": "Cantidad Pagada",
        "isFeePerSeatActive": "Cargo por pasajero",
        "minSeat": "Número mínimo de pasajeros",
        "minSeatTooltip": "Este es el número mínimo de asientos para cobrar por una reserva.",
        "dropOffZoneIds": "Zonas de entrega",
        "applyGeniusDiscount": "Booking.com: Aplicar Descuento Genius (5%)"
    },
    "flatRateSettings": {
        "flatZoneNote": "Las zonas que cree aquí solo se utilizan para configurar sus tarifas planas."
    },
    "deliverySetting": {
        "Name": "NaNombreme",
        "Last_Update": "Última actualización",
        "Status": "Estado",
        "Actions": "Comportamiento"
    },
    "sharingSetting": {
        "EDIT_RATE": "Editar tarifa de uso compartido de la calle",
        "ADD_RATE": "Agregar tarifa de uso compartido de la calle",
        "VIEW_RATE": "Ver tarifa de uso compartido de la calle",
        "Name": "Nombre",
        "startingFee": "Tarifa inicial",
        "minimumFee": "Tarifa mínima",
        "Update_streetSharing_rate_fail": "Se produjeron errores al actualizar la tarifa de uso compartido de la calle",
        "Update_streetSharing_rate_success": "La tarifa de uso compartido de la calle se ha actualizado correctamente",
        "Created_streetSharing_rate_success": "La tarifa de uso compartido de la calle se ha creado correctamente",
        "Created_streetSharing_rate_fail": "Se produjeron errores al crear la tarifa de uso compartido de la calle",
        "Loading_streetSharing_rate_fail": "Se produjeron errores al cargar el detalle de la tarifa de uso compartido de la calle",
        "Delete_streetSharing_rate_success": "La tarifa de uso compartido de la calle se ha eliminado correctamente",
        "Delete_streetSharing_rate_fail": "Se produjeron errores al eliminar la tarifa de uso compartido de la calle",
        "Delete_streetSharing_rate": "Eliminar tarifa de uso compartido de la calle",
        "Assign_Car": "Asignar tipo de automóvil"
    },
    "carTypeSetting": {
        "ID": "ID de tipo de carro",
        "newService": "Nuevo servicio",
        "editService": "Editar servicio",
        "serviceInfo": "Información del servicio",
        "name": "Nombre",
        "namePH": "Nombre del tipo de automóvil",
        "enterNumber": "Ingrese un número",
        "appDisplayName": "Nombre de visualización de la aplicación",
        "shortDescription": "Descripción breve",
        "maxPassengers": "Máximo de pasajeros",
        "maxLuggage": "Máximo de equipajes",
        "vehiclePhoto": "Fotos del vehículo",
        "iconShowList": "Ícono para mostrar en la lista",
        "imageShowWeb": "Imagen para mostrar en la web",
        "carPinOnMap": "PIN del automóvil en el mapa",
        "recommendedSize": "Tamaño recomendado:",
        "serviceSetting": "Configuración del servicio",
        "serviceType": "Tipo de servicio",
        "reservation": "Reserva",
        "onDemand": "Bajo demanda",
        "destinationSetting": "Configuración del destino",
        "requireDestination": "Requerir destino",
        "extraDestination": "Destino adicional",
        "calculatorFareMode": "Modo de cálculo de tarifa",
        "hideDestinationOnDemand": "Bajo demanda",
        "meteredFare": "Tarifa medida",
        "quotedFare": "Tarifa cotizada",
        "availableZones": "Zonas disponibles",
        "dispatchAssociation": "Asociación de despacho",
        "Save": "Guardar",
        "Edit": "Editar",
        "Cancel": "Cancelar",
        "validateName": "Por favor, ingrese el nombre",
        "validateAppDisplayName": "Por favor, ingrese el nombre de visualización de la aplicación",
        "validateSelectImage": "Por favor, seleccione una imagen",
        "updateSuccess": "Actualización exitosa",
        "createSuccess": "Creación exitosa",
        "failApi": "¡Algo salió mal!",
        "validateRequire": "Por favor, especifique la cantidad de pasajeros y verifique el equipaje."
    },
    "carSetting": {
        "Details": "Detalles",
        "vehicleInfo": "Información del vehículo",
        "Documents": "Documentos",
        "vehicle": "Vehículo",
        "addVehicle": "Agregar vehículo",
        "detailVehicle": "Detalles del vehículo",
        "additionalVehicleTitle": "Información adicional del vehículo",
        "Phone_Number_Tooltip": "Ingrese un número de teléfono específico del vehículo para uso del cliente. Si no se proporciona, las llamadas se dirigirán al número personal del conductor. Ideal para proveedores que equipan vehículos con teléfonos de contacto dedicados.",
        "discardChange": "Descartar cambios",
        "model_name_is_required": "Modelo de vehículo obligatorio",
        "DELETE_CAR": "Eliminar coche",
        "DELETE_CONFIRM": "¿Quieres eliminar el coche seleccionado?",
        "Yes": "sí",
        "Cancel": "Cancelar",
        "EDIT_CAR": "editar coche",
        "CREATE_CAR": "crear coche",
        "Plate_Number": "Número de placa",
        "Car_Type": "Tipo de carro",
        "Select_car_type": "Seleccionar tipo de coche",
        "Make": "Fabricar",
        "Select_car_make": "Seleccionar marca de coche",
        "Model": "Modelo",
        "Select_a_car_model": "Seleccione un modelo de coche",
        "Year": "Año",
        "Select_year": "Seleccionar año",
        "Hardware_Meter": "Medidor de hardware",
        "VIN": "Número de identificación del vehículo (VIN)",
        "Company": "Compañía",
        "Select_company": "Seleccionar empresa",
        "Max_Passengers": "Pasajeros máximos",
        "Max_Luggage": "Equipaje máximo",
        "Color": "Color",
        "License_expiry": "Caducidad de la licencia",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Add": "Agregar",
        "Car_Model": "Modelo de auto",
        "Created_Date": "Fecha de creación",
        "Status": "Estado",
        "Actions": "Acciones",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Active": "Activo",
        "activeVehicle": "Vehículo activo",
        "Inactive": "Inactivo",
        "Edit": "Editar",
        "Deactivate": "Desactivar",
        "Activate": "Activar",
        "Delete": "Borrar",
        "Name": "Nombre",
        "MODEL_LIST": "Lista de modelos",
        "Model_Name": "Nombre del modelo",
        "Add_Model": "Añadir modelo",
        "DELETE_CAR_MODEL": "Eliminar modelo de vehículo",
        "DELETE_CONFIRM_MODEL": "Desea eliminar el modelo de vehículo?",
        "DELETE_CAR_MAKE": "Eliminar marca de coche",
        "DELETE_CONFIRM_CAR_MAKE": "¿Quieres eliminar esta marca de coche?",
        "EDIT_CAR_MAKE": "Editar marca de coche",
        "CREATE_CAR_MAKE": "Añadir marca de coche",
        "Assign_Rate": "Asignar tarifa",
        "ASSIGN_RATE": "Asignar tarifa",
        "Car_type_ID": "Identificación del tipo de coche",
        "App_Display_Name": "nombre App",
        "Affiliate_car_type": "Tipo de vehículo afiliado",
        "Regular_rate": "Tarifa regular",
        "Zone": "Zona",
        "Rate": "Calificar",
        "Zone_Rate": "Zona - Tarifa",
        "Flat_Fare": "Tarifa Plana",
        "Flat_Delivery": "Tarifa de entrega fija",
        "Select_flat_rate": "Seleccionar tarifa plana",
        "Hourly_daily_rate": "Horas/días",
        "Dispatch_To": "Envío a",
        "Normal_Fare": "Tarifa normal",
        "Upload_an_image": "Subir una imagen",
        "DETAIL_CAR": "Detalle de vehículo",
        "DELETE_MULTI_CAR": "Eliminar vehículos seleccionados",
        "DELETE_MULTI_CAR_CONFIRM": "Desea eliminar estos vehículos?. Sólo pueden ser eliminados vehículos en situación de Inactivos",
        "DETAIL_CAR_MAKE": "Marca de vehículo",
        "Car_Make": "Marca de auto",
        "Create_car_success": "Nuevo coche ha sido creado con éxito",
        "Update_car_success": "el vehículo ha sido actualizado correctamente",
        "Update_car_fail": "error al actualizar vehículo",
        "Create_car_fail": "Los errores ocurrieron al crear el auto",
        "Load_car_fail": "Los errores ocurrieron al cargar el auto",
        "Delete_car_fail": "Los errores ocurrieron al eliminar el auto",
        "Delete_car_success": "El coche se ha eliminado correctamente",
        "Change_cars_status_success": "Todos los estados de los coches se han cambiado con éxito",
        "Change_cars_status_fail": "Los errores ocurrieron al cambiar los estados del automóvil.",
        "Delete_cars_success": "Todos los autos seleccionados se han eliminado con éxito",
        "Delete_cars_fail": "Los errores ocurrieron al eliminar autos",
        "Update_car_type_success": "El tipo de coche se ha actualizado correctamente",
        "Update_car_type_fail": "Los errores ocurrieron al actualizar el tipo de automóvil.",
        "Load_car_type_details_fail": "No se pudieron cargar los detalles del tipo de auto",
        "Update_car_make_fail": "Los errores ocurrieron al actualizar la marca del automóvil.",
        "Update_car_make_success": "La marca del coche se ha actualizado correctamente",
        "Create_car_make_fail": "Los errores ocurrieron al crear la marca del automóvil.",
        "Create_car_make_success": "La nueva marca de automóvil se ha creado con éxito",
        "Update_car_model_fail": "Los errores ocurrieron al actualizar el modelo de automóvil.",
        "Update_car_model_success": "El modelo de coche se ha actualizado con éxito.",
        "Create_car_model_fail": "Los errores ocurrieron al crear el modelo de automóvil.",
        "Create_car_model_success": "El nuevo modelo de coche se ha creado con éxito.",
        "Loading_car_model_fail": "Los errores ocurrieron al cargar el modelo de automóvil.",
        "Delete_car_make_success": "La marca del coche se ha eliminado correctamente",
        "Delete_cat_make_fail": "Los errores ocurrieron al eliminar la marca del automóvil.",
        "Delete_regular_rate_success": "Tarifa regular eliminada correctamente",
        "Delete_regular_rate_fail": "Error al eliminar tarifa regular",
        "Update_status_error": "Error actualización del estatus",
        "Case_number": "número de expediente",
        "Phone_Number": "Número de teléfono",
        "ERROR_INPUT_VALIDPHONE": "Por favor ingrese un número de teléfono válido.",
        "Car_type_filter": "Filtro de tipo de coche",
        "No": "No",
        "Intercity_Rate": "Tarifa interurbana",
        "Select_intercity_rate": "Seleccionar tarifa interurbana",
        "Delivery_Rate": "Tarifa de entrega",
        "Select_delivery_rate": "Seleccionar tarifa de entrega",
        "vehicleOwner": "Nombre del propietario del vehículo",
        "EDIT_CAR_COLOR": "Editar color del automóvil",
        "DETAIL_CAR_COLOR": "Detalle del color del automóvil",
        "CREATE_CAR_COLOR": "Agregar color del automóvil",
        "Car_Color": "Color del automóvil",
        "Update_car_color_fail": "Se produjeron errores al actualizar el color del automóvil.",
        "Update_car_color_success": "El color del automóvil se ha actualizado correctamente.",
        "Create_car_color_fail": "Se produjeron errores al crear el color del automóvil.",
        "Create_car_color_success": "El nuevo color del automóvil se ha creado correctamente.",
        "Delete_car_color_success": "El color del automóvil se ha eliminado correctamente.",
        "Delete_car_color_fail": "Se produjeron errores al eliminar el color del automóvil.",
        "DELETE_CAR_COLOR": "Eliminar color del automóvil",
        "DELETE_CONFIRM_CAR_COLOR": "¿Desea eliminar este color de automóvil?",
        "sharing_Rate": "Tarifa de uso compartido de la calle",
        "bookingAffiliate": "Tipo de automóvil afiliado a Booking.com",
        "streetSharing": "Uso compartido de la calle",
        "colorCode": "Código de color",
        "selectColorCode": "Seleccionar código de color"
    },
    "operationSetting": {
        "Driver": "Conductor",
        "Search_driver_name": "Buscar nombre del controlador",
        "Company": "Compañía",
        "License_plate": "Placa",
        "Select_license_plate": "Seleccionar matrícula",
        "Shift": "Turno",
        "Zone": "Zona",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "No": "No.",
        "Car_Type": "Tipo de carro",
        "Plate_Number": "Número de placa",
        "Unassign": "Desasignar",
        "Please_choose_driver": "Por favor elija conductor.",
        "Please_choose_company": "Por favor seleccione empresa",
        "Please_license_plate": "Por favor, elija la matrícula.",
        "Please_choose_shift": "Por favor, elija turno.",
        "Please_choose_zone": "Por favor elija zona.",
        "CONFIRM_UNASSIGN": "¿Desea anular la asignación de este controlador?",
        "Assign_success": "La operación ha sido asignada con éxito",
        "Unassign_success": "El controlador se ha desasignado con éxito."
    },
    "paymentMethod": {
        "cash": "Efectivo",
        "easyPaisa": "Easy Paisa",
        "jazzCash": "Jazz Cash",
        "cashBySender": "Efectivo por remitente",
        "cashByRecipient": "Efectivo por remitente",
        "personalCard": "Tarjeta personal",
        "corporateCard": "Tarjeta corporativa",
        "qrCodePayment": "Código QR",
        "directBilling": "Facturación Directa",
        "externalCard": "tarjeta externa",
        "mDispatcherCard": "tarjeta de socio",
        "corporatePrepaid": "prepago corporativo",
        "fleetCard": "tarjeta externa",
        "applePay": "Apple Pay",
        "creditExternalCard": "Tarjeta de crédito (externa)",
        "googlePay": "Google Pay",
        "wallet": "Cartera",
        "BankOfGeorgia": "Banco de Georgia",
        "tnGeWalletlet": "Monedero electrónico TnG",
        "paymentMethod_1": "Efectivo",
        "paymentMethod_2": "Tarjeta personal",
        "paymentMethod_3": "tarjeta de socio",
        "paymentMethod_4": "Tarjeta corporativa",
        "paymentMethod_5": "Facturación Directa",
        "paymentMethod_6": "tarjeta externa",
        "paymentMethod_7": "prepago corporativo",
        "paymentMethod_8": "Código QR",
        "paymentMethod_9": "Apple Pay",
        "paymentMethod_11": "pago aéreo",
        "paymentMethod_12": "Tarjeta de crédito (externa)",
        "paymentMethod_13": "Cartera",
        "paymentMethod_14": "Monedero electrónico TnG",
        "paymentMethod_16": "Efectivo por remitente",
        "paymentMethod_17": "Efectivo por destinatario",
        "paymentMethod_19": "Boost eWallet",
        "paymentMethod_20": "Vipps",
        "paymentMethod_21": "ZainCash",
        "paymentMethod_23": "Google Pay",
        "paymentMethod_25": "Easy Paisa",
        "paymentMethod_27": "Samsung Pay",
        "paymentMethod_28": "Kakao Pay",
        "paymentMethod_29": "Naver Pay",
        "paymentMethod_30": "WeChat Pay",
        "paymentMethod_31": "Alipay",
        "paymentMethod_32": "PayNow",
        "paymentMethod_33": "GrabPay",
        "paymentMethod_34": "Cash App Pay",
        "vippseWallet": "Vipps",
        "paymentMethod_credit": "Tarjeta personal",
        "paymentMethod_razerPay": "RazerPay",
        "paymentMethod_gCash": "GCash",
        "paymentMethod_zainCash": "ZainCash",
        "paymentMethod_xenDit": "Xendit",
        "paymentMethod_alipayExternal": "Alipay",
        "paymentMethod_FIB": "FIB",
        "paymentMethod_SantimPay": "SantimPay",
        "paymentMethod_ksher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_fawry": "Fawry",
        "paymentMethod_BankOfGeorgia": "Banco de Georgia",
        "paymentLink": "Enlace de pago",
        "paymentMethod_xendit": "Xendit",
        "paymentMethod_easyPaisa": "Easy Paisa",
        "paymentMethod_jazzCash": "Jazz Cash",
        "paymentMethod_flooz": "Flooz",
        "paymentMethod_tmoney": "Tmoney",
        "paymentMethod_samsung_pay": "Samsung Pay",
        "paymentMethod_kakao_pay": "Kakao Pay",
        "paymentMethod_naver_pay": "Naver Pay",
        "paymentMethod_wechat_pay": "WeChat Pay",
        "paymentMethod_alipay": "Alipay",
        "paymentMethod_paynow": "PayNow",
        "paymentMethod_grabpay": "GrabPay",
        "paymentMethod_cashapp": "Cash App Pay"
    },
    "changePassword": {
        "Change_password": "Cambia la contraseña",
        "Current_password": "Contraseña actual",
        "New_password": "Nueva contraseña",
        "Confirm_password": "Confirmar contraseña",
        "ERROR_INPUT_PASSWORD": "Por favor ingrese la contraseña",
        "ERROR_INPUT_VALID_PASSWORD": "La contraseña debe contener al menos 8 caracteres, un dígito numérico y un carácter especial",
        "ERROR_INPUT_MATCH_PASSWORD": "Las contraseñas no coinciden.  Inténtalo de nuevo",
        "Save": "Ahorrar",
        "Cancel": "Cancelar"
    },
    "userProfile": {
        "My_account": "Mi cuenta",
        "Username": "nombre de usuario",
        "First_name": "Nombre de pila",
        "Last_name": "Apellido",
        "Phone_number": "Número de teléfono",
        "Email_address": "Dirección de correo electrónico",
        "Address": "Habla a",
        "Save": "Ahorrar",
        "Edit_profile": "Editar perfil",
        "Change_password": "Cambia la contraseña",
        "ERROR_INPUT_USERNAME": "Por favor ingrese el nombre de usuario.",
        "ERROR_INPUT_FIRSTNAME": "Por favor ingrese el primer nombre.",
        "ERROR_INPUT_VALID_EMAIL": "Por favor introduzca un correo electrónico válido.",
        "Required_fields": "Campos requeridos"
    },
    "General": {
        "widgetChat": "Support / Chat",
        "searchQueuingDriver": "Buscar: nombre del conductor, número de teléfono",
        "search": "Buscar",
        "User": "Usuario",
        "My_Account": "Mi cuenta",
        "Product_Discovery": "Descubrimiento de Producto",
        "Sign_out": "desconectar",
        "My_site": "Mi sitio",
        "Command_center": "Centro de comando",
        "Notifications": "Notificaciones",
        "Show_all": "Mostrar todo",
        "SOS_Notifications": "Notificaciones emergencia",
        "You_dont_have_any_message": "no tienes ningun mensaje",
        "Mon": "Lun",
        "Tue": "Mar",
        "Wed": "Casarse",
        "Thu": "Jue",
        "Fri": "Vie",
        "Sat": "Se sentó",
        "Sun": "Sol",
        "Now": "Ahora",
        "NowComplete": "Ahora (Hora real de recogida)",
        "hrs": "horas",
        "patmentMethod_1": "Dinero en efectivo",
        "patmentMethod_2": "Tarjeta personal",
        "patmentMethod_3": "tarjeta de socio",
        "patmentMethod_4": "Tarjeta corporativa",
        "patmentMethod_5": "facturación directa",
        "patmentMethod_6": "tarjeta externa",
        "patmentMethod_7": "Prepago Corporativo",
        "patmentMethod_8": "Código QR",
        "patmentMethod_9": "Apple Pay",
        "patmentMethod_10": "Apple Pay",
        "patmentMethod_12": "Tarjeta de crédito (externa)",
        "patmentMethod_13": "Cartera",
        "patmentMethod_14": "Monedero electrónico TnG",
        "patmentMethod_16": "Efectivo por remitente",
        "patmentMethod_17": "Efectivo por destinatario",
        "patmentMethod_19": "Impulso",
        "patmentMethod_20": "Vipps",
        "patmentMethod_23": "Google Pay",
        "patmentMethod_24": "Enlace de pago",
        "patmentMethod_25": "Easy Paisa",
        "patmentMethod_26": "Jazz Cash",
        "patmentMethod_27": "Samsung Pay",
        "patmentMethod_28": "Kakao Pay",
        "patmentMethod_29": "Naver Pay",
        "patmentMethod_30": "WeChat Pay",
        "patmentMethod_31": "Alipay",
        "patmentMethod_32": "PayNow",
        "patmentMethod_33": "GrabPay",
        "patmentMethod_34": "Cash App Pay",
        "patmentMethod_ZainCash": "ZainCash",
        "patmentMethod_Xendit": "Xendit",
        "patmentMethod_FIB": "FIB",
        "patmentMethod_SantimPay": "SantimPay",
        "patmentMethod_GCash": "GCash",
        "patmentMethod_cash": "Efectivo",
        "patmentMethod_credit": "Personal card",
        "patmentMethod_mDispatcher": "Partner card",
        "patmentMethod_corpCredit": "Tarjeta corporativa",
        "patmentMethod_directBilling": "Direct invoicing",
        "patmentMethod_fleetCard": "Tarjeta externa",
        "patmentMethod_prepaid": "Prepago corporativo",
        "patmentMethod_QRCode": "Código QR",
        "patmentMethod_applePay": "Apple Pay",
        "patmentMethod_easyPaisa": "Easy Paisa",
        "patmentMethod_jazzCash": "Jazz Cash",
        "patmentMethod_prePaid": "Prepago corporativo",
        "patmentMethod_GooglePay": "Google Pay",
        "patmentMethod_creditCardExternal": "Tarjeta de crédito",
        "patmentMethod_exXendit": "QRIS",
        "patmentMethod_PaxWallet": "Billetera",
        "patmentMethod_TnGeWallet": "TnG eWallet",
        "patmentMethod_boosteWallet": "Impulso",
        "patmentMethod_Vipps": "Vipps",
        "patmentMethod_exZainCash": "ZainCash",
        "patmentMethod_exGCash": "GCash",
        "patmentMethod_exPayTM": "PayTM",
        "patmentMethod_exFlooz": "Flooz",
        "patmentMethod_exTmoney": "Tmoney",
        "patmentMethod_exTelebirr": "GCash",
        "paymentMethod_exzainCash": "ZainCash",
        "paymentMethod_exXendit": "Xendit",
        "paymentMethod_exalipay": "Alipay",
        "paymentMethod_exFIB": "FIB",
        "paymentMethod_exSantimPay": "SantimPay",
        "patmentMethod_exKsher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_exfawry": "Fawry",
        "patmentMethod_exBankOfGeorgia": "Banco de Georgia",
        "patmentMethod_exPayDunya": "PayDunya",
        "patmentMethod_21": "ZainCash",
        "patmentMethod_paymentLink": "Enlace de pago",
        "patmentMethod_card": "Tarjeta personal",
        "patmentMethod_corporateCard": "Tarjeta corporativa",
        "patmentMethod_paxWallet": "Billetera",
        "patmentMethod_externalWallet": "Billetera externa",
        "patmentMethod_googlePay": "Google Pay",
        "patmentMethod_manual": "Manual",
        "patmentMethod_samsung_pay": "Samsung Pay",
        "patmentMethod_kakao_pay": "Kakao Pay",
        "patmentMethod_naver_pay": "Naver Pay",
        "patmentMethod_wechat_pay": "WeChat Pay",
        "patmentMethod_alipay": "Alipay",
        "patmentMethod_paynow": "PayNow",
        "patmentMethod_grabpay": "GrabPay",
        "patmentMethod_cashapp": "Cash App Pay",
        "patmentMethod_online": "Pago con tarjeta/En línea",
        "patmentMethod_check": "Verificar",
        "patmentMethod_wire": "Alambre",
        "patmentMethod_digitalWallet": "Billetera Digital",
        "patmentMethod_bankTransfer": "Transferencia Bancaria",
        "patmentMethod_offlineMethod": "Pago sin conexión",
        "patmentAirlineMethod_5": "Direct invoicing",
        "patmentAirlineMethod_4": "Tarjeta de aerolínea",
        "patmentAirlineMethod_7": "Prepago de aerolínea",
        "Name": "Nombre",
        "Delete": "Borrar",
        "App_SOS_dialog_form_message_1": "{0} SOS de emergencia!",
        "App_SOS_dialog_form_message_2": "necesito ayuda en",
        "App_SOS_dialog_form_message_3": "Reserva: {0}, Conductor: {1}, Pasajero: {2}, Placa de matrícula: {3} ({4})",
        "mins": "minutos",
        "Credit_Card": "Tarjeta de crédito",
        "ALL": "Todo",
        "NotFound": "la página solicitad no se ha encontrado",
        "ServerError": "Ocurrió un error",
        "AccessDenied": "No tienes permiso para acceder a este área",
        "Retry": "Intentar de nuevo",
        "Can_not_get_data": "no puedo obtener datos"
    },
    "shiftSettings": {
        "Add": "Agregar",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "Name": "Nombre",
        "Time_Range": "Intervalo de tiempo",
        "Actions": "Acciones",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Edit": "Editar",
        "Delete": "Borrar",
        "EDIT_SHIFT_SETTING": "Editar ajuste de turno",
        "ADD_SHIFT_SETTING": "Añadir ajuste de turno",
        "DETAIL_SHIFT_SETTING": "Ajuste de cambio de detalle",
        "DELETE_SHIFT_SETTING": "Eliminar ajuste de turno",
        "Delete_confirm_shift_setting": "¿Quieres eliminar este artículo?",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "From": "Desde",
        "To": "A",
        "Edit_shift_template": "Editar plantilla de turno",
        "Add_shift_template": "Agregar plantilla de turno",
        "Detail_shift_template": "Plantilla de cambio de detalle",
        "Delete_shift_template": "Eliminar plantilla turnos",
        "Delete_confirm_shift_template": "¿Quieres eliminar este artículo?",
        "Working_time": "Tiempo de trabajo",
        "Create_shift_settings_success": "La nueva configuración de turno se ha creado con éxito",
        "Create_shift_settings_fail": "Los errores ocurrieron al crear la configuración de turno",
        "Update_shift_settings_success": "La configuración de turnos se ha actualizado correctamente",
        "Update_shift_settings_fail": "Los errores ocurrieron al actualizar la configuración de turnos",
        "Delete_shift_settings_success": "La configuración de turno se ha eliminado correctamente",
        "Delete_shift_settings_fail": "Los errores ocurrieron al eliminar la configuración de turno",
        "Create_shift_template_success": "La nueva plantilla de turno se ha creado con éxito",
        "Create_shift_template_fail": "Los errores ocurrieron al crear la plantilla de turno",
        "Update_shift_template_success": "La plantilla de turno se ha actualizado correctamente",
        "Update_shift_template_fail": "Los errores ocurrieron al actualizar la plantilla de turno",
        "Delete_shift_template_success": "La plantilla de turno se ha eliminado correctamente",
        "Delete_shift_template_fail": "Los errores ocurrieron al eliminar la plantilla de turno",
        "Yes": "Sí",
        "No": "No"
    },
    "promotionSettings": {
        "Detail_campaign": "Detalle Campaña",
        "Edit_campaign": "Editar campaña",
        "Add_campaign": "Agregar campaña",
        "Delete_campaign": "Eliminar campaña",
        "Delete_confirm_campaign": "¿Desea eliminar la campaña seleccionada?",
        "Add": "Agregar",
        "Corporate_list": "Lista corporativa",
        "permittedCorporate": "Lista corporativa permitida",
        "CorporateCustomers": "Clientes corporativos",
        "auto_add_corporate": "Agregar automáticamente a la lista de promociones de usuarios corporativos",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "Name": "Nombre",
        "Actions": "Acciones",
        "Private": "Privado",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Edit": "Editar",
        "Delete": "Borrar",
        "Send_to_inbox": "Enviar a Bandeja de Entrada",
        "Save": "Ahorrar",
        "Duplicate": "Duplicar",
        "Cancel": "Cancelar",
        "Required_fields": "Campos requeridos",
        "Promotion_code": "El código de promoción",
        "Promotion_type": "Tipo de promoción",
        "Campaign": "Campaña",
        "Type": "Tipo",
        "Value": "Valor",
        "keepMinFee": "La tarifa total después de la promoción debe ser mayor que la tarifa mínima",
        "Zone": "Zonas",
        "paymentMethodsApply": "Métodos de pago",
        "schedules": "Horarios",
        "minimumEstFareApply": "Tarifa total estimada mínima para aplicar el código",
        "quantityLimitPerYear": "Uso máximo/usuario/año",
        "termAndCondition": "Términos y condiciones",
        "Valid_from": "Válida desde",
        "Valid_to": "Válido hasta",
        "Total_uses_user": "Usos Totales/Usuario",
        "Released_quantity": "Cantidad liberada",
        "Number_of_sending_inbox": "Número de bandeja de entrada de envío",
        "Status": "Estado",
        "Activate": "Activar",
        "Deactivate": "Desactivar",
        "Add_promotion_code": "Añadir código de promoción",
        "Edit_promotion_code": "Editar código de promoción",
        "Detail_promotion_code": "Detalle código de promoción",
        "Delete_promotion_code": "Eliminar código de promoción",
        "Delete_confirm_promotion_code": "¿Desea eliminar el código de promoción seleccionado?",
        "New_customer": "Nuevos clientes",
        "Budget_per_user": "Presupuesto/usuario (para todo el período de promoción)",
        "Budget_per_user_day": "Presupuesto/usuario/día",
        "Budget_per_user_month": "Presupuesto/usuario/mes",
        "Budget_per_user_year": "Presupuesto/usuario/año",
        "Unlimited": "Ilimitado",
        "Limited": "Limitado",
        "Total_uses_per_user": "Usos máximos/usuario (durante todo el período de promoción)",
        "Send_an_in_box_automatically_to_new_customers": "Enviar una bandeja de entrada automáticamente a nuevos clientes",
        "Notes": "Notas",
        "Public": "Público",
        "Create_campaign_success": "La nueva campaña se ha creado con éxito",
        "Create_campaign_fail": "Los errores ocurrieron al crear la campaña.",
        "Update_campaign_success": "La campaña ha sido actualizada con éxito",
        "Update_campaign_fail": "Los errores ocurrieron al actualizar la campaña.",
        "Delete_campaign_success": "Campaña eliminada correctamente",
        "Delete_campaign_fail": "Error al eliminar la campaña",
        "Loading_campaign_fail": "Los errores ocurrieron al cargar la campaña.",
        "Update_campaign_status_success": "El estado de la campaña se ha actualizado correctamente",
        "Update_campaign_status_fail": "Los errores ocurrieron al actualizar el estado de la campaña.",
        "Loading_promotion_code_fail": "Error al cargar el código promocional",
        "Select_campaign": "Seleccionar campaña",
        "Create_promotion_code_success": "El nuevo código de promoción se ha creado con éxito",
        "Create_promotion_code_fail": "Los errores ocurrieron al crear el código de promoción",
        "Update_promotion_code_status_success": "El estado del código de promoción se ha actualizado correctamente",
        "Update_promotion_code_status_fail": "Los errores ocurrieron al actualizar el estado del código de promoción",
        "Delete_promotion_code_confirmation": "¿Quieres eliminar estos códigos de promoción?",
        "Just_delete_inactive": "** Solo se puede eliminar el código de promoción en estado inactivo.",
        "Send_inbox_confirmation": "Está seguro de querer enviar este código promocional a la bandeja de entrada de los usuarios?",
        "Send_inbox_success": "Código promocional enviado correctamente",
        "Send_inbox_fail": "Error al enviar código promocional. Inténtelo de nuevo",
        "Confirmation": "Confirmación",
        "Delete_promotion_codes_success": "Código promocional eliminado correctamente",
        "Delete_promotion_codes_fail": "Error al eliminar código promocional",
        "Delete_multiple_promotion_codes_success": "Los códigos de promoción se han eliminado correctamente",
        "Delete_multiple_promotion_codes_fail": "Error al eliminar códigos promocionales",
        "Delete_promotion_code_success": "Código promocional eliminado correctamente",
        "Delete_promotion_code_fail": "Error al eliminar código promocional",
        "Update_multiple_promotion_code_status_success": "Los estados del código de promoción se han actualizado correctamente",
        "Update_multiple_promotion_code_status_fail": "Error al eliminar situación código promocional",
        "Search_here": "Busca aquí",
        "Please_input_campaign_name": "Ingrese el nombre de la campaña",
        "Please_input_promotion_code": "Por favor ingrese el código de promoción",
        "Please_input_promotion_code_at_least_4_characters": "Introduzca al menos 4 caracteres",
        "Please_select_campaign": "Por favor seleccione campaña",
        "Please_input_value": "Por favor ingrese el valor",
        "Please_select_date": "Por favor seleccione la fecha",
        "Please_add_schedules": "Por favor, agregue un horario",
        "Please_add_corporate": "Por favor, agregue corporativo",
        "Please_choose_at_least_one_customer": "Elija al menos un cliente.",
        "This_campaign_name_has_been_existing_on_the_system_Please_input_another_one": "Este nombre de campaña ha existido en el sistema.  Por favor ingrese otro.",
        "This_promotion_code_has_been_existing_on_the_system_Please_input_another_one": "Este código de promoción ha existido en el sistema.  Por favor ingrese otro.",
        "Invalid_file": "Archivo no válido",
        "File_size_larger_than_5Mb": "Tamaño de archivo es superior a 5 Mb",
        "Import_promotions_success": "Archivo importado correctamente",
        "Import_Promotions": "Importar documento",
        "Number_successful_imports": "Documentos importados",
        "Number_skipped": "Saltar documento",
        "File": "Archivo",
        "Phone_Numbers": "Número(s) de teléfono",
        "Import_Promotion_code_success": "El código de promoción <b>{0}</b> se ha importado correctamente",
        "Import_Promotion_code_fail": "El código de promoción <b>{0}</b> no se ha podido importar. Por favor, inténtelo de nuevo",
        "Customer_type": "Tipo de cliente",
        "All": "Todo",
        "Referred_customers": "Clientes referidos",
        "Common_customers": "Clientes generales",
        "Operation_zone": "Zonas de funcionamiento",
        "totalUsesLimitPerDay": "Usos máximos/usuario/día",
        "quantityLimitPerDay": "Cantidad máxima/día",
        "quantityLimitPerMonth": "Cantidad máxima/usuario/mes",
        "applyVerifiedCustomers": "Aplicar solo para clientes de Malasia verificados",
        "applyWhenBudgetLimit": "El usuario puede aplicar el código hasta que se alcance el límite del presupuesto",
        "applyVerifiedCustomersTooltip": "Esta promoción se aplica solo a los malayos que hayan verificado su identificación nacional y hayan subido su tarjeta de identificación al sistema.",
        "valueLimitPerUse": "Valor máximo/uso (Aplicar para la app v48 y superior)",
        "Promotion_Services": "Servicio",
        "transport": "Transporte",
        "shuttle": "Transporte compartido",
        "parcel": "Paquete",
        "food": "Comida",
        "mart": "Tienda",
        "intercity": "Interurbano",
        "addSchedule": "Agregar horario",
        "editSchedule": "Editar horario",
        "date": "Fecha",
        "Time_range": "Rango de tiempo",
        "startTime": "Hora de inicio",
        "endTime": "Hora de fin",
        "applyForOtherDays": "Aplicar para otros días",
        "scheduleTimeOverlap": "El horario no debe superponerse entre sí",
        "schedule_startDate_greater_than_endDate": "La fecha de inicio es mayor que la fecha de finalización",
        "scheduleTimeDuplicate": "El horario no debe duplicarse entre sí",
        "promoIcon": "Ícono de promoción",
        "bannerImage": "Imagen de banner",
        "Upload_an_image": "Subir una imagen",
        "Click_here_to_view": "Haga clic aquí para ver."
    },
    "quest_event": {
        "name": "Nombre",
        "userType": "Tipo de Usuario",
        "carType": "Tipo de automóvil",
        "operationZones": "Zona de operación",
        "type": "Tipo de evento",
        "isLuckyDraw": "Sorteo de la suerte",
        "start_date": "Fecha de inicio",
        "end_date": "Fecha final",
        "numOfQualify": "Número de Calificados",
        "event_progress": "Progreso del evento",
        "isActive": "Estado",
        "Actions": "Acción",
        "passenger": "Cliente",
        "driver": "Conductor",
        "first_will_win": "El primero ganará",
        "largest_will_win": "El mayor ganará (tabla de clasificación)",
        "not_start": "No iniciado",
        "active": "Activo",
        "closed": "Cerrado",
        "event_details": "Detalles de la misión",
        "add_event": "Agregar misión",
        "limited": "Limitado",
        "unlimited": "Ilimitado",
        "eventImage": "Imagen del evento",
        "sharedImage": "Imagen compartida",
        "qualifiedImage": "Imagen calificada",
        "expiredImage": "Imagen expirada",
        "luckyDrawImage": "Imagen de sorteo",
        "Upload_an_image": "Subir una imagen",
        "Required_Image": "Extensiones de imagen (.jpg, .png, .gif)",
        "ok": "Está bien",
        "eventId": "ID del evento",
        "passengerMetric": {
            "booking_distance": "Distancia de reserva",
            "booking_time": "Tiempo de reserva",
            "booking_amount_spent": "Monto gastado en reserva",
            "num_of_ondemand": "Número de bajo demanda",
            "num_of_reservation": "Número de reservas",
            "num_of_intercity": "Número de interurbanos",
            "num_of_delivery": "Número de entregas",
            "num_of_referral": "Número de referencias",
            "num_of_sharing": "Número de compartidos",
            "topup_wallet_amount": "Monto de recarga de billetera",
            "num_of_complete_wallet": "Número de reservas completadas (billetera)",
            "num_of_complete_booking_by_referee": "Número de reservas completadas (por referido)",
            "number_of_complete_booking": "Número de reservas completadas",
            "number_of_food_mart": "Número de comida / tienda"
        },
        "driverMetric": {
            "booking_distance": "Distancia de trabajo",
            "booking_time": "Tiempo de trabajo",
            "num_of_referral": "Número de referencias",
            "num_of_complete": "Número de reservas completadas (cliente único)",
            "num_of_referral_driver": "Número de referencias (conductor)",
            "num_of_accept": "Número de reservas aceptadas",
            "num_of_receive": "Número de reservas recibidas",
            "num_of_cancel": "Número de reservas canceladas por el conductor",
            "sum_of_rating": "Número total de estrellas de calificación",
            "total_rating": "Número total de veces calificadas",
            "earnings_amount": "Monto de ganancias",
            "num_of_complete_wallet": "Número de reservas completadas (billetera)",
            "num_of_complete_booking_by_referee": "Número de reservas completadas (por referido)",
            "available_time": "Tiempo en línea"
        },
        "Click_here_to_view": "Haga clic aquí para ver.",
        "view": "Haga clic aquí para ver.",
        "metricType": "Tipo",
        "task": "Tarea",
        "value": "Valor",
        "quantity": "Cantidad",
        "quests_list": "Misiones",
        "rankImages": "Imagen de rango (punto)",
        "qualifiedPrizeOrder": "Premios calificados",
        "luckyDrawPrizeOrder": "Premios de sorteo",
        "reward": "Artículo",
        "from": "Desde",
        "to": "Hasta",
        "image": "Imagen",
        "Add_Prize": "Agregar",
        "bannerText": "Texto del banner",
        "buttonText": "Texto del botón",
        "bannerLink": "Enlace del banner",
        "shortLink": "Enlace corto",
        "buttonLinkDesktop": "Enlace del botón (Escritorio)",
        "buttonLinkAndroid": "Enlace del botón (Android)",
        "buttonLinkiOS": "Enlace del botón (iOS)",
        "termsURL": "Enlace de términos y condiciones",
        "metadataTitle": "Título de metadatos",
        "metadataDescription": "Descripción de metadatos",
        "isDarkMode": "Modo oscuro",
        "isActive_details": "Activo",
        "Required_fields": "Campos obligatorios",
        "change": "Cambiar",
        "Please_input_name": "Por favor, ingrese el nombre",
        "Please_select_date": "Por favor, seleccione la fecha",
        "endDate_invalid": "Fecha de finalización inválida",
        "startDate_greater_than_endDate": "La fecha de inicio es mayor que la fecha de finalización",
        "Please_input_termsURL": "Por favor, ingrese el enlace de términos y condiciones",
        "Please_input_metadataTitle": "Por favor, ingrese el título de metadatos",
        "Please_input_metadataDescription": "Por favor, ingrese la descripción de metadatos",
        "Please_input_bannerText": "Por favor, ingrese el texto del banner",
        "Please_input_buttonText": "Por favor, ingrese el texto del botón",
        "Please_input_bannerLink": "Por favor, ingrese el enlace del banner",
        "Please_input_shortLink": "Por favor, ingrese el enlace corto",
        "Please_input_buttonLinkDesktop": "Por favor, ingrese el enlace del botón (Escritorio)",
        "Please_input_buttonLinkAndroid": "Por favor, ingrese el enlace del botón (Android)",
        "Please_input_buttonLinkiOS": "Por favor, ingrese el enlace del botón (iOS)",
        "the_range_1_to_5": "Por favor, ingrese un valor en el rango de 1 a 5 para %{name}!",
        "the_range_1_to_100": "Por favor, ingrese un valor en el rango de 1 a 100 para %{name}!",
        "task_is_empty": "Por favor, ingrese tarea para %{name}!",
        "task_limit_50_characters": "La longitud máxima de la tarea es de 50 caracteres para %{name}!",
        "please_input_points": "Por favor, ingrese puntos para %{name}!",
        "please_input_value": "Por favor, ingrese un valor para %{name}!",
        "value_is_invalid": "%{name}, el valor debe ser un número",
        "please_upload_image": "Por favor, suba una imagen para el artículo %{name}!",
        "rank_invalid": "El rango %{name} no es válido!",
        "rank_invalid_to": "El rango \"Hasta\" debe ser un número",
        "deepLink": "Enlace profundo",
        "point_per_task": "Puntos por tarea",
        "points": "Puntos",
        "points_per_some_think": "Puntos por %{unit}",
        "criterias": "Criterios (opcional)",
        "criterias_list": "Criterios",
        "criteriaType": "Tipo",
        "criteriaValue": "Valor",
        "acceptance_rating": "Calificación de aceptación (mayor o igual)",
        "cancellation_rating": "Calificación de cancelación (menor o igual)",
        "driver_rating": "Calificación del conductor (mayor o igual)",
        "please_upload_image_rank": "Por favor, suba una imagen para el rango %{name}!",
        "Update_event_success": "La misión se ha actualizado correctamente",
        "Update_event_fail": "Se produjeron errores al actualizar la misión",
        "Create_event_success": "La nueva misión se ha creado correctamente",
        "Create_event_fail": "Se produjeron errores al crear la misión",
        "suspend_list": "Lista de suspensión"
    },
    "voucherSettings": {
        "Search_here": "Buscar aquí",
        "Voucher_code": "Código #",
        "Campaign": "Campaña",
        "Type": "Tipo",
        "Value": "Valor",
        "Valid_from": "Válido desde",
        "Valid_to": "Válido hasta",
        "isActive": "Estado",
        "Activate": "Activar",
        "Deactivate": "Desactivar",
        "Actions": "Acciones",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "redeemed": "Canjeado",
        "expired": "Expirado",
        "Add_Voucher_code": "Agregar código",
        "Add": "Agregar",
        "Show_per_page": "Artículos por página",
        "Page": "Página",
        "Name": "Nombre",
        "show_pages": "{0} - {1} de {2} mostrados",
        "Edit": "Editar",
        "Delete": "Eliminar",
        "Save": "Guardar",
        "Duplicate": "Duplicar",
        "Cancel": "Cancelar",
        "Required_fields": "Campos obligatorios",
        "Detail_voucher_code": "Detalle del código de cupón",
        "Delete_voucher_code": "Eliminar código de cupón",
        "Confirmation": "Confirmación",
        "Delete_confirm_voucher_code": "¿Desea eliminar el código de cupón seleccionado?",
        "Delete_voucher_code_confirmation": "¿Desea eliminar estos códigos de cupón?",
        "Just_delete_inactive": "** Solo los códigos de cupón con estado inactivo pueden eliminarse.",
        "Loading_voucher_code_fail": "Se produjeron errores al cargar el código de cupón.",
        "Select_campaign": "Seleccionar campaña",
        "Create_voucher_code_success": "El nuevo código de cupón se ha creado correctamente.",
        "Create_voucher_code_fail": "Se produjeron errores al crear el código de cupón.",
        "Update_voucher_code_status_success": "El estado del código de cupón se ha actualizado correctamente.",
        "Update_voucher_code_status_fail": "Se produjeron errores al actualizar el estado del código de cupón.",
        "Delete_voucher_codes_success": "El código de cupón se ha eliminado correctamente.",
        "Delete_voucher_codes_fail": "Se produjeron errores al eliminar el código de cupón.",
        "Delete_multiple_voucher_codes_success": "Los códigos de cupón se han eliminado correctamente.",
        "Delete_multiple_voucher_codes_fail": "Se produjeron errores al eliminar los códigos de cupón.",
        "Delete_voucher_code_success": "El código de cupón se ha eliminado correctamente.",
        "Delete_voucher_code_fail": "Se produjeron errores al eliminar el código de cupón.",
        "Update_multiple_voucher_code_status_success": "Los estados del código de cupón se han actualizado correctamente.",
        "Update_multiple_voucher_code_status_fail": "Se produjeron errores al eliminar los estados del código de cupón.",
        "Please_input_voucher_code": "Por favor, ingrese el código de cupón.",
        "Please_input_voucher_code_at_least_4_characters": "Por favor, ingrese al menos 4 caracteres.",
        "Please_select_campaign": "Por favor, seleccione la campaña.",
        "Please_input_value": "Por favor, ingrese el valor.",
        "Please_select_date": "Por favor, seleccione la fecha.",
        "Invalid_file": "El contenido del archivo no es válido.",
        "File_size_larger_than_5Mb": "El tamaño del archivo es mayor de 5Mb.",
        "Import_vouchers_success": "El archivo se ha importado correctamente.",
        "Import_vouchers": "Importar archivo",
        "Number_successful_imports": "Artículos importados",
        "Number_skipped": "Omitir artículos",
        "File": "Archivo",
        "Phone_Numbers": "Número(s) de teléfono",
        "Import_voucher_code_success": "El código de cupón <b>{0}</b> se ha importado correctamente.",
        "Import_voucher_code_fail": "No se pudo importar el código de cupón <b>{0}</b>. Por favor, inténtelo de nuevo.",
        "All": "Todo"
    },
    "pointConfig": {
        "point_config": "Configuración de puntos",
        "Convert_spent_amount_to_points": "Convertir monto gastado a puntos",
        "Convert_topup_amount_to_points": "Convertir monto de recarga a puntos",
        "Redeem_points_to_voucher": "Canjear puntos por cupón",
        "others": "Otro",
        "Online_Payment": "Pago en línea",
        "transport": "Transporte",
        "parcel": "Paquete",
        "food": "Comida",
        "mart": "Tienda",
        "delivery": "Entrega",
        "intercity": "Interurbano",
        "applyCash": "Aplicar para efectivo",
        "point": "Punto",
        "vourcherName": "Nombre",
        "pointsToRedeem": "Puntos para canjear",
        "vourcherValue": "Valor del cupón",
        "validTime": "Tiempo válido",
        "month": "Mes(es)",
        "day": "Día(s)",
        "termAndCondition": "Términos y condiciones",
        "Actions": "Acciones",
        "add_voucher": "Agregar",
        "instructionURL": "Enlace de instrucciones",
        "displayName": "Mostrar nombre en la súper aplicación",
        "isActive": "Activo",
        "EDIT_VOUCHER": "Actualizar cupón",
        "DETAIL_VOUCHER": "Detalles del cupón",
        "CREATE_VOUCHER": "Agregar cupón",
        "update_successfully": "La configuración de puntos se ha actualizado correctamente.",
        "Create_voucher_successfully": "El nuevo cupón se ha creado correctamente.",
        "Create_voucher_fail": "Se produjeron errores al crear el cupón.",
        "Update_voucher_successfully": "El cupón se ha actualizado correctamente.",
        "Update_voucher_fail": "Se produjeron errores al actualizar el cupón.",
        "Delete_voucher_successfully": "El cupón se ha eliminado correctamente.",
        "Delete_voucher_fail": "Se produjeron errores al eliminar el cupón.",
        "Confirmation": "Confirmación",
        "Delete_voucher_confirmation": "¿Desea eliminar este cupón?",
        "Please_enter_value_least_one": "¡Se requiere tasa de conversión! Configure el monto gastado o el monto",
        "Please_enter_value_is_number_spentAmount": "Por favor, ingrese un monto válido en el servicio \"Convertir monto gastado\" \"{0}\".",
        "Please_enter_value_is_number_topUp": "Por favor, ingrese un monto válido en el método \"Convertir monto de recarga\" \"{0}\"."
    },
    "resetPassword": {
        "New_Password": "Nueva contraseña",
        "New_Comfirm_Password": "Nuevo Confirmar contraseña",
        "Save": "Ahorrar",
        "INFO_SUCCESS": "Se ha enviado un enlace para restablecer la contraseña a su correo electrónico",
        "TOKEN_EXPIRED": "El token para restablecer la contraseña ha caducado",
        "Back_To_Login_Page": "Volver a página de inicio"
    },
    "permission": {
        "editBooking": "Editar reservas subcontratadas",
        "companyOperator": "Operador de empresa",
        "Third_Party_Integration_Booking": "Integración de terceros (Booking.com)",
        "Third_Party_Integration_HolidayTaxis": "Integración de terceros (HolidayTaxis)",
        "supplierPermission": "Permiso del proveedor",
        "Hint_edit_booking": "Permitir que las empresas/proveedores editen reservas subcontratadas por el",
        "View": "Vista",
        "Actions": "Acciones",
        "EditFare": "Editar tarifa",
        "EditDriverEarning": "Editar ganancias del conductor",
        "EditTotal": "Editar total",
        "ImportBookings": "Importar reservas de transporte",
        "ImportDeliveryBookings": "Importar reservas de entrega",
        "ShowFare": "Mostrar tarifa",
        "delete_permission": "Eliminar permiso",
        "DELETE_CONFIRM": "¿Está seguro de que desea eliminar el permiso seleccionado?",
        "Yes": "Sí",
        "No": "No",
        "Cancel": "Cancelar",
        "DRIVERS": "Conductores",
        "Driver_list": "Lista de conductores",
        "Enter_to_search": "Entrar para buscar",
        "Permitted_driver_list": "Lista de conductores permitidos",
        "Save": "Ahorrar",
        "CAR": "Vehículo",
        "Car_list": "Lista de carros",
        "Permitted_car_list": "Lista de autos permitidos",
        "Edit_permission": "Editar permiso",
        "Add_permission": "Agregar permiso",
        "Detail_permission": "Permiso de detalle",
        "Name": "Nombre",
        "Driver_Car": "Conductor/vehículo",
        "All": "Todo",
        "Company": "Compañía",
        "By_specific": "Individual",
        "Drivers": "Conductores",
        "Cars": "Coches",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrados",
        "Delete": "Borrar",
        "Edit": "Editar",
        "Status": "Estado",
        "Action": "Acción",
        "Inactive": "Inactivo",
        "Active": "Activo",
        "Update_status_error": "Error actualización del estatus",
        "All_tooltip": "Todos los conductores se muestran en Mapa, Panel de reservas, Conductores, Operaciones e Informes. Todos los vehículos se mostrarán en Detalle de vehículos",
        "Company_tooltip": "Los conductores permitidos se muestran en Mapa, Panel de reservas, Conductores, Operaciones e Informes. Los vehículos permitidos se mostrarán en Detalle de vehículos",
        "By_specific_tooltip": "Los conductores permitidos se muestran en Conductores, Operaciones e Informes. Los vehículos permitidos se mostrarán en Detalle de vehículos",
        "Full_permissions": "Permiso completo",
        "Balance": "Cambiar saldo",
        "ChangeBalance": "Cambiar saldo",
        "ChangeCashBalance": "Cambiar saldo en efectivo",
        "TotalBalance": "Balance total",
        "WriteOffDebt": "Cancelar deuda",
        "topupPaxWallet": "Cambiar saldo",
        "SeFleetCommission": "Establecer comisión de flota",
        "EditFleetCommission": "Editar comisión de flota",
        "EditBalance": "Editar saldo",
        "ViewHeatMap": "Ver mapas de calor",
        "Delete_permission_success": "el permiso ha sido eliminado correctamente",
        "Delete_permission_fail": "Error al eliminar permiso",
        "Create_permission_fail": "Error al crear nuevo permiso",
        "Create_permission_success": "Nuevo permiso ha sido creado correctamente",
        "Update_permission_fail": "Error al actualizar permiso",
        "Update_permission_success": "Permiso actualizado correctamente",
        "No_action_selected": "Marque al menos una acción en la lista de acciones",
        "Required_fields": "Campos requeridos",
        "sendSMS": "Enviar mensaje (SMS)",
        "sendInbox": "Enviar mensaje (Bandeja de entrada)",
        "PayToDriver": "Ver 'Pagar al conductor'",
        "PayoutHistory": "Ver 'Historial de pagos'",
        "Pay": "Pagar al conductor",
        "ActivateDriver": "Activar conductor",
        "Export": "Exportar",
        "Export_csv": "Exportar .csv",
        "Street-sharing_rate": "Tarifa de compartición de calle"
    },
    "thirdPartySettings": {
        "category": "Categoría",
        "Not_over_limit_subs": "No puede crear más de 10 sububicaciones",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrados",
        "Delete": "Borrar",
        "Edit": "Editar",
        "Status": "Estatus",
        "Actions": "Acciones",
        "Action": "Acción",
        "Inactive": "Inactivo",
        "Active": "Activo",
        "website": "Sitio web",
        "Check_Google_Address": "Verifique la dirección de Google de latitud y longitud",
        "Delete_Category_success": "La categoría ha sido eliminada con éxito",
        "Delete_category_fail": "Los errores ocurrieron al eliminar la categoría",
        "availableTime": "Tiempo disponible",
        "Please_choose_at_least_one_category": "Por favor elige al menos una categoría",
        "Please_input_category_name": "Ingrese el nombre de la categoría",
        "Create_category_success": "La categoría ha sido creada con éxito",
        "Create_category_fail": "Los errores ocurrieron al crear la categoría.",
        "Update_third_party_success": "La ubicación ha sido actualizada con éxito",
        "Update_category_fail": "Los errores ocurrieron al actualizar la categoría.",
        "All_Category": "toda la compañía",
        "Delete_Category": "Editar categoria",
        "Edit_Category": "Editar categoria",
        "Add_Category": "Añadir categoría",
        "Add_Third_Party_location": "Agregar ubicación de terceros",
        "Add": "Agregar",
        "Edit_Third_Party_location": "Editar ubicación de terceros",
        "Location_Not_Found": "Ubicación no encontrada",
        "Create_third_party_success": "La ubicación se ha creado correctamente",
        "Create_third_party_fail": "Error al crear ubicación",
        "Update_third_party_fail": "Los errores ocurrieron al actualizar la ubicación",
        "Alias": "Alias",
        "Address": "Habla a",
        "Latitude": "Latitud",
        "Longitude": "Longitud",
        "Please_input_address": "Por favor ingrese la dirección",
        "Please_input_name": "Ingrese el nombre de la ubicación",
        "Please_input_latitude": "Por favor ingrese la latitud",
        "Please_input_longitude": "Por favor ingrese la longitud",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "Required_fields": "Campos requeridos",
        "Last_update": "última actualización",
        "Username": "nombre de usuario",
        "locationType": "LocationType",
        "single": "Ubicación única",
        "multiple": "Múltiples ubicaciones",
        "AddMore": "Añadir más",
        "locationList": "Lista de ubicaciones",
        "instructionLink": "Enlace de instrucciones",
        "location": "Ubicación",
        "checkOnMap": "Consultar en el mapa",
        "Remove": "Eliminar",
        "all": "Todo",
        "PU": "Levantar",
        "DO": "Dejar",
        "namePlaceholder": "e.j. Terminal 1",
        "instructionLinkPlaceholder": "Página HTML con todas las instrucciones",
        "instructionLinkTooltip": "Introducir un enlace para la página de instrucciones. El pasajero puede seguir las instrucciones en este enlace para encontrar el punto de recogida",
        "longitudePlaceholder": "108.1837969",
        "latitudePlaceholder": "16.0393381",
        "Error_message_lat_in_range": "La latitud debe estar entre -90,0 y 90,0",
        "Error_message_lng_in_range": "La longitud debe estar entre -180,0 y 180,0.",
        "Delete_third_party_success": "La ubicación se ha eliminado correctamente",
        "Delete_third_party_fail": "Los errores ocurrieron al eliminar la ubicación",
        "Delete_location": "Eliminar ubicación",
        "Note_guide": "Nota: al buscar en el mapa, su ubicación se marcará rápidamente con un pin.",
        "PostalCode": "Código Postal",
        "meetZonesTooltip": "Zona de Reunión: Define el área que incluye todos los puntos de reunión designados. Útil para lugares como aeropuertos donde los puntos específicos de recogida y entrega deben ser claramente identificados.",
        "instructions": "Instrucciones de recogida",
        "pickupMode": "Tipo de Recogida",
        "tripSegment": "Segmento de Viaje",
        "buildingLevel": "Nivel del edificio",
        "instructionType": "Tipo de Instrucción",
        "instructionUrl": "URL de instrucciones",
        "instructionImage": "Imágenes de Instrucción",
        "imageInstructions": "Instrucciones para la imagen de recogida",
        "addMultipleInstructions": "Agregar múltiples instrucciones de recogida.",
        "maximum3Images": "Máximo 3 imágenes.",
        "image": "Imagen",
        "uploadImage": "Subir una imagen",
        "description": "Descripción",
        "descriptionPlaceholder": "El nombre del punto de encuentro.",
        "altText": "Texto alternativo",
        "altTextPlaceholder": "El nombre del punto de encuentro.",
        "addImage": "Agregar imagen",
        "imageCount": "Conteo de imágenes",
        "viewEditImages": "Ver/Editar Imágenes",
        "addMeetingZone": "Agregar zona de reunión"
    },
    "city": {
        "DELETE_CITY": "Eliminar ciudad",
        "DELETE_CONFIRM": "¿Está seguro de que desea eliminar la ciudad seleccionada?",
        "Yes": "Sí",
        "No": "No",
        "Cancel": "Cancelar",
        "EDIT_CITY": "editar ciudad",
        "ADD_CITY": "Añadir ciudad",
        "Name": "Nombre",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Add": "Agregar",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Delete": "Eliminar",
        "Edit": "Editar",
        "DETAIL_CITY": "Detalle ciudad",
        "Update_city_success": "Ciudad actualizada correctamente",
        "Create_city_success": "Nueva ciudad creada correctamente",
        "Delete_city_success": "Ciudad eliminada correctamente",
        "cityName": "Nombre de la ciudad",
        "Service": "Servicio",
        "serviceTransportation": "Transporte",
        "serviceAssistant": "Asistente",
        "serviceDelivery": "Entrega",
        "isShowDriverSignUp": "Mostrar en el registro del proveedor",
        "note_isShowDriverSignUp": "(Aplicar para el nuevo módulo de registro desde la versión 4.6.46 en adelante)"
    },
    "blockPassenger": {
        "Imei": "IMEI",
        "EditImei": "Editar Bloque IMEI",
        "AddImei": "Agregar Bloqueo IMEI",
        "DetailImei": "Bloque de Detalle IMEI",
        "Update_Imei_success": "La IMEI bloqueada se ha actualizado correctamente",
        "Update_Imei_Fail": "Se produjeron errores al actualizar el Bloque IMEI",
        "Create_Imei_success": "Se ha creado el nuevo bloque IMEI con éxito",
        "Create_Imei_Fail": "Los errores ocurrieron al crear el Bloque IMEI",
        "Delete_Imei_success": "La IMEI bloqueada ha sido eliminada con éxito",
        "Delete_Imei_fail": "Se produjeron errores al eliminar el Bloque IMEI",
        "DELETE_IMEI": "Borrar Bloque IMEI",
        "DELETE_CONFIRM": "¿Está seguro de que desea eliminar el IMEI del bloque seleccionado?"
    },
    "jobTab": {
        "DELETE_JOBTAB": "Eliminar pestaña de trabajos",
        "DELETE_CONFIRM": "¿Estás seguro de que deseas eliminar la pestaña de trabajos seleccionada?",
        "Yes": "Sí",
        "No": "No",
        "Cancel": "Cancelar",
        "EDIT_JOBTAB": "Editar pestaña de trabajos",
        "ADD_JOBTAB": "Agregar pestaña de trabajos",
        "Name": "Nombre",
        "Required_fields": "Campos obligatorios",
        "Save": "Guardar",
        "Add": "Agregar",
        "Show_per_page": "Elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrados",
        "Delete": "Eliminar",
        "Edit": "Editar",
        "DETAIL_JOBTAB": "Detalles de la pestaña de trabajos",
        "Update_JOBTAB_success": "La pestaña de trabajos se ha actualizado correctamente",
        "Create_JOBTAB_success": "Se ha creado una nueva pestaña de trabajos correctamente",
        "Delete_JOBTAB_success": "La pestaña de trabajos se ha eliminado correctamente",
        "JOBTABName": "Nombre de la pestaña de trabajos",
        "jobsLink": "Enlace"
    },
    "driverNote": {
        "name": "Nota del conductor",
        "DELETE": "Eliminar nota del conductor",
        "DELETE_CONFIRM": "¿Estás seguro de que deseas eliminar la nota del conductor seleccionada?",
        "EDIT": "Editar nota del conductor",
        "ADD": "Agregar nota del conductor",
        "DETAIL": "Detalles de la nota del conductor",
        "Update_success": "La nota del conductor se ha actualizado correctamente",
        "Create_success": "Se ha creado una nueva nota del conductor correctamente",
        "Delete_success": "La nota del conductor se ha eliminado correctamente",
        "Delete_fail": "Se produjeron errores al eliminar la nota del conductor",
        "Load_fail": "Se produjeron errores al cargar la nota del conductor",
        "Update_fail": "Se produjeron errores al actualizar la nota del conductor",
        "Create_fail": "Se produjeron errores al crear la nota del conductor"
    },
    "flightIntegration": {
        "Username": "nombre de usuario",
        "provider": "Proveedor de vuelos",
        "Key": "Clave API",
        "apiKeys": "Claves API",
        "apiId": "ID de API",
        "Save": "Ahorrar",
        "Update_flight_integration_success": "La integración de vuelos se ha actualizado con éxito.",
        "Update_flight_integration_fail": "Los errores ocurrieron al actualizar la integración de vuelos."
    },
    "smsIntegration": {
        "provider": "Proveedor de SMS",
        "apiToken": "Token de API",
        "subAccountId": "ID de subcuenta",
        "senderIdSource": "ID del remitente (fuente):",
        "apiKey": "Clave API",
        "username": "Nombre de usuario",
        "shortCode": "Código corto",
        "key": "Clave",
        "webService": "Servicio web",
        "bearerToken": "Token de acceso",
        "keyId": "ID de clave",
        "email": "Correo electrónico",
        "appKey": "Clave de la aplicación",
        "sender": "Remitente",
        "password": "Contraseña",
        "maskedPhone": "Número de teléfono enmascarado",
        "senderId": "ID del remitente",
        "webservice": "Servicio web",
        "brandname": "Nombre de la marca",
        "appSecret": "Secreto de la aplicación",
        "consumerKey": "Clave de consumidor",
        "requestUrl": "URL de solicitud",
        "authId": "ID de autenticación",
        "authToken": "Token de autenticación",
        "authKey": "Clave de autenticación",
        "templateId": "ID de plantilla",
        "templateKey": "Clave de plantilla",
        "phloId": "ID de PHLO",
        "dlcNumber": "Número 10DLC",
        "app_key": "Clave de la aplicación",
        "api_key": "Clave API",
        "accountSID": "SID de cuenta",
        "applicationId": "ID de aplicación",
        "phoneNumber": "Número de SMS 1",
        "phoneNumber2": "Número de SMS 2",
        "SenderID_1": "ID del remitente 1",
        "SenderID_2": "ID del remitente 2",
        "smsMarketingNumber": "Número de teléfono de marketing por SMS",
        "updateSMSSuccess": "The sms integration has been updated successfully",
        "Deleted_success": "El SMS se ha eliminado correctamente",
        "receiverCountries": "Países receptores",
        "error": {
            "ERROR_CREATE": "Se produjeron errores al crear el SMS",
            "COUNTRY_EXISTED": "El país ya existe en el sistema",
            "ERROR_DELETE": "Fallo al eliminar el SMS",
            "ERROR_UPDATE": "Fallo al actualizar el SMS"
        },
        "identifierId": "ID de identificador"
    },
    "mDispatcher": {
        "mDispatchers": "Socios",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "Deactivate": "Desactivar",
        "Activate": "Activar",
        "Delete": "Borrar",
        "Save": "Ahorrar",
        "Edit": "Editar",
        "ADD_MDISPATCHER": "Agregar socio",
        "EDIT_MDISPATCHER": "Editar socio",
        "Phone_number": "Número de teléfono",
        "first_name": "Nombre de pila",
        "last_name": "Apellido",
        "email": "Correo electrónico",
        "address": "Habla a",
        "mDispatcher_type": "tipo de socio",
        "mDispatcher_type_toolTip": "Para agregar más tipos de socios, vaya a Configuración > Tipo de socio",
        "queuing_area_toolTip": "Para agregar más áreas de espera, vaya al menú Área de espera.",
        "mDispatcher": "Compañero",
        "card_management": "Gestión de tarjeta",
        "Select_mDispatcher_type": "Seleccionar tipo de socio",
        "Amount": "Monto",
        "Percent": "Por ciento",
        "Yes": "Sí",
        "Required_fields": "Campos requeridos",
        "Cancel": "Cancelar",
        "commission_type": "Tipo de comisión",
        "commission_value": "Valor de la comisión",
        "Name": "Nombre",
        "Phone_Number": "Número de teléfono",
        "queuing_area": "Área de espera",
        "mdispatcher_type": "tipo de socio",
        "registered_from": "Registrado desde",
        "registration_date": "Fecha de Registro",
        "status": "Estado",
        "actions": "Acciones",
        "Select_queue_area": "Seleccione el área de la cola",
        "for_new_mDipatcher_account_password_default_is_password": "Para una nueva cuenta de socio, la contraseña predeterminada es \"12345678",
        "Create_mDispatcher_success": "El nuevo socio se ha creado con éxito",
        "Create_mDispatcher_fail": "Los errores ocurrieron al crear el socio",
        "Load_mDispatcher_fail": "Los errores ocurrieron al cargar el socio",
        "Update_mDispatcher_success": "El socio se ha actualizado correctamente",
        "Update_mDispatcher_fail": "Los errores ocurrieron al actualizar el socio",
        "Update_mDispatcher_status_success": "El estado del socio se ha actualizado correctamente",
        "Update_mDispatcher_status_fail": "Los errores ocurrieron al actualizar el estado del socio",
        "Update_mDispatcher_statuses_success": "Los estados de los socios se han actualizado correctamente",
        "Update_mDispatcher_statuses_fail": "Los errores ocurrieron al actualizar los estados de los socios",
        "Delete_mDispatcher_success": "El socio se ha eliminado correctamente",
        "Delete_mDispatcher_fail": "Los errores ocurrieron al eliminar al socio",
        "Delete_mDispatchers_success": "Los socios se han eliminado correctamente",
        "Delete_mDispatchers_fail": "Los errores ocurrieron al eliminar socios",
        "Do_you_want_to_delete_these_mDipatchers": "¿Desea eliminar estos socios?",
        "Only_mDistcher_in_the_inactive_status_can_be_deleted": "***Sólo pueden ser eliminados los colaboradores en situación inactiva",
        "No_card": "Tarjeta no encontrada",
        "Reset_Password": "Restablecer la contraseña",
        "Reset_password_success": "La contraseña de socio se ha restablecido correctamente",
        "Reset_password_fail": "Los errores ocurrieron al restablecer la contraseña de los socios",
        "Do_you_want_to_reset_password": "Desea restablecer la contraseña?",
        "ERROR_EXISTED_PHONE": "Este teléfono ha existido en el sistema.  Por favor ingrese otro",
        "ERROR_INPUT_VALIDPHONE": "Por favor ingrese un número de teléfono válido.",
        "Partner_detail": "Detalles del socio",
        "ALERT_SELECT_ACTIVATE": "Seleccione socios para activar.",
        "ALERT_SELECT_DEACTIVATE": "Seleccione socios para desactivar.",
        "CONFIRM_DEACTIVATE_MULTI": "¿Desea desactivar estos socios?",
        "CONFIRM_ACTIVATE_MULTI": "¿Quieres activar estos socios?",
        "ERROR_COMMISSION_NUMBERS": "por favor ingrese un número valido",
        "No_Support": "La nueva tarjeta introducidad no es válida en esta zona",
        "Add": "Agregar",
        "Default_zone": "Zona por defecto",
        "required_email_payment": "Se requiere el correo electrónico del socio.  Por favor, actualice el perfil para continuar.",
        "titleGuestQR": "Enlace QR de invitado para socios",
        "questQRContent": "¡Tu enlace de reserva personalizado para socios está aquí! Muéstralo de manera destacada en bares, recepciones de hoteles, habitaciones de huéspedes y en tu sitio web, en cualquier lugar donde tus clientes puedan necesitar un viaje o una entrega. Considera diseñar expositores con tu código QR único, permitiendo a los clientes escanearlo rápida y fácilmente para reservar su viaje.",
        "View_Guest_QR": "Ver QR de invitado"
    },
    "mDispatcherType": {
        "Name": "Nombre",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "No": "No",
        "Add": "Agregar",
        "Show_per_page": "elementos por página",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrado",
        "Delete": "Eliminar",
        "Edit": "Editar",
        "DELETE_MDISPATCHER_TYPE": "Eliminar tipo de socio",
        "DELETE_CONFIRM": "¿Está seguro de eliminar el tipo de socio?",
        "Yes": "Sí",
        "EDIT_MDISPATCHER_TYPE": "Editar tipo de socio",
        "ADD_MDISPATCHER_TYPE": "Agregar tipo de socio",
        "DETAIL_MDISPATCHER_TYPE": "Detalle tipo de socio",
        "Actions": "Acciones",
        "Delete_mDispatcherType_success": "El tipo de socio se ha eliminado correctamente",
        "Delete_mDispatcherType_fail": "Los errores ocurrieron al eliminar el tipo de socio",
        "Load_mDispatcherType_fail": "Los errores ocurrieron al cargar el tipo de socios",
        "Create_mDispatcherType_success": "El nuevo tipo de socio se ha creado correctamente",
        "Create_mDispatcherType_fail": "Los errores ocurrieron al crear el tipo de socios",
        "Update_mDispatcherType_success": "El tipo de socio se ha actualizado correctamente",
        "Update_mDispatcherType_fail": "Los errores ocurrieron al actualizar el tipo de socios"
    },
    "queuingArea": {
        "queuing_area_info": "Información del área de cola",
        "queuingDrivers": "Conductores activos",
        "Name": "Nombre",
        "Required_fields": "Campos requeridos",
        "Save": "Ahorrar",
        "Cancel": "Cancelar",
        "Yes": "Sí",
        "No": "No",
        "Add": "Agregar",
        "Show_per_page": "elementos por página",
        "Enter_to_search": "Intro para buscar",
        "Page": "Página",
        "show_pages": "{0} - {1} de {2} mostrados",
        "Delete": "Borrar",
        "Edit": "Editar",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "Deactivate": "Desactivar",
        "Activate": "Activar",
        "drivers": {
            "order": "Pedido",
            "Driver_name": "Nombre del conductor",
            "Phone_Number": "Número de teléfono",
            "driverLicenseNumber": "Placa",
            "Car_Type": "Tipo de carro",
            "checkInTime": "Hora de entrada",
            "duration": "Duración",
            "timestampScore": "Puntuación de marca de tiempo",
            "changeOrderDriver": "Cambia el orden",
            "detailOrderDriver": "Orden del conductor",
            "Yes": "Sí",
            "No": "No",
            "insert": "Insertar",
            "refresh": "Refrescar",
            "insertDriver": "Insertar un controlador en la cola",
            "orderDriver": "Orden #",
            "reason": "Razón",
            "removeDriver": "Eliminar controlador de la cola",
            "removeDriverConfirm": "¿Desea eliminar este controlador de la cola?",
            "driverNotStay": "El conductor no está en el área de la cola. Por favor, inténtelo de nuevo más tarde.",
            "overOrder": "El número de # pedido no puede ser mayor que el número total de conductores en la cola.",
            "noDriverFound": "No se encontró ningún controlador",
            "driverUpdateErrRs": "El conductor no está en el área de la cola.  Por favor, inténtelo de nuevo más tarde.",
            "orderUpdateErrRs": "El número de # pedido no puede ser mayor que el número total de conductores en la cola.",
            "removeDriverSuccess": "El controlador se ha eliminado correctamente del área de la cola.",
            "removeDriverFail": "Se produjo un error al eliminar el controlador del área de la cola.",
            "operationInsertFailRs": "El controlador no existe o no está disponible.",
            "versionInsertFailRs": "Para aplicar esta función, el controlador debe actualizar su aplicación de controlador a la última versión",
            "queueInsertFailRs": "La cola no existe o el conductor no está en el área de la cola.  Por favor, inténtelo de nuevo más tarde.",
            "vehicleInsertFailRs": "La cola no admite el tipo de vehículo del conductor.",
            "orderInsertFailRs": "El número # de pedido no puede ser mayor que el número total de conductores en la cola.",
            "positionInsertFailRs": "Ocurrió un error al insertar el controlador en el área de la cola.",
            "insertDriverSuccess": "El controlador se ha insertado correctamente en el área de la cola.",
            "changeOrderSuccess": "La posición del conductor se ha cambiado con éxito.",
            "insertDriverFail": "Ocurrió un error al insertar el controlador desde el área de la cola.",
            "changeOrderFail": "Ocurrió un error al cambiar la posición del conductor desde el área de la cola.",
            "selectToInsert": "Buscar: nombre del conductor, número de teléfono",
            "updateBy": "Actualizado por el operador",
            "changeOrder": "Cambia el orden",
            "remove": "Eliminar"
        },
        "keepDriverPlaceCancelNoShow": "Mantener el lugar del conductor cuando la reserva se cancela / no se presenta",
        "keepDriverPlaceUnavailable": "Mantenga el lugar del conductor cuando el conductor no esté disponible o esté desconectado",
        "range": "rango de cola",
        "queueRangeTooltip": "Así es como los conductores verán su número de posición en la cola en la aplicación del conductor. Por ejemplo:\n- Establecer el rango de la cola en 1: los conductores verán su posición en la cola como un solo número: 1, 2, 3, 4, etc.\n- Establecer el rango de la cola en 5: los conductores verán su posición en la cola como un rango: 1-5, 6-10, 11-15, 16-20, etc.\n- Establecer el rango de la cola en 10: los conductores verán su posición en la cola como un rango: 1-10, 11-20, 21-30, 31-40, etc. ",
        "queueCanceledTooltip": "- Cuando el pasajero cancele o no se presente, el conductor permanecerá en la posición superior si el conductor vuelve a la cola dentro del tiempo establecido.\n- La posición del conductor tendrá alta prioridad si el conductor vuelve a la cola dentro del tiempo establecido después de completar una reserva de viaje corto ",
        "DELETE_QUEUING_AREA": "Eliminar área de espera",
        "DELETE_CONFIRM": "Desea eliminar área de espera?",
        "EDIT_QUEUING_AREA": "Editar área de espera",
        "ADD_QUEUING_AREA": "Agregar área de espera",
        "DETAIL_QUEUING_AREA": "Detalle zona de colas",
        "Queuing_area": "zona de cola",
        "Address": "Dirección",
        "Enter_a_location": "Introduce una ubicación",
        "Entered_Address_is_incorrect": "El sistema no puede determinar su ubicación.  Utilice la dirección sugerida.",
        "Not_supported_zone": "Esta área de cola no está en la zona admitida",
        "Active_mDispatcher_list": "Lista de socios activos",
        "Queue_list": "lista de colas",
        "Allow_radius": "Permitir radio",
        "Min_drivers_required": "# mínimo de conductores necesarios",
        "Open_queuing_area": "Zona de cola abierta",
        "Auto_dispatch": "Envío automático a los conductores en cola (no es necesario usar la aplicación Partner)",
        "Active_car_list": "Lista de autos activos",
        "mDispatcher": "Compañero",
        "Google_Address": "Dirección de Google",
        "Status": "Estado",
        "Update_status_error": "Error actualización del estatus",
        "driver_checkin_area": "Área de registro del conductor",
        "EDIT_POLYGONS": "Editar polígonos",
        "pax_pickup_area": "Área de recogida de pasajeros",
        "pickup_area": "Área de recogida",
        "your_chosen_polygon": "El polígono elegido",
        "other_queues": "Otras colas",
        "operation_zones": "Zonas de operación",
        "delete_pickup_area_confirm": "¿Estás seguro de que deseas eliminar esta área de recogida?",
        "delete_pickup_area": "Elija el área de registro del conductor.",
        "please_choose_driver_check_in_area": "Por favor, elija el área de recogida.",
        "please_choose_pick_up_area": "Por favor, elija el área de recogida.",
        "Load_queuing_area_fail": "Error al cargar el área de espera",
        "Create_queuingArea_success": "Área de espera creada correctamente",
        "Update_queuingArea_success": "Área de espera actualizada correctamente",
        "Delete_queuingArea_success": "El área de espera ha sido eliminada exitosamente",
        "Delete_queuingArea_fail": "Los errores ocurrieron al eliminar el área de espera",
        "Create_queuingArea_fail": "Los errores ocurrieron al crear el área de espera",
        "Load_queuingArea_fail": "Los errores ocurrieron al cargar el área de espera",
        "Update_queuingArea_fail": "Los errores ocurrieron al actualizar el área de espera"
    },
    "appBanner": {
        "Save": "Ahorrar",
        "Pax_app": "App de pasajero",
        "Apply_to": "Aplica a",
        "Please_select_view": "Selecciones vista",
        "Select_Type": "Por favor seleccione el tipo de banner",
        "Home_view": "Vista Principal",
        "Other_view": "Otra vista",
        "Banner_1": "Pancarta #1",
        "Upload_an_image": "Ninguna imagen seleccionada",
        "Action": "Acción",
        "NA": "No aplica",
        "Link_to_website": "Enlace a web",
        "Make_a_call": "realizar una llamada",
        "Send_an_email": "Enviar un correo electrónico",
        "Banner_2": "Pancarta #2",
        "Banner_3": "Pancarta #3",
        "Driver_app": "App conductor",
        "pax": "Aplicación Pasajero",
        "driver": "Aplicación de conductor",
        "merchant": "Aplicación comerciante",
        "Name": "Nombre",
        "viewType": "Tipo",
        "status": "Estado",
        "image": "Imagen",
        "html": "HTML",
        "Delete_Banner": "Eliminar pancarta",
        "Delete_confirm_banner": "¿Estás seguro de que deseas eliminar el banner seleccionado?",
        "Delete_banner_success": "El banner se ha eliminado correctamente",
        "Delete_banner_fail": "Los errores ocurrieron al eliminar el banner",
        "edit_banner": "Editar pancarta",
        "detail_banner": "Banner de detalle",
        "create_banner": "Agregar pancarta",
        "note_1": "*La extensión del archivo debe ser .jpg, .jpeg, .png, .gif y tener un tamaño menor a %{limit}MB.",
        "note_2": "*Las imágenes deben tener una relación de aspecto de 16:9.",
        "note_3": "Otras vistas incluye Bandeja de Entrada, amigos referidos, Recibos, Mis reservas, código promocional, agregar tarjeta/método pago, perfil, esperando asignación/reserva completada, vista completa",
        "Update_app_banner_success": "Banner en App actualizado correctamente",
        "Update_app_banner_fail": "Error al actualizar banner de App",
        "Create_app_banner_success": "El banner de la aplicación se ha creado correctamente",
        "Create_app_banner_fail": "¡No se pudo crear el banner de la aplicación!",
        "Note": "Utilice el archivo en formato .png (fondo transparente, tamaño 400:200px) para un mejor rendimiento de la aplicación",
        "Limit_size_upload": "El tamaño del archivo debe ser inferior a 8Mb.",
        "display_duration": "Duración de visualización",
        "playback_settings": "Configuración de reproducción",
        "display_banner_again_after": "Volver a mostrar los banners después de",
        "stop_display_banner_after": "Detener la visualización del banner después de",
        "enable_playback": "Habilitar reproducción",
        "Update_playback_success": "La configuración de reproducción se ha actualizado correctamente",
        "Update_playback_fail": "¡Error al actualizar la configuración de reproducción!",
        "language": "Idioma",
        "single": "Idioma único",
        "multi": "Múltiples idiomas",
        "es-ES": "Español",
        "en-US": "Inglés",
        "fr-FR": "Francés",
        "id-ID": "Bahasa Indonesia",
        "vi-VN": "Vietnamita",
        "ur-PK": "Urdu",
        "ms-MY": "Malayo",
        "ar-AR": "Árabe",
        "nb-NO": "Noruego",
        "en-GB": "Inglés (Reino Unido)",
        "am-ET": "Amhárico",
        "ro-RO": "Rumano",
        "version": "Versión de la aplicación",
        "comparisonVersionApp": {
            "is": "Es",
            "is_not": "No es",
            "is_one_of": "Es uno de",
            "is_not_one_of": "No es uno de",
            "greater_or_equal": "Mayor o igual",
            "less_or_equal": "Menor o igual"
        },
        "platform": "Plataforma",
        "platformItem": {
            "all": "Todo",
            "iOS": "iOS",
            "android": "Android"
        },
        "userStatus": "Estado del usuario",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "in_review_completed": "En revisión (perfil completado)",
        "in_review_incomplete": "En revisión (perfil incompleto)",
        "in_review_inProgress": "En revisión (perfil en progreso)",
        "zones": "Zonas"
    },
    "reservation": {
        "name": "Reserva",
        "company": "Empresa",
        "carType": "Categoría de vehículo",
        "licensePlate": "Placa de matrícula: %{name}",
        "driver": "Conductor: %{name}",
        "showAllDrivers": "Mostrar todos los conductores",
        "available": "Disponible",
        "reserved": "Reservado",
        "search_holder": "Empresa, nombre del conductor, tipo de vehículo, matrícula",
        "all": "Todos",
        "today": "Hoy",
        "thisWeek": "Esta semana",
        "day": "A diario",
        "week": "Semanalmente",
        "bookingID": "ID reserva",
        "tripId": "ID de viaje",
        "pickupTime": "Hora de recogida",
        "pickupLocation": "Dirección de recogida",
        "monday": "Lunes",
        "tuesday": "Martes",
        "wednesday": "Miércoles",
        "thursday": "Jueves",
        "friday": "Viernes",
        "saturday": "Sábado",
        "sunday": "Domingo",
        "overlapped": "Solapado",
        "noData": "No se han encontrado datos",
        "bookingDetails": "Detalles de reserva",
        "reservedHint": "Las reservas están confirmadas",
        "availableHint": "No existen reservas confirmadas",
        "overlappedHint": "Dos o más reservas se encuentran solapadas"
    },
    "dashboard": {
        "API": "API",
        "cc": "Central Reservas",
        "dmc": "Panel de reservas",
        "streetSharing": "Uso compartido de calles",
        "kiosk": "terminal",
        "mDispatcher": "Compañero",
        "paxApp": "App pasajero",
        "webBooking": "Reservas Web",
        "carHailing": "Coche-Hailing",
        "acceptance": "Aceptación",
        "booking_com": "Booking.com",
        "completed": "Completado",
        "noShow": "No presentarse",
        "driverNoShow": "Falta del conductor",
        "canceled": "Cancelado",
        "incident": "Incidencia",
        "rate1": "1 estrella",
        "rate2": "2 estrellas",
        "rate3": "3 estrellas",
        "rate4": "4 estrellas",
        "rate5": "5 estrellas",
        "Export_to_Excel": "Exportar a excel",
        "Profit": "Lucro",
        "day_change": "Cambio diario",
        "week_change": "Cambio semanal",
        "month_change": "Cambio mensual",
        "Booking_requests": "Peticiones de reservas",
        "Complete_bookings": "Reservas completadas",
        "New_customers": "Nuevo cliente",
        "Booking_dashboard": "Panel de reservas",
        "others": "Otros",
        "Revenue_booking": "Beneficio & reservas finalizadas",
        "Profit_finish_booking": "Beneficio & reservas finalizadas",
        "Booking_request": "Petición de reserva",
        "Finished_booking": "Reserva finalizada",
        "failed": "Fallido",
        "partialCompleted": "Completado parcialmente",
        "Finished_booking_char_header": "Reserva finalizada ({0})",
        "Bookings": "Reservas ({0})",
        "Ratings": "Calificaciones ({0})",
        "Daily": "Diario",
        "Weekly": "Semanal",
        "Monthly": "Mensual",
        "Total_customer": "Total cliente",
        "ProfitToolTips": "Importe obtenido por la flota excluyendo todos los gastos",
        "RevenueToolTips": "Importe obtenido por la flota en el periodo indicado, incluyendo promociones, descuento conductores, impuestos, etc.",
        "ProfitChangeToolTips": "Porcentaje de variación en beneficio de la flota comparado con periodo anterior",
        "BookingRequestsToolTips": "Número de peticiones a tiempo real y reservas creadas en el periodo indicado",
        "PercentageOfAcceptanceToolTips": "Porcentaje de reservas aceptadas durante el periodo indicado",
        "BookingChangeHint": "Porcentaje de variación en reservas creadas comparado con periodo anterior",
        "CompletedBookingHint": "Número de peticiones a tiempo real y reservas que han sido finalizadas en el periodo indicado",
        "PercentageOfSatisfactionHint": "Porcentaje de satisfacción durante el periodo indicado",
        "CompleteBookingDailyChangeHint": "Porcentaje de variación en reservas finalizadas comparado con periodo anterior",
        "NewCustomersHint": "Número de nuevos clientes registrados durante el periodo indicado",
        "CustomerChangeHint": "Número y porcentaje de variación de clientes durante el periodo indicado",
        "TotalCustomer": "Número de clientes en el sistema",
        "ProfitAndFinishedBookingHint": "Beneficio & reservas finalizadas durante el periodo indicado",
        "BookingRequestHint": "Número de peticiones a tiempo real y reservas creadas en el periodo indicado",
        "FinishedBookingChartsHint": "Número de peticiones a tiempo real y reservas que han sido cerradas en el periodo indicado, incluyendo canceladas, No Show, Incidencias y finalizadas",
        "Customer_count": "{0} cantidad de clientes",
        "Revenue": "Ventas"
    },
    "referral": {
        "first_package": "Primer Plan (p. ej. la primera reserva finalizada del pasajero)",
        "driver_refers_to_pax": "Conductor recomienda a pasajeros",
        "driver_will_get": "Conductor lo obtendrá",
        "money": "Dinero",
        "amount": "Monto",
        "percent": "Percent",
        "settlement": "Comisión (% subtotal de cada reserva completada)",
        "pax_will_get": "Pasajero obtendrá",
        "promotion_code": "Código promocional",
        "select_a_promotion": "Seleccionar código promocional",
        "maximum": "Máximo",
        "second_package": "Segundo Plan",
        "from": "Desde",
        "to": "a",
        "After_2nd_package": "Después segundo Plan",
        "from_end_value_of_above_package": "Del valor del último paquete anterior + 1",
        "Expiration_date": "Fecha caducidad",
        "Never": "Nunca",
        "Customized_date": "Fecha personalizada",
        "limited": "Limitado",
        "unlimited": "Ilimitado",
        "Valid_from": "Válido desde",
        "Valid_to": "Válido hasta",
        "Invitation_limit": "Límite de árbitro/conductor",
        "Status": "Estatus",
        "Active": "Activo",
        "Inactive": "Inactivo",
        "note": "* Tenga en cuenta que, una vez que la campaña esté activa, cualquier actualización de los valores de recompensa solo afectará a los nuevos clientes.",
        "Required_fields": "Campos requeridos",
        "refferal_update_successfully": "Configuración de referencia actualizada correctamente",
        "distributeIncentiveToDriver": "Distribuir incentivo al conductor",
        "Immediate": "Inmediato",
        "Periodic": "Periódico (Manual)",
        "Period": "Período",
        "startDate": "Fecha de inicio",
        "nextDistributionDate": "Próxima fecha de distribución",
        "oneMonth": "1 mes",
        "threeMonth": "3 meses",
        "sixMonth": "6 meses",
        "passenger_refers_to_pax": "Passenger refers to Passengers",
        "referer_will_get": "El referente recibirá",
        "referee_will_get": "El referido recibirá",
        "promo": "Promoción",
        "Pax_invitation_limit": "Límite de invitaciones/usuario",
        "promoPaidBy": "Promoción pagada por",
        "fleet": "Flota",
        "driver": "Conductor",
        "promoCode": "Código de promoción",
        "isSendInbox": "Enviar a la bandeja de entrada",
        "isDefaultCode": "Aplicación automática en la app",
        "autoApplyOnWeb": "Aplicación automática en la web",
        "isDefaultCode_hint": "Agregar código de promoción a la lista del cliente y aplicarlo automáticamente a la reserva cuando el cliente crea un pedido",
        "Actions": "Acciones",
        "add_promoCode": "Agregar",
        "Send_an_in_box_automatically_to_new_customers": "Enviar bandeja de entrada al cliente",
        "set_default_promo_code": "Aplicación automática en la app",
        "EDIT_PROMO_CODE": "Editar código de promoción",
        "DETAIL_PROMO_CODE": "Detalles del código de promoción",
        "CREATE_PROMO_CODE": "Crear código de promoción",
        "DELETE_PROMO_CODE": "Eliminar código de promoción",
        "DELETE_CONFIRM_PROMO_CODE": "¿Quieres eliminar este código de promoción?",
        "ERROR_INPUT_SOURCE": "Por favor, elige al menos uno."
    },
    "upload_document": {
        "NO_FILE_CHOSEN": "Archivo no seleccionado",
        "Limit_size_upload": "El tamaño del archivo supera el límite permitido {0}Mb."
    },
    "payment_info": {
        "member_since": "Miembro desde",
        "package_name": "Nombre del Plan",
        "last_payment": "Último pago",
        "credit_card": "Tarjeta de crédito",
        "last_digits": "Últimos 4 dígitos",
        "default": "Por defecto",
        "add_new_card": "Agregar nueva tarjeta",
        "history": "Historial",
        "transaction_date": "Fecha de transacción",
        "transaction_id": "ID de transacción",
        "billing_cycle": "Ciclo de facturación",
        "amount": "Importe",
        "payment_history": "Historial de facturación",
        "card_information": "Información de tarjeta",
        "card_holder": "Titular de la tarjeta",
        "card_number": "Número de tarjeta",
        "expiration_date": "Fecha caducidad",
        "cvv": "CVV"
    },
    "search_by": {
        "group_id": "ID de grupo",
        "booking_id": "Reserva #",
        "recurring_id": "# recurrente",
        "ExternalID": "# externo",
        "tripId": "# de viaje",
        "driver_name": "Nombre del conductor",
        "driver_phone_number": "Número de teléfono del conductor",
        "license_plate": "Placa",
        "vehicle": "Vehículo",
        "operator": "Operador",
        "passenger_email": "E-mail del pasajero",
        "passenger_name": "Nombre del pasajero",
        "passenger_phone_number": "Número de teléfono del pasajero",
        "destination": "Destino",
        "pick_up": "Levantar",
        "flight_number": "Vuelo",
        "book_from": "reserva desde",
        "note": "Notas",
        "email": "Correo electrónico",
        "phone": "Teléfono"
    },
    "withdrawal": {
        "transferToEWallet": "Transferido a billetera electrónica externa *{0}",
        "channelCode": "Código de canal",
        "channelName": "Nombre del canal",
        "reversed": "Revertido",
        "requestTime": "Tiempo requerido",
        "referenceId": "Referencia #",
        "driverName": "Nombre del conductor",
        "phoneNumber": "Número de teléfono",
        "company": "Compañía",
        "description": "Descripción",
        "requestAmount": "Cantidad de la solicitud",
        "transferAmount": "Monto de la transferencia",
        "currentBalance": "Saldo actual",
        "currency": "Divisa",
        "action": "Acción",
        "approve": "Aprobar",
        "reject": "Rechazar",
        "transferToBankAccount": "Transferido a la cuenta bancaria *{0}",
        "transferToWingBank": "Transferido a la cuenta bancaria Wing ID *{0}",
        "transferToCreditWallet": "Transferido a la billetera de crédito",
        "reason": "Razón",
        "search": "Nombre del conductor, teléfono, compañía, ID de transacción, número de referencia",
        "message": {
            "approve": "¿Está seguro de que desea pagarle a este controlador una cantidad de {0}?",
            "approveMulti": "¿Está seguro de que desea pagar a los conductores seleccionados?",
            "approveSuccess": "La solicitud seleccionada ha sido pagada",
            "approveFail": "La solicitud seleccionada no tuvo éxito.  Inténtalo de nuevo.",
            "approveMultiSuccess": "Se han pagado {0} de {1} solicitudes seleccionadas",
            "approveMultiFail": "{0} de {1} solicitud (s) seleccionada (s) no tuvo éxito. Inténtalo de nuevo",
            "buttonConfirmTitle": "Sí",
            "closeButtonText": "No",
            "pleaseInputReason": "Por favor ingrese el motivo",
            "rejectSuccess": "La solicitud del conductor ha sido rechazada",
            "rejectFail": "Error al rechazar la solicitud seleccionada."
        },
        "getDataFailure": "no puedo obtener datos",
        "rejectRequest": "Rechazar solicitud"
    },
    "dynamicSurcharge": {
        "operationZone": "Zona de operación",
        "activeSurcharge": "Recargo activo",
        "surcharge": "Recargo",
        "surchargeName": "Nombre del recargo",
        "parameter": "Parámetro (por ejemplo, 1.x)",
        "pickupPoint": "Zona de recogida",
        "dropOffPoint": "Zona de entrega",
        "delete_surcharge_success": "El recargo se ha eliminado correctamente",
        "delete_surcharge_fail": "Los errores ocurrieron al eliminar el recargo",
        "update_surcharge_fail": "Los errores ocurrieron al actualizar el recargo",
        "update_surcharge_success": "El recargo se ha actualizado correctamente",
        "create_surcharge_fail": "Los errores ocurrieron al crear el recargo",
        "create_surcharge_success": "El recargo se ha creado correctamente",
        "active_surcharge_fail": "Los errores ocurrieron al activar el recargo",
        "active_surcharge_success": "El recargo se ha activado correctamente",
        "deactive_surcharge_fail": "Los errores ocurrieron al desactivar el recargo",
        "deactive_surcharge_success": "El recargo se ha desactivado correctamente",
        "delete_surcharge": "Eliminar recargo",
        "delete_confirm_message": "¿Está seguro de que desea eliminar el recargo seleccionado?",
        "note": "*Nota: esto es por lo que se multiplicará su tarifa básica.  Ejemplo: una tarifa de $20 sería $30 cuando el parámetro es 1.5x"
    },
    "dynamicFare": {
        "operationZone": "Zona de operación",
        "activeFare": "tarifa activa",
        "fare": "Tarifa",
        "fareName": "Nombre de la tarifa",
        "factor": "Multiplicar por factor",
        "fix_amount": "Monto",
        "parameter": "Parámetro (por ejemplo, 1.x)",
        "delete_fare_success": "La tarifa se ha eliminado correctamente",
        "delete_fare_fail": "Los errores ocurrieron al eliminar la tarifa",
        "update_fare_fail": "Los errores ocurrieron al actualizar la tarifa",
        "update_fare_success": "La tarifa ha sido actualizada con éxito",
        "create_fare_fail": "Los errores ocurrieron al crear la tarifa.",
        "create_fare_success": "La tarifa se ha creado correctamente",
        "active_fare_fail": "Los errores ocurrieron al activar la tarifa",
        "active_fare_success": "La tarifa se ha activado con éxito",
        "deactive_fare_fail": "Los errores ocurrieron al desactivar la tarifa",
        "deactive_fare_success": "La tarifa se ha desactivado con éxito",
        "delete_fare": "Eliminar tarifa",
        "delete_confirm_message": "¿Está seguro de que desea eliminar la tarifa seleccionada?",
        "note": "*Nota: esto es por lo que se multiplicará su tarifa básica.  Ejemplo: una tarifa de $20 sería $30 cuando el parámetro es 1.5x",
        "note_amount": "*Nota: este es el monto que se agregará a tu tarifa básica. Ejemplo: una tarifa de $20 sería de $25 cuando el monto establecido es $5"
    },
    "notifications": {
        "search": "Buscar ID reserva, external ID",
        "searchProviderName": "Buscar nombre de proveedor",
        "statusItem": {
            "all": "Todas las notificaciones",
            "canceledByDriver": "Transporte - Cancelado por el conductor",
            "canceledByPartner": "Afiliado - Cancelado por el socio",
            "reservationReminder": "Recordatorio de reserva",
            "localPending": "Local - Pendiente",
            "reservationIsNotStarted": "Reserva no ha comenzado",
            "partnerRequestsCars": "Vehículo solicitado por el partner",
            "timeout": "Se acabó el tiempo",
            "noShow": "Afiliado - No show",
            "driverNoShow": "No presentación del conductor",
            "affiliatePending": "Afiliación - Pendiente",
            "affiliatePaymentFailed": "Afiliación - Pago rechazado",
            "affiliateTimeout": "Afiliación - Fuera de tiempo",
            "flightApi": "API de vuelo",
            "DebtWriteOff": "Deuda cancelada",
            "driverCancelTrip": "Driver cancels trip",
            "minimumSeatRequired": "Asientos mínimos requeridos",
            "newFarmInJobFrom3rd": "Booking.com  - Nueva reserva",
            "canceledJobBy3rd": "Booking.com  - Cancelado",
            "updatedJobBy3rd": "Booking.com  - Actualizado",
            "incidentJobBy3rd": "Booking.com - Incidente",
            "newFarmInJobFromHolidayTaxis": "HolidayTaxis - Nueva reserva",
            "canceledJobByHolidayTaxis": "HolidayTaxis - Cancelado",
            "updatedJobByHolidayTaxis": "HolidayTaxis - Actualizado",
            "newFarmInJobFromKarhoo": "Karhoo - Nueva reserva",
            "canceledJobByKarhoo": "Karhoo - Cancelado",
            "updatedJobByKarhoo": "Karhoo - Actualizado",
            "newFarmInJobFromHoppa": "Hoppa - Nueva reserva",
            "canceledJobByHoppa": "Hoppa - Cancelado",
            "updatedJobByHoppa": "Hoppa - Actualizado",
            "newFarmInJobFromKlook": "Klook - Nueva reserva",
            "canceledJobByKlook": "Klook - Cancelado",
            "updatedJobByKlook": "Klook - Actualizado",
            "newFarmInJobFromTransferZ": "TransferZ - Nueva reserva",
            "canceledJobByTransferZ": "TransferZ - Cancelado",
            "updatedJobByTransferZ": "TransferZ - Actualizado",
            "incidentReport": "Incidente",
            "incidentAutoReport": "Necesita revisión"
        },
        "sos": {
            "sosSearch": "Buscar ID de reserva, nombre del pasajero, nombre del conductor",
            "statusItem": {
                "all": "Todo",
                "driver": "Conductores",
                "passenger": "Pasajeros",
                "crew": "Tripulación"
            }
        }
    },
    "smartData": {
        "No": "No.",
        "driverName": "Nombre",
        "phone": "Teléfono",
        "rating": "Clasificación",
        "completed": "Terminado",
        "noShow": "no presentarse",
        "driverNoShow": "No presentación del conductor",
        "incident": "Incidente",
        "canceled": "Cancelado por el conductor",
        "accepted": "Aceptado",
        "reject": "Rechazar",
        "ignore": "Ignorar",
        "earning": "Ganador",
        "query": {
            "top20": "20 mejores",
            "top50": "50 mejores",
            "top100": "100 mejores",
            "bottom20": "20 inferiores",
            "bottom50": "50 inferiores",
            "bottom100": "100 inferiores"
        },
        "status": {
            "canceled": "Cancelado por el conductor",
            "noShow": "no presentarse",
            "driverNoShow": "Falta de presentación del conductor",
            "incident": "Incidente",
            "completed": "Terminado",
            "earning": "Ganador",
            "reject": "Rechazar",
            "ignore": "Ignorar",
            "accepted": "Aceptado"
        }
    },
    "Reject": "No presentarse",
    "Do not allow Driver to start reservat": "Afiliados",
    "intercityRate": {
        "Delete_intercity_rate": "Eliminar tarifa interurbana",
        "edit_intercity_rate": "Editar tarifa interurbana",
        "view_intercity_rate": "Ver tarifa interurbana",
        "add_intercity_rate": "Agregar tarifa interurbana",
        "Delete_confirm_intercity_rate": "¿Quieres eliminar este elemento?",
        "Update_intercity_rate_success": "La tarifa interurbana se ha actualizado correctamente",
        "Update_intercity_rate_fail": "Se produjeron errores al actualizar la tarifa interurbana",
        "Created_intercity_rate_success": "La tarifa interurbana se ha creado correctamente",
        "Created_intercity_rate_fail": "Se produjeron errores al crear la tarifa interurbana",
        "Update_intercity_rate_route_success": "La ruta de tarifa interurbana se ha actualizado correctamente",
        "Update_intercity_rate_route_fail": "Se produjeron errores al actualizar la ruta interurbana",
        "Created_intercity_rate_route_success": "La ruta de tarifa interurbana se ha creado correctamente",
        "Created_intercity_rate_route_fail": "Se produjeron errores al crear la ruta interurbana",
        "Loading_intercity_rate_fail": "Se produjeron errores al cargar el detalle de la tarifa interurbana",
        "Delete_intercity_rate_route_fail": "Se produjeron errores al eliminar la ruta de tarifa interurbana",
        "Delete_intercity_rate_success": "La tarifa interurbana se ha eliminado correctamente",
        "Delete_intercity_rate_fail": "Se produjeron errores al eliminar la tarifa interurbana"
    },
    "intercityRoute": {
        "alias": "Alias",
        "routeNameHint": "Para cambiar el nombre de la ruta, ve a Configuración > Zona > Interurbano y cambia el nombre de las zonas de la ciudad según corresponda.",
        "pricePerSeat": "Precio por asiento (impuestos excluidos)",
        "distance": "Distancia",
        "duration": "Duración",
        "cancellationPenalty": "Monto de penalización por asiento",
        "noShow": "No presentación de pasajero/socio",
        "penalty": "Monto de penalización por asiento",
        "no_show_tooltip": "El monto que se cobrará al cliente por asiento. Además de la penalización, el cliente pagará impuestos o tarifa tecnológica si corresponde.",
        "firstLocation": "Primera ubicación",
        "secondLocation": "Segunda ubicación",
        "routeOneSetup": "Configurar ruta 1",
        "routetwoSetup": "Configurar ruta 2",
        "schedules": "Horarios",
        "date": "Fecha",
        "time": "Hora",
        "editSchedule": "Editar horario",
        "addSchedule": "Agregar horario",
        "requestTimeEnable": "Permitir al cliente establecer la hora de solicitud",
        "extraFee": "Tarifa adicional",
        "hideRouteEnable": "Ocultar esta ruta",
        "timeRange": "Rango de tiempo",
        "workingTime": "Tiempo de trabajo",
        "applyForOtherDays": "Aplicar para otros días",
        "limitSeatLuggage": "Límite de asiento / equipaje",
        "warningMinimumSeats": "Asientos mínimos requeridos",
        "warningMinimumSeatsHint": "Número mínimo de asientos necesarios para que el viaje ocurra",
        "allowStartLessMinRequiredSeats": "Allow driver to start trip regardless of the minimum seat requirement",
        "allowStartLessMinRequiredSeatsHint": "Driver can start a trip even if requested seats less than minimum seat required",
        "freeLuggagePerSeat": "Equipaje gratuito por asiento",
        "freeLuggagePerSeatHint": "Number free of luggage included per seat",
        "allowToAddExtraLuggage": "Allow to add additional luggage",
        "allowToAddExtraLuggageHint": "Passenger can request to add more luggage",
        "feePerExtraLuggage": "Tarifa por equipaje adicional",
        "Delete_intercity_route": "Eliminar ruta interurbana",
        "Delete_confirm_intercity_route": "¿Quieres eliminar esta ruta?",
        "Update_intercity_route_fail": "Intercity route has been updated successfully",
        "Update_intercity_route_success": "La ruta interurbana se ha actualizado correctamente",
        "created_intercity_route_success": "La ruta interurbana se ha creado correctamente",
        "created_intercity_route_fail": "Se produjeron errores al crear la ruta interurbana",
        "Delete_intercity_route_success": "La ruta interurbana se ha eliminado correctamente",
        "Delete_intercity_route_fail": "Se produjeron errores al eliminar la ruta interurbana",
        "penalty_less_than_or_equal_to_price": "Introduce un valor menor o igual al precio por asiento.",
        "scheduleTimeOverlap": "El horario no debe superponerse con otros.",
        "allows_adding_extra": "Permite agregar un cargo adicional cuando el cliente solicita un horario que no está programado por la flota.",
        "this_is_to_limit_users": "Esto limita a los usuarios (es decir, clientes, conductores, operadores) de crear nuevas reservas o viajes en esta ruta. Las reservas o viajes existentes permanecen reservados."
    },
    "dayOfWeek": {
        "0": "Domingo",
        "1": "Lunes",
        "2": "Martes",
        "3": "Miércoles",
        "4": "Jueves",
        "5": "Viernes",
        "6": "Sábado"
    },
    "intercityBooking": {
        "route": "Ruta",
        "departureDate": "Fecha de salida",
        "departureTime": "Hora de salida",
        "Departure": "Salida",
        "Arrival": "Llegada",
        "RefundFare": "Tarifa de reembolso",
        "intercityZoneNote": "These zones are not operational zone. And they are used for setting intercity rate only.",
        "zoneNameHint": "Por favor, mantén el nombre de la zona corto y claro para que tus clientes puedan buscar y seleccionar fácilmente.",
        "zoneUploadNote_2": "* Se recomienda que la resolución de la imagen sea de 1095x360 y el tamaño del archivo sea menor a 5MB.",
        "Complete_booking": "Completar reserva",
        "ConfirmCancel": "Confirmar cancelación"
    },
    "deliveryRate": {
        "Delete_delivery_rate": "Eliminar tarifa de entrega",
        "edit_delivery_rate": "Editar tarifa de entrega",
        "view_delivery_rate": "Ver tarifa de entrega",
        "add_delivery_rate": "Agregar tarifa de entrega",
        "Delete_confirm_delivery_rate": "¿Quieres eliminar este elemento?",
        "Update_delivery_rate_success": "La tarifa de entrega se ha actualizado correctamente",
        "Update_delivery_rate_fail": "Se produjeron errores al actualizar la tarifa de entrega",
        "Created_delivery_rate_success": "La tarifa de entrega se ha creado correctamente",
        "Created_delivery_rate_fail": "Se produjeron errores al crear la tarifa de entrega",
        "Update_delivery_rate_route_success": "La ruta de tarifa de entrega se ha actualizado correctamente",
        "Update_delivery_rate_route_fail": "Se produjeron errores al actualizar la ruta de entrega",
        "Created_delivery_rate_route_success": "La ruta de tarifa de entrega se ha creado correctamente",
        "Created_delivery_rate_route_fail": "Se produjeron errores al crear la ruta de entrega",
        "Loading_delivery_rate_fail": "Se produjeron errores al cargar el detalle de la tarifa de entrega",
        "Delete_delivery_rate_route_fail": "Se produjeron errores al eliminar la ruta de tarifa de entrega",
        "Delete_delivery_rate_success": "La tarifa de entrega se ha eliminado correctamente",
        "Delete_delivery_rate_fail": "Se produjeron errores al eliminar la tarifa de entrega",
        "distance_km": "Tarifa por km",
        "distance_mile": "Tarifa por milla",
        "flat": "Tarifa fija",
        "startingFee": "Tarifa inicial",
        "feeFirstDistance": "Tarifa primera distancia",
        "feeSecondDistance": "Tarifa segunda distancia",
        "feeThirdDistance": "Tarifa tercera distancia",
        "feeAfterThirdDistance": "Tarifa después de tercera distancia",
        "feePerMinute": "Tarifa por minuto",
        "feeMinimum": "Tarifa mínima",
        "feeFirstStop": "Tarifa por primera parada",
        "feeExtraStop": "Tarifa por cada parada extra"
    },
    "aiAtlasSettings": {
        "title": "Chatbot de Atlas AI",
        "titleDes": "Hagamos saber a Atlas sobre su empresa y su servicio",
        "information": "Información del Atlas",
        "informationDes": "Por ejemplo, añade detalles de la empresa como correo electrónico, número de teléfono, dirección, etc.",
        "updateSettingSuccess": "Actualizar la configuración de AI Atlas con éxito",
        "updateSettingFail": "Actualizar configuración de AI Atlas fallida"
    },
    "pwaSettings": {
        "pwa": "PWA",
        "iconName": "Icono y nombre",
        "logoBackgroundColor": "Logo, fondo y color",
        "longName": "Nombre largo",
        "shortName": "Nombre corto",
        "icon192": "Icono en pantalla de inicio (192x192)",
        "icon512": "Icono en pantalla de bienvenida",
        "logo": "Logo (300x300)",
        "logoMenu": "Logo del menú (300x300)",
        "backgroundImage": "Imagen de fondo - Transporte (1024x500)",
        "backgroundImageDelivery": "Imagen de fondo - Entrega (1024x500)",
        "mainColor": "Color principal",
        "secondaryColor": "Color secundario",
        "showMainColor": "Mostrar color principal en lugar de imagen de fondo",
        "success": "La configuración de PWA se ha actualizado correctamente",
        "failed": "Error al actualizar la configuración de PWA. ¡Inténtalo de nuevo!",
        "errorUploadFileSize": "Las dimensiones requeridas son {0}x{0} px.",
        "hideWBInstallAppBtn": "Ocultar botón de instalación de la aplicación",
        "enableBookNow": "Ahora",
        "enableGuestCheckout": "Pago como invitado",
        "enableBookLater": "Más tarde",
        "enableHideRecipient": "Ocultar información del destinatario (contenido del paquete, instrucciones de entrega)",
        "pwaLink": "PWA para pasajero",
        "partnerLink": "PWA para socio",
        "pwaDriverLink": "PWA para conductor",
        "providerSignUp": "Enlace de registro de conductor",
        "AdsTracking": "Seguimiento de anuncios",
        "googleId": "ID de etiqueta de Google",
        "placeholdergoogleId": "Introducir ID de etiqueta de Google",
        "metaId": "ID de píxel de Meta",
        "placeholdermetaId": "Introducir ID de píxel de Meta"
    },
    "emailConfig": {
        "emailServer": "Servidor de correo electrónico",
        "default": "Predeterminado",
        "customized": "Personalizado",
        "fromName": "Nombre del remitente",
        "email": "Correo del remitente",
        "replyTo": "Responder a",
        "userAuth": "Nombre de usuario",
        "password": "Contraseña",
        "smtpServer": "Servidor SMTP",
        "port": "Puerto SMTP",
        "isAuthenticated": "Autenticado",
        "option": "Habilitar opción",
        "none": "Ninguno",
        "tls": "TLS",
        "ssl": "SSL",
        "save": "Guardar",
        "cancel": "Cancelar",
        "success": "Actualización del servidor de correo electrónico exitosa",
        "fail": "Error en la actualización del servidor de correo electrónico",
        "loadFail": "Error al cargar los detalles del servidor de correo electrónico"
    },
    "driverFields": {
        "Load_fail": "",
        "Edit": "Editar",
        "View": "Ver",
        "Cancel": "Cancelar",
        "show": "Mostrar",
        "hide": "Ocultar",
        "EDIT_DRIVER_FIELDS": "Editar campos del conductor",
        "DETAIL_DRIVER_FIELDS": "Detalles de los campos del conductor",
        "ADD_DRIVER_FIELDS": "Agregar campos del conductor",
        "fieldKey": "Clave de los campos",
        "fieldName": "Nombre de los campos",
        "availableCC": "Disponible en el Centro de Comando",
        "availableDrvSignUp": "Disponible en el registro de conductor",
        "availableCompanyCar": "Auto de empresa - Conductores de transporte",
        "deliveryCompany": "Auto de empresa - Conductores de entrega",
        "availableIndividualCar": "Auto individual - Conductores de transporte",
        "deliveryIndividual": "Auto individual - Conductores de entrega",
        "required": "Requerido",
        "Update_fail": "Se produjeron errores al actualizar los campos del conductor",
        "Update_success": "Los campos del conductor se han actualizado correctamente",
        "FieldKey": "Clave de los campos",
        "FieldName": "Nombre de los campos (Inglés Americano)",
        "CommandCenter": "Disponible en el Centro de Comando",
        "SignUp": "Disponible en el registro de conductor",
        "CompanyTransport": "Auto de empresa - Transporte",
        "CompanyDelivery": "Auto de empresa - Entrega",
        "IndividualTransport": "Auto individual - Transporte",
        "IndividualDelivery": "Auto individual - Entrega",
        "Require": "Requerido",
        "Actions": "Acciones",
        "fieldType": "Tipo de campos",
        "default": "Predeterminado",
        "customized": "Personalizado"
    },
    "driverDocument": {
        "Load_fail": "",
        "Edit": "Editar",
        "View": "Ver",
        "Cancel": "Cancelar",
        "show": "Mostrar",
        "hide": "Ocultar",
        "EDIT_DRIVER_DOCUMENT": "Editar documento del conductor",
        "DETAIL_DRIVER_DOCUMENT": "Detalles del documento del conductor",
        "ADD_DRIVER_DOCUMENT": "Agregar documento del conductor",
        "documentKey": "Clave del documento",
        "documentName": "Nombre del documento",
        "documentNameDetail": {
            "zh-HK": "Chino tradicional",
            "it-IT": "Italiano estándar",
            "es-ES": "Español",
            "en-US": "Inglés americano",
            "fr-FR": "Francés estándar",
            "zh-CN": "Chino simplificado",
            "id-ID": "Bahasa Indonesia",
            "vi-VN": "Vietnamita",
            "ur-PK": "Urdu (República Islámica)",
            "ms-MY": "Malayo (Malasia)",
            "ar-AR": "Árabe",
            "en-GB": "Inglés (Reino Unido)",
            "nb-NO": "Noruego",
            "am-ET": "Amhárico",
            "ro-RO": "Rumano",
            "th-TH": "Tailandés",
            "ta-IN": "Tamil",
            "hi-IN": "Hindi",
            "te-IN": "Telugu",
            "ka-GE": "Georgiano",
            "ru-RU": "Ruso",
            "kn-IN": "Canarés"
        },
        "isIndividual": "Auto de empresa - Conductores de transporte",
        "deliveryCompany": "Auto de empresa - Conductores de entrega",
        "isOwner": "Conductor individual - Conductores de transporte",
        "deliveryIndividual": "Conductor individual - Conductores de entrega",
        "availableCC": "Disponible en el Centro de Comando",
        "availableDrvSignUp": "Disponible en el registro de conductor",
        "isRequired": "Requerido",
        "isExpiredDate": "Fecha de vencimiento - Centro de Comando",
        "expiredDateForDrvSignUp": "Fecha de vencimiento - Registro de conductor",
        "requireExpiredDate": "Requerir fecha de vencimiento",
        "requireExpiredDateForDrvSignUp": "Requerir fecha de vencimiento",
        "requireDocumentId": "Requerir ID de documento",
        "documentId": "ID de documento - Centro de Comando",
        "documentIdForDrvSignUp": "ID de documento - Registro de conductor",
        "Update_fail": "Se produjeron errores al actualizar el documento del conductor",
        "Update_success": "El documento del conductor se ha actualizado correctamente",
        "DocumentKey": "Clave del documento",
        "DocumentName": "Nombre del documento (Inglés Americano)",
        "CommandCenter": "Disponible en el Centro de Comando",
        "SignUp": "Disponible en el registro de conductor",
        "CompanyTransport": "Auto de empresa - Transporte",
        "CompanyDelivery": "Auto de empresa - Entrega",
        "IndividualTransport": "Auto individual - Transporte",
        "IndividualDelivery": "Auto individual - Entrega",
        "Require": "Requerido",
        "Actions": "Acciones"
    },
    "holidayTaxis": {
        "title": "Credenciales de API de HolidayTaxis",
        "note": "Comunícate con el equipo técnico de HolidayTaxis para que te proporcionen la clave API para conectarte a su sistema.",
        "apiKey": "Clave API",
        "placeHolderApiKey": "Ingresar clave API"
    },
    "trailNotes": {
        "maxLengthFiles": "Máximo 3 archivos por comentario",
        "maxSizeFiles": "Máximo 10MB por archivo",
        "typeFiles": "Tipos de archivo admitidos: pdf, doc, docx, csv, xls, xlsx, jpeg, jpg, png, webp, txt, nota",
        "maxComments": "Máximo 20 comentarios por reserva",
        "bookingActivity": "Actividad de reserva",
        "viewAll": "Ver todo",
        "operator": "Operador",
        "driver": "Conductor",
        "passenger": "Cliente",
        "pHInput": "Agregar un nuevo comentario. Puedes hacer clic en guardar para guardar la nota. También puedes arrastrar y soltar varios archivos aquí.",
        "addFiles": "Agregar archivos",
        "save": "Guardar",
        "inputNotes": "Por favor, ingresa texto",
        "successDeleteTrailNotes": "Notas de seguimiento eliminadas correctamente",
        "successCreateTrailNotes": "Notas de seguimiento creadas correctamente",
        "deleteTrailNote": "Eliminar una nota de seguimiento",
        "msgDeleteTrailNote": "¿Estás seguro de que quieres eliminar esto?"
    },
    "supplier": {
        "permissionRequired": "El operador debe seleccionar un permiso",
        "offerDetail": "Detalle de la oferta",
        "orderDetail": "Detalle del pedido",
        "bookingNumber": "Número de reserva",
        "date": "Fecha",
        "pickupLocation": "Pick up Location",
        "dropoffLocation": "Ubicación de entrega",
        "passenger": "Pasajero",
        "luggage": "Equipaje",
        "pickupService": "Servicio de recogida",
        "pickupSignage": "Señalización de recogida",
        "flightNumber": "Número de vuelo",
        "departure": "Salida",
        "arrival": "Llegada",
        "terminal": "Terminal",
        "gate": "Puerta",
        "meetGreet": "Encuentro y bienvenida",
        "specialRequests": "Solicitudes especiales",
        "additionalServices": "Servicios adicionales",
        "price": "Precio",
        "prices": "Precios",
        "guest": "Invitado",
        "serviceClass": "Clase de servicio",
        "distance": "Distancia",
        "duration": "Duración",
        "acceptOffer": "Aceptar oferta",
        "updateBooking": "Actualizar reserva",
        "package": "Paquete",
        "route": "Ruta",
        "assignedChauffer": "Conductor asignado",
        "assignedVehicle": "Vehículo asignado",
        "logs": "Registros",
        "link": "Enlaces",
        "desLink": "Haz clic para copiar enlace",
        "trackLink": "Enlace de seguimiento",
        "driverLink": "Enlace del conductor",
        "close": "Cerrar",
        "links": "Enlaces",
        "linksDes": "Haz clic para copiar enlace",
        "status": "Estado",
        "rating": "Calificación",
        "permissions": "Permisos",
        "permissionsNote": "Asigna diferentes niveles de autorización a tu equipo. Puedes elegir si tus operadores tienen visibilidad de ofertas abiertas o solo de asignaciones ya aceptadas.",
        "owner": "Propietario",
        "ownerNote": "Acceso completo",
        "manageUsers": "Administrar usuarios",
        "manageUsersNote": "Agregar/eliminar nuevos operadores",
        "manageDrivers": "Administrar conductores",
        "manageDriversNote": "Agregar/eliminar conductores",
        "manageVehicles": "Administrar vehículos",
        "manageVehiclesNote": "Agregar/eliminar vehículos",
        "mapView": "Mapa en vivo",
        "mapViewNote": "Seguimiento de conductores y viajes activos en el mapa en tiempo real.",
        "calendarView": "Vista de calendario",
        "calendarViewNote": "Ver el calendario de todos los viajes asignados.",
        "bookingView": "Vista de reserva",
        "bookingViewNote": "Ver y administrar reservas actuales, asignar conductores y distribuir vehículos.",
        "offersView": "Vista de ofertas",
        "offersViewNote": "Aceptar nuevas ofertas de trabajo.",
        "pricing": "Precios",
        "pricingNote": "Ver precios de viaje",
        "report": "Informes",
        "reportNote": "Ver informes de reservas y financieros",
        "reportExport": "Exportar informes",
        "reportExportNote": "Exportar informes a .csv",
        "userDetail": "Detalles del usuario",
        "addOperator": "Agregar operador",
        "updateOperator": "Actualizar operador",
        "supplier": "Proveedor",
        "zone": "Zona",
        "emails": "Correos electrónicos",
        "email": "Correo electrónico",
        "phoneNumber": "Número de teléfono",
        "Deactivate": "Desactivar",
        "Activate": "Activar",
        "ALERT_SELECT_DEACTIVATE": "Por favor, selecciona el proveedor para desactivar",
        "ALERT_SELECT_ACTIVATE": "Por favor, selecciona el proveedor para activar",
        "CONFIRM_DEACTIVATE_MULTI": "¿Quieres desactivar estos proveedores?",
        "CONFIRM_ACTIVATE_MULTI": "¿Quieres activar estos proveedores?",
        "Update_supplier_user_status_success": "El estado del proveedor se ha actualizado correctamente",
        "Update_supplier_user_status_fail": "Se produjeron errores al actualizar el estado del proveedor",
        "agent": "Agente",
        "Supplier": "Proveedor",
        "addSupplier": "Agregar proveedor",
        "detailSupplier": "Detalles del proveedor",
        "addUser": "Agregar usuario",
        "Add": "Agregar",
        "ContactInfo": "Información de contacto",
        "policy": "Política",
        "users": "Usuarios",
        "setting": "Configuración",
        "zones": "Zonas",
        "actions": "Acciones",
        "companyName": "Nombre de la empresa",
        "corporationType": "Tipo de corporación",
        "country": "País",
        "nationality": "Nacionalidad",
        "driverIC": "IC de controlador",
        "ADMIN_INFORMATION": "Información del administrador",
        "firstName": "Nombre",
        "lastName": "Apellido",
        "commissionValue": "Comisión de flota",
        "commissionValueDes": "Establecer las comisiones que la flota gana por cada pedido completo.",
        "SupplierType": "Tipo de proveedor",
        "SupplierTypeDes": "Seleccionar un tipo de proveedor.",
        "paymentMethodsApplyDes": "Métodos de pago específicos para trabajos que los proveedores pueden procesar:",
        "bookingSettings": "Configuración de reservas",
        "bookingSettingsDes": "Configurar la visibilidad del trabajo, los tiempos de lanzamiento y las demoras para operaciones eficientes de los proveedores.",
        "advanceBookingVisibilityTooltip": "Especificar cuántos días antes pueden los proveedores ver los pedidos.",
        "delayBroadcastToolTip": "Establecer un tiempo de demora desde la hora de lanzamiento si está configurado o desde el inicio del día (00:00). Esta demora controla cuándo los trabajos se vuelven visibles para los proveedores después de la hora de lanzamiento inicial.",
        "releaseTimeToolTip": "Establece la hora del día en que los trabajos se liberan a los proveedores, comenzando desde el primer día en que pueden ver las reservas. Asegúrate de que esta hora les permita suficiente tiempo de preparación.",
        "otherSettings": "Otras configuraciones",
        "hideFare": "Conductor - Ocultar tarifa siempre",
        "hideFareDes": "Ocultar la tarifa para todos los conductores de este proveedor.",
        "supplierJobRequired": "Aceptación de trabajo del proveedor requerida",
        "supplierJobRequiredDes": "Los proveedores deben reconocer y aceptar trabajos antes de poder asignar un conductor/vehículo o permitir que el trabajo sea visto por los conductores en el mercado.",
        "supplierApproval": "Aprobación de conductor/vehículo por el proveedor",
        "supplierApprovalDes": "Permitir a los operadores del proveedor activar conductores y vehículos dentro de su flota.",
        "emailsApply": "Notificaciones por correo electrónico",
        "emailsApplyDes": "Correos electrónicos para enviar nuevos trabajos y actualizaciones de reservas.",
        "address": "Dirección",
        "zipCode": "Código postal",
        "city": "Ciudad",
        "state": "Estado/Provincia",
        "tax": "Número de identificación fiscal",
        "businessRegistration": "Número de registro comercial",
        "vatNumber": "Número de identificación del IVA",
        "mobile": "Móvil",
        "editOperator": "Editar operador",
        "searchEmail": "Buscar correo electrónico",
        "acceptOfferSuccess": "Oferta aceptada exitosamente",
        "acceptOfferFail": "Reserva no encontrada o otro proveedor ha aceptado la reserva",
        "driverPayout": "Pago al conductor",
        "payout": "Pago",
        "totalPayout": "Pago total",
        "totalPayoutDes": "El pago total incluye el monto base del pago más cualquier tarifa adicional que hayas elegido asignar a tus proveedores.",
        "supplierPayout": "Pago al proveedor",
        "driverTip": "Propina del conductor",
        "cancel": "Cancelar",
        "save": "Guardar",
        "activeSupplier": "Proveedor activo",
        "userName": "Nombre de usuario",
        "bookingCompletedView": "Reservas completadas",
        "bookingCompletedViewNote": "Ver el historial de todas las reservas completadas.",
        "driverEarning": "Ganancias del conductor",
        "payoutCurrency": "Moneda de pago",
        "payoutCurrencyDes": "Moneda para pagar al proveedor/conductor",
        "autoCreatePayout": "Creación Automática de Pagos",
        "autoCreatePayoutDes": "Configura cuándo crear automáticamente un estado de pago para tus socios",
        "startDate": "Fecha de inicio",
        "frequency": "Frecuencia",
        "daily": "Diario",
        "weekly": "Semanal",
        "biWeekly": "Quincenal",
        "monthly": "Mensual",
        "commissionSupplier": "Comisión",
        "commissionSupplierDes": "Establecer las comisiones que el proveedor gana por cada pedido completado.",
        "amount": "Monto fijo",
        "percent": "Porcentaje",
        "commissionSupplierValue": "Ingresar valor de comisión",
        "payments": "Pagos",
        "paymentsDes": "Saldo a ser pagado a usted en cada calendario de pagos",
        "ConnectWithStripe": "Conectar con Stripe",
        "viewStripeAccount": "Ver cuenta de Stripe",
        "viewBankInfo": "Ver información bancaria",
        "AddBankInfo": "Agregar información bancaria",
        "confirmChangeBalane": "¿Está seguro de que desea cambiar el saldo del proveedor?",
        "changeBalaneSuccess": "El saldo de efectivo del proveedor se ha actualizado con éxito.",
        "restrictedZoneAccess": "Acceso a Zona Restringida",
        "restrictedZoneAccessDes": "Define áreas específicas de alta seguridad o controladas—como bases militares o instalaciones de la fuerza aérea—donde las recogidas o entregas están permitidas solo para conductores autorizados con acceso especial o permisos.",
        "DrvSignUpLink": "Enlace de Registro para Conductores"
    },
    "vehicleLeadTime": {
        "vehicleLeadTime": "Política de Tiempo de Entrega de Vehículos",
        "customLocationLeadTime": "Tiempo de entrega para ubicación personalizada",
        "leadTime": "Tiempo de entrega",
        "ConfirmDelete": "¿Está seguro de que desea eliminar esta póliza?",
        "Delete_success": "La política ha sido eliminada con éxito",
        "Update_Policy_success": "La política se ha actualizado correctamente",
        "Create_Policy_success": "La política se ha creado con éxito",
        "Update_Policy_fail": "Se produjeron errores al actualizar la política",
        "Create_Policy_fail": "Se produjeron errores al crear la política",
        "setDefaultSuccess": "La política de tiempo de entrega predeterminada del vehículo se ha establecido con éxito.",
        "setDefaultFail": "Se produjeron errores al establecer la política predeterminada",
        "Policies": "Políticas",
        "pricingPolicy": "Política de Precios",
        "customizeLeadTime": "Personalizar el Tiempo de Entrega",
        "SelectVehiclePolicy": "Seleccionar Política de Tiempo de Entrega del Vehículo"
    },
    "noResultFound": "No se encontraron resultados",
    "invalidDate": "La fecha no es válida. Por favor, ingresa la fecha en formato mm/dd/yyyy.",
    "billingUsage": {
        "GSNTitle": "Cartera GSN",
        "GSNNote": "Las flotas recargan para enviar o recibir trabajos desde la red.",
        "GSNPlatform": "Plataforma",
        "GSNPlatformNote": "Seguimiento de suscripción y uso de reservas. Facturado al final de su ciclo de facturación. Permanece separado de su Cartera GSN.",
        "GSNPlatformLimit": "Facturación de plataforma",
        "GSNPlatformLimitNote": "Seguimiento de suscripción y uso. Facturado al final de su ciclo de facturación. Es independiente de su Cartera GSN.",
        "usageBalanceNote": "Seguimiento de suscripción y uso. Facturado al final de su ciclo de facturación. Es independiente de su Cartera GSN.",
        "usageBalanceNoteDate": "Suscripción y uso pendiente",
        "usageBalanceNoteDateValue": "vencimiento el %{date}.",
        "usageBalance": "Saldo de uso",
        "platformUsage": "Uso de plataforma",
        "payoutBalance": "Saldo de pago",
        "invoicePayoutBalanceTooltip": "Ingresos de reservas de red completadas, disponibles para retiro. Si su saldo de crédito es insuficiente, este saldo puede usarse para cubrir transacciones de red.",
        "autoPayoutBalanceTooltip": "Este saldo muestra lo que ha ganado en la red y puede retirar. Si su crédito es bajo, los cargos pueden deducirse automáticamente de aquí.",
        "creditBalance": "Saldo de crédito",
        "gsnCreditBalance": "Saldo de crédito GSN",
        "totalBalance": "Saldo total",
        "paid": "Completado",
        "failed": "Fallido",
        "processing": "Procesando",
        "pending": "Pendiente",
        "bookingDeduct": "GSN Farm-Out",
        "cancellationPenalty": "GSN cancelación tardía",
        "noShowPenalty": "GSN inasistencia",
        "withdraw": "Retirar",
        "bookingEarning": "GSN Farm-In",
        "booking": "Tarifa de plataforma",
        "subscriptionFee": "Subscription Fee",
        "waived": "Waived*",
        "learnMore": "Aprender más",
        "viewUsage": "View Usage",
        "productDiscovery": "Descubrimiento de Producto",
        "productDiscoveryDescription": "Explora todo lo que puedes lanzar con GoodJourney. Descubre aplicaciones para conductores, herramientas de reserva en la web y otros productos para potenciar tus operaciones.",
        "overview": "Resumen",
        "paymentMethods": "Métodos de Pago",
        "billingHistory": "Historial de facturación",
        "creditGrants": "Concesiones de crédito",
        "transactionHistory": "Historial de Transacciones",
        "getStartedDescription": "Tu guía todo en uno para la plataforma. Explora tutoriales paso a paso, preguntas frecuentes y mejores prácticas para dominar reservas, despacho, pagos y más.",
        "getStartedButton": "Comenzar",
        "walletOverview": "Resumen de la billetera",
        "calculateTotal": "Total = Crédito + Efectivo",
        "autoRechargeOn": "Cuando tu saldo de crédito alcance $0, pasarás al nivel gratuito. Activa la recarga automática para mantener automáticamente tu saldo de crédito lleno.",
        "autoRechargeOff": "Consejo: Activa la Recarga Automática para mantener tu saldo lleno. Cuando tu crédito caiga a $0, las nuevas reservas se pausarán hasta que agregues fondos.",
        "updateSettingsOn": "Actualizar Configuración",
        "updateSettingsOff": "Habilitar recarga automática",
        "autoChargeTitle": "Configuraciones de recarga automática",
        "autoChargeTitleQuestion": "¿Te gustaría configurar la recarga automática?",
        "autoChargeCbx": "Sí, recarga automáticamente mi tarjeta cuando mi saldo de crédito cae por debajo de un umbral.",
        "crdBelow": "Cuando el saldo de crédito baja de",
        "crdBelowNote": "Enter an amount between $5 and $100",
        "backupTo": "Restaurar el saldo de crédito a",
        "backupToNote": "Enter an amount between $10 and $100",
        "greaterThan": "El valor debe ser mayor que {0}",
        "lessThan": "El valor debe ser menor que {0}",
        "AddBalance": "Añadir al saldo de crédito",
        "toAdd": "Cantidad a añadir",
        "confirm": "Confirmar pago",
        "usageCredit": "Crédito de Uso de Buen Viaje",
        "estTotal": "Total Estimado",
        "topUpSuccess": "Recarga exitosa",
        "topUpFailMessage": "Se produjeron errores al recargar el crédito",
        "autoRechargeSuccess": "La configuración de recarga automática se ha actualizado con éxito.",
        "autoRechargeFailMessage": "Se produjeron errores al actualizar la configuración de recarga automática.",
        "creditBalanceTooltip": "Tu saldo prepago cubre las tarifas de la plataforma y el uso. Manténlo recargado para que el servicio funcione sin interrupciones.",
        "gsnCreditBalanceTooltip": "Créditos prepagos para enviar y recibir reservas en la red. Mantenga un saldo suficiente para seguir operando sin interrupciones.",
        "creditLineTitle": "Línea de crédito",
        "creditLineTooltip": "Límite de crédito para la actividad de Good Journey Network. Lo utilizado se descuenta del límite; lo disponible es el margen restante antes del pago.",
        "creditLineLimit": "Límite",
        "creditLineUsed": "Usado",
        "creditLineAvailable": "Disponible",
        "creditLineNextPaymentLead": "Próximo pago automático %{date}",
        "creditLineNextPaymentTail": "o cuando su saldo alcance %{limitAmount}",
        "creditLineNextPaymentTailOnly": "El pago vence cuando su saldo alcance %{limitAmount}",
        "creditLineMakePayment": "Realizar pago",
        "cashBalanceTooltip": "Estos son tus ingresos de trabajos completados en la red. Esta cantidad está disponible para retiro. Si tu saldo de crédito es bajo, también se pueden deducir tarifas de aquí.",
        "systemTopUp": "Recarga del sistema",
        "gsnManualTopUp": "Recarga Manual",
        "gsnSystemTopUp": "Recarga del sistema",
        "autoTopUp": "Recarga Automática",
        "manualTopUp": "Recarga Manual",
        "subscription": "Suscripción",
        "subscriptionOneTime": "Suscripción Única",
        "subscriptionAddOn": "Complemento de Suscripción",
        "subscriptionAddOnOneTime": "Suscripción Adicional Única",
        "booking": "Tarifa de Reserva",
        "addOn": "Complemento",
        "subscriptionEnded": "Tu suscripción ha terminado. Selecciona un nuevo plan para continuar.",
        "continue": "Continuar",
        "openGuide": "Abrir guía",
        "amountMustBeGreaterThan": "La cantidad debe ser mayor que {0}",
        "amountMustBeLessThan": "La cantidad debe ser menor que {0}",
        "billingAndUsage": "Facturación y Uso",
        "manageSubscription": "Gestionar Suscripción",
        "failedToOpenBillingUrl": "Error al abrir la URL de facturación",
        "autoChargeAmountMustBeGreaterThanThreshold": "cuando la carga automática está habilitada, el monto debe ser mayor que el umbral de recarga (5)",
        "rechargeWillHappenImmediately": "La recarga se realizará de inmediato.",
        "rechargeWillHappenImmediatelyDescription": "Tu saldo de crédito está por debajo del umbral de recarga que has establecido, por lo que una recarga ocurrirá inmediatamente después de que guardes estos ajustes.",
        "amountIsRequired": "Se requiere un monto",
        "selectPaymentMethod": "Selecciona un método de pago",
        "byContinuingYouAgree": "Al continuar, aceptas nuestra",
        "serviceCreditTerms": "términos de crédito de servicio",
        "paidCreditsNonRefundable": "Los créditos pagados no son reembolsables y caducan un año a partir de la fecha de compra.",
        "back": "Volver",
        "cancel": "Cancelar",
        "topUp": "Recargar",
        "autoRechargeIs": "La recarga automática es",
        "on": "en",
        "off": "apagado",
        "viewTransactions": "Ver Transacciones",
        "bankInfo": "Información bancaria",
        "setupPayment": "Configurar Pago",
        "bookingUsage": "Booking Usage",
        "overages": "Overages",
        "included": "included",
        "of": "of",
        "extra": "extra",
        "received": "Recibido",
        "state": "Estado",
        "active": "Activo",
        "expired": "Expirado",
        "balance": "Balance",
        "expires": "Expira",
        "last7Days": "Últimos 7 Días",
        "viewHistory": "Ver historial",
        "creditsListedHereWillBeRemoved": "Los créditos listados aquí se eliminarán del saldo en su fecha de expiración.",
        "recentTransactions": "Transacciones recientes",
        "onlyPreviewShown": "Solo se muestra una vista previa. Consulta las transacciones para el libro mayor completo.",
        "showingTransactionsPast12Months": "Mostrando transacciones dentro de los últimos 12 meses",
        "filter": "Filtro",
        "export": "Exportar",
        "all": "Todo",
        "date": "Fecha",
        "amount": "Cantidad",
        "addOns": "Complementos",
        "edit": "Editar",
        "usage": "Uso",
        "usageThisCycle": "Uso este ciclo",
        "requests": "solicitudes",
        "base": "Base",
        "overage": "Exceso",
        "per": "por",
        "endOfSubscription": "Fin de la Suscripción",
        "fleetPlan": "Plan de Flota",
        "currentPlan": "Plan actual",
        "billing": "Facturación",
        "startDate": "Fecha de inicio",
        "nextBillingDate": "Fin de la suscripción",
        "change": "Cambiar",
        "getStarted": "Comenzar",
        "oneTimeSetup": "Configuración única:",
        "fee": "Tarifa:",
        "overagePerRequest": "Exceso",
        "overagePerRequestText": "por solicitud",
        "upToRequestsIncluded": "Hasta",
        "requestsIncluded": "solicitudes incluidas",
        "subscribed": "Suscrito",
        "contactUs": "Contáctanos",
        "enableOnlyWhatYouNeed": "Habilita solo lo que necesitas. Los precios se ajustan con el ciclo de facturación. Los complementos basados en el uso por cualquier exceso se deducirán de tu billetera de flota.",
        "subscriptionSummary": "Resumen de Suscripción",
        "reviewAndUpdate": "Revisa y actualiza tu suscripción.",
        "plan": "Plan",
        "ongoingTotal": "Total en curso",
        "nextBillingCycle": "Siguiente ciclo de facturación",
        "cancelSubscription": "Cancelar suscripción",
        "areYouSureCancelSubscription": "¿Está seguro de que desea cancelar su suscripción? Continuará teniendo acceso al servicio.",
        "until": "hasta",
        "resumeSubscription": "Reanudar Suscripción",
        "no": "No",
        "yes": "Sí",
        "updateSubscription": "Actualizar Suscripción",
        "upgrade": "Actualizar",
        "from": "De:",
        "totalDueToday": "Total a pagar hoy",
        "howProrationWorks": "Cómo funciona la prorrata",
        "prorationDescription": "Cualquier tiempo no utilizado de tu plan actual o complementos se acreditará hacia el nuevo plan. Los complementos añadidos a mitad de ciclo se cobran solo por los días restantes en el período de facturación actual.",
        "pleaseSelectPaymentMethod": "Por favor, seleccione un método de pago",
        "paymentConfirmedSuccessfully": "Pago confirmado con éxito",
        "failedToConfirmPayment": "Error al confirmar el pago",
        "confirmPayment": "Confirm Payment",
        "failedToGetBillingPlan": "Error al obtener el plan de facturación por código de país",
        "failedToGetPreview": "Error al obtener el plan de facturación de vista previa",
        "failedToPreviewAddOns": "Error al previsualizar complementos",
        "subscriptionCancelledSuccessfully": "Suscripción cancelada con éxito",
        "failedToCancelSubscription": "Error al cancelar la suscripción",
        "addOnChangedSuccessfully": "Complemento cambiado con éxito",
        "failedToChangedAddOn": "Error al cambiar el complemento",
        "failedToGetUsage": "Error al obtener el uso",
        "annual": "Anual",
        "monthly": "Mensual",
        "currentPlanButton": "Plan Actual",
        "upgradeButton": "Actualizar",
        "save": "Guardar",
        "expiresText": "Expira",
        "noExpiry": "No Expiración",
        "managePayment": "Gestionar Pago",
        "changePlan": "Change Plan",
        "addOns": "Complementos",
        "viewUsage": "Ver uso",
        "requestWithdrawal": "Solicitar retiro",
        "withdraw": "Retirar",
        "withdrawalGsn": {
            "requestWithdrawal": "Solicitar retiro",
            "reviewWithdrawal": "Revisar retiro",
            "payTo": "Pagar a",
            "availableBalance": "Saldo disponible ({currency})",
            "payoutBalance": "Saldo de pago ({currency})",
            "payoutBalanceLabel": "Saldo de pago",
            "amountOwedToPlatform": "Importe adeudado a la plataforma",
            "availableToWithdraw": "Disponible para retirar",
            "amountToWithdraw": "Importe a retirar ({currency})",
            "minimumWithdrawal": "Retiro mínimo: {amount} {currency}",
            "minimumTransferAmount": "Importe mínimo de transferencia: {amount} {currency}",
            "noPayoutMethods": "Sin métodos de pago",
            "review": "Revisar",
            "payoutSpeed": "Velocidad de pago",
            "normalPayout": "Pago normal",
            "instantPayout": "Pago instantáneo",
            "recommended": "Recomendado",
            "transferFeePercent": "Comisión de transferencia del {percent} %",
            "transferFee": "Comisión de transferencia",
            "withdrawalAmount": "Importe del retiro",
            "amountDeducted": "Importe deducido",
            "youWillReceive": "Recibirá",
            "totalToReceive": "Total a recibir",
            "confirmWithdrawal": "Confirmar retiro",
            "disclaimer": "Los retiros se envían en USD",
            "disclaimer1": "Los bancos receptores pueden convertir los fondos a moneda local y aplicar sus propias comisiones y tipos de cambio",
            "disclaimer2": "El importe final recibido puede diferir del enviado.",
            "requestSuccess": "Solicitud de retiro enviada correctamente."
        },
        "addNewPaymentMethod": "Añadir nuevo método de pago",
        "warningCurrentBalance": "El importe que debe a la plataforma supera su saldo de pago actual. No puede solicitar un retiro en este momento."
    },
    "signup": {
        "limitation": {
            "driver": "Driver",
            "vehicle": "Vehicle",
            "operator": "Operator",
            "drivers": "Drivers",
            "vehicles": "Vehicles",
            "operators": "Operators"
        },
        "language": "Idioma",
        "contactHeader": "Para cualquier problema o consulta, por favor contacte a",
        "stepAccountTitle": "Crear cuenta",
        "stepAccountDesc": "Por favor, proporcione su nombre de usuario y contraseña.",
        "stepCompanyTitle": "Detalles de la empresa",
        "stepCompanyDesc": "Agrega tu logo, tema de color e información de la empresa.",
        "stepZoneTitle": "Zona de Operación",
        "stepZoneDesc": "Seleccione su ciudad de operación.",
        "stepPlanTitle": "Elige un Plan",
        "stepPlanDesc": "Seleccione un plan de pago adecuado para usted.",
        "stepPlanCustom": "Tu Plan Personalizado",
        "stepPlanTitleCustom": "Revisa Tu Plan Personalizado",
        "stepPlanDescCustom": "Un plan diseñado específicamente para tu flota.",
        "accountStepTitle": "Crear Cuenta",
        "accountStepUsername": "Nombre de usuario",
        "accountStepEmail": "Correo electrónico",
        "accountStepChoosePassword": "Elegir Contraseña",
        "accountStepConfirmPassword": "Confirmar contraseña",
        "accountStepPasswordHint": "La contraseña debe tener al menos 8 caracteres, 1 letra mayúscula y 1 carácter especial.",
        "accountStepCreateAccount": "Crear cuenta",
        "accountStepAlreadyHaveAccount": "¿Ya tienes una cuenta?",
        "accountStepCaptchaError": "Por favor, verifica el captcha.",
        "accountStepGenericError": "Se produjo un error al crear la cuenta",
        "accountStepSuccess": "Cuenta creada exitosamente",
        "usernameRequired": "Se requiere nombre de usuario",
        "usernameMinLength": "El nombre de usuario debe tener al menos 3 caracteres",
        "usernameMaxLength": "El nombre de usuario debe tener menos de 20 caracteres",
        "usernamePattern": "El nombre de usuario debe comenzar con una letra minúscula y solo puede contener letras minúsculas y números",
        "emailRequired": "Se requiere correo electrónico",
        "emailInvalid": "El correo electrónico no es válido",
        "passwordRequired": "Se requiere contraseña",
        "passwordMinLength": "La contraseña debe tener al menos 8 caracteres",
        "passwordPattern": "La contraseña debe contener al menos 1 letra mayúscula y 1 carácter especial.",
        "confirmPasswordMismatch": "Las contraseñas no coinciden",
        "companyStepTitle": "Detalles de la empresa",
        "companyStepAddLogo": "Agregar logo",
        "companyStepColorTheme": "Tema de Color",
        "companyStepSelectThemeColor": "Seleccionar color de tema",
        "companyStepFirstName": "Nombre",
        "companyStepLastName": "Apellido",
        "companyStepPhone": "Teléfono",
        "companyStepEmail": "Correo electrónico",
        "companyStepCompanyName": "Nombre de la Empresa",
        "companyStepFleetId": "ID de flota",
        "companyStepCompanyAddress": "Dirección de la empresa",
        "companyStepCompanyWebsite": "Sitio web de la empresa",
        "companyStepDriversNumber": "¿Cuántos conductores hay en su flota?",
        "companyStepVehiclesNumber": "¿Cuántos vehículos hay en su flota?",
        "companyStepContinue": "Continuar",
        "companyStepGenericError": "Se produjo un error al guardar la empresa",
        "companyStepSuccess": "Empresa guardada con éxito",
        "companyStepPhoneInvalid": "Por favor, introduzca un número de teléfono válido.",
        "companyNameRequired": "Se requiere el nombre de la empresa",
        "fleetIdRequired": "Se requiere FleetId",
        "fleetIdPattern": "Debe tener entre 4 y 30 caracteres, debe comenzar con una letra minúscula y solo puede contener letras minúsculas y números",
        "zoneStepTitle": "Configurar Área de Operación",
        "zoneStepDescription": "Esta es tu zona de operación inicial. Para futuras expansiones, siéntete libre de",
        "zoneStepSearchAddress": "Buscar una dirección",
        "zoneStepLatitude": "Latitud",
        "zoneStepLongitude": "Longitud",
        "zoneStepRadius": "¿Qué tan lejos saldrás de tu zona central?",
        "zoneStepRadiusDescription": "Distancia más lejana del punto central.",
        "zoneStepContinue": "Continuar",
        "zoneStepGenericError": "Se produjo un error al guardar la zona",
        "zoneStepSuccess": "Zona guardada con éxito",
        "zoneStepInvalidCoordinates": "la latitud y longitud no son válidas",
        "latitudeRequired": "La latitud es obligatoria",
        "latitudeDecimalPlaces": "La latitud puede tener como máximo 10 lugares decimales.",
        "latitudeRange": "La latitud debe estar entre -90 y 90 grados",
        "longitudeRequired": "Se requiere longitud",
        "longitudeDecimalPlaces": "La longitud puede tener como máximo 10 decimales.",
        "longitudeRange": "La longitud debe estar entre -180 y 180 grados.",
        "radiusRequired": "Se requiere radio",
        "radiusMinError": "El radio debe ser de al menos {0} km",
        "radiusMaxError": "El radio no puede exceder los {0} km",
        "contactUs": "contáctanos",
        "planTitle": "Elegir Plan",
        "planDescription": "Elige un plan que se ajuste a tus necesidades. Mejora o cancela en cualquier momento. Sin tarifas ocultas, nunca.",
        "planDescriptionCustom": "Un plan diseñado específicamente para tu flota.",
        "billingMonthly": "Mensual",
        "billingAnnual": "Anual",
        "saveBadge": "Ahorrar 20%",
        "popularBadge": "MÁS POPULAR",
        "customPricing": "Personalizado",
        "periodAnnual": "Anual",
        "periodMonthly": "Mensual",
        "bonusCredits": "Bono de {0} Créditos de Una Vez",
        "savePercentage": "Guardar {0}%",
        "oneTimeSetupFee": "Tarifa de Configuración de Una Vez",
        "waived": "Waived*",
        "planFeatures": {
            "feePerBooking39": "3.9% por reserva",
            "feePerBooking29": "2.9% por reserva",
            "feePerBooking": "{0} por reserva adicional",
            "freeBookingPerMonth": "{0} reservas GRATIS por mes",
            "unlimitedUsers": "Usuarios ilimitados",
            "commandCenterAdminDashboard": "Panel de Administración del Centro de Comando",
            "nativeDriverApp": "Aplicación de Conductor Nativo",
            "webDriverApp": "Aplicación Web Driver",
            "customerBookingLink": "Enlace de Reserva del Cliente",
            "plusEverythingInStartup": "Además de todo en Startup",
            "corporateManagement": "Gestión Corporativa",
            "invoicingManagement": "Gestión de Facturación",
            "driverPayoutManagement": "Gestión de Pagos a Conductores",
            "promotionManagement": "Gestión de Promociones",
            "plusEverythingInPro": "Además de todo en Pro",
            "tierDiscountPricing": "Precios con Descuento por Nivel",
            "customFeatureDevelopment": "Desarrollo de Funciones Personalizadas",
            "unlimitedOperators": "Operadores Ilimitados",
            "unlimitedDrivers": "Conductores Ilimitados",
            "unlimitedVehicles": "Vehículos Ilimitados"
        },
        "planDescriptions": {
            "enterprise": "Enterprise incluye facturación personalizada, incorporación dedicada, Precios con Descuento por Niveles y Desarrollo de Funciones Personalizadas para adaptarse perfectamente a su flujo de trabajo específico."
        },
        "limitedNotes": "(*) Promoción exclusiva por tiempo limitado",
        "unlimitedText": "Ilimitado",
        "volumeDiscount": "Descuento por volumen",
        "letsTalkButton": "¡Hablemos!",
        "buildingStepTitle": "Construyendo tu flota...",
        "congratulationsTitle": "¡Felicidades! Tu cuenta está lista",
        "congratulationsDescription": "Inicia sesión en tu panel de administración aquí.",
        "congratulationsViewDashboard": "Ver Panel de Control",
        "congratulationsContact": "¿Preguntas? Contáctanos en",
        "fleetIdDescription": "Elige un código corto y simple para tu flota — fácil de compartir y recordar.",
        "fleetIdPlaceholder": "por ejemplo, goodjourney",
        "firstNameRequired": "El nombre es obligatorio",
        "logIn": "Iniciar sesión",
        "instead": "en su lugar.",
        "submittingData": "Enviando datos...",
        "upload": "Cargar",
        "phoneNumberPlaceholder": "+1 Número de Teléfono",
        "km": "KM",
        "selectPlan": "Seleccionar Plan",
        "upgrade": "Actualizar",
        "goodJourney": "Buen viaje",
        "loading": "Cargando...",
        "lastNameRequired": "El apellido es obligatorio",
        "agreeToTerms": "Al continuar, reconoces que has leído y aceptas",
        "termsOfService": "Términos de Servicio",
        "privacyPolicy": "Política de Privacidad",
        "and": "y",
        "refresh": "Actualizar",
        "takingTooLong": "¿Tarda demasiado?"
    },
    "addonTemplate": {
        "Addon_Template": "Add-On Template",
        "Add_On_Template": "Add-On Template",
        "Create_addon_template_success": "Add-on template has been created successfully",
        "Create_addon_template_fail": "The errors occurred while creating add-on template",
        "Update_addon_template_success": "Add-on template has been updated successfully",
        "Update_addon_template_fail": "The errors occurred while updating add-on template",
        "Update_template_success": "Template has been updated successfully",
        "Update_template_fail": "The errors occurred while updating template",
        "Edit_Template": "Edit Template",
        "New_Template": "New Template",
        "Enter_Add_On_Template_Name": "Enter Add-On Template Name*",
        "Confirm_Delete": "Confirm Delete",
        "Confirm_Delete_Message": "Are you sure you want to delete this template? Deleting this template will unlink from all the partners/corp it links to",
        "Delete_success": "Template has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting template",
        "Set_Default": "Set as Default",
        "Confirm_Set_Default_Message": "Are you sure you want to set this Add-On as default?",
        "Set_Default_Success": "Add-on template has been set as default successfully",
        "Set_Default_Fail": "The errors occurred while setting add-on template as default",
        "Clone_addon_template": "Clone Add-On Template"
    },
    "addonService": {
        "Additional_Service": "Additional Service",
        "Service_Name": "Service Name",
        "Description": "Description",
        "desPlaceholder": "Brief description of the service",
        "namePlaceholder": "e.g. Meet & Greet, Local-E Sim, GST Tax",
        "Who_pays_for_this_add_on": "Who pays for this add-on?",
        "customer": "Customer",
        "driver": "Driver",
        "fleet": "Fleet",
        "Required": "Required",
        "Apply_Tax": "Apply Tax",
        "Itemize": "Itemize",
        "Attribute": "Attribute",
        "Fee_Type": "Fee Type",
        "feeType.amount": "Amount",
        "feeType.percentageSubtotal": "Percentage of Subtotal",
        "feeType.percentageTotal": "Percentage of Total",
        "feeType.custom": "Custom (Driver Input)",
        "Unit_Settings": "Unit Settings",
        "unit.none": "None",
        "unit.perDay": "per day",
        "unit.eachTime": "each time",
        "unit.perPerson": "per person",
        "Maximum_Quantity": "Maximum Quantity",
        "Maximum_Quantity_Value": "Maximum Quantity Value",
        "How_much_will_the_fleet_make": "How much will the fleet make for this add-on?",
        "Fleet_Commission": "Fleet Commission",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "Currency": "Currency",
        "Unlimited": "Unlimited",
        "Limited": "Limited",
        "Vehicle_Type": "Vehicle Type",
        "Service_Type": "Service Type",
        "Meeting_Zone": "Meeting Zone",
        "Trip_Context": "Trip Context",
        "Trip_Context_Value": {
            "departure": "Departure",
            "arrival": "Arrival"
        },
        "Operation_Zone": "Operation Zone",
        "Restricted_Zone": "Restricted Zone",
        "User_Type": "User Type",
        "Price_Unit": "Price Unit",
        "Info": "Info",
        "Rules": "Rules",
        "Basic_Information": "Basic Information",
        "Delete": "Delete",
        "Delete_addon_service": "Are you sure you want to delete this add-on service?",
        "Delete_success": "Add-on service has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting add-on service",
        "Create_addon_service_success": "Add-on service has been created successfully",
        "Create_addon_service_fail": "The errors occurred while creating add-on service",
        "Update_addon_service_success": "Add-on service has been updated successfully",
        "Update_addon_service_fail": "The errors occurred while updating add-on service",
        "Please_save_template_first": "Please save the template first before adding services",
        "Attribute_Tooltip": "Travel Attribute: Used to map this add-on to its corresponding standardized service key across connected OTAs (e.g., CHILD_SEAT, MEET_GREET).",
        "feeType": {
            "amount": "Amount",
            "percentageSubtotal": "Percentage of Subtotal",
            "percentageTotal": "Percentage of Total",
            "custom": "Custom (Driver Input)"
        },
        "unit": {
            "none": "None",
            "perDay": "Per day (Charge per day)",
            "eachTime": "Each time (Charge per ride)",
            "perPerson": "Per person (Charge per person)",
            "each": "Each (Charge per quantity)"
        },
        "none": "None",
        "perDay": "Per day",
        "eachTime": "Each time",
        "perPerson": "Per person",
        "each": "Each",
        "Unit_Settings_Title": "Unit Settings",
        "Itemize_Tooltip": "Itemize: This will list the add-on as a separate line item in the fare breakdown. If this is disabled, it will be under additional services.",
        "Booking_Channel": "Booking Channel",
        "pointToPoint": "Point To Point",
        "fromAirport": "From Airport",
        "toAirport": "To Airport",
        "hourly": "Hourly",
        "roundTrip": "Round Trip",
        "ADD_ON_BOOKING_CHANNEL_VALUE": {
            "PWA": "Web App",
            "passenger": "Customer App",
            "API": "API",
            "CC": "Command Center",
            "partner": "Partner App",
            "CarHailing": "Street Hailing",
            "streetSharing": "Street Sharing"
        },
        "Select_Attribute": "Select Attribute",
        "allowNoteInput": "Driver Input: Notes or Receipts",
        "allowNoteInputTooltip": "Allows drivers to submit notes and upload supporting photos or receipts for this service at the end of the trip (e.g. parking fees, tolls, additional charges).",
        "isDriverCapability": "Driver Capability",
        "Driver_Capability_Tooltip": "Exposes this service as a selectable capability in the driver profile. Used for driver profiling and booking-to-driver matching.",
        "isVehicleAttribute": "Vehicle Attribute",
        "Vehicle_Attribute_Tooltip": "Exposes this service as a selectable attribute in the vehicle profile. Used for vehicle profiling and booking matching.",
        "linkAtr": "Link attributes to a specific driver.",
        "addOnServicePolicy": "Add-On Policy",
        "selectAddonTemplate": "Select Add-on Template"
    }
};
